module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "ee94");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0046":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var isArray = __webpack_require__("eb0a");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "009f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "01da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "024b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2cc1");
var fails = __webpack_require__("a6cc");
var global = __webpack_require__("79a2");

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "0286":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("47c8").f;
var hasOwn = __webpack_require__("80a8");
var wellKnownSymbol = __webpack_require__("eebc");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "0314":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "03e6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("3eb0");
var anObject = __webpack_require__("6d4e");
var aPossiblePrototype = __webpack_require__("3f12");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "05a9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "05bc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("799f");
var uncurryThis = __webpack_require__("7630");
var aCallable = __webpack_require__("f938");
var arrayFromConstructorAndList = __webpack_require__("6ca7");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),

/***/ "05ee":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0604":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__("80a8");
var ownKeys = __webpack_require__("5327");
var getOwnPropertyDescriptorModule = __webpack_require__("ef57");
var definePropertyModule = __webpack_require__("47c8");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "0781":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("69a2");

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),

/***/ "08a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__("213e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "099b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),

/***/ "0d07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");
var createPropertyDescriptor = __webpack_require__("8b31");

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "0d52":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__("f385");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "0ef3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("e2a4");
var createNonEnumerableProperty = __webpack_require__("abb2");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "0f5a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var isCallable = __webpack_require__("0d52");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "1081":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("799f");
var lengthOfArrayLike = __webpack_require__("2e86");
var toIntegerOrInfinity = __webpack_require__("08a0");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),

/***/ "14a3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__("37cd");
var uncurryThis = __webpack_require__("7630");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "14d1":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__("2bd7")('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ "178e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("54df");
var global = __webpack_require__("79a2");
var apply = __webpack_require__("ba17");
var wrapErrorConstructorWithCause = __webpack_require__("f66f");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "190c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollBarWidth = void 0;

;

/***/ }),

/***/ "195a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");
var transformData = __webpack_require__("30e5");
var isCancel = __webpack_require__("05a9");
var defaults = __webpack_require__("64cb");
var Cancel = __webpack_require__("641f");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "1ce3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var isObject = __webpack_require__("e2a4");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "1eca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var fails = __webpack_require__("a6cc");
var createElement = __webpack_require__("1ce3");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ "2085":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__("2e86");
var toIntegerOrInfinity = __webpack_require__("08a0");

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};


/***/ }),

/***/ "20a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var fails = __webpack_require__("a6cc");
var isCallable = __webpack_require__("0d52");
var hasOwn = __webpack_require__("80a8");
var DESCRIPTORS = __webpack_require__("6bd2");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("7465").CONFIGURABLE;
var inspectSource = __webpack_require__("85c5");
var InternalStateModule = __webpack_require__("5bb8");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "20c0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__("d080");
var enumBugKeys = __webpack_require__("8cd3");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "213e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "22ec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("aa98");
var IndexedObject = __webpack_require__("4a45");
var toObject = __webpack_require__("ca07");
var lengthOfArrayLike = __webpack_require__("2e86");

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE === 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),

/***/ "233f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__("8409");

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};

/***/ }),

/***/ "242d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("0d52");
var definePropertyModule = __webpack_require__("47c8");
var makeBuiltIn = __webpack_require__("20a5");
var defineGlobalProperty = __webpack_require__("4113");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "24fe":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2648":
/***/ (function(module, exports) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ "26b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__("a6f3");

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__("2b58");

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__("190c");

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__("5a8b");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idSeed = 1;

var scrollBarWidth = void 0;

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),

/***/ "2703":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("4a45");
var requireObjectCoercible = __webpack_require__("37d8");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "29f7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "2b58":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__("5a8b");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasModal = false;
var hasInitZIndex = false;
var zIndex = void 0;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set: function set(value) {
    zIndex = value;
  }
});

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),

/***/ "2bd7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("2db7");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"VUE_APP_TASK_HALL":"https://task.survey.work","VUE_APP_WEBSITE":"https://survey.work","VUE_APP_OFFICIAL_ACCOUNT_URL":"https://wj.survey.work/img/qrcode/dygc-pro.jpeg","NODE_ENV":"production","VUE_APP_BASE_API_TREEYEE":"https://testcloud.treeyee.com/api","BASE_URL":"/pc/"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("3117")))

/***/ }),

/***/ "2c86":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;
    if (callback) {
      callback.apply(null, arguments);
    }
  };
  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }
  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
};

; /**
   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
   *
   * @param {Vue} instance Vue instance.
   * @param {Function} callback callback of after-leave event
   * @param {Number} speed the speed of transition, default value is 300ms
   * @param {Boolean} once weather bind after-leave once. default value is false.
   */

/***/ }),

/***/ "2cc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var userAgent = __webpack_require__("5f67");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "2d7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "2db7":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("f9ec");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "2e86":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__("97bb");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "2f9c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("a059");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "2fb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("47c8").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "30e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");
var defaults = __webpack_require__("64cb");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "3117":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("fe2d");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "3185":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("08a0");

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ "3505":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "37bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var fails = __webpack_require__("a6cc");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ "37cd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "37d8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__("01da");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "3a91":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ariaUtils = __webpack_require__("b081");

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constructor
 * @desc Dialog object providing modal focus management.
 *
 * Assumptions: The element serving as the dialog container is present in the
 * DOM and hidden. The dialog container has role='dialog'.
 *
 * @param dialogId
 *          The ID of the element serving as the dialog container.
 * @param focusAfterClosed
 *          Either the DOM node or the ID of the DOM node to focus when the
 *          dialog closes.
 * @param focusFirst
 *          Optional parameter containing either the DOM node or the ID of the
 *          DOM node to focus when the dialog opens. If not specified, the
 *          first focusable element in the dialog will receive focus.
 */
var aria = aria || {};
var tabEvent;

aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
  var _this = this;

  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
  }

  if (typeof focusAfterClosed === 'string') {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }

  if (typeof focusFirst === 'string') {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }

  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }

  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};

aria.Dialog.prototype.addListeners = function () {
  document.addEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.removeListeners = function () {
  document.removeEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.closeDialog = function () {
  var _this2 = this;

  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function () {
      _this2.focusAfterClosed.focus();
    });
  }
};

aria.Dialog.prototype.trapFocus = function (event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};

exports.default = aria.Dialog;

/***/ }),

/***/ "3ac8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("5794");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "3eb0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var aCallable = __webpack_require__("f938");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "3f12":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("0d52");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "401d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4113":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "4114":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "411b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__("e7d4");
var uid = __webpack_require__("a961");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "4366":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("490d"));
	else {}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ "47c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var IE8_DOM_DEFINE = __webpack_require__("1eca");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("37bb");
var anObject = __webpack_require__("6d4e");
var toPropertyKey = __webpack_require__("56bb");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "480a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ "480ab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),

/***/ "490d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ "4a45":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var fails = __webpack_require__("a6cc");
var classof = __webpack_require__("37cd");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "4aa6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("54df");
var $reduce = __webpack_require__("83b7").left;
var arrayMethodIsStrict = __webpack_require__("5b14");
var CHROME_VERSION = __webpack_require__("2cc1");
var IS_NODE = __webpack_require__("a8c9");

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");
var bind = __webpack_require__("d7d9");
var Axios = __webpack_require__("fa71");
var mergeConfig = __webpack_require__("c3c5");
var defaults = __webpack_require__("64cb");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("641f");
axios.CancelToken = __webpack_require__("8073");
axios.isCancel = __webpack_require__("05a9");
axios.VERSION = __webpack_require__("2648").version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("61b4");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("009f");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "4d40":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("2f9c");
var hasOwn = __webpack_require__("80a8");
var isPrototypeOf = __webpack_require__("29f7");
var regExpFlags = __webpack_require__("9310");

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ "4e07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("54df");
var global = __webpack_require__("79a2");
var getBuiltIn = __webpack_require__("c64c");
var createPropertyDescriptor = __webpack_require__("8b31");
var defineProperty = __webpack_require__("47c8").f;
var hasOwn = __webpack_require__("80a8");
var anInstance = __webpack_require__("4eb7");
var inheritIfRequired = __webpack_require__("ef26");
var normalizeStringArgument = __webpack_require__("b839");
var DOMExceptionConstants = __webpack_require__("99db");
var clearErrorStack = __webpack_require__("5d7c");
var DESCRIPTORS = __webpack_require__("6bd2");
var IS_PURE = __webpack_require__("eed0");

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = new Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ "4eb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__("29f7");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "4eef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ "50c6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};

var _util = __webpack_require__("f3b3");

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

/***/ }),

/***/ "5327":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("c64c");
var uncurryThis = __webpack_require__("7630");
var getOwnPropertyNamesModule = __webpack_require__("20c0");
var getOwnPropertySymbolsModule = __webpack_require__("bf92");
var anObject = __webpack_require__("6d4e");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "54df":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var getOwnPropertyDescriptor = __webpack_require__("ef57").f;
var createNonEnumerableProperty = __webpack_require__("abb2");
var defineBuiltIn = __webpack_require__("242d");
var defineGlobalProperty = __webpack_require__("4113");
var copyConstructorProperties = __webpack_require__("0604");
var isForced = __webpack_require__("bcf4");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "56bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("b799");
var isSymbol = __webpack_require__("fd95");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "5794":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("480a");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "58f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("54df");
var toObject = __webpack_require__("ca07");
var lengthOfArrayLike = __webpack_require__("2e86");
var setArrayLength = __webpack_require__("0046");
var doesNotExceedSafeInteger = __webpack_require__("f8ca");
var fails = __webpack_require__("a6cc");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "5a8b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null && vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),

/***/ "5b14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "5bb8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__("0f5a");
var global = __webpack_require__("79a2");
var isObject = __webpack_require__("e2a4");
var createNonEnumerableProperty = __webpack_require__("abb2");
var hasOwn = __webpack_require__("80a8");
var shared = __webpack_require__("f499");
var sharedKey = __webpack_require__("411b");
var hiddenKeys = __webpack_require__("099b");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "5c75":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
;// CONCATENATED MODULE: ./src/common/command.js
/**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */
function command(type) {
  try {
    return document.execCommand(type);
  } catch (err) {
    return false;
  }
}
;// CONCATENATED MODULE: ./src/actions/cut.js


/**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */

var ClipboardActionCut = function ClipboardActionCut(target) {
  var selectedText = select_default()(target);
  command('cut');
  return selectedText;
};

/* harmony default export */ var actions_cut = (ClipboardActionCut);
;// CONCATENATED MODULE: ./src/common/create-fake-element.js
/**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */
function createFakeElement(value) {
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

  fakeElement.style.fontSize = '12pt'; // Reset box model

  fakeElement.style.border = '0';
  fakeElement.style.padding = '0';
  fakeElement.style.margin = '0'; // Move element out of screen horizontally

  fakeElement.style.position = 'absolute';
  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElement.style.top = "".concat(yPosition, "px");
  fakeElement.setAttribute('readonly', '');
  fakeElement.value = value;
  return fakeElement;
}
;// CONCATENATED MODULE: ./src/actions/copy.js



/**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */

var fakeCopyAction = function fakeCopyAction(value, options) {
  var fakeElement = createFakeElement(value);
  options.container.appendChild(fakeElement);
  var selectedText = select_default()(fakeElement);
  command('copy');
  fakeElement.remove();
  return selectedText;
};
/**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */


var ClipboardActionCopy = function ClipboardActionCopy(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    container: document.body
  };
  var selectedText = '';

  if (typeof target === 'string') {
    selectedText = fakeCopyAction(target, options);
  } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
    // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
    selectedText = fakeCopyAction(target.value, options);
  } else {
    selectedText = select_default()(target);
    command('copy');
  }

  return selectedText;
};

/* harmony default export */ var actions_copy = (ClipboardActionCopy);
;// CONCATENATED MODULE: ./src/actions/default.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */

var ClipboardActionDefault = function ClipboardActionDefault() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Defines base properties passed from constructor.
  var _options$action = options.action,
      action = _options$action === void 0 ? 'copy' : _options$action,
      container = options.container,
      target = options.target,
      text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

  if (action !== 'copy' && action !== 'cut') {
    throw new Error('Invalid "action" value, use either "copy" or "cut"');
  } // Sets the `target` property using an element that will be have its content copied.


  if (target !== undefined) {
    if (target && _typeof(target) === 'object' && target.nodeType === 1) {
      if (action === 'copy' && target.hasAttribute('disabled')) {
        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
      }

      if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
      }
    } else {
      throw new Error('Invalid "target" value, use a valid Element');
    }
  } // Define selection strategy based on `text` property.


  if (text) {
    return actions_copy(text, {
      container: container
    });
  } // Defines which selection strategy based on `target` property.


  if (target) {
    return action === 'cut' ? actions_cut(target) : actions_copy(target, {
      container: container
    });
  }
};

/* harmony default export */ var actions_default = (ClipboardActionDefault);
;// CONCATENATED MODULE: ./src/clipboard.js
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }






/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    _classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  _createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;
      var action = this.action(trigger) || 'copy';
      var text = actions_default({
        action: action,
        container: this.container,
        target: this.target(trigger),
        text: this.text(trigger)
      }); // Fires an event based on the copy operation result.

      this.emit(text ? 'success' : 'error', {
        action: action,
        text: text,
        trigger: trigger,
        clearSelection: function clearSelection() {
          if (trigger) {
            trigger.focus();
          }

          window.getSelection().removeAllRanges();
        }
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Allow fire programmatically a copy action
     * @param {String|HTMLElement} target
     * @param {Object} options
     * @returns Text copied.
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();
    }
  }], [{
    key: "copy",
    value: function copy(target) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        container: document.body
      };
      return actions_copy(target, options);
    }
    /**
     * Allow fire programmatically a cut action
     * @param {String|HTMLElement} target
     * @returns Text cutted.
     */

  }, {
    key: "cut",
    value: function cut(target) {
      return actions_cut(target);
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(686);
/******/ })()
.default;
});

/***/ }),

/***/ "5d7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "5dea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isVNode = isVNode;

var _util = __webpack_require__("f3b3");

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

/***/ }),

/***/ "5f67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "61b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "6297":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "638a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

/* harmony default export */ var tslib_es6 = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
});

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/@fingerprintjs+fingerprintjs@4.4.1/node_modules/@fingerprintjs/fingerprintjs/dist/fp.esm.js
/* unused harmony export componentsToDebugString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fp_esm_index; });
/* unused harmony export getFullscreenElement */
/* unused harmony export getUnstableAudioFingerprint */
/* unused harmony export getUnstableCanvasFingerprint */
/* unused harmony export getUnstableScreenFrame */
/* unused harmony export getUnstableScreenResolution */
/* unused harmony export getWebGLContext */
/* unused harmony export hashComponents */
/* unused harmony export isAndroid */
/* unused harmony export isChromium */
/* unused harmony export isDesktopWebKit */
/* unused harmony export isEdgeHTML */
/* unused harmony export isGecko */
/* unused harmony export isTrident */
/* unused harmony export isWebKit */
/* unused harmony export load */
/* unused harmony export loadSources */
/* unused harmony export murmurX64Hash128 */
/* unused harmony export prepareForSources */
/* unused harmony export sources */
/* unused harmony export transformSource */
/* unused harmony export withIframe */
/**
 * FingerprintJS v4.4.1 - Copyright (c) FingerprintJS, Inc, 2024 (https://fingerprint.com)
 *
 * Licensed under Business Source License 1.1 https://mariadb.com/bsl11/
 * Licensor: FingerprintJS, Inc.
 * Licensed Work: FingerprintJS browser fingerprinting library
 * Additional Use Grant: None
 * Change Date: Four years from first release for the specific version.
 * Change License: MIT, text at https://opensource.org/license/mit/ with the following copyright notice:
 * Copyright 2015-present FingerprintJS, Inc.
 */



var version = "4.4.1";

function wait(durationMs, resolveWith) {
    return new Promise(function (resolve) { return setTimeout(resolve, durationMs, resolveWith); });
}
/**
 * Allows asynchronous actions and microtasks to happen.
 */
function releaseEventLoop() {
    return wait(0);
}
function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
    if (deadlineTimeout === void 0) { deadlineTimeout = Infinity; }
    var requestIdleCallback = window.requestIdleCallback;
    if (requestIdleCallback) {
        // The function `requestIdleCallback` loses the binding to `window` here.
        // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
        // Therefore, an error can occur. `call(window,` prevents the error.
        return new Promise(function (resolve) { return requestIdleCallback.call(window, function () { return resolve(); }, { timeout: deadlineTimeout }); });
    }
    else {
        return wait(Math.min(fallbackTimeout, deadlineTimeout));
    }
}
function isPromise(value) {
    return !!value && typeof value.then === 'function';
}
/**
 * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
 * Catches errors in both cases.
 *
 * If just you run a code like this:
 * ```
 * console.time('Action duration')
 * await action()
 * console.timeEnd('Action duration')
 * ```
 * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
 * returns the control back to the code.
 */
function awaitIfAsync(action, callback) {
    try {
        var returnedValue = action();
        if (isPromise(returnedValue)) {
            returnedValue.then(function (result) { return callback(true, result); }, function (error) { return callback(false, error); });
        }
        else {
            callback(true, returnedValue);
        }
    }
    catch (error) {
        callback(false, error);
    }
}
/**
 * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
 * (e.g. completing a network request, rendering the page) won't be able to happen.
 * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
 */
function mapWithBreaks(items, callback, loopReleaseInterval) {
    if (loopReleaseInterval === void 0) { loopReleaseInterval = 16; }
    return __awaiter(this, void 0, void 0, function () {
        var results, lastLoopReleaseTime, i, now;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    results = Array(items.length);
                    lastLoopReleaseTime = Date.now();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < items.length)) return [3 /*break*/, 4];
                    results[i] = callback(items[i], i);
                    now = Date.now();
                    if (!(now >= lastLoopReleaseTime + loopReleaseInterval)) return [3 /*break*/, 3];
                    lastLoopReleaseTime = now;
                    // Allows asynchronous actions and microtasks to happen
                    return [4 /*yield*/, wait(0)];
                case 2:
                    // Allows asynchronous actions and microtasks to happen
                    _a.sent();
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, results];
            }
        });
    });
}
/**
 * Makes the given promise never emit an unhandled promise rejection console warning.
 * The promise will still pass errors to the next promises.
 *
 * Otherwise, promise emits a console warning unless it has a `catch` listener.
 */
function suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, function () { return undefined; });
}

/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */
/**
 * Does the same as Array.prototype.includes but has better typing
 */
function includes(haystack, needle) {
    for (var i = 0, l = haystack.length; i < l; ++i) {
        if (haystack[i] === needle) {
            return true;
        }
    }
    return false;
}
/**
 * Like `!includes()` but with proper typing
 */
function excludes(haystack, needle) {
    return !includes(haystack, needle);
}
/**
 * Be careful, NaN can return
 */
function toInt(value) {
    return parseInt(value);
}
/**
 * Be careful, NaN can return
 */
function toFloat(value) {
    return parseFloat(value);
}
function replaceNaN(value, replacement) {
    return typeof value === 'number' && isNaN(value) ? replacement : value;
}
function countTruthy(values) {
    return values.reduce(function (sum, value) { return sum + (value ? 1 : 0); }, 0);
}
function round(value, base) {
    if (base === void 0) { base = 1; }
    if (Math.abs(base) >= 1) {
        return Math.round(value / base) * base;
    }
    else {
        // Sometimes when a number is multiplied by a small number, precision is lost,
        // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
        var counterBase = 1 / base;
        return Math.round(value * counterBase) / counterBase;
    }
}
/**
 * Parses a CSS selector into tag name with HTML attributes.
 * Only single element selector are supported (without operators like space, +, >, etc).
 *
 * Multiple values can be returned for each attribute. You decide how to handle them.
 */
function parseSimpleCssSelector(selector) {
    var _a, _b;
    var errorMessage = "Unexpected syntax '".concat(selector, "'");
    var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    var tag = tagMatch[1] || undefined;
    var attributes = {};
    var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    var addAttribute = function (name, value) {
        attributes[name] = attributes[name] || [];
        attributes[name].push(value);
    };
    for (;;) {
        var match = partsRegex.exec(tagMatch[2]);
        if (!match) {
            break;
        }
        var part = match[0];
        switch (part[0]) {
            case '.':
                addAttribute('class', part.slice(1));
                break;
            case '#':
                addAttribute('id', part.slice(1));
                break;
            case '[': {
                var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                if (attributeMatch) {
                    addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : '');
                }
                else {
                    throw new Error(errorMessage);
                }
                break;
            }
            default:
                throw new Error(errorMessage);
        }
    }
    return [tag, attributes];
}
/**
 * Converts a string to UTF8 bytes
 */
function getUTF8Bytes(input) {
    // Benchmark: https://jsbench.me/b6klaaxgwq/1
    // If you want to just count bytes, see solutions at https://jsbench.me/ehklab415e/1
    var result = new Uint8Array(input.length);
    for (var i = 0; i < input.length; i++) {
        // `charCode` is faster than encoding, so we prefer that when it's possible
        var charCode = input.charCodeAt(i);
        // In case of non-ASCII symbols we use proper encoding
        if (charCode > 127) {
            return new TextEncoder().encode(input);
        }
        result[i] = charCode;
    }
    return result;
}

/*
 * Based on https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
 */
/**
 * Adds two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */
function x64Add(m, n) {
    var m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    var n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    var o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 + n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 + n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 + n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 + n0;
    o0 &= 0xffff;
    m[0] = (o0 << 16) | o1;
    m[1] = (o2 << 16) | o3;
}
/**
 * Multiplies two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */
function x64Multiply(m, n) {
    var m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    var n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    var o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 * n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 * n3;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o2 += m3 * n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 * n3;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m2 * n2;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m3 * n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 * n3 + m1 * n2 + m2 * n1 + m3 * n0;
    o0 &= 0xffff;
    m[0] = (o0 << 16) | o1;
    m[1] = (o2 << 16) | o3;
}
/**
 * Provides left rotation of the given int64 value (provided as tuple of two int32)
 * by given number of bits. Result is written back to the value
 */
function x64Rotl(m, bits) {
    var m0 = m[0];
    bits %= 64;
    if (bits === 32) {
        m[0] = m[1];
        m[1] = m0;
    }
    else if (bits < 32) {
        m[0] = (m0 << bits) | (m[1] >>> (32 - bits));
        m[1] = (m[1] << bits) | (m0 >>> (32 - bits));
    }
    else {
        bits -= 32;
        m[0] = (m[1] << bits) | (m0 >>> (32 - bits));
        m[1] = (m0 << bits) | (m[1] >>> (32 - bits));
    }
}
/**
 * Provides a left shift of the given int32 value (provided as tuple of [0, int32])
 * by given number of bits. Result is written back to the value
 */
function x64LeftShift(m, bits) {
    bits %= 64;
    if (bits === 0) {
        return;
    }
    else if (bits < 32) {
        m[0] = m[1] >>> (32 - bits);
        m[1] = m[1] << bits;
    }
    else {
        m[0] = m[1] << (bits - 32);
        m[1] = 0;
    }
}
/**
 * Provides a XOR of the given int64 values(provided as tuple of two int32).
 * Result is written back to the first value
 */
function x64Xor(m, n) {
    m[0] ^= n[0];
    m[1] ^= n[1];
}
var F1 = [0xff51afd7, 0xed558ccd];
var F2 = [0xc4ceb9fe, 0x1a85ec53];
/**
 * Calculates murmurHash3's final x64 mix of that block and writes result back to the input value.
 * (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
 * only place where we need to right shift 64bit ints.)
 */
function x64Fmix(h) {
    var shifted = [0, h[0] >>> 1];
    x64Xor(h, shifted);
    x64Multiply(h, F1);
    shifted[1] = h[0] >>> 1;
    x64Xor(h, shifted);
    x64Multiply(h, F2);
    shifted[1] = h[0] >>> 1;
    x64Xor(h, shifted);
}
var C1 = [0x87c37b91, 0x114253d5];
var C2 = [0x4cf5ad43, 0x2745937f];
var M$1 = [0, 5];
var N1 = [0, 0x52dce729];
var N2 = [0, 0x38495ab5];
/**
 * Given a string and an optional seed as an int, returns a 128 bit
 * hash using the x64 flavor of MurmurHash3, as an unsigned hex.
 * All internal functions mutates passed value to achieve minimal memory allocations and GC load
 *
 * Benchmark https://jsbench.me/p4lkpaoabi/1
 */
function x64hash128(input, seed) {
    var key = getUTF8Bytes(input);
    seed = seed || 0;
    var length = [0, key.length];
    var remainder = length[1] % 16;
    var bytes = length[1] - remainder;
    var h1 = [0, seed];
    var h2 = [0, seed];
    var k1 = [0, 0];
    var k2 = [0, 0];
    var i;
    for (i = 0; i < bytes; i = i + 16) {
        k1[0] = key[i + 4] | (key[i + 5] << 8) | (key[i + 6] << 16) | (key[i + 7] << 24);
        k1[1] = key[i] | (key[i + 1] << 8) | (key[i + 2] << 16) | (key[i + 3] << 24);
        k2[0] = key[i + 12] | (key[i + 13] << 8) | (key[i + 14] << 16) | (key[i + 15] << 24);
        k2[1] = key[i + 8] | (key[i + 9] << 8) | (key[i + 10] << 16) | (key[i + 11] << 24);
        x64Multiply(k1, C1);
        x64Rotl(k1, 31);
        x64Multiply(k1, C2);
        x64Xor(h1, k1);
        x64Rotl(h1, 27);
        x64Add(h1, h2);
        x64Multiply(h1, M$1);
        x64Add(h1, N1);
        x64Multiply(k2, C2);
        x64Rotl(k2, 33);
        x64Multiply(k2, C1);
        x64Xor(h2, k2);
        x64Rotl(h2, 31);
        x64Add(h2, h1);
        x64Multiply(h2, M$1);
        x64Add(h2, N2);
    }
    k1[0] = 0;
    k1[1] = 0;
    k2[0] = 0;
    k2[1] = 0;
    var val = [0, 0];
    switch (remainder) {
        case 15:
            val[1] = key[i + 14];
            x64LeftShift(val, 48);
            x64Xor(k2, val);
        // fallthrough
        case 14:
            val[1] = key[i + 13];
            x64LeftShift(val, 40);
            x64Xor(k2, val);
        // fallthrough
        case 13:
            val[1] = key[i + 12];
            x64LeftShift(val, 32);
            x64Xor(k2, val);
        // fallthrough
        case 12:
            val[1] = key[i + 11];
            x64LeftShift(val, 24);
            x64Xor(k2, val);
        // fallthrough
        case 11:
            val[1] = key[i + 10];
            x64LeftShift(val, 16);
            x64Xor(k2, val);
        // fallthrough
        case 10:
            val[1] = key[i + 9];
            x64LeftShift(val, 8);
            x64Xor(k2, val);
        // fallthrough
        case 9:
            val[1] = key[i + 8];
            x64Xor(k2, val);
            x64Multiply(k2, C2);
            x64Rotl(k2, 33);
            x64Multiply(k2, C1);
            x64Xor(h2, k2);
        // fallthrough
        case 8:
            val[1] = key[i + 7];
            x64LeftShift(val, 56);
            x64Xor(k1, val);
        // fallthrough
        case 7:
            val[1] = key[i + 6];
            x64LeftShift(val, 48);
            x64Xor(k1, val);
        // fallthrough
        case 6:
            val[1] = key[i + 5];
            x64LeftShift(val, 40);
            x64Xor(k1, val);
        // fallthrough
        case 5:
            val[1] = key[i + 4];
            x64LeftShift(val, 32);
            x64Xor(k1, val);
        // fallthrough
        case 4:
            val[1] = key[i + 3];
            x64LeftShift(val, 24);
            x64Xor(k1, val);
        // fallthrough
        case 3:
            val[1] = key[i + 2];
            x64LeftShift(val, 16);
            x64Xor(k1, val);
        // fallthrough
        case 2:
            val[1] = key[i + 1];
            x64LeftShift(val, 8);
            x64Xor(k1, val);
        // fallthrough
        case 1:
            val[1] = key[i];
            x64Xor(k1, val);
            x64Multiply(k1, C1);
            x64Rotl(k1, 31);
            x64Multiply(k1, C2);
            x64Xor(h1, k1);
        // fallthrough
    }
    x64Xor(h1, length);
    x64Xor(h2, length);
    x64Add(h1, h2);
    x64Add(h2, h1);
    x64Fmix(h1);
    x64Fmix(h2);
    x64Add(h1, h2);
    x64Add(h2, h1);
    return (('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8));
}

/**
 * Converts an error object to a plain object that can be used with `JSON.stringify`.
 * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
 */
function errorToObject(error) {
    var _a;
    return __assign({ name: error.name, message: error.message, stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split('\n') }, error);
}
function isFunctionNative(func) {
    return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(func));
}

function isFinalResultLoaded(loadResult) {
    return typeof loadResult !== 'function';
}
/**
 * Loads the given entropy source. Returns a function that gets an entropy component from the source.
 *
 * The result is returned synchronously to prevent `loadSources` from
 * waiting for one source to load before getting the components from the other sources.
 */
function loadSource(source, sourceOptions) {
    var sourceLoadPromise = new Promise(function (resolveLoad) {
        var loadStartTime = Date.now();
        // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
        // correctly (other microtasks won't affect the duration).
        awaitIfAsync(source.bind(null, sourceOptions), function () {
            var loadArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                loadArgs[_i] = arguments[_i];
            }
            var loadDuration = Date.now() - loadStartTime;
            // Source loading failed
            if (!loadArgs[0]) {
                return resolveLoad(function () { return ({ error: loadArgs[1], duration: loadDuration }); });
            }
            var loadResult = loadArgs[1];
            // Source loaded with the final result
            if (isFinalResultLoaded(loadResult)) {
                return resolveLoad(function () { return ({ value: loadResult, duration: loadDuration }); });
            }
            // Source loaded with "get" stage
            resolveLoad(function () {
                return new Promise(function (resolveGet) {
                    var getStartTime = Date.now();
                    awaitIfAsync(loadResult, function () {
                        var getArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            getArgs[_i] = arguments[_i];
                        }
                        var duration = loadDuration + Date.now() - getStartTime;
                        // Source getting failed
                        if (!getArgs[0]) {
                            return resolveGet({ error: getArgs[1], duration: duration });
                        }
                        // Source getting succeeded
                        resolveGet({ value: getArgs[1], duration: duration });
                    });
                });
            });
        });
    });
    suppressUnhandledRejectionWarning(sourceLoadPromise);
    return function getComponent() {
        return sourceLoadPromise.then(function (finalizeSource) { return finalizeSource(); });
    };
}
/**
 * Loads the given entropy sources. Returns a function that collects the entropy components.
 *
 * The result is returned synchronously in order to allow start getting the components
 * before the sources are loaded completely.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function loadSources(sources, sourceOptions, excludeSources) {
    var includedSources = Object.keys(sources).filter(function (sourceKey) { return excludes(excludeSources, sourceKey); });
    // Using `mapWithBreaks` allows asynchronous sources to complete between synchronous sources
    // and measure the duration correctly
    var sourceGettersPromise = mapWithBreaks(includedSources, function (sourceKey) {
        return loadSource(sources[sourceKey], sourceOptions);
    });
    suppressUnhandledRejectionWarning(sourceGettersPromise);
    return function getComponents() {
        return __awaiter(this, void 0, void 0, function () {
            var sourceGetters, componentPromises, componentArray, components, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sourceGettersPromise];
                    case 1:
                        sourceGetters = _a.sent();
                        return [4 /*yield*/, mapWithBreaks(sourceGetters, function (sourceGetter) {
                                var componentPromise = sourceGetter();
                                suppressUnhandledRejectionWarning(componentPromise);
                                return componentPromise;
                            })];
                    case 2:
                        componentPromises = _a.sent();
                        return [4 /*yield*/, Promise.all(componentPromises)
                            // Keeping the component keys order the same as the source keys order
                        ];
                    case 3:
                        componentArray = _a.sent();
                        components = {};
                        for (index = 0; index < includedSources.length; ++index) {
                            components[includedSources[index]] = componentArray[index];
                        }
                        return [2 /*return*/, components];
                }
            });
        });
    };
}
/**
 * Modifies an entropy source by transforming its returned value with the given function.
 * Keeps the source properties: sync/async, 1/2 stages.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function transformSource(source, transformValue) {
    var transformLoadResult = function (loadResult) {
        if (isFinalResultLoaded(loadResult)) {
            return transformValue(loadResult);
        }
        return function () {
            var getResult = loadResult();
            if (isPromise(getResult)) {
                return getResult.then(transformValue);
            }
            return transformValue(getResult);
        };
    };
    return function (options) {
        var loadResult = source(options);
        if (isPromise(loadResult)) {
            return loadResult.then(transformLoadResult);
        }
        return transformLoadResult(loadResult);
    };
}

/*
 * Functions to help with features that vary through browsers
 */
/**
 * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isTrident() {
    var w = window;
    var n = navigator;
    // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
    return (countTruthy([
        'MSCSSMatrix' in w,
        'msSetImmediate' in w,
        'msIndexedDB' in w,
        'msMaxTouchPoints' in n,
        'msPointerEnabled' in n,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isEdgeHTML() {
    // Based on research in October 2020
    var w = window;
    var n = navigator;
    return (countTruthy(['msWriteProfilerMark' in w, 'MSStream' in w, 'msLaunchUri' in n, 'msSaveBlob' in n]) >= 3 &&
        !isTrident());
}
/**
 * Checks whether the browser is based on Chromium without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isChromium() {
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    var w = window;
    var n = navigator;
    return (countTruthy([
        'webkitPersistentStorage' in n,
        'webkitTemporaryStorage' in n,
        n.vendor.indexOf('Google') === 0,
        'webkitResolveLocalFileSystemURL' in w,
        'BatteryManager' in w,
        'webkitMediaStream' in w,
        'webkitSpeechGrammar' in w,
    ]) >= 5);
}
/**
 * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
 * All iOS browsers use WebKit (the Safari engine).
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isWebKit() {
    // Based on research in September 2020
    var w = window;
    var n = navigator;
    return (countTruthy([
        'ApplePayError' in w,
        'CSSPrimitiveValue' in w,
        'Counter' in w,
        n.vendor.indexOf('Apple') === 0,
        'getStorageUpdates' in n,
        'WebKitMediaKeys' in w,
    ]) >= 4);
}
/**
 * Checks whether this WebKit browser is a desktop browser.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isDesktopWebKit() {
    // Checked in Safari and DuckDuckGo
    var w = window;
    var HTMLElement = w.HTMLElement, Document = w.Document;
    return (countTruthy([
        'safari' in w,
        !('ongestureend' in w),
        !('TouchEvent' in w),
        !('orientation' in w),
        HTMLElement && !('autocapitalize' in HTMLElement.prototype),
        Document && 'pointerLockElement' in Document.prototype,
    ]) >= 4);
}
/**
 * Checks whether this WebKit browser is Safari.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning! The function works properly only for Safari version 15 and newer.
 */
function isSafariWebKit() {
    // Checked in Safari, Chrome, Firefox, Yandex, UC Browser, Opera, Edge and DuckDuckGo.
    // iOS Safari and Chrome were checked on iOS 11-17. DuckDuckGo was checked on iOS 17 and macOS 14.
    // Desktop Safari versions 12-17 were checked.
    // The other browsers were checked on iOS 17; there was no chance to check them on the other OS versions.
    var w = window;
    if (!isFunctionNative(w.print)) {
        return false; // Chrome, Firefox, Yandex, DuckDuckGo macOS, Edge
    }
    return (countTruthy([
        // Incorrect in Safari <= 14 (iOS and macOS)
        String(w.browser) === '[object WebPageNamespace]',
        // Incorrect in desktop Safari and iOS Safari <= 15
        'MicrodataExtractor' in w,
    ]) >= 1);
}
/**
 * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isGecko() {
    var _a, _b;
    var w = window;
    // Based on research in September 2020
    return (countTruthy([
        'buildID' in navigator,
        'MozAppearance' in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
        'onmozfullscreenchange' in w,
        'mozInnerScreenX' in w,
        'CSSMozDocumentRule' in w,
        'CanvasCaptureMediaStream' in w,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */
function isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
    var w = window;
    return (countTruthy([
        !('MediaSettingsRange' in w),
        'RTCEncodedAudioFrame' in w,
        '' + w.Intl === '[object Intl]',
        '' + w.Reflect === '[object Reflect]',
    ]) >= 3);
}
/**
 * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
 */
function isWebKit606OrNewer() {
    // Checked in Safari 9–17
    var w = window;
    return (countTruthy([
        'DOMRectList' in w,
        'RTCPeerConnectionIceEvent' in w,
        'SVGGeometryElement' in w,
        'ontransitioncancel' in w,
    ]) >= 3);
}
/**
 * Checks whether the browser is based on WebKit version ≥616 (Safari ≥17) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://developer.apple.com/documentation/safari-release-notes/safari-17-release-notes Safari 17 release notes
 * @see https://tauri.app/v1/references/webview-versions/#webkit-versions-in-safari Safari-WebKit versions map
 */
function isWebKit616OrNewer() {
    var w = window;
    var n = navigator;
    var CSS = w.CSS, HTMLButtonElement = w.HTMLButtonElement;
    return (countTruthy([
        !('getStorageUpdates' in n),
        HTMLButtonElement && 'popover' in HTMLButtonElement.prototype,
        'CSSCounterStyleRule' in w,
        CSS.supports('font-size-adjust: ex-height 0.5'),
        CSS.supports('text-transform: full-width'),
    ]) >= 4);
}
/**
 * Checks whether the device is an iPad.
 * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
 */
function isIPad() {
    // Checked on:
    // Safari on iPadOS (both mobile and desktop modes): 8, 11-17
    // Chrome on iPadOS (both mobile and desktop modes): 11-17
    // Safari on iOS (both mobile and desktop modes): 9-17
    // Chrome on iOS (both mobile and desktop modes): 9-17
    // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
    if (navigator.platform === 'iPad') {
        return true;
    }
    var s = screen;
    var screenRatio = s.width / s.height;
    return (countTruthy([
        'MediaSource' in window,
        !!Element.prototype.webkitRequestFullscreen,
        // iPhone 4S that runs iOS 9 matches this, but it is not supported
        screenRatio > 0.65 && screenRatio < 1.53,
    ]) >= 2);
}
/**
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getFullscreenElement() {
    var d = document;
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function exitFullscreen() {
    var d = document;
    // `call` is required because the function throws an error without a proper "this" context
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
/**
 * Checks whether the device runs on Android without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isAndroid() {
    var isItChromium = isChromium();
    var isItGecko = isGecko();
    var w = window;
    var n = navigator;
    var c = 'connection';
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    if (isItChromium) {
        return (countTruthy([
            !('SharedWorker' in w),
            // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
            // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
            // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
            n[c] && 'ontypechange' in n[c],
            !('sinkId' in new window.Audio()),
        ]) >= 2);
    }
    else if (isItGecko) {
        return countTruthy(['onorientationchange' in w, 'orientation' in w, /android/i.test(navigator.appVersion)]) >= 2;
    }
    else {
        // Only 2 browser engines are presented on Android.
        // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
        return false;
    }
}

/**
 * A deep description: https://fingerprint.com/blog/audio-fingerprinting/
 * Inspired by and based on https://github.com/cozylife/audio-fingerprint
 *
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * Audio signal is noised in private mode of Safari 17, so audio fingerprinting is skipped in Safari 17.
 */
function getAudioFingerprint() {
    if (doesBrowserPerformAntifingerprinting$1()) {
        return -4 /* SpecialFingerprint.KnownForAntifingerprinting */;
    }
    return getUnstableAudioFingerprint();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getUnstableAudioFingerprint() {
    var w = window;
    var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
    if (!AudioContext) {
        return -2 /* SpecialFingerprint.NotSupported */;
    }
    // In some browsers, audio context always stays suspended unless the context is started in response to a user action
    // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
    // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
    // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
    if (doesBrowserSuspendAudioContext()) {
        return -1 /* SpecialFingerprint.KnownForSuspending */;
    }
    var hashFromIndex = 4500;
    var hashToIndex = 5000;
    var context = new AudioContext(1, hashToIndex, 44100);
    var oscillator = context.createOscillator();
    oscillator.type = 'triangle';
    oscillator.frequency.value = 10000;
    var compressor = context.createDynamicsCompressor();
    compressor.threshold.value = -50;
    compressor.knee.value = 40;
    compressor.ratio.value = 12;
    compressor.attack.value = 0;
    compressor.release.value = 0.25;
    oscillator.connect(compressor);
    compressor.connect(context.destination);
    oscillator.start(0);
    var _a = startRenderingAudio(context), renderPromise = _a[0], finishRendering = _a[1];
    var fingerprintPromise = renderPromise.then(function (buffer) { return getHash(buffer.getChannelData(0).subarray(hashFromIndex)); }, function (error) {
        if (error.name === "timeout" /* InnerErrorName.Timeout */ || error.name === "suspended" /* InnerErrorName.Suspended */) {
            return -3 /* SpecialFingerprint.Timeout */;
        }
        throw error;
    });
    // Suppresses the console error message in case when the fingerprint fails before requested
    suppressUnhandledRejectionWarning(fingerprintPromise);
    return function () {
        finishRendering();
        return fingerprintPromise;
    };
}
/**
 * Checks if the current browser is known for always suspending audio context
 */
function doesBrowserSuspendAudioContext() {
    // Mobile Safari 11 and older
    return isWebKit() && !isDesktopWebKit() && !isWebKit606OrNewer();
}
/**
 * Checks if the current browser is known for applying anti-fingerprinting measures in all or some critical modes
 */
function doesBrowserPerformAntifingerprinting$1() {
    // Safari 17
    return isWebKit() && isWebKit616OrNewer() && isSafariWebKit();
}
/**
 * Starts rendering the audio context.
 * When the returned function is called, the render process starts finishing.
 */
function startRenderingAudio(context) {
    var renderTryMaxCount = 3;
    var renderRetryDelay = 500;
    var runningMaxAwaitTime = 500;
    var runningSufficientTime = 5000;
    var finalize = function () { return undefined; };
    var resultPromise = new Promise(function (resolve, reject) {
        var isFinalized = false;
        var renderTryCount = 0;
        var startedRunningAt = 0;
        context.oncomplete = function (event) { return resolve(event.renderedBuffer); };
        var startRunningTimeout = function () {
            setTimeout(function () { return reject(makeInnerError("timeout" /* InnerErrorName.Timeout */)); }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
        };
        var tryRender = function () {
            try {
                var renderingPromise = context.startRendering();
                // `context.startRendering` has two APIs: Promise and callback, we check that it's really a promise just in case
                if (isPromise(renderingPromise)) {
                    // Suppresses all unhadled rejections in case of scheduled redundant retries after successful rendering
                    suppressUnhandledRejectionWarning(renderingPromise);
                }
                switch (context.state) {
                    case 'running':
                        startedRunningAt = Date.now();
                        if (isFinalized) {
                            startRunningTimeout();
                        }
                        break;
                    // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                    // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                    // background on iPhone. Retries usually help in this case.
                    case 'suspended':
                        // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                        // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                        // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                        // can be suspended when `document.hidden === false` and start running after a retry.
                        if (!document.hidden) {
                            renderTryCount++;
                        }
                        if (isFinalized && renderTryCount >= renderTryMaxCount) {
                            reject(makeInnerError("suspended" /* InnerErrorName.Suspended */));
                        }
                        else {
                            setTimeout(tryRender, renderRetryDelay);
                        }
                        break;
                }
            }
            catch (error) {
                reject(error);
            }
        };
        tryRender();
        finalize = function () {
            if (!isFinalized) {
                isFinalized = true;
                if (startedRunningAt > 0) {
                    startRunningTimeout();
                }
            }
        };
    });
    return [resultPromise, finalize];
}
function getHash(signal) {
    var hash = 0;
    for (var i = 0; i < signal.length; ++i) {
        hash += Math.abs(signal[i]);
    }
    return hash;
}
function makeInnerError(name) {
    var error = new Error(name);
    error.name = name;
    return error;
}

/**
 * Creates and keeps an invisible iframe while the given function runs.
 * The given function is called when the iframe is loaded and has a body.
 * The iframe allows to measure DOM sizes inside itself.
 *
 * Notice: passing an initial HTML code doesn't work in IE.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function withIframe(action, initialHtml, domPollInterval) {
    var _a, _b, _c;
    if (domPollInterval === void 0) { domPollInterval = 50; }
    return __awaiter(this, void 0, void 0, function () {
        var d, iframe;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    d = document;
                    _d.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 1];
                case 3:
                    iframe = d.createElement('iframe');
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, , 10, 11]);
                    return [4 /*yield*/, new Promise(function (_resolve, _reject) {
                            var isComplete = false;
                            var resolve = function () {
                                isComplete = true;
                                _resolve();
                            };
                            var reject = function (error) {
                                isComplete = true;
                                _reject(error);
                            };
                            iframe.onload = resolve;
                            iframe.onerror = reject;
                            var style = iframe.style;
                            style.setProperty('display', 'block', 'important'); // Required for browsers to calculate the layout
                            style.position = 'absolute';
                            style.top = '0';
                            style.left = '0';
                            style.visibility = 'hidden';
                            if (initialHtml && 'srcdoc' in iframe) {
                                iframe.srcdoc = initialHtml;
                            }
                            else {
                                iframe.src = 'about:blank';
                            }
                            d.body.appendChild(iframe);
                            // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
                            // This code checks for the loading state manually.
                            // See https://github.com/fingerprintjs/fingerprintjs/issues/645
                            var checkReadyState = function () {
                                var _a, _b;
                                // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                                // So an infinite setTimeout loop can happen without this check.
                                // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                                if (isComplete) {
                                    return;
                                }
                                // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                                // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                                if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === 'complete') {
                                    resolve();
                                }
                                else {
                                    setTimeout(checkReadyState, 10);
                                }
                            };
                            checkReadyState();
                        })];
                case 5:
                    _d.sent();
                    _d.label = 6;
                case 6:
                    if (!!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body)) return [3 /*break*/, 8];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 7:
                    _d.sent();
                    return [3 /*break*/, 6];
                case 8: return [4 /*yield*/, action(iframe, iframe.contentWindow)];
                case 9: return [2 /*return*/, _d.sent()];
                case 10:
                    (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    });
}
/**
 * Creates a DOM element that matches the given selector.
 * Only single element selector are supported (without operators like space, +, >, etc).
 */
function selectorToElement(selector) {
    var _a = parseSimpleCssSelector(selector), tag = _a[0], attributes = _a[1];
    var element = document.createElement(tag !== null && tag !== void 0 ? tag : 'div');
    for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
        var name_1 = _b[_i];
        var value = attributes[name_1].join(' ');
        // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
        // https://github.com/fingerprintjs/fingerprintjs/issues/733
        if (name_1 === 'style') {
            addStyleString(element.style, value);
        }
        else {
            element.setAttribute(name_1, value);
        }
    }
    return element;
}
/**
 * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
 */
function addStyleString(style, source) {
    // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
    // Even though the browsers ignore this standard, we don't use `cssText` just in case.
    for (var _i = 0, _a = source.split(';'); _i < _a.length; _i++) {
        var property = _a[_i];
        var match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
        if (match) {
            var name_2 = match[1], value = match[2], priority = match[4];
            style.setProperty(name_2, value, priority || ''); // The last argument can't be undefined in IE11
        }
    }
}

// We use m or w because these two characters take up the maximum width.
// And we use a LLi so that the same matching fonts can get separated.
var testString = 'mmMwWLliI0O&1';
// We test using 48px font size, we may use any size. I guess larger the better.
var textSize = '48px';
// A font will be compared against all the three default fonts.
// And if for any default fonts it doesn't match, then that font is available.
var baseFonts = ['monospace', 'sans-serif', 'serif'];
var fontList = [
    // This is android-specific font from "Roboto" family
    'sans-serif-thin',
    'ARNO PRO',
    'Agency FB',
    'Arabic Typesetting',
    'Arial Unicode MS',
    'AvantGarde Bk BT',
    'BankGothic Md BT',
    'Batang',
    'Bitstream Vera Sans Mono',
    'Calibri',
    'Century',
    'Century Gothic',
    'Clarendon',
    'EUROSTILE',
    'Franklin Gothic',
    'Futura Bk BT',
    'Futura Md BT',
    'GOTHAM',
    'Gill Sans',
    'HELV',
    'Haettenschweiler',
    'Helvetica Neue',
    'Humanst521 BT',
    'Leelawadee',
    'Letter Gothic',
    'Levenim MT',
    'Lucida Bright',
    'Lucida Sans',
    'Menlo',
    'MS Mincho',
    'MS Outlook',
    'MS Reference Specialty',
    'MS UI Gothic',
    'MT Extra',
    'MYRIAD PRO',
    'Marlett',
    'Meiryo UI',
    'Microsoft Uighur',
    'Minion Pro',
    'Monotype Corsiva',
    'PMingLiU',
    'Pristina',
    'SCRIPTINA',
    'Segoe UI Light',
    'Serifa',
    'SimHei',
    'Small Fonts',
    'Staccato222 BT',
    'TRAJAN PRO',
    'Univers CE 55 Medium',
    'Vrinda',
    'ZWAdobeF',
];
// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
function getFonts() {
    var _this = this;
    // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
    // https://github.com/fingerprintjs/fingerprintjs/issues/592
    // https://github.com/fingerprintjs/fingerprintjs/issues/628
    return withIframe(function (_, _a) {
        var document = _a.document;
        return __awaiter(_this, void 0, void 0, function () {
            var holder, spansContainer, defaultWidth, defaultHeight, createSpan, createSpanWithFonts, initializeBaseFontsSpans, initializeFontsSpans, isFontAvailable, baseFontsSpans, fontsSpans, index;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        holder = document.body;
                        holder.style.fontSize = textSize;
                        spansContainer = document.createElement('div');
                        spansContainer.style.setProperty('visibility', 'hidden', 'important');
                        defaultWidth = {};
                        defaultHeight = {};
                        createSpan = function (fontFamily) {
                            var span = document.createElement('span');
                            var style = span.style;
                            style.position = 'absolute';
                            style.top = '0';
                            style.left = '0';
                            style.fontFamily = fontFamily;
                            span.textContent = testString;
                            spansContainer.appendChild(span);
                            return span;
                        };
                        createSpanWithFonts = function (fontToDetect, baseFont) {
                            return createSpan("'".concat(fontToDetect, "',").concat(baseFont));
                        };
                        initializeBaseFontsSpans = function () {
                            return baseFonts.map(createSpan);
                        };
                        initializeFontsSpans = function () {
                            // Stores {fontName : [spans for that font]}
                            var spans = {};
                            var _loop_1 = function (font) {
                                spans[font] = baseFonts.map(function (baseFont) { return createSpanWithFonts(font, baseFont); });
                            };
                            for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
                                var font = fontList_1[_i];
                                _loop_1(font);
                            }
                            return spans;
                        };
                        isFontAvailable = function (fontSpans) {
                            return baseFonts.some(function (baseFont, baseFontIndex) {
                                return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
                                    fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
                            });
                        };
                        baseFontsSpans = initializeBaseFontsSpans();
                        fontsSpans = initializeFontsSpans();
                        // add all the spans to the DOM
                        holder.appendChild(spansContainer);
                        return [4 /*yield*/, releaseEventLoop()
                            // get the default width for the three base fonts
                        ];
                    case 1:
                        _b.sent();
                        // get the default width for the three base fonts
                        for (index = 0; index < baseFonts.length; index++) {
                            defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
                            defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
                        }
                        // check available fonts
                        return [2 /*return*/, fontList.filter(function (font) { return isFontAvailable(fontsSpans[font]); })];
                }
            });
        });
    });
}

function getPlugins() {
    var rawPlugins = navigator.plugins;
    if (!rawPlugins) {
        return undefined;
    }
    var plugins = [];
    // Safari 10 doesn't support iterating navigator.plugins with for...of
    for (var i = 0; i < rawPlugins.length; ++i) {
        var plugin = rawPlugins[i];
        if (!plugin) {
            continue;
        }
        var mimeTypes = [];
        for (var j = 0; j < plugin.length; ++j) {
            var mimeType = plugin[j];
            mimeTypes.push({
                type: mimeType.type,
                suffixes: mimeType.suffixes,
            });
        }
        plugins.push({
            name: plugin.name,
            description: plugin.description,
            mimeTypes: mimeTypes,
        });
    }
    return plugins;
}

/**
 * @see https://www.browserleaks.com/canvas#how-does-it-work
 *
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * Canvas image is noised in private mode of Safari 17, so image rendering is skipped in Safari 17.
 */
function getCanvasFingerprint() {
    return getUnstableCanvasFingerprint(doesBrowserPerformAntifingerprinting());
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getUnstableCanvasFingerprint(skipImages) {
    return __awaiter(this, void 0, void 0, function () {
        var winding, geometry, text, _a, canvas, context;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    winding = false;
                    _a = makeCanvasContext(), canvas = _a[0], context = _a[1];
                    if (!!isSupported(canvas, context)) return [3 /*break*/, 1];
                    geometry = text = "unsupported" /* ImageStatus.Unsupported */;
                    return [3 /*break*/, 4];
                case 1:
                    winding = doesSupportWinding(context);
                    if (!skipImages) return [3 /*break*/, 2];
                    geometry = text = "skipped" /* ImageStatus.Skipped */;
                    return [3 /*break*/, 4];
                case 2:
                    return [4 /*yield*/, renderImages(canvas, context)];
                case 3:
                    _b = _c.sent(), geometry = _b[0], text = _b[1];
                    _c.label = 4;
                case 4: return [2 /*return*/, { winding: winding, geometry: geometry, text: text }];
            }
        });
    });
}
function makeCanvasContext() {
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return [canvas, canvas.getContext('2d')];
}
function isSupported(canvas, context) {
    return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, 'evenodd');
}
function renderImages(canvas, context) {
    return __awaiter(this, void 0, void 0, function () {
        var textImage1, textImage2, geometryImage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    renderTextImage(canvas, context);
                    return [4 /*yield*/, releaseEventLoop()];
                case 1:
                    _a.sent();
                    textImage1 = canvasToString(canvas);
                    textImage2 = canvasToString(canvas) // It's slightly faster to double-encode the text image
                    ;
                    // Some browsers add a noise to the canvas: https://github.com/fingerprintjs/fingerprintjs/issues/791
                    // The canvas is excluded from the fingerprint in this case
                    if (textImage1 !== textImage2) {
                        return [2 /*return*/, ["unstable" /* ImageStatus.Unstable */, "unstable" /* ImageStatus.Unstable */]];
                    }
                    // Text is unstable:
                    // https://github.com/fingerprintjs/fingerprintjs/issues/583
                    // https://github.com/fingerprintjs/fingerprintjs/issues/103
                    // Therefore it's extracted into a separate image.
                    renderGeometryImage(canvas, context);
                    return [4 /*yield*/, releaseEventLoop()];
                case 2:
                    _a.sent();
                    geometryImage = canvasToString(canvas);
                    return [2 /*return*/, [geometryImage, textImage1]];
            }
        });
    });
}
function renderTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = 'alphabetic';
    context.fillStyle = '#f60';
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = '#069';
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    var printedText = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835) /* 😃 */);
    context.fillText(printedText, 2, 15);
    context.fillStyle = 'rgba(102, 204, 0, 0.2)';
    context.font = '18pt Arial';
    context.fillText(printedText, 4, 45);
}
function renderGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = 'multiply';
    for (var _i = 0, _a = [
        ['#f2f', 40, 40],
        ['#2ff', 80, 40],
        ['#ff2', 60, 80],
    ]; _i < _a.length; _i++) {
        var _b = _a[_i], color = _b[0], x = _b[1], y = _b[2];
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = '#f9c';
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill('evenodd');
}
function canvasToString(canvas) {
    return canvas.toDataURL();
}
/**
 * Checks if the current browser is known for applying anti-fingerprinting measures in all or some critical modes
 */
function doesBrowserPerformAntifingerprinting() {
    // Safari 17
    return isWebKit() && isWebKit616OrNewer() && isSafariWebKit();
}

/**
 * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
 * of a touch screen with a JS, without actually subscribing to a touch event.
 *
 * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
 * @see https://github.com/Modernizr/Modernizr/issues/548
 */
function getTouchSupport() {
    var n = navigator;
    var maxTouchPoints = 0;
    var touchEvent;
    if (n.maxTouchPoints !== undefined) {
        maxTouchPoints = toInt(n.maxTouchPoints);
    }
    else if (n.msMaxTouchPoints !== undefined) {
        maxTouchPoints = n.msMaxTouchPoints;
    }
    try {
        document.createEvent('TouchEvent');
        touchEvent = true;
    }
    catch (_a) {
        touchEvent = false;
    }
    var touchStart = 'ontouchstart' in window;
    return {
        maxTouchPoints: maxTouchPoints,
        touchEvent: touchEvent,
        touchStart: touchStart,
    };
}

function getOsCpu() {
    return navigator.oscpu;
}

function getLanguages() {
    var n = navigator;
    var result = [];
    var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
        result.push([language]);
    }
    if (Array.isArray(n.languages)) {
        // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
        // the value of `navigator.language`. Therefore the value is ignored in this browser.
        if (!(isChromium() && isChromium86OrNewer())) {
            result.push(n.languages);
        }
    }
    else if (typeof n.languages === 'string') {
        var languages = n.languages;
        if (languages) {
            result.push(languages.split(','));
        }
    }
    return result;
}

function getColorDepth() {
    return window.screen.colorDepth;
}

function getDeviceMemory() {
    // `navigator.deviceMemory` is a string containing a number in some unidentified cases
    return replaceNaN(toFloat(navigator.deviceMemory), undefined);
}

/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * The window resolution is always the document size in private mode of Safari 17,
 * so the window resolution is not used in Safari 17.
 */
function getScreenResolution() {
    if (isWebKit() && isWebKit616OrNewer() && isSafariWebKit()) {
        return undefined;
    }
    return getUnstableScreenResolution();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getUnstableScreenResolution() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    // Some browsers even return  screen resolution as not numbers.
    var parseDimension = function (value) { return replaceNaN(toInt(value), null); };
    var dimensions = [parseDimension(s.width), parseDimension(s.height)];
    dimensions.sort().reverse();
    return dimensions;
}

var screenFrameCheckInterval = 2500;
var roundingPrecision = 10;
// The type is readonly to protect from unwanted mutations
var screenFrameBackup;
var screenFrameSizeTimeoutId;
/**
 * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
 * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
 *
 * This trick is required to mitigate the fact that the screen frame turns null in some cases.
 * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
 */
function watchScreenFrame() {
    if (screenFrameSizeTimeoutId !== undefined) {
        return;
    }
    var checkScreenFrame = function () {
        var frameSize = getCurrentScreenFrame();
        if (isFrameSizeNull(frameSize)) {
            screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
        }
        else {
            screenFrameBackup = frameSize;
            screenFrameSizeTimeoutId = undefined;
        }
    };
    checkScreenFrame();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getUnstableScreenFrame() {
    var _this = this;
    watchScreenFrame();
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var frameSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    frameSize = getCurrentScreenFrame();
                    if (!isFrameSizeNull(frameSize)) return [3 /*break*/, 2];
                    if (screenFrameBackup) {
                        return [2 /*return*/, __spreadArray([], screenFrameBackup, true)];
                    }
                    if (!getFullscreenElement()) return [3 /*break*/, 2];
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    return [4 /*yield*/, exitFullscreen()];
                case 1:
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    _a.sent();
                    frameSize = getCurrentScreenFrame();
                    _a.label = 2;
                case 2:
                    if (!isFrameSizeNull(frameSize)) {
                        screenFrameBackup = frameSize;
                    }
                    return [2 /*return*/, frameSize];
            }
        });
    }); };
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 *
 * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
 * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
 *
 * The frame width is always 0 in private mode of Safari 17, so the frame is not used in Safari 17.
 */
function getScreenFrame() {
    var _this = this;
    if (isWebKit() && isWebKit616OrNewer() && isSafariWebKit()) {
        return function () { return Promise.resolve(undefined); };
    }
    var screenFrameGetter = getUnstableScreenFrame();
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var frameSize, processSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, screenFrameGetter()];
                case 1:
                    frameSize = _a.sent();
                    processSize = function (sideSize) { return (sideSize === null ? null : round(sideSize, roundingPrecision)); };
                    // It might look like I don't know about `for` and `map`.
                    // In fact, such code is used to avoid TypeScript issues without using `as`.
                    return [2 /*return*/, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
            }
        });
    }); };
}
function getCurrentScreenFrame() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    //
    // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
    // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
    return [
        replaceNaN(toFloat(s.availTop), null),
        replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
        replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
        replaceNaN(toFloat(s.availLeft), null),
    ];
}
function isFrameSizeNull(frameSize) {
    for (var i = 0; i < 4; ++i) {
        if (frameSize[i]) {
            return false;
        }
    }
    return true;
}

function getHardwareConcurrency() {
    // sometimes hardware concurrency is a string
    return replaceNaN(toInt(navigator.hardwareConcurrency), undefined);
}

function getTimezone() {
    var _a;
    var DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
        var timezone = new DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) {
            return timezone;
        }
    }
    // For browsers that don't support timezone names
    // The minus is intentional because the JS offset is opposite to the real offset
    var offset = -getTimezoneOffset();
    return "UTC".concat(offset >= 0 ? '+' : '').concat(offset);
}
function getTimezoneOffset() {
    var currentYear = new Date().getFullYear();
    // The timezone offset may change over time due to daylight saving time (DST) shifts.
    // The non-DST timezone offset is used as the result timezone offset.
    // Since the DST season differs in the northern and the southern hemispheres,
    // both January and July timezones offsets are considered.
    return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}

function getSessionStorage() {
    try {
        return !!window.sessionStorage;
    }
    catch (error) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
function getLocalStorage() {
    try {
        return !!window.localStorage;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getIndexedDB() {
    // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
    // visitor identifier in normal and private modes.
    if (isTrident() || isEdgeHTML()) {
        return undefined;
    }
    try {
        return !!window.indexedDB;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getOpenDatabase() {
    return !!window.openDatabase;
}

function getCpuClass() {
    return navigator.cpuClass;
}

function getPlatform() {
    // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
    var platform = navigator.platform;
    // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
    // iPad uses desktop mode by default since iOS 13
    // The value is 'MacIntel' on M1 Macs
    // The value is 'iPhone' on iPod Touch
    if (platform === 'MacIntel') {
        if (isWebKit() && !isDesktopWebKit()) {
            return isIPad() ? 'iPad' : 'iPhone';
        }
    }
    return platform;
}

function getVendor() {
    return navigator.vendor || '';
}

/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */
function getVendorFlavors() {
    var flavors = [];
    for (var _i = 0, _a = [
        // Blink and some browsers on iOS
        'chrome',
        // Safari on macOS
        'safari',
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        '__crWeb',
        '__gCrWeb',
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        'yandex',
        // Yandex Browser on iOS (checked in 21.2 on 14)
        '__yb',
        '__ybro',
        // Firefox on iOS (checked in 32 on 14)
        '__firefox__',
        // Edge on iOS (checked in 46 on 14)
        '__edgeTrackingPreventionStatistics',
        'webkit',
        // Opera Touch on iOS (checked in 2.6 on 14)
        'oprt',
        // Samsung Internet on Android (checked in 11.1)
        'samsungAr',
        // UC Browser on Android (checked in 12.10 and 13.0)
        'ucweb',
        'UCShellJava',
        // Puffin on Android (checked in 9.0)
        'puffinDevice',
        // UC on iOS and Opera on Android have no specific global variables
        // Edge for Android isn't checked
    ]; _i < _a.length; _i++) {
        var key = _a[_i];
        var value = window[key];
        if (value && typeof value === 'object') {
            flavors.push(key);
        }
    }
    return flavors.sort();
}

/**
 * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
 * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
 * site-specific exceptions. Don't rely on it.
 *
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
 */
function areCookiesEnabled() {
    var d = document;
    // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
    // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
    // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
    // with site-specific exceptions. Don't rely on it.
    // try..catch because some in situations `document.cookie` is exposed but throws a
    // SecurityError if you try to access it; e.g. documents created from data URIs
    // or in sandboxed iframes (depending on flags/context)
    try {
        // Create cookie
        d.cookie = 'cookietest=1; SameSite=Strict;';
        var result = d.cookie.indexOf('cookietest=') !== -1;
        // Delete cookie
        d.cookie = 'cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return result;
    }
    catch (e) {
        return false;
    }
}

/**
 * Only single element selector are supported (no operators like space, +, >, etc).
 * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
 * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
 *
 * The "inappropriate" selectors are obfuscated. See https://github.com/fingerprintjs/fingerprintjs/issues/734.
 * A function is used instead of a plain object to help tree-shaking.
 *
 * The function code is generated automatically. See docs/content_blockers.md to learn how to make the list.
 */
function getFilters() {
    var fromB64 = atob; // Just for better minification
    return {
        abpIndo: [
            '#Iklan-Melayang',
            '#Kolom-Iklan-728',
            '#SidebarIklan-wrapper',
            '[title="ALIENBOLA" i]',
            fromB64('I0JveC1CYW5uZXItYWRz'),
        ],
        abpvn: ['.quangcao', '#mobileCatfish', fromB64('LmNsb3NlLWFkcw=='), '[id^="bn_bottom_fixed_"]', '#pmadv'],
        adBlockFinland: [
            '.mainostila',
            fromB64('LnNwb25zb3JpdA=='),
            '.ylamainos',
            fromB64('YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd'),
        ],
        adBlockPersian: [
            '#navbar_notice_50',
            '.kadr',
            'TABLE[width="140px"]',
            '#divAgahi',
            fromB64('YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd'),
        ],
        adBlockWarningRemoval: [
            '#adblock-honeypot',
            '.adblocker-root',
            '.wp_adblock_detect',
            fromB64('LmhlYWRlci1ibG9ja2VkLWFk'),
            fromB64('I2FkX2Jsb2NrZXI='),
        ],
        adGuardAnnoyances: [
            '.hs-sosyal',
            '#cookieconsentdiv',
            'div[class^="app_gdpr"]',
            '.as-oil',
            '[data-cypress="soft-push-notification-modal"]',
        ],
        adGuardBase: [
            '.BetterJsPopOverlay',
            fromB64('I2FkXzMwMFgyNTA='),
            fromB64('I2Jhbm5lcmZsb2F0MjI='),
            fromB64('I2NhbXBhaWduLWJhbm5lcg=='),
            fromB64('I0FkLUNvbnRlbnQ='),
        ],
        adGuardChinese: [
            fromB64('LlppX2FkX2FfSA=='),
            fromB64('YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd'),
            '#widget-quan',
            fromB64('YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd'),
            fromB64('YVtocmVmKj0iLjE5NTZobC5jb20vIl0='),
        ],
        adGuardFrench: [
            '#pavePub',
            fromB64('LmFkLWRlc2t0b3AtcmVjdGFuZ2xl'),
            '.mobile_adhesion',
            '.widgetadv',
            fromB64('LmFkc19iYW4='),
        ],
        adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
        adGuardJapanese: [
            '#kauli_yad_1',
            fromB64('YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0='),
            fromB64('Ll9wb3BJbl9pbmZpbml0ZV9hZA=='),
            fromB64('LmFkZ29vZ2xl'),
            fromB64('Ll9faXNib29zdFJldHVybkFk'),
        ],
        adGuardMobile: [
            fromB64('YW1wLWF1dG8tYWRz'),
            fromB64('LmFtcF9hZA=='),
            'amp-embed[type="24smi"]',
            '#mgid_iframe1',
            fromB64('I2FkX2ludmlld19hcmVh'),
        ],
        adGuardRussian: [
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0='),
            fromB64('LnJlY2xhbWE='),
            'div[id^="smi2adblock"]',
            fromB64('ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd'),
            '#psyduckpockeball',
        ],
        adGuardSocial: [
            fromB64('YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0='),
            fromB64('YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0='),
            '.etsy-tweet',
            '#inlineShare',
            '.popup-social',
        ],
        adGuardSpanishPortuguese: ['#barraPublicidade', '#Publicidade', '#publiEspecial', '#queTooltip', '.cnt-publi'],
        adGuardTrackingProtection: [
            '#qoo-counter',
            fromB64('YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=='),
            fromB64('YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0='),
            fromB64('YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=='),
            '#top100counter',
        ],
        adGuardTurkish: [
            '#backkapat',
            fromB64('I3Jla2xhbWk='),
            fromB64('YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0='),
            fromB64('YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd'),
            fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ=='),
        ],
        bulgarian: [fromB64('dGQjZnJlZW5ldF90YWJsZV9hZHM='), '#ea_intext_div', '.lapni-pop-over', '#xenium_hot_offers'],
        easyList: [
            '.yb-floorad',
            fromB64('LndpZGdldF9wb19hZHNfd2lkZ2V0'),
            fromB64('LnRyYWZmaWNqdW5reS1hZA=='),
            '.textad_headline',
            fromB64('LnNwb25zb3JlZC10ZXh0LWxpbmtz'),
        ],
        easyListChina: [
            fromB64('LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=='),
            fromB64('LmZyb250cGFnZUFkdk0='),
            '#taotaole',
            '#aafoot.top_box',
            '.cfa_popup',
        ],
        easyListCookie: [
            '.ezmob-footer',
            '.cc-CookieWarning',
            '[data-cookie-number]',
            fromB64('LmF3LWNvb2tpZS1iYW5uZXI='),
            '.sygnal24-gdpr-modal-wrap',
        ],
        easyListCzechSlovak: [
            '#onlajny-stickers',
            fromB64('I3Jla2xhbW5pLWJveA=='),
            fromB64('LnJla2xhbWEtbWVnYWJvYXJk'),
            '.sklik',
            fromB64('W2lkXj0ic2tsaWtSZWtsYW1hIl0='),
        ],
        easyListDutch: [
            fromB64('I2FkdmVydGVudGll'),
            fromB64('I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=='),
            '.adstekst',
            fromB64('YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0='),
            '#semilo-lrectangle',
        ],
        easyListGermany: [
            '#SSpotIMPopSlider',
            fromB64('LnNwb25zb3JsaW5rZ3J1ZW4='),
            fromB64('I3dlcmJ1bmdza3k='),
            fromB64('I3Jla2xhbWUtcmVjaHRzLW1pdHRl'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0='),
        ],
        easyListItaly: [
            fromB64('LmJveF9hZHZfYW5udW5jaQ=='),
            '.sb-box-pubbliredazionale',
            fromB64('YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ=='),
        ],
        easyListLithuania: [
            fromB64('LnJla2xhbW9zX3RhcnBhcw=='),
            fromB64('LnJla2xhbW9zX251b3JvZG9z'),
            fromB64('aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd'),
            fromB64('aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd'),
            fromB64('aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd'),
        ],
        estonian: [fromB64('QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==')],
        fanboyAnnoyances: ['#ac-lre-player', '.navigate-to-top', '#subscribe_popup', '.newsletter_holder', '#back-top'],
        fanboyAntiFacebook: ['.util-bar-module-firefly-visible'],
        fanboyEnhancedTrackers: [
            '.open.pushModal',
            '#issuem-leaky-paywall-articles-zero-remaining-nag',
            '#sovrn_container',
            'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
            '.BlockNag__Card',
        ],
        fanboySocial: ['#FollowUs', '#meteored_share', '#social_follow', '.article-sharer', '.community__social-desc'],
        frellwitSwedish: [
            fromB64('YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=='),
            fromB64('YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=='),
            'article.category-samarbete',
            fromB64('ZGl2LmhvbGlkQWRz'),
            'ul.adsmodern',
        ],
        greekAdBlock: [
            fromB64('QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd'),
            fromB64('QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=='),
            fromB64('QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd'),
            'DIV.agores300',
            'TABLE.advright',
        ],
        hungarian: [
            '#cemp_doboz',
            '.optimonk-iframe-container',
            fromB64('LmFkX19tYWlu'),
            fromB64('W2NsYXNzKj0iR29vZ2xlQWRzIl0='),
            '#hirdetesek_box',
        ],
        iDontCareAboutCookies: [
            '.alert-info[data-block-track*="CookieNotice"]',
            '.ModuleTemplateCookieIndicator',
            '.o--cookies--container',
            '#cookies-policy-sticky',
            '#stickyCookieBar',
        ],
        icelandicAbp: [fromB64('QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==')],
        latvian: [
            fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0O' +
                'iA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0='),
            fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6I' +
                'DMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=='),
        ],
        listKr: [
            fromB64('YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0='),
            fromB64('I2xpdmVyZUFkV3JhcHBlcg=='),
            fromB64('YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=='),
            fromB64('aW5zLmZhc3R2aWV3LWFk'),
            '.revenue_unit_item.dable',
        ],
        listeAr: [
            fromB64('LmdlbWluaUxCMUFk'),
            '.right-and-left-sponsers',
            fromB64('YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=='),
            fromB64('YVtocmVmKj0iYm9vcmFxLm9yZyJd'),
            fromB64('YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd'),
        ],
        listeFr: [
            fromB64('YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=='),
            fromB64('I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=='),
            fromB64('YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0='),
            '.site-pub-interstitiel',
            'div[id^="crt-"][data-criteo-id]',
        ],
        officialPolish: [
            '#ceneo-placeholder-ceneo-12',
            fromB64('W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd'),
            fromB64('YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=='),
            fromB64('YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=='),
            fromB64('ZGl2I3NrYXBpZWNfYWQ='),
        ],
        ro: [
            fromB64('YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0='),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd'),
            'a[href^="/url/"]',
        ],
        ruAd: [
            fromB64('YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd'),
            fromB64('YVtocmVmKj0iLy91dGltZy5ydS8iXQ=='),
            fromB64('YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0='),
            '#pgeldiz',
            '.yandex-rtb-block',
        ],
        thaiAds: [
            'a[href*=macau-uta-popup]',
            fromB64('I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=='),
            fromB64('LmFkczMwMHM='),
            '.bumq',
            '.img-kosana',
        ],
        webAnnoyancesUltralist: [
            '#mod-social-share-2',
            '#social-tools',
            fromB64('LmN0cGwtZnVsbGJhbm5lcg=='),
            '.zergnet-recommend',
            '.yt.btn-link.btn-md.btn',
        ],
    };
}
/**
 * The order of the returned array means nothing (it's always sorted alphabetically).
 *
 * Notice that the source is slightly unstable.
 * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
 * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
 * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
 * If you are a website owner, don't make your visitors want to disable content blockers.
 */
function getDomBlockers(_a) {
    var _b = _a === void 0 ? {} : _a, debug = _b.debug;
    return __awaiter(this, void 0, void 0, function () {
        var filters, filterNames, allSelectors, blockedSelectors, activeBlockers;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!isApplicable()) {
                        return [2 /*return*/, undefined];
                    }
                    filters = getFilters();
                    filterNames = Object.keys(filters);
                    allSelectors = (_c = []).concat.apply(_c, filterNames.map(function (filterName) { return filters[filterName]; }));
                    return [4 /*yield*/, getBlockedSelectors(allSelectors)];
                case 1:
                    blockedSelectors = _d.sent();
                    if (debug) {
                        printDebug(filters, blockedSelectors);
                    }
                    activeBlockers = filterNames.filter(function (filterName) {
                        var selectors = filters[filterName];
                        var blockedCount = countTruthy(selectors.map(function (selector) { return blockedSelectors[selector]; }));
                        return blockedCount > selectors.length * 0.6;
                    });
                    activeBlockers.sort();
                    return [2 /*return*/, activeBlockers];
            }
        });
    });
}
function isApplicable() {
    // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
    return isWebKit() || isAndroid();
}
function getBlockedSelectors(selectors) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var d, root, elements, blockedSelectors, i, element, holder, i;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    d = document;
                    root = d.createElement('div');
                    elements = new Array(selectors.length);
                    blockedSelectors = {} // Set() isn't used just in case somebody need older browser support
                    ;
                    forceShow(root);
                    // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
                    // browser will alternate tree modification and layout reading, that is very slow.
                    for (i = 0; i < selectors.length; ++i) {
                        element = selectorToElement(selectors[i]);
                        if (element.tagName === 'DIALOG') {
                            element.show();
                        }
                        holder = d.createElement('div') // Protects from unwanted effects of `+` and `~` selectors of filters
                        ;
                        forceShow(holder);
                        holder.appendChild(element);
                        root.appendChild(holder);
                        elements[i] = element;
                    }
                    _b.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(50)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 1];
                case 3:
                    d.body.appendChild(root);
                    return [4 /*yield*/, releaseEventLoop()];
                case 4:
                    _b.sent();
                    try {
                        // Then check which of the elements are blocked
                        for (i = 0; i < selectors.length; ++i) {
                            if (!elements[i].offsetParent) {
                                blockedSelectors[selectors[i]] = true;
                            }
                        }
                    }
                    finally {
                        // Then remove the elements
                        (_a = root.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(root);
                    }
                    return [2 /*return*/, blockedSelectors];
            }
        });
    });
}
function forceShow(element) {
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('display', 'block', 'important');
}
function printDebug(filters, blockedSelectors) {
    var message = 'DOM blockers debug:\n```';
    for (var _i = 0, _a = Object.keys(filters); _i < _a.length; _i++) {
        var filterName = _a[_i];
        message += "\n".concat(filterName, ":");
        for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
            var selector = _c[_b];
            message += "\n  ".concat(blockedSelectors[selector] ? '🚫' : '➡️', " ").concat(selector);
        }
    }
    // console.log is ok here because it's under a debug clause
    // eslint-disable-next-line no-console
    console.log("".concat(message, "\n```"));
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */
function getColorGamut() {
    // rec2020 includes p3 and p3 includes srgb
    for (var _i = 0, _a = ['rec2020', 'p3', 'srgb']; _i < _a.length; _i++) {
        var gamut = _a[_i];
        if (matchMedia("(color-gamut: ".concat(gamut, ")")).matches) {
            return gamut;
        }
    }
    return undefined;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
 */
function areColorsInverted() {
    if (doesMatch$5('inverted')) {
        return true;
    }
    if (doesMatch$5('none')) {
        return false;
    }
    return undefined;
}
function doesMatch$5(value) {
    return matchMedia("(inverted-colors: ".concat(value, ")")).matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
 */
function areColorsForced() {
    if (doesMatch$4('active')) {
        return true;
    }
    if (doesMatch$4('none')) {
        return false;
    }
    return undefined;
}
function doesMatch$4(value) {
    return matchMedia("(forced-colors: ".concat(value, ")")).matches;
}

var maxValueToCheck = 100;
/**
 * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
 * If the display is not monochrome, the returned value will be 0.
 * If the browser doesn't support this feature, the returned value will be undefined.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
 */
function getMonochromeDepth() {
    if (!matchMedia('(min-monochrome: 0)').matches) {
        // The media feature isn't supported by the browser
        return undefined;
    }
    // A variation of binary search algorithm can be used here.
    // But since expected values are very small (≤10), there is no sense in adding the complexity.
    for (var i = 0; i <= maxValueToCheck; ++i) {
        if (matchMedia("(max-monochrome: ".concat(i, ")")).matches) {
            return i;
        }
    }
    throw new Error('Too high value');
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
 */
function getContrastPreference() {
    if (doesMatch$3('no-preference')) {
        return 0 /* ContrastPreference.None */;
    }
    // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
    // Need to check it when all browsers implement the feature.
    if (doesMatch$3('high') || doesMatch$3('more')) {
        return 1 /* ContrastPreference.More */;
    }
    if (doesMatch$3('low') || doesMatch$3('less')) {
        return -1 /* ContrastPreference.Less */;
    }
    if (doesMatch$3('forced')) {
        return 10 /* ContrastPreference.ForcedColors */;
    }
    return undefined;
}
function doesMatch$3(value) {
    return matchMedia("(prefers-contrast: ".concat(value, ")")).matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
function isMotionReduced() {
    if (doesMatch$2('reduce')) {
        return true;
    }
    if (doesMatch$2('no-preference')) {
        return false;
    }
    return undefined;
}
function doesMatch$2(value) {
    return matchMedia("(prefers-reduced-motion: ".concat(value, ")")).matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-transparency
 */
function isTransparencyReduced() {
    if (doesMatch$1('reduce')) {
        return true;
    }
    if (doesMatch$1('no-preference')) {
        return false;
    }
    return undefined;
}
function doesMatch$1(value) {
    return matchMedia("(prefers-reduced-transparency: ".concat(value, ")")).matches;
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
 */
function isHDR() {
    if (doesMatch('high')) {
        return true;
    }
    if (doesMatch('standard')) {
        return false;
    }
    return undefined;
}
function doesMatch(value) {
    return matchMedia("(dynamic-range: ".concat(value, ")")).matches;
}

var M = Math; // To reduce the minified code size
var fallbackFn = function () { return 0; };
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */
function getMathFingerprint() {
    // Native operations
    var acos = M.acos || fallbackFn;
    var acosh = M.acosh || fallbackFn;
    var asin = M.asin || fallbackFn;
    var asinh = M.asinh || fallbackFn;
    var atanh = M.atanh || fallbackFn;
    var atan = M.atan || fallbackFn;
    var sin = M.sin || fallbackFn;
    var sinh = M.sinh || fallbackFn;
    var cos = M.cos || fallbackFn;
    var cosh = M.cosh || fallbackFn;
    var tan = M.tan || fallbackFn;
    var tanh = M.tanh || fallbackFn;
    var exp = M.exp || fallbackFn;
    var expm1 = M.expm1 || fallbackFn;
    var log1p = M.log1p || fallbackFn;
    // Operation polyfills
    var powPI = function (value) { return M.pow(M.PI, value); };
    var acoshPf = function (value) { return M.log(value + M.sqrt(value * value - 1)); };
    var asinhPf = function (value) { return M.log(value + M.sqrt(value * value + 1)); };
    var atanhPf = function (value) { return M.log((1 + value) / (1 - value)) / 2; };
    var sinhPf = function (value) { return M.exp(value) - 1 / M.exp(value) / 2; };
    var coshPf = function (value) { return (M.exp(value) + 1 / M.exp(value)) / 2; };
    var expm1Pf = function (value) { return M.exp(value) - 1; };
    var tanhPf = function (value) { return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1); };
    var log1pPf = function (value) { return M.log(1 + value); };
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1e300),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1e300),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100),
    };
}

/**
 * We use m or w because these two characters take up the maximum width.
 * Also there are a couple of ligatures.
 */
var defaultText = 'mmMwWLliI0fiflO&1';
/**
 * Settings of text blocks to measure. The keys are random but persistent words.
 */
var presets = {
    /**
     * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
     * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
     */
    default: [],
    /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
    apple: [{ font: '-apple-system-body' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    serif: [{ fontFamily: 'serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    sans: [{ fontFamily: 'sans-serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    mono: [{ fontFamily: 'monospace' }],
    /**
     * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
     * The height can be 0 in Chrome on a retina display.
     */
    min: [{ fontSize: '1px' }],
    /** Tells one OS from another in desktop Chrome. */
    system: [{ fontFamily: 'system-ui' }],
};
/**
 * The result is a dictionary of the width of the text samples.
 * Heights aren't included because they give no extra entropy and are unstable.
 *
 * The result is very stable in IE 11, Edge 18 and Safari 14.
 * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
 * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
 * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
 */
function getFontPreferences() {
    return withNaturalFonts(function (document, container) {
        var elements = {};
        var sizes = {};
        // First create all elements to measure. If the DOM steps below are done in a single cycle,
        // browser will alternate tree modification and layout reading, that is very slow.
        for (var _i = 0, _a = Object.keys(presets); _i < _a.length; _i++) {
            var key = _a[_i];
            var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
            var element = document.createElement('span');
            element.textContent = text;
            element.style.whiteSpace = 'nowrap';
            for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
                var name_1 = _f[_e];
                var value = style[name_1];
                if (value !== undefined) {
                    element.style[name_1] = value;
                }
            }
            elements[key] = element;
            container.append(document.createElement('br'), element);
        }
        // Then measure the created elements
        for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
            var key = _h[_g];
            sizes[key] = elements[key].getBoundingClientRect().width;
        }
        return sizes;
    });
}
/**
 * Creates a DOM environment that provides the most natural font available, including Android OS font.
 * Measurements of the elements are zoom-independent.
 * Don't put a content to measure inside an absolutely positioned element.
 */
function withNaturalFonts(action, containerWidthPx) {
    if (containerWidthPx === void 0) { containerWidthPx = 4000; }
    /*
     * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
     * - The iframe mustn't have a `display: none;` style;
     * - The text mustn't be positioned absolutely;
     * - The text block must be wide enough.
     *   2560px on some devices in portrait orientation for the biggest font size option (32px);
     * - There must be much enough text to form a few lines (I don't know the exact numbers);
     * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
     *
     * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
     * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
     *   The only way to set it is to use the `srcdoc` attribute of the iframe;
     * - The iframe content must get loaded before adding extra content with JavaScript;
     *
     * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
     *
     * Observations on how page zoom affects the measurements:
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
     * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
     * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
     * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - iOS Safari 14.0: offsetWidth = 100% reliable;
     * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
     * - Chrome 87: offsetWidth = 1px fluctuation;
     * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
     * - Firefox 48, 51: offsetWidth = 10% fluctuation;
     * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
     *   fluctuation;
     * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
     * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
     *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
     *   fluctuate;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
     * - IE 11, Edge 18: offsetWidth = 100% reliable;
     * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
     */
    return withIframe(function (_, iframeWindow) {
        var iframeDocument = iframeWindow.document;
        var iframeBody = iframeDocument.body;
        var bodyStyle = iframeBody.style;
        bodyStyle.width = "".concat(containerWidthPx, "px");
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = 'none';
        // See the big comment above
        if (isChromium()) {
            iframeBody.style.zoom = "".concat(1 / iframeWindow.devicePixelRatio);
        }
        else if (isWebKit()) {
            iframeBody.style.zoom = 'reset';
        }
        // See the big comment above
        var linesOfText = iframeDocument.createElement('div');
        linesOfText.textContent = __spreadArray([], Array((containerWidthPx / 20) << 0), true).map(function () { return 'word'; }).join(' ');
        iframeBody.appendChild(linesOfText);
        return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}

function isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
}

/**
 * Unlike most other architectures, on x86/x86-64 when floating-point instructions
 * have no NaN arguments, but produce NaN output, the output NaN has sign bit set.
 * We use it to distinguish x86/x86-64 from other architectures, by doing subtraction
 * of two infinities (must produce NaN per IEEE 754 standard).
 *
 * See https://codebrowser.bddppq.com/pytorch/pytorch/third_party/XNNPACK/src/init.c.html#79
 */
function getArchitecture() {
    var f = new Float32Array(1);
    var u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
}

/**
 * The return type is a union instead of the enum, because it's too challenging to embed the const enum into another
 * project. Turning it into a union is a simple and an elegant solution.
 */
function getApplePayState() {
    var ApplePaySession = window.ApplePaySession;
    if (typeof (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : ApplePaySession.canMakePayments) !== 'function') {
        return -1 /* ApplePayState.NoAPI */;
    }
    try {
        return ApplePaySession.canMakePayments() ? 1 /* ApplePayState.Enabled */ : 0 /* ApplePayState.Disabled */;
    }
    catch (error) {
        return getStateFromError(error);
    }
}
function getStateFromError(error) {
    if (error instanceof Error) {
        // See full expected error messages in the test
        if (error.name === 'InvalidAccessError') {
            if (/\bfrom\b.*\binsecure\b/i.test(error.message)) {
                return -2 /* ApplePayState.NotAvailableInInsecureContext */;
            }
            if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(error.message)) {
                return -3 /* ApplePayState.NotAvailableInFrame */;
            }
        }
        if (error.name === 'SecurityError') {
            if (/\bthird.party iframes?.*\bnot.allowed\b/i.test(error.message)) {
                return -3 /* ApplePayState.NotAvailableInFrame */;
            }
        }
    }
    throw error;
}

/**
 * Checks whether the Safari's Privacy Preserving Ad Measurement setting is on.
 * The setting is on when the value is not undefined.
 * A.k.a. private click measurement, privacy-preserving ad attribution.
 *
 * Unfortunately, it doesn't work in mobile Safari.
 * Probably, it will start working in mobile Safari or stop working in desktop Safari later.
 * We've found no way to detect the setting state in mobile Safari. Help wanted.
 *
 * @see https://webkit.org/blog/11529/introducing-private-click-measurement-pcm/
 * @see https://developer.apple.com/videos/play/wwdc2021/10033
 */
function getPrivateClickMeasurement() {
    var _a;
    var link = document.createElement('a');
    var sourceId = (_a = link.attributionSourceId) !== null && _a !== void 0 ? _a : link.attributionsourceid;
    return sourceId === undefined ? undefined : String(sourceId);
}

/** WebGl context is not available */
var STATUS_NO_GL_CONTEXT = -1;
/** WebGL context `getParameter` method is not a function */
var STATUS_GET_PARAMETER_NOT_A_FUNCTION = -2;
var validContextParameters = new Set([
    10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961, 2962, 2963, 2964, 2965, 2966, 2967, 2968,
    2978, 3024, 3042, 3088, 3089, 3106, 3107, 32773, 32777, 32777, 32823, 32824, 32936, 32937, 32938, 32939, 32968, 32969,
    32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902, 34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414,
    3415, 34467, 34816, 34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739, 36003, 36004, 36005,
    36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937, 7938,
    // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
    // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]);
var validExtensionParams = new Set([
    34047,
    35723,
    36063,
    34852,
    34853,
    34854,
    34229,
    36392,
    36795,
    38449, // MAX_VIEWS_OVR
]);
var shaderTypes = ['FRAGMENT_SHADER', 'VERTEX_SHADER'];
var precisionTypes = ['LOW_FLOAT', 'MEDIUM_FLOAT', 'HIGH_FLOAT', 'LOW_INT', 'MEDIUM_INT', 'HIGH_INT'];
var rendererInfoExtensionName = 'WEBGL_debug_renderer_info';
var polygonModeExtensionName = 'WEBGL_polygon_mode';
/**
 * Gets the basic and simple WebGL parameters
 */
function getWebGlBasics(_a) {
    var _b, _c, _d, _e, _f, _g;
    var cache = _a.cache;
    var gl = getWebGLContext(cache);
    if (!gl) {
        return STATUS_NO_GL_CONTEXT;
    }
    if (!isValidParameterGetter(gl)) {
        return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    }
    var debugExtension = shouldAvoidDebugRendererInfo() ? null : gl.getExtension(rendererInfoExtensionName);
    return {
        version: ((_b = gl.getParameter(gl.VERSION)) === null || _b === void 0 ? void 0 : _b.toString()) || '',
        vendor: ((_c = gl.getParameter(gl.VENDOR)) === null || _c === void 0 ? void 0 : _c.toString()) || '',
        vendorUnmasked: debugExtension ? (_d = gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)) === null || _d === void 0 ? void 0 : _d.toString() : '',
        renderer: ((_e = gl.getParameter(gl.RENDERER)) === null || _e === void 0 ? void 0 : _e.toString()) || '',
        rendererUnmasked: debugExtension ? (_f = gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)) === null || _f === void 0 ? void 0 : _f.toString() : '',
        shadingLanguageVersion: ((_g = gl.getParameter(gl.SHADING_LANGUAGE_VERSION)) === null || _g === void 0 ? void 0 : _g.toString()) || '',
    };
}
/**
 * Gets the advanced and massive WebGL parameters and extensions
 */
function getWebGlExtensions(_a) {
    var cache = _a.cache;
    var gl = getWebGLContext(cache);
    if (!gl) {
        return STATUS_NO_GL_CONTEXT;
    }
    if (!isValidParameterGetter(gl)) {
        return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    }
    var extensions = gl.getSupportedExtensions();
    var contextAttributes = gl.getContextAttributes();
    // Features
    var attributes = [];
    var parameters = [];
    var extensionParameters = [];
    var shaderPrecisions = [];
    // Context attributes
    if (contextAttributes) {
        for (var _i = 0, _b = Object.keys(contextAttributes); _i < _b.length; _i++) {
            var attributeName = _b[_i];
            attributes.push("".concat(attributeName, "=").concat(contextAttributes[attributeName]));
        }
    }
    // Context parameters
    var constants = getConstantsFromPrototype(gl);
    for (var _c = 0, constants_1 = constants; _c < constants_1.length; _c++) {
        var constant = constants_1[_c];
        var code = gl[constant];
        parameters.push("".concat(constant, "=").concat(code).concat(validContextParameters.has(code) ? "=".concat(gl.getParameter(code)) : ''));
    }
    // Extension parameters
    if (extensions) {
        for (var _d = 0, extensions_1 = extensions; _d < extensions_1.length; _d++) {
            var name_1 = extensions_1[_d];
            if ((name_1 === rendererInfoExtensionName && shouldAvoidDebugRendererInfo()) ||
                (name_1 === polygonModeExtensionName && shouldAvoidPolygonModeExtensions())) {
                continue;
            }
            var extension = gl.getExtension(name_1);
            if (!extension) {
                continue;
            }
            for (var _e = 0, _f = getConstantsFromPrototype(extension); _e < _f.length; _e++) {
                var constant = _f[_e];
                var code = extension[constant];
                extensionParameters.push("".concat(constant, "=").concat(code).concat(validExtensionParams.has(code) ? "=".concat(gl.getParameter(code)) : ''));
            }
        }
    }
    // Shader precision
    for (var _g = 0, shaderTypes_1 = shaderTypes; _g < shaderTypes_1.length; _g++) {
        var shaderType = shaderTypes_1[_g];
        for (var _h = 0, precisionTypes_1 = precisionTypes; _h < precisionTypes_1.length; _h++) {
            var precisionType = precisionTypes_1[_h];
            var shaderPrecision = getShaderPrecision(gl, shaderType, precisionType);
            shaderPrecisions.push("".concat(shaderType, ".").concat(precisionType, "=").concat(shaderPrecision.join(',')));
        }
    }
    // Postprocess
    extensionParameters.sort();
    parameters.sort();
    return {
        contextAttributes: attributes,
        parameters: parameters,
        shaderPrecisions: shaderPrecisions,
        extensions: extensions,
        extensionParameters: extensionParameters,
    };
}
/**
 * This function usually takes the most time to execute in all the sources, therefore we cache its result.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getWebGLContext(cache) {
    if (cache.webgl) {
        return cache.webgl.context;
    }
    var canvas = document.createElement('canvas');
    var context;
    canvas.addEventListener('webglCreateContextError', function () { return (context = undefined); });
    for (var _i = 0, _a = ['webgl', 'experimental-webgl']; _i < _a.length; _i++) {
        var type = _a[_i];
        try {
            context = canvas.getContext(type);
        }
        catch (_b) {
            // Ok, continue
        }
        if (context) {
            break;
        }
    }
    cache.webgl = { context: context };
    return context;
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLShaderPrecisionFormat
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getShaderPrecisionFormat
 * https://www.khronos.org/registry/webgl/specs/latest/1.0/#5.12
 */
function getShaderPrecision(gl, shaderType, precisionType) {
    var shaderPrecision = gl.getShaderPrecisionFormat(gl[shaderType], gl[precisionType]);
    return shaderPrecision ? [shaderPrecision.rangeMin, shaderPrecision.rangeMax, shaderPrecision.precision] : [];
}
function getConstantsFromPrototype(obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var keys = Object.keys(obj.__proto__);
    return keys.filter(isConstantLike);
}
function isConstantLike(key) {
    return typeof key === 'string' && !key.match(/[^A-Z0-9_x]/);
}
/**
 * Some browsers print a console warning when the WEBGL_debug_renderer_info extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */
function shouldAvoidDebugRendererInfo() {
    return isGecko();
}
/**
 * Some browsers print a console warning when the WEBGL_polygon_mode extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */
function shouldAvoidPolygonModeExtensions() {
    return isChromium() || isWebKit();
}
/**
 * Some unknown browsers have no `getParameter` method
 */
function isValidParameterGetter(gl) {
    return typeof gl.getParameter === 'function';
}

function getAudioContextBaseLatency() {
    var _a;
    // The signal emits warning in Chrome and Firefox, therefore it is enabled on Safari where it doesn't produce warning
    // and on Android where it's less visible
    var isAllowedPlatform = isAndroid() || isWebKit();
    if (!isAllowedPlatform) {
        return -2 /* SpecialFingerprint.Disabled */;
    }
    if (!window.AudioContext) {
        return -1 /* SpecialFingerprint.NotSupported */;
    }
    return (_a = new AudioContext().baseLatency) !== null && _a !== void 0 ? _a : -1 /* SpecialFingerprint.NotSupported */;
}

/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 *
 * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
 * no need to export the sources individually.
 */
var fp_esm_sources = {
    // READ FIRST:
    // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
    // to learn how entropy source works and how to make your own.
    // The sources run in this exact order.
    // The asynchronous sources are at the start to run in parallel with other sources.
    fonts: getFonts,
    domBlockers: getDomBlockers,
    fontPreferences: getFontPreferences,
    audio: getAudioFingerprint,
    screenFrame: getScreenFrame,
    canvas: getCanvasFingerprint,
    osCpu: getOsCpu,
    languages: getLanguages,
    colorDepth: getColorDepth,
    deviceMemory: getDeviceMemory,
    screenResolution: getScreenResolution,
    hardwareConcurrency: getHardwareConcurrency,
    timezone: getTimezone,
    sessionStorage: getSessionStorage,
    localStorage: getLocalStorage,
    indexedDB: getIndexedDB,
    openDatabase: getOpenDatabase,
    cpuClass: getCpuClass,
    platform: getPlatform,
    plugins: getPlugins,
    touchSupport: getTouchSupport,
    vendor: getVendor,
    vendorFlavors: getVendorFlavors,
    cookiesEnabled: areCookiesEnabled,
    colorGamut: getColorGamut,
    invertedColors: areColorsInverted,
    forcedColors: areColorsForced,
    monochrome: getMonochromeDepth,
    contrast: getContrastPreference,
    reducedMotion: isMotionReduced,
    reducedTransparency: isTransparencyReduced,
    hdr: isHDR,
    math: getMathFingerprint,
    pdfViewerEnabled: isPdfViewerEnabled,
    architecture: getArchitecture,
    applePay: getApplePayState,
    privateClickMeasurement: getPrivateClickMeasurement,
    audioBaseLatency: getAudioContextBaseLatency,
    // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
    // after other sources.
    webGlBasics: getWebGlBasics,
    webGlExtensions: getWebGlExtensions,
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */
function loadBuiltinSources(options) {
    return loadSources(fp_esm_sources, options, []);
}

var commentTemplate = '$ if upgrade to Pro: https://fpjs.dev/pro';
function getConfidence(components) {
    var openConfidenceScore = getOpenConfidenceScore(components);
    var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
    return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "".concat(proConfidenceScore)) };
}
function getOpenConfidenceScore(components) {
    // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
    // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
    // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
    if (isAndroid()) {
        return 0.4;
    }
    // Safari (mobile and desktop)
    if (isWebKit()) {
        return isDesktopWebKit() && !(isWebKit616OrNewer() && isSafariWebKit()) ? 0.5 : 0.3;
    }
    var platform = 'value' in components.platform ? components.platform.value : '';
    // Windows
    if (/^Win/.test(platform)) {
        // The score is greater than on macOS because of the higher variety of devices running Windows.
        // Chrome provides more entropy than Firefox according too
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.6;
    }
    // macOS
    if (/^Mac/.test(platform)) {
        // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
        // Chrome is more popular than Safari and Safari is more popular than Firefox according to
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.5;
    }
    // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
    return 0.7;
}
function deriveProConfidenceScore(openConfidenceScore) {
    return round(0.99 + 0.01 * openConfidenceScore, 0.0001);
}

function componentsToCanonicalString(components) {
    var result = '';
    for (var _i = 0, _a = Object.keys(components).sort(); _i < _a.length; _i++) {
        var componentKey = _a[_i];
        var component = components[componentKey];
        var value = 'error' in component ? 'error' : JSON.stringify(component.value);
        result += "".concat(result ? '|' : '').concat(componentKey.replace(/([:|\\])/g, '\\$1'), ":").concat(value);
    }
    return result;
}
function componentsToDebugString(components) {
    return JSON.stringify(components, function (_key, value) {
        if (value instanceof Error) {
            return errorToObject(value);
        }
        return value;
    }, 2);
}
function hashComponents(components) {
    return x64hash128(componentsToCanonicalString(components));
}
/**
 * Makes a GetResult implementation that calculates the visitor id hash on demand.
 * Designed for optimisation.
 */
function makeLazyGetResult(components) {
    var visitorIdCache;
    // This function runs very fast, so there is no need to make it lazy
    var confidence = getConfidence(components);
    // A plain class isn't used because its getters and setters aren't enumerable.
    return {
        get visitorId() {
            if (visitorIdCache === undefined) {
                visitorIdCache = hashComponents(this.components);
            }
            return visitorIdCache;
        },
        set visitorId(visitorId) {
            visitorIdCache = visitorId;
        },
        confidence: confidence,
        components: components,
        version: version,
    };
}
/**
 * A delay is required to ensure consistent entropy components.
 * See https://github.com/fingerprintjs/fingerprintjs/issues/254
 * and https://github.com/fingerprintjs/fingerprintjs/issues/307
 * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
 */
function prepareForSources(delayFallback) {
    if (delayFallback === void 0) { delayFallback = 50; }
    // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
    return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
/**
 * The function isn't exported from the index file to not allow to call it without `load()`.
 * The hiding gives more freedom for future non-breaking updates.
 *
 * A factory function is used instead of a class to shorten the attribute names in the minified code.
 * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
 */
function makeAgent(getComponents, debug) {
    var creationTime = Date.now();
    return {
        get: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var startTime, components, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startTime = Date.now();
                            return [4 /*yield*/, getComponents()];
                        case 1:
                            components = _a.sent();
                            result = makeLazyGetResult(components);
                            if (debug || (options === null || options === void 0 ? void 0 : options.debug)) {
                                // console.log is ok here because it's under a debug clause
                                // eslint-disable-next-line no-console
                                console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(result.version, "\nuserAgent: ").concat(navigator.userAgent, "\ntimeBetweenLoadAndGet: ").concat(startTime - creationTime, "\nvisitorId: ").concat(result.visitorId, "\ncomponents: ").concat(componentsToDebugString(components), "\n```"));
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        },
    };
}
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */
function monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) {
        return;
    }
    try {
        var request = new XMLHttpRequest();
        request.open('get', "https://m1.openfpcdn.io/fingerprintjs/v".concat(version, "/npm-monitoring"), true);
        request.send();
    }
    catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
/**
 * Builds an instance of Agent and waits a delay required for a proper operation.
 */
function load(options) {
    var _a;
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var delayFallback, debug, getComponents;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if ((_a = options.monitoring) !== null && _a !== void 0 ? _a : true) {
                        monitor();
                    }
                    delayFallback = options.delayFallback, debug = options.debug;
                    return [4 /*yield*/, prepareForSources(delayFallback)];
                case 1:
                    _b.sent();
                    getComponents = loadBuiltinSources({ cache: {}, debug: debug });
                    return [2 /*return*/, makeAgent(getComponents, debug)];
            }
        });
    });
}

// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
var fp_esm_index = { load: load, hashComponents: hashComponents, componentsToDebugString: componentsToDebugString };
// The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
/** Not documented, out of Semantic Versioning, usage is at your own risk */
var murmurX64Hash128 = x64hash128;




/***/ }),

/***/ "63ff":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "641f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "64cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("665b");
var normalizeHeaderName = __webpack_require__("b135");
var enhanceError = __webpack_require__("480a");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("c7b3");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("c7b3");
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("3117")))

/***/ }),

/***/ "64d4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("08a0");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "665b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("d7d9");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "66d4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var uncurryThis = __webpack_require__("7630");
var defineBuiltInAccessor = __webpack_require__("93c1");

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),

/***/ "680d":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__("26b9");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8511");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = __webpack_require__("5dea");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8bbf");

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-message-fade" },
      on: { "after-leave": _vm.handleAfterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: [
            "el-message",
            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
            _vm.center ? "is-center" : "",
            _vm.showClose ? "is-closable" : "",
            _vm.customClass
          ],
          style: _vm.positionStyle,
          attrs: { role: "alert" },
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
        },
        [
          _vm.iconClass
            ? _c("i", { class: _vm.iconClass })
            : _c("i", { class: _vm.typeClass }),
          _vm._t("default", [
            !_vm.dangerouslyUseHTMLString
              ? _c("p", { staticClass: "el-message__content" }, [
                  _vm._v(_vm._s(_vm.message))
                ])
              : _c("p", {
                  staticClass: "el-message__content",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
          ]),
          _vm.showClose
            ? _c("i", {
                staticClass: "el-message__closeBtn el-icon-close",
                on: { click: _vm.close }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false
    };
  },


  computed: {
    typeClass: function typeClass() {
      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + typeMap[this.type] : '';
    },
    positionStyle: function positionStyle() {
      return {
        'top': this.verticalOffset + 'px'
      };
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    }
  },

  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
});
// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/message/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/message/src/main.vue"
/* harmony default export */ var main = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_ = __webpack_require__(13);

// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_ = __webpack_require__(23);

// EXTERNAL MODULE: external "element-ui/lib/utils/types"
var types_ = __webpack_require__(17);

// CONCATENATED MODULE: ./packages/message/src/main.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var MessageConstructor = external_vue_default.a.extend(main);

var instance = void 0;
var instances = [];
var seed = 1;

var main_Message = function Message(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  var userOnClose = options.onClose;
  var id = 'message_' + seed++;

  options.onClose = function () {
    Message.close(id, userOnClose);
  };
  instance = new MessageConstructor({
    data: options
  });
  instance.id = id;
  if (Object(vdom_["isVNode"])(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  }
  instance.$mount();
  document.body.appendChild(instance.$el);
  var verticalOffset = options.offset || 20;
  instances.forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  instance.verticalOffset = verticalOffset;
  instance.visible = true;
  instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
  instances.push(instance);
  return instance;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  main_Message[type] = function (options) {
    if (Object(types_["isObject"])(options) && !Object(vdom_["isVNode"])(options)) {
      return main_Message(_extends({}, options, {
        type: type
      }));
    }
    return main_Message({
      type: type,
      message: options
    });
  };
});

main_Message.close = function (id, userOnClose) {
  var len = instances.length;
  var index = -1;
  var removedHeight = void 0;
  for (var i = 0; i < len; i++) {
    if (id === instances[i].id) {
      removedHeight = instances[i].$el.offsetHeight;
      index = i;
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
  if (len <= 1 || index === -1 || index > instances.length - 1) return;
  for (var _i = index; _i < len - 1; _i++) {
    var dom = instances[_i].$el;
    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
  }
};

main_Message.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

/* harmony default export */ var src_main = (main_Message);
// CONCATENATED MODULE: ./packages/message/index.js

/* harmony default export */ var message = __webpack_exports__["default"] = (src_main);

/***/ })

/******/ });

/***/ }),

/***/ "685f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayWith = __webpack_require__("2085");
var ArrayBufferViewCore = __webpack_require__("799f");
var isBigIntArray = __webpack_require__("0781");
var toIntegerOrInfinity = __webpack_require__("08a0");
var toBigInt = __webpack_require__("72cc");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);


/***/ }),

/***/ "68a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomProgress_vue_vue_type_style_index_0_id_57f151d0_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4114");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomProgress_vue_vue_type_style_index_0_id_57f151d0_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomProgress_vue_vue_type_style_index_0_id_57f151d0_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "68c4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69a2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("aef3");
var isCallable = __webpack_require__("0d52");
var classofRaw = __webpack_require__("37cd");
var wellKnownSymbol = __webpack_require__("eebc");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "6bd2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ "6ca7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__("2e86");

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ "6d4e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("e2a4");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "6e2e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("54df");
var global = __webpack_require__("79a2");
var setToStringTag = __webpack_require__("0286");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "70d6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var call = __webpack_require__("2f9c");
var ArrayBufferViewCore = __webpack_require__("799f");
var lengthOfArrayLike = __webpack_require__("2e86");
var toOffset = __webpack_require__("81c8");
var toIndexedObject = __webpack_require__("ca07");
var fails = __webpack_require__("a6cc");

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw new RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ "72cc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("b799");

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ "740c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var toObject = __webpack_require__("ca07");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "7465":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var hasOwn = __webpack_require__("80a8");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "7588":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("7ced");
var combineURLs = __webpack_require__("6297");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "7630":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("a059");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "776a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeInput_vue_vue_type_style_index_0_id_9e856404_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f514");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeInput_vue_vue_type_style_index_0_id_9e856404_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_CodeInput_vue_vue_type_style_index_0_id_9e856404_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "799f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__("4eef");
var DESCRIPTORS = __webpack_require__("6bd2");
var global = __webpack_require__("79a2");
var isCallable = __webpack_require__("0d52");
var isObject = __webpack_require__("e2a4");
var hasOwn = __webpack_require__("80a8");
var classof = __webpack_require__("69a2");
var tryToString = __webpack_require__("b150");
var createNonEnumerableProperty = __webpack_require__("abb2");
var defineBuiltIn = __webpack_require__("242d");
var defineBuiltInAccessor = __webpack_require__("93c1");
var isPrototypeOf = __webpack_require__("29f7");
var getPrototypeOf = __webpack_require__("7cac");
var setPrototypeOf = __webpack_require__("03e6");
var wellKnownSymbol = __webpack_require__("eebc");
var uid = __webpack_require__("a961");
var InternalStateModule = __webpack_require__("5bb8");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ "79a2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("0314")))

/***/ }),

/***/ "7cac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__("80a8");
var isCallable = __webpack_require__("0d52");
var toObject = __webpack_require__("ca07");
var sharedKey = __webpack_require__("411b");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("8b8e");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "7ced":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "7dcc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ "8053":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8073":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("641f");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "80a8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var toObject = __webpack_require__("ca07");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "81c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPositiveInteger = __webpack_require__("3185");

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ "82f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cascade */
/* unused harmony export CascadeStyleType */
/* unused harmony export Choice */
/* unused harmony export DateIssue */
/* unused harmony export Scale */
/* unused harmony export TextFill */
/* unused harmony export ValidateType */
/* unused harmony export assign */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertObjToUrlSearch; });
/* unused harmony export deepClone */
/* unused harmony export defaultTitle */
/* unused harmony export generateId */
/* unused harmony export getDefaultsContent */
/* unused harmony export getObjFactory */
/* unused harmony export getTextByList */
/* unused harmony export questionType */
/* unused harmony export setIdGenerateFn */
let id = 1;
let idGenerate = () => {
    return (id++).toString();
};
function setIdGenerateFn(fn) {
    idGenerate = fn;
}
function generateId() {
    return idGenerate();
}
function getDefaultsContent(content = {}) {
    let result = {
        text: '',
        video: [],
        audio: [],
        image: [],
        richText: '',
        allowPhotoNum: 0,
        allowMinPhotoNum: 0,
        allowFileTypes: []
    };
    return Object.assign({}, result, content);
}
function getTextByList(list, defaultText, getTextCb) {
    let n = 1;
    let text = `${defaultText}${n}`;
    while (list.find(r => {
        let temp = getTextCb(r);
        return temp === text;
    })) {
        text = `${defaultText}${++n}`;
    }
    return text;
}

function deepClone(obj) {
    const nullValues = [null, undefined, NaN, false];
    if (nullValues.includes(obj))
        return obj;
    if (typeof obj !== 'object' && typeof obj !== 'function') {
        // 原始类型直接返回
        return obj;
    }
    const o = Array.isArray(obj) ? [] : {};
    for (const i in obj) {
        // @ts-ignore
        if (obj.hasOwnProperty(i)) {
            o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i];
        }
    }
    return o;
}
/**
 *
 * @param data
 * @param ignoreAttrs 需要忽略的key
 */
function assign(data, ignoreAttrs = []) {
    const results = {};
    for (const key in data) {
        if (!ignoreAttrs.includes(key)) {
            results[key] = data[key];
        }
    }
    return results;
}
/**
 * 返回 foo=1&bar=2
 * @param obj
 */
function convertObjToUrlSearch(obj) {
    const kvs = [];
    for (const key in obj) {
        const value = obj[key];
        if (value === 'undefined' || value === 'null')
            continue;
        kvs.push(`${key}=${value}`);
    }
    return kvs.join('&');
}
function getObjFactory(objs) {
    return function (type) {
        let s = Object.keys(objs).find(key => {
            let t = objs[key].type;
            if (Array.isArray(t)) {
                return t.includes(type);
            }
            else {
                return t === type;
            }
        });
        if (!s) {
            return null;
        }
        return objs[s];
    };
}

let g_id = 1;
function initItems(items = []) {
    return items.map(item => {
        if (!item.content.richText) {
            item.content.richText = item.content.text;
        }
        if (!item.setting) {
            item.setting = {
                enableRelation: false
            };
        }
        return Object.assign({ validate: null }, item);
    });
}
function convertGroups(items) {
    return items.map(item => {
        return Object.assign({
            groupId: g_id++
        }, item);
    });
}
function createItem(text) {
    return {
        id: generateId(),
        content: getDefaultsContent({
            text: text,
            richText: text,
            allowPhotoNum: 0
        }),
        is_other_item: 0,
        is_exclusive: false,
        validate: null,
        maxLength: '',
        minLength: '',
        required: true,
        tips: '',
        setting: {
            enableRelation: false
        }
    };
}
class Choice {
    constructor(data) {
        this.correct_answer = data.correct_answer || []; // 质控题正确答案
        this.items = initItems(data.items || []);
        this.is_rand = data.is_rand || false;
        this.randList = data.randList || [];
        this.choice_num_per_row = data.choice_num_per_row || 1;
        this.item_groups = convertGroups(data.item_groups || []);
        this.append_items = data.append_items || [];
    }
    getParams(ignoreKeys = []) {
        return assign(this, ignoreKeys);
    }
    addItem() {
        const text = getTextByList(this.items, '选项', item => {
            return item.content.text;
        });
        this.addItems([text]);
    }
    addItems(texts) {
        const items = texts.map(createItem);
        this.items.push(...items);
    }
    addOtherItem() {
        let item = createItem('其他');
        item.is_other_item = 1;
        this.items.push(item);
    }
}

function transformGroupsByLevel(groups = [], level = 3) {
    const isLast = level - 1 === 0;
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        if (isLast) {
            group.nextLevelOptions = null;
            group.isNextLevel = false;
        }
        else {
            transformGroupsByLevel(group.nextLevelOptions, level - 1);
        }
    }
}
function getValueByIds(groups = [], ids = [], isRoot = false, parent) {
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        if (group.nextLevelOptions && group.nextLevelOptions.length) {
            getValueByIds(group.nextLevelOptions.slice(), ids, false, group);
        }
        if (!isRoot) {
            ids.forEach(val => {
                let index = val.findIndex((item) => {
                    if (!item)
                        return false;
                    return item.id === group.id;
                });
                if (index !== -1) {
                    val[index] = {
                        id: group.id,
                        content: group.content
                    };
                    val.unshift({
                        id: parent.id,
                        content: parent.content
                    });
                }
            });
        }
        else {
            ids.forEach(val => {
                if (val.length === 1) {
                    let find = groups.find(g => g.id === val[0].id);
                    if (find) {
                        val[0].content = find.content;
                    }
                }
            });
        }
    }
    return ids;
}
const CascadeStyleType = {
    One: 1,
    Many: 2
};
class Cascade {
    constructor(data) {
        this.groups = data.groups || [];
        this.levelsNum = data.levelsNum || 0;
        this.levels = (data.levels || []).filter(Boolean);
        this.prompt = data.prompt || '';
        this.fillContext = data.fillContext || [];
        this.requiredNum = data.requiredNum || this.levelsNum;
        this.styleType = data.styleType || CascadeStyleType.Many;
    }
    getGroupsByLevel(n) {
        if (!n || n < 0) {
            n = Math.min(this.levelsNum, this.requiredNum);
        }
        const groups = deepClone(this.groups);
        transformGroupsByLevel(groups, n);
        return groups;
    }
    getValueByLastIds(ids = []) {
        return this.getValueByIds(ids).map(item => item.map((i) => i.id));
    }
    getTextByLastIds(ids = []) {
        return this.getValueByIds(ids).map(item => item.map((i) => i.content));
    }
    getValueByIds(ids = []) {
        const groups = this.groups.slice();
        return getValueByIds(groups, ids.map(id => [{ id }]), true);
    }
    getParams() {
        let res = assign(this, ['levels']);
        let levels = this.levels.slice();
        if (levels.length < this.levelsNum) {
            levels.push('');
        }
        res.levels = levels.filter(Boolean);
        return res;
    }
}

var questionType;
(function (questionType) {
    questionType[questionType["SINGLE_CHOICE"] = 1] = "SINGLE_CHOICE";
    questionType[questionType["MULTIPLE_CHOICE"] = 2] = "MULTIPLE_CHOICE";
    questionType[questionType["LINKAGE"] = 3] = "LINKAGE";
    questionType[questionType["BLANKS"] = 4] = "BLANKS";
    questionType[questionType["MATRIX_SINGLE_CHOICE"] = 5] = "MATRIX_SINGLE_CHOICE";
    questionType[questionType["MATRIX_MULTIPLE_CHOICE"] = 6] = "MATRIX_MULTIPLE_CHOICE";
    questionType[questionType["SINGLE_TEXT_FILL"] = 7] = "SINGLE_TEXT_FILL";
    questionType[questionType["MULTIPLE_TEXT_FILL"] = 8] = "MULTIPLE_TEXT_FILL";
    questionType[questionType["SINGLE_SELECT"] = 12] = "SINGLE_SELECT";
    questionType[questionType["MULTIPLE_SELECT"] = 13] = "MULTIPLE_SELECT";
    questionType[questionType["ONLY_TEXT"] = 20] = "ONLY_TEXT";
    questionType[questionType["SORT"] = 11] = "SORT";
    questionType[questionType["SCALE"] = 21] = "SCALE";
    questionType[questionType["MATRIX_SCALE"] = 9] = "MATRIX_SCALE";
    questionType[questionType["NPS_SCALE"] = 10] = "NPS_SCALE";
    questionType[questionType["CUSTOM_SINGLE_SCALE"] = 15] = "CUSTOM_SINGLE_SCALE";
    questionType[questionType["CUSTOM_MULTIPLE_SCALE"] = 16] = "CUSTOM_MULTIPLE_SCALE";
    questionType[questionType["TOTAL"] = 119] = "TOTAL";
    questionType[questionType["DATE"] = 17] = "DATE";
    questionType[questionType["UPLOAD_FILE"] = 18] = "UPLOAD_FILE";
    questionType[questionType["HANDWRITING"] = 14] = "HANDWRITING";
    questionType[questionType["CITY_ADDRESS"] = 19] = "CITY_ADDRESS";
    questionType[questionType["MAP"] = 100] = "MAP";
    questionType[questionType["DOWNLOADABLE"] = 112] = "DOWNLOADABLE";
    questionType[questionType["PHONE_VALIDATE"] = 109] = "PHONE_VALIDATE";
    questionType[questionType["CASCADE_REGION"] = 114] = "CASCADE_REGION";
    questionType[questionType["MATRIX_AUTO"] = 102] = "MATRIX_AUTO";
    questionType[questionType["MATRIX_SCROLL"] = 103] = "MATRIX_SCROLL";
    questionType[questionType["MATRIX_GRAVITY"] = 104] = "MATRIX_GRAVITY";
    questionType[questionType["MULTIPLE_BLANKS"] = 105] = "MULTIPLE_BLANKS";
    questionType[questionType["MATRIX_COMPOSE"] = 110] = "MATRIX_COMPOSE";
    questionType[questionType["MATRIX_FILL"] = 107] = "MATRIX_FILL";
    questionType[questionType["IMAGE_CHOICE"] = 113] = "IMAGE_CHOICE";
    questionType[questionType["IMAGE_MULTIPLE_CHOICE"] = 117] = "IMAGE_MULTIPLE_CHOICE";
    questionType[questionType["MATRIX_SELECT_CHOICE"] = 106] = "MATRIX_SELECT_CHOICE";
    questionType[questionType["QUESTION_GROUP"] = 115] = "QUESTION_GROUP";
    questionType[questionType["CLASSIFICATION"] = 111] = "CLASSIFICATION";
    questionType[questionType["PAGE_BREAK"] = 108] = "PAGE_BREAK";
    questionType[questionType["NAME"] = 22] = "NAME";
    questionType[questionType["CELLPHONE"] = 23] = "CELLPHONE";
    questionType[questionType["EMAIL"] = 24] = "EMAIL";
    questionType[questionType["REAL_NAME"] = 26] = "REAL_NAME";
    questionType[questionType["GENDER"] = 27] = "GENDER";
    questionType[questionType["PERMANENT_ADDRESS"] = 28] = "PERMANENT_ADDRESS";
    questionType[questionType["DATE_OF_BIRTH"] = 29] = "DATE_OF_BIRTH";
    questionType[questionType["ID_NUMBER"] = 31] = "ID_NUMBER";
    questionType[questionType["AGE_RANGE"] = 32] = "AGE_RANGE";
    questionType[questionType["DOMICILE"] = 33] = "DOMICILE";
    questionType[questionType["EDUCATIONAL_ATTAINMENT"] = 34] = "EDUCATIONAL_ATTAINMENT";
    questionType[questionType["SPECIALITY"] = 35] = "SPECIALITY";
    questionType[questionType["SCHOOL"] = 36] = "SCHOOL";
    questionType[questionType["INDUSTRY"] = 37] = "INDUSTRY";
    questionType[questionType["JOB"] = 38] = "JOB";
    questionType[questionType["MARITAL_STATUS"] = 39] = "MARITAL_STATUS";
    questionType[questionType["MONTHLY_INCOME_RANGE"] = 40] = "MONTHLY_INCOME_RANGE"; // 个人月收入
})(questionType || (questionType = {}));

const titleMap = new Map();
titleMap.set(questionType.SINGLE_CHOICE, '请选择以下选项');
titleMap.set(questionType.MULTIPLE_CHOICE, '请从以下选项中选择选项');
titleMap.set(questionType.MATRIX_SINGLE_CHOICE, '评价一项新的规则');
titleMap.set(questionType.MATRIX_MULTIPLE_CHOICE, '评价一项新的规则');
titleMap.set(questionType.MATRIX_SELECT_CHOICE, '评价一项新的规则');
titleMap.set(questionType.LINKAGE, '您的常住地址');
titleMap.set(questionType.SINGLE_SELECT, '请选择以下选项');
titleMap.set(questionType.IMAGE_CHOICE, '请选择以下图片');
titleMap.set(questionType.CLASSIFICATION, '请按照分类规则，将左侧选项选入右侧分组中');
titleMap.set(questionType.BLANKS, '请填写以下信息');
titleMap.set(questionType.MATRIX_FILL, '请填写以下内容');
titleMap.set(questionType.MULTIPLE_BLANKS, '请填写以下信息');
titleMap.set(questionType.SINGLE_TEXT_FILL, '请填写以下信息');
titleMap.set(questionType.ONLY_TEXT, '这是一段文本描述');
titleMap.set(questionType.NPS_SCALE, '您向朋友或同事推荐我们的可能性有多大？');
titleMap.set(questionType.MATRIX_SCALE, '评价一项新的规则');
titleMap.set(questionType.SORT, '请给以下选项排序');
titleMap.set(questionType.SCALE, '这条描述与你的匹配度');
titleMap.set(questionType.CUSTOM_SINGLE_SCALE, '请为我们的服务打分');
titleMap.set(questionType.CUSTOM_MULTIPLE_SCALE, '请为我们的服务打分');
titleMap.set(questionType.MATRIX_SCROLL, '评价一项新的规则');
titleMap.set(questionType.MATRIX_AUTO, '请填写你的团队成员信息');
titleMap.set(questionType.MATRIX_COMPOSE, '请填写以下表格');
titleMap.set(questionType.MATRIX_GRAVITY, '评价一项新的规则');
titleMap.set(questionType.TOTAL, '评价一项新的规则');
titleMap.set(questionType.UPLOAD_FILE, '请上传文件');
titleMap.set(questionType.HANDWRITING, '被访者手写签名');
titleMap.set(questionType.DATE, '请选择日期');
titleMap.set(questionType.DOWNLOADABLE, '请下载附件');
titleMap.set(questionType.CITY_ADDRESS, '详细地址');
titleMap.set(questionType.CASCADE_REGION, '请选择');
titleMap.set(questionType.PHONE_VALIDATE, '请输入手机号');
titleMap.set(questionType.MAP, '所在位置');
titleMap.set(questionType.QUESTION_GROUP, '问题组');
titleMap.set(questionType.NAME, '姓名：');
titleMap.set(questionType.CELLPHONE, '手机号：');
titleMap.set(questionType.EMAIL, '邮箱：');
titleMap.set(questionType.GENDER, '性别：');
titleMap.set(questionType.DATE_OF_BIRTH, '出生日期：');
titleMap.set(questionType.AGE_RANGE, '年龄：');
titleMap.set(questionType.PERMANENT_ADDRESS, '请选择您的常住地：');
titleMap.set(questionType.DOMICILE, '请选择您的户籍地：');
titleMap.set(questionType.ID_NUMBER, '您的身份证号是：');
titleMap.set(questionType.EDUCATIONAL_ATTAINMENT, '学历：');
titleMap.set(questionType.SPECIALITY, '您大学所学专业是：');
titleMap.set(questionType.SCHOOL, '您所就读的院校是：');
titleMap.set(questionType.INDUSTRY, '您目前所处行业：');
titleMap.set(questionType.JOB, '您目前的职业是：');
titleMap.set(questionType.MARITAL_STATUS, '婚姻状况：');
titleMap.set(questionType.MONTHLY_INCOME_RANGE, '个人月收入：');
const defaultTitle = titleMap;

const ValidateType = {
    NUM: 'num',
    NULL: null,
    PHONE: 'phone',
    EMAIL: 'email',
    CHAR: 'char',
    CHINESE: 'chinese',
    ID_NUMBER: 'idNumber',
    WEBSITE: 'website',
    TEXT: 'text',
    PASSWORD: 'password' // 密码样式
};

class TextFill {
    constructor(data) {
        this.min_length = data.min_length || '';
        this.max_length = data.max_length || '';
        this.rows = data.rows || 1;
        this.digit = data.digit || '';
        this.validate = data.validate || ValidateType.NULL;
        this.default_text = data.default_text || '';
        this.data_unique = Boolean(data.data_unique || 0);
        this.message_validate = data.message_validate || 0;
        this.placeholder = data.placeholder || '';
        this.setting = data.setting || {
            enableRelation: false
        };
    }
    getParams() {
        let res = assign(this, ['data_unique']);
        res.data_unique = this.data_unique ? 1 : 0;
        res.digit = isNaN(this.digit) ? 0 : Number(this.digit);
        return res;
    }
    getCellParams() {
        return {
            min_length: this.min_length || '',
            max_length: this.max_length || '',
            validate: this.validate,
            rows: this.rows,
            placeholder: this.placeholder
        };
    }
}
class DateIssue {
    constructor(data) {
        this.fillContext = data.fillContext || [];
        this.fillNumber = data.fillNumber || 0;
        this.fillText = '';
        this.numCompareRule = {
            leftEles: [],
            operator: '',
            rightEles: []
        };
        this.context = this.fillContext[0] || {};
    }
    createContext() {
        return {
            dateType: '日',
            digit: 2,
            id: generateId(),
            maxLength: '',
            minLength: '',
            rangeLength: '',
            required: true,
            validate: 'time'
        };
    }
    init() {
        const context = this.createContext();
        this.context = context;
        this.fillContext.push(context);
        this.fillNumber = 1;
    }
    getParams() {
        let res = assign(this, ['context']);
        res.fillContext[0] = this.context;
        return res;
    }
}

class Scale {
    constructor(data) {
        this.correct_answer = data.correct_answer || []; // 质控题正确答案
        this.level = data.level || 0;
        this.items = data.items || [];
        this.labels = this.convertLabels(data.labels || []);
        this.is_rand = data.is_rand || false;
        this.show_unknown = data.showUnknown || false;
        this.unknown_text = data.unknownText || '不清楚';
        this.show_option_desc = typeof data.show_option_desc === 'boolean' ? data.show_option_desc : true;
        this.show_option_value = typeof data.show_option_value === 'boolean' ? data.show_option_value : true;
    }
    convertLabels(labels = []) {
        return labels.map(l => {
            // 2.0 之前的版本是没有 ID 的
            if (!l.id) {
                l = Object.assign({}, { id: generateId() }, l);
            }
            return l;
        });
    }
    getParams() {
        // 前端大部分字段已用 下划线 命名 修改起来不方便
        const res = assign(this, ['show_unknown', 'unknown_text']);
        // @ts-ignore
        res.showUnknown = this.show_unknown;
        // @ts-ignore
        res.unknownText = this.unknown_text;
        return res;
    }
    addItems(texts = []) {
        let items = texts.map(text => {
            return {
                content: getDefaultsContent({ text: text, richText: text }),
                id: generateId()
            };
        });
        this.items.push(...items);
    }
    addItem() {
        let text = getTextByList(this.items, '子题干', item => {
            return item.content.text;
        });
        this.addItems([text]);
    }
    addLabel() {
        let text = getTextByList(this.labels, '选项', t => t.text);
        this.addLabels([text]);
    }
    addLabels(texts = []) {
        texts.forEach(text => {
            this.labels.push({
                id: generateId(),
                text,
                num: this.getLabelNum()
            });
        });
    }
    getLabelNum() {
        let n = 1;
        let labels = this.labels;
        while (labels.find(l => l.num.toString() === n.toString())) {
            n++;
        }
        return n;
    }
    deleteLabel(label) {
        let index = this.labels.findIndex(l => l === label);
        if (index > -1) {
            this.labels.splice(index, 1);
        }
    }
    deleteItemByIndex(index) {
        if (index > -1)
            this.items.splice(index, 1);
    }
    deleteItemByItem(item) {
        this.deleteItemByIndex(this.items.findIndex(i => i.id === item.id));
    }
    initLabels(n, firstLabelText = '', lastLabelText = '') {
        let v = 1;
        let labels = [];
        while (v <= n) {
            labels.push({
                text: '',
                num: v,
                id: generateId()
            });
            v++;
        }
        labels[0].text = firstLabelText;
        labels[labels.length - 1].text = lastLabelText;
        this.labels = labels;
    }
}




/***/ }),

/***/ "83b7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("f938");
var toObject = __webpack_require__("ca07");
var IndexedObject = __webpack_require__("4a45");
var lengthOfArrayLike = __webpack_require__("2e86");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "8409":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;

var _zhCN = __webpack_require__("db2d");

var _zhCN2 = _interopRequireDefault(_zhCN);

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _deepmerge = __webpack_require__("7dcc");

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _format = __webpack_require__("50c6");

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };

/***/ }),

/***/ "8420":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("024b");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "8511":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDefined = exports.isUndefined = exports.isFunction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isString = isString;
exports.isObject = isObject;
exports.isHtmlElement = isHtmlElement;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

/**
 *  - Inspired:
 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
 */
var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

if ( true && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
  exports.isFunction = isFunction = function isFunction(obj) {
    return typeof obj === 'function' || false;
  };
}

exports.isFunction = isFunction;
var isUndefined = exports.isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = exports.isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};

/***/ }),

/***/ "85c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var isCallable = __webpack_require__("0d52");
var store = __webpack_require__("f499");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "86db":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 72);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__("26b9");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__("5a8b");

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __webpack_require__("2c86");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8bbf");

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-loading-fade" },
      on: { "after-leave": _vm.handleAfterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-loading-mask",
          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
          style: { backgroundColor: _vm.background || "" }
        },
        [
          _c("div", { staticClass: "el-loading-spinner" }, [
            !_vm.spinner
              ? _c(
                  "svg",
                  {
                    staticClass: "circular",
                    attrs: { viewBox: "25 25 50 50" }
                  },
                  [
                    _c("circle", {
                      staticClass: "path",
                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
                    })
                  ]
                )
              : _c("i", { class: _vm.spinner }),
            _vm.text
              ? _c("p", { staticClass: "el-loading-text" }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },


  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
});
// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/loading/src/loading.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/loading/src/loading.vue"
/* harmony default export */ var loading = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(2);

// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_ = __webpack_require__(13);

// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
var after_leave_ = __webpack_require__(41);
var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);

// CONCATENATED MODULE: ./packages/loading/src/directive.js





var Mask = external_vue_default.a.extend(loading);

var loadingDirective = {};
loadingDirective.install = function (Vue) {
  if (Vue.prototype.$isServer) return;
  var toggleLoading = function toggleLoading(el, binding) {
    if (binding.value) {
      Vue.nextTick(function () {
        if (binding.modifiers.fullscreen) {
          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();

          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
          insertDom(document.body, el, binding);
        } else {
          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');

          if (binding.modifiers.body) {
            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');

            ['top', 'left'].forEach(function (property) {
              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
            });
            ['height', 'width'].forEach(function (property) {
              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
            });

            insertDom(document.body, el, binding);
          } else {
            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
            insertDom(el, el, binding);
          }
        }
      });
    } else {
      after_leave_default()(el.instance, function (_) {
        if (!el.instance.hiding) return;
        el.domVisible = false;
        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
        el.instance.hiding = false;
      }, 300, true);
      el.instance.visible = false;
      el.instance.hiding = true;
    }
  };
  var insertDom = function insertDom(parent, el, binding) {
    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
      Object.keys(el.maskStyle).forEach(function (property) {
        el.mask.style[property] = el.maskStyle[property];
      });

      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
      }
      el.domVisible = true;

      parent.appendChild(el.mask);
      Vue.nextTick(function () {
        if (el.instance.hiding) {
          el.instance.$emit('after-leave');
        } else {
          el.instance.visible = true;
        }
      });
      el.domInserted = true;
    } else if (el.domVisible && el.instance.hiding === true) {
      el.instance.visible = true;
      el.instance.hiding = false;
    }
  };

  Vue.directive('loading', {
    bind: function bind(el, binding, vnode) {
      var textExr = el.getAttribute('element-loading-text');
      var spinnerExr = el.getAttribute('element-loading-spinner');
      var backgroundExr = el.getAttribute('element-loading-background');
      var customClassExr = el.getAttribute('element-loading-custom-class');
      var vm = vnode.context;
      var mask = new Mask({
        el: document.createElement('div'),
        data: {
          text: vm && vm[textExr] || textExr,
          spinner: vm && vm[spinnerExr] || spinnerExr,
          background: vm && vm[backgroundExr] || backgroundExr,
          customClass: vm && vm[customClassExr] || customClassExr,
          fullscreen: !!binding.modifiers.fullscreen
        }
      });
      el.instance = mask;
      el.mask = mask.$el;
      el.maskStyle = {};

      binding.value && toggleLoading(el, binding);
    },

    update: function update(el, binding) {
      el.instance.setText(el.getAttribute('element-loading-text'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },

    unbind: function unbind(el, binding) {
      if (el.domInserted) {
        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
      el.instance && el.instance.$destroy();
    }
  });
};

/* harmony default export */ var directive = (loadingDirective);
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// CONCATENATED MODULE: ./packages/loading/src/index.js







var LoadingConstructor = external_vue_default.a.extend(loading);

var defaults = {
  text: null,
  fullscreen: true,
  body: false,
  lock: false,
  customClass: ''
};

var fullscreenLoading = void 0;

LoadingConstructor.prototype.originalPosition = '';
LoadingConstructor.prototype.originalOverflow = '';

LoadingConstructor.prototype.close = function () {
  var _this = this;

  if (this.fullscreen) {
    fullscreenLoading = undefined;
  }
  after_leave_default()(this, function (_) {
    var target = _this.fullscreen || _this.body ? document.body : _this.target;
    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
    if (_this.$el && _this.$el.parentNode) {
      _this.$el.parentNode.removeChild(_this.$el);
    }
    _this.$destroy();
  }, 300);
  this.visible = false;
};

var src_addStyle = function addStyle(options, parent, instance) {
  var maskStyle = {};
  if (options.fullscreen) {
    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
  } else if (options.body) {
    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
    ['top', 'left'].forEach(function (property) {
      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
    });
    ['height', 'width'].forEach(function (property) {
      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
    });
  } else {
    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
  }
  Object.keys(maskStyle).forEach(function (property) {
    instance.$el.style[property] = maskStyle[property];
  });
};

var src_Loading = function Loading() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (external_vue_default.a.prototype.$isServer) return;
  options = merge_default()({}, defaults, options);
  if (typeof options.target === 'string') {
    options.target = document.querySelector(options.target);
  }
  options.target = options.target || document.body;
  if (options.target !== document.body) {
    options.fullscreen = false;
  } else {
    options.body = true;
  }
  if (options.fullscreen && fullscreenLoading) {
    return fullscreenLoading;
  }

  var parent = options.body ? document.body : options.target;
  var instance = new LoadingConstructor({
    el: document.createElement('div'),
    data: options
  });

  src_addStyle(options, parent, instance);
  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
  }
  if (options.fullscreen && options.lock) {
    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
  }
  parent.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.visible = true;
  });
  if (options.fullscreen) {
    fullscreenLoading = instance;
  }
  return instance;
};

/* harmony default export */ var src = (src_Loading);
// CONCATENATED MODULE: ./packages/loading/index.js



/* harmony default export */ var packages_loading = __webpack_exports__["default"] = ({
  install: function install(Vue) {
    Vue.use(directive);
    Vue.prototype.$loading = src;
  },

  directive: directive,
  service: src
});

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__("a6f3");

/***/ })

/******/ });

/***/ }),

/***/ "89ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__("242d");
var uncurryThis = __webpack_require__("7630");
var toString = __webpack_require__("90a9");
var validateArgumentsLength = __webpack_require__("ee1f");

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ "8b31":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "8b8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8bca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("799f");
var $findLast = __webpack_require__("22ec").findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlast
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "8cd3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "8e6f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("2703");
var toAbsoluteIndex = __webpack_require__("64d4");
var lengthOfArrayLike = __webpack_require__("2e86");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "90a9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("69a2");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "9310":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("6d4e");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "93c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__("20a5");
var defineProperty = __webpack_require__("47c8");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "95b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__("242d");
var uncurryThis = __webpack_require__("7630");
var toString = __webpack_require__("90a9");
var validateArgumentsLength = __webpack_require__("ee1f");

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ "97bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("08a0");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "99db":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ "9ebc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "a059":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "a1e9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a6cc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "a6f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),

/***/ "a8c9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var classof = __webpack_require__("37cd");

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ "a961":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "aa32":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("54df");
var call = __webpack_require__("2f9c");
var uncurryThis = __webpack_require__("7630");
var requireObjectCoercible = __webpack_require__("37d8");
var isCallable = __webpack_require__("0d52");
var isNullOrUndefined = __webpack_require__("01da");
var isRegExp = __webpack_require__("e4be");
var toString = __webpack_require__("90a9");
var getMethod = __webpack_require__("e043");
var getRegExpFlags = __webpack_require__("4d40");
var getSubstitution = __webpack_require__("740c");
var wellKnownSymbol = __webpack_require__("eebc");
var IS_PURE = __webpack_require__("eed0");

var REPLACE = wellKnownSymbol('replace');
var $TypeError = TypeError;
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
        if (!~indexOf(flags, 'g')) throw new $TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});


/***/ }),

/***/ "aa98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("14a3");
var aCallable = __webpack_require__("f938");
var NATIVE_BIND = __webpack_require__("a059");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "abb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var definePropertyModule = __webpack_require__("47c8");
var createPropertyDescriptor = __webpack_require__("8b31");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "aef3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("eebc");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "b081":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};

exports.default = aria.Utils;

/***/ }),

/***/ "b135":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "b150":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "b166":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = __webpack_require__("c54a");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __webpack_require__("d246");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__("480ab");

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.type === "textarea" ? "el-textarea" : "el-input",
        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
        {
          "is-disabled": _vm.inputDisabled,
          "is-exceed": _vm.inputExceed,
          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "el-input-group--append": _vm.$slots.append,
          "el-input-group--prepend": _vm.$slots.prepend,
          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "el-input--suffix":
            _vm.$slots.suffix ||
            _vm.suffixIcon ||
            _vm.clearable ||
            _vm.showPassword
        }
      ],
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      _vm.type !== "textarea"
        ? [
            _vm.$slots.prepend
              ? _c(
                  "div",
                  { staticClass: "el-input-group__prepend" },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e(),
            _vm.type !== "textarea"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      staticClass: "el-input__inner",
                      attrs: {
                        tabindex: _vm.tabindex,
                        type: _vm.showPassword
                          ? _vm.passwordVisible
                            ? "text"
                            : "password"
                          : _vm.type,
                        disabled: _vm.inputDisabled,
                        readonly: _vm.readonly,
                        autocomplete: _vm.autoComplete || _vm.autocomplete,
                        "aria-label": _vm.label
                      },
                      on: {
                        compositionstart: _vm.handleCompositionStart,
                        compositionupdate: _vm.handleCompositionUpdate,
                        compositionend: _vm.handleCompositionEnd,
                        input: _vm.handleInput,
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _vm._e(),
            _vm.$slots.prefix || _vm.prefixIcon
              ? _c(
                  "span",
                  { staticClass: "el-input__prefix" },
                  [
                    _vm._t("prefix"),
                    _vm.prefixIcon
                      ? _c("i", {
                          staticClass: "el-input__icon",
                          class: _vm.prefixIcon
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm.getSuffixVisible()
              ? _c("span", { staticClass: "el-input__suffix" }, [
                  _c(
                    "span",
                    { staticClass: "el-input__suffix-inner" },
                    [
                      !_vm.showClear ||
                      !_vm.showPwdVisible ||
                      !_vm.isWordLimitVisible
                        ? [
                            _vm._t("suffix"),
                            _vm.suffixIcon
                              ? _c("i", {
                                  staticClass: "el-input__icon",
                                  class: _vm.suffixIcon
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.showClear
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-circle-close el-input__clear",
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault()
                              },
                              click: _vm.clear
                            }
                          })
                        : _vm._e(),
                      _vm.showPwdVisible
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-view el-input__clear",
                            on: { click: _vm.handlePasswordVisible }
                          })
                        : _vm._e(),
                      _vm.isWordLimitVisible
                        ? _c("span", { staticClass: "el-input__count" }, [
                            _c(
                              "span",
                              { staticClass: "el-input__count-inner" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.textLength) +
                                    "/" +
                                    _vm._s(_vm.upperLimit) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.validateState
                    ? _c("i", {
                        staticClass: "el-input__icon",
                        class: ["el-input__validateIcon", _vm.validateIcon]
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.$slots.append
              ? _c(
                  "div",
                  { staticClass: "el-input-group__append" },
                  [_vm._t("append")],
                  2
                )
              : _vm._e()
          ]
        : _c(
            "textarea",
            _vm._b(
              {
                ref: "textarea",
                staticClass: "el-textarea__inner",
                style: _vm.textareaStyle,
                attrs: {
                  tabindex: _vm.tabindex,
                  disabled: _vm.inputDisabled,
                  readonly: _vm.readonly,
                  autocomplete: _vm.autoComplete || _vm.autocomplete,
                  "aria-label": _vm.label
                },
                on: {
                  compositionstart: _vm.handleCompositionStart,
                  compositionupdate: _vm.handleCompositionUpdate,
                  compositionend: _vm.handleCompositionEnd,
                  input: _vm.handleInput,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange
                }
              },
              "textarea",
              _vm.$attrs,
              false
            )
          ),
      _vm.isWordLimitVisible && _vm.type === "textarea"
        ? _c("span", { staticClass: "el-input__count" }, [
            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
var migrating_ = __webpack_require__(11);
var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
};
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_ = __webpack_require__(21);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [emitter_default.a, migrating_default.a],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator: function validator(val) {
          false && false;
        return true;
      }
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    },
    isWordLimitVisible: function isWordLimitVisible() {
      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
    },
    upperLimit: function upperLimit() {
      return this.$attrs.maxlength;
    },
    textLength: function textLength() {
      if (typeof this.value === 'number') {
        return String(this.value).length;
      }

      return (this.value || '').length;
    },
    inputExceed: function inputExceed() {
      // show exceed style if length of initial value greater then maxlength
      return this.isWordLimitVisible && this.textLength > this.upperLimit;
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },

    // native input value is set explicitly
    // do not use v-model / :value in template
    // see: https://github.com/ElemeFE/element/issues/14521
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },

    // when change between <input> and <textarea>,
    // update DOM dependent value and styles
    // https://github.com/ElemeFE/element/issues/14857
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart(event) {
      this.$emit('compositionstart', event);
      this.isComposing = true;
    },
    handleCompositionUpdate: function handleCompositionUpdate(event) {
      this.$emit('compositionupdate', event);
      var text = event.target.value;
      var lastCharacter = text[text.length - 1] || '';
      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      this.$emit('compositionend', event);
      if (this.isComposing) {
        this.isComposing = false;
        this.handleInput(event);
      }
    },
    handleInput: function handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return;

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
      if (!elList.length) return;
      var el = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }
      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      var _this2 = this;

      this.passwordVisible = !this.passwordVisible;
      this.$nextTick(function () {
        _this2.focus();
      });
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    getSuffixVisible: function getSuffixVisible() {
      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
});
// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/input/src/input.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/input/src/input.vue"
/* harmony default export */ var input = (component.exports);
// CONCATENATED MODULE: ./packages/input/index.js


/* istanbul ignore next */
input.install = function (Vue) {
  Vue.component(input.name, input);
};

/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__("a6f3");

/***/ })

/******/ });

/***/ }),

/***/ "b4db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MatrixScale_vue_vue_type_style_index_0_id_0940c748_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ba8c");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MatrixScale_vue_vue_type_style_index_0_id_0940c748_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MatrixScale_vue_vue_type_style_index_0_id_0940c748_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b799":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("2f9c");
var isObject = __webpack_require__("e2a4");
var isSymbol = __webpack_require__("fd95");
var getMethod = __webpack_require__("e043");
var ordinaryToPrimitive = __webpack_require__("eb72");
var wellKnownSymbol = __webpack_require__("eebc");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "b7d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "b839":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__("90a9");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "ba17":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("a059");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "ba8c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bcf4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("a6cc");
var isCallable = __webpack_require__("0d52");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "be09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MaxDiff_vue_vue_type_style_index_0_id_8527e586_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("24fe");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MaxDiff_vue_vue_type_style_index_0_id_8527e586_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_MaxDiff_vue_vue_type_style_index_0_id_8527e586_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bf92":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "bf98":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("4d2b");

/***/ }),

/***/ "c3c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ "c512":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnswerStatus */
/* unused harmony export Blanks */
/* unused harmony export BoundFailedType */
/* unused harmony export BoundStatus */
/* unused harmony export Bus */
/* unused harmony export BusData */
/* unused harmony export CascaderStyleType */
/* unused harmony export ErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileErrorCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GD_KEY; });
/* unused harmony export H5PlatformInit */
/* unused harmony export H5Platforms */
/* unused harmony export MessageType */
/* unused harmony export OAUTH_INFO_API_URL */
/* unused harmony export PostMessage */
/* unused harmony export Question */
/* unused harmony export Queue */
/* unused harmony export RequiredType */
/* unused harmony export SEPARATOR */
/* unused harmony export SelectType */
/* unused harmony export SubmitErrorCode */
/* unused harmony export UploadConfig */
/* unused harmony export ValidateRule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ValidateType; });
/* unused harmony export addErrorLog */
/* unused harmony export addEventListener */
/* unused harmony export addLogStory */
/* unused harmony export addorUpdateWjInvestigator */
/* unused harmony export answerGetAward */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return answerMixin; });
/* unused harmony export answerPreview */
/* unused harmony export answeringThirdSurvey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return appendQuotaText; });
/* unused harmony export audioFiles */
/* unused harmony export batchProcess */
/* unused harmony export bindExtraAward */
/* unused harmony export bindingPassword */
/* unused harmony export bingAnswerAndGetUser */
/* unused harmony export busGetters */
/* unused harmony export calcNumExpress */
/* unused harmony export cascaderTypes */
/* unused harmony export checkAnswer */
/* unused harmony export checkContent */
/* unused harmony export checkFile */
/* unused harmony export checkFileType */
/* unused harmony export checkPassword */
/* unused harmony export checkQuotaIsFull */
/* unused harmony export checkUrl */
/* unused harmony export checkValidateValue */
/* unused harmony export clearStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return compareDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return componentMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return convertDownloadUrl; });
/* unused harmony export convertInputType */
/* unused harmony export convertQuestionList */
/* unused harmony export convertRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return convertUrl; });
/* unused harmony export copyProperty */
/* unused harmony export copyText */
/* unused harmony export cost_settlement_available_companyIds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createIssueFactory; });
/* unused harmony export createQuestionFactory */
/* unused harmony export createStyle */
/* unused harmony export dataURLToBlob */
/* unused harmony export dateTypes */
/* unused harmony export defaultsSurveyAttr */
/* unused harmony export defineFillValue */
/* unused harmony export docFiles */
/* unused harmony export downloadFileByStream */
/* unused harmony export downloadFileByUrl */
/* unused harmony export editAnswer */
/* unused harmony export editAnswerByAgent */
/* unused harmony export filterParams */
/* unused harmony export formatSeconds */
/* unused harmony export getAddress */
/* unused harmony export getAllStore */
/* unused harmony export getAnswerChatGPT */
/* unused harmony export getAnswerDimensionScore */
/* unused harmony export getAnswerHistory */
/* unused harmony export getAnswerIdByPhone */
/* unused harmony export getAnswerItemByExpr */
/* unused harmony export getAnswerPoint */
/* unused harmony export getAnswerRes */
/* unused harmony export getAnswerScore */
/* unused harmony export getAwardBySurveyId */
/* unused harmony export getAwardCountBySurveyId */
/* unused harmony export getAwardInfoByAnswerId */
/* unused harmony export getAwardV2BySurveyId */
/* unused harmony export getCanLuck */
/* unused harmony export getCascaderRegion */
/* unused harmony export getChannelById */
/* unused harmony export getComponentFactory */
/* unused harmony export getCoupon */
/* unused harmony export getCouponHistory */
/* unused harmony export getCouponSetting */
/* unused harmony export getCurrentAnswerHide */
/* unused harmony export getExprValueByAnswer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFileStream; });
/* unused harmony export getFinger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getGeocode; });
/* unused harmony export getH5Platform */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getHistoryQuestionAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getImgCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getInputPrefixIcon; });
/* unused harmony export getJsSDKSignature */
/* unused harmony export getMeetConditionsByValue */
/* unused harmony export getMiniProgramScheme */
/* unused harmony export getMoreSurveyList */
/* unused harmony export getMoreSurveyStatus */
/* unused harmony export getOfficialAccountQrcode */
/* unused harmony export getPageConfigByKeys */
/* unused harmony export getPlatformSdk */
/* unused harmony export getPositionList */
/* unused harmony export getShareAnswer */
/* unused harmony export getSourceAnswer */
/* unused harmony export getSpecialSettingStatus */
/* unused harmony export getStatusConfig */
/* unused harmony export getStore */
/* unused harmony export getSurvey */
/* unused harmony export getSurveyById */
/* unused harmony export getSurveyInformedConsent */
/* unused harmony export getSurveyPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getTextFillErrorTip; });
/* unused harmony export getUserById */
/* unused harmony export getUserInformedConsentSign */
/* unused harmony export getUserStoryByAnswerId */
/* unused harmony export getViewAnswer */
/* unused harmony export hasValue */
/* unused harmony export html2text */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return imageFiles; });
/* unused harmony export initContent */
/* unused harmony export initDefaultsTip */
/* unused harmony export initQuotaCount */
/* unused harmony export invalidMine */
/* unused harmony export investigatorMixin */
/* unused harmony export isOnlyImageType */
/* unused harmony export isPC */
/* unused harmony export isSameValue */
/* unused harmony export isWeixin */
/* unused harmony export jsonp */
/* unused harmony export linkLogoSrc */
/* unused harmony export loadScript */
/* unused harmony export logoSrc */
/* unused harmony export loopList */
/* unused harmony export merge */
/* unused harmony export normalMax */
/* unused harmony export normalMin */
/* unused harmony export normalizeUrlParams */
/* unused harmony export normalizeUrlParamsDouble */
/* unused harmony export objectToQuery */
/* unused harmony export once */
/* unused harmony export padLeft */
/* unused harmony export questionSubType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return questionType; });
/* unused harmony export randList */
/* unused harmony export reRequest */
/* unused harmony export receiveAward */
/* unused harmony export refreshAnswerAddress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return registerMixin; });
/* unused harmony export removeStore */
/* unused harmony export request */
/* unused harmony export resetQuestionListNum */
/* unused harmony export rowRandList */
/* unused harmony export secondToTime */
/* unused harmony export sendMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sendSmsCode; });
/* unused harmony export serialize */
/* unused harmony export setRequestInterceptors */
/* unused harmony export setResponseInterceptors */
/* unused harmony export setStore */
/* unused harmony export showReportAfterAnswer */
/* unused harmony export shuffle */
/* unused harmony export singleTypes */
/* unused harmony export startAnswering */
/* unused harmony export startTestAnswering */
/* unused harmony export submitAnswer */
/* unused harmony export textMap */
/* unused harmony export textTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return transFormPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return transformRichText2Text; });
/* unused harmony export typeMapping */
/* unused harmony export updateById */
/* unused harmony export updateUserByWxCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return validateCode; });
/* unused harmony export validatenull */
/* unused harmony export valueByCalc */
/* unused harmony export videoFiles */
/* unused harmony export zipFiles */
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("58f3");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_exception_stack_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4e07");
/* harmony import */ var core_js_modules_web_dom_exception_stack_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_exception_stack_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_typed_array_at_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1081");
/* harmony import */ var core_js_modules_es_typed_array_at_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_at_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_typed_array_find_last_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8bca");
/* harmony import */ var core_js_modules_es_typed_array_find_last_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_last_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_typed_array_find_last_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fd1c");
/* harmony import */ var core_js_modules_es_typed_array_find_last_index_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_find_last_index_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("70d6");
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_typed_array_to_reversed_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("cdb3");
/* harmony import */ var core_js_modules_es_typed_array_to_reversed_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_reversed_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_typed_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("05bc");
/* harmony import */ var core_js_modules_es_typed_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_typed_array_with_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("685f");
/* harmony import */ var core_js_modules_es_typed_array_with_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_with_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("95b2");
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("89ca");
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("66d4");
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4aa6");
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("178e");
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_replace_all_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("aa32");
/* harmony import */ var core_js_modules_es_string_replace_all_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_all_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_reflect_to_string_tag_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("6e2e");
/* harmony import */ var core_js_modules_es_reflect_to_string_tag_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_to_string_tag_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var jsonp__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("14d1");
/* harmony import */ var jsonp__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(jsonp__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var clipboard__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("5c75");
/* harmony import */ var clipboard__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(clipboard__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("bf98");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("638a");
/* harmony import */ var _survey_util__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("82f4");






















function jsonp(url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);
  return new Promise((resolve, reject) => {
    jsonp__WEBPACK_IMPORTED_MODULE_16___default()(url, option, (err, data) => {
      if (!err) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}
function param(data) {
  let url = '';
  for (const k in data) {
    let value = data[k] !== undefined ? data[k] : '';
    url += '&' + k + '=' + encodeURIComponent(value);
  }
  return url ? url.substring(1) : '';
}
const request = axios__WEBPACK_IMPORTED_MODULE_18___default.a.create();
const convertRequest = axios__WEBPACK_IMPORTED_MODULE_18___default.a.create({
  baseURL: window.location.origin
});
convertRequest.interceptors.response.use(res => {
  return res.data;
});
const createReRequest = () => {
  const instance = axios__WEBPACK_IMPORTED_MODULE_18___default.a.create({
    baseURL: window.location.origin
  });
  instance.interceptors.response.use(res => {
    return res.data;
  }, error => {
    const config = error.config;
    const is_timeout = error.code === "ECONNABORTED" && (config.reCount || 0) < 3;
    const is_retry = error.response && error.response.status >= 500 && error.isAxiosError && (config.reCount || 0) < 10;
    if (is_timeout || is_retry) {
      config.reCount = (config.reCount || 0) + 1;
      return instance(config);
    }
    return Promise.reject(error);
  });
  return instance;
};
const reRequest = createReRequest();
const setRequestInterceptors = function (transform) {
  request.interceptors.request.use(transform);
  convertRequest.interceptors.request.use(transform);
  reRequest.interceptors.request.use(transform);
};
const setResponseInterceptors = function (...args) {
  request.interceptors.response.use(...args);
  convertRequest.interceptors.response.use(...args);
  reRequest.interceptors.response.use(...args);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
const defaultsSurveyAttr = {
  welcome: '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！'
};
// export const GD_KEY = '7bd1074152ac09c17080952b9ed1aa55'
// export const GD_KEY = '544a0f9cbeaa8989627e8fb101708ad3'
// export const GD_KEY = '58fcd2e537a1da4b577ef5f2d7e2daca'
const GD_KEY = '3b3590d07b87fb4b49c74d0a00dece14';
const SEPARATOR = '|'; // 地理位置答案分割符
const SelectType = {
  Include: 'contain',
  NotInclude: 'not_contain',
  Equal: 'eq',
  NotEqual: 'ne',
  Select: 'contain',
  NotSelect: 'not_contain',
  Null: 'is_null',
  NotNull: 'not_null',
  Show: 'display',
  Hidden: 'hidden',
  GT: 'gt',
  GTEqual: 'ge',
  LT: 'lt',
  LTEqual: 'le',
  Between: 'between',
  NotBetween: 'not_between'
};
/**
 * 北京清研灵智科技有限公司 7
 * 贵州清研灵智信息咨询有限公司 1451012
 * 优数研科环境科技（北京）有限公司 1451011
 * 北京数太奇科技有限公司 32
 * 北京奕捷科技有限责任公司 1450982
 * 北京达洲信息咨询有限公司 1451052
 * 北京清研灵智文化传播有限公司 1451082
 * 现阶段是如上【7】家企业可签署协议，签署人为企业管理员身份可签署，企业签署后，可使用结算
 */
const cost_settlement_available_companyIds = [7, 1451012, 1451011, 32, 1450982, 1451052, 1451082];
const OAUTH_INFO_API_URL = '/award/oauthInfo';

// 双向支持url参数解析（hash和search先后顺序不同都能获取到参数）
function normalizeUrlParamsDouble() {
  const href = window.location.href || '';
  const sIndex = href.indexOf('?');
  if (sIndex === -1) return {};
  const hIndex = href.indexOf('#');
  const result = {};
  let kvstr = '';
  if (sIndex < hIndex) {
    // ?在#前面
    const search = window.location.search || '';
    kvstr = search.replace(/^\?|\/$/g, '');
  } else {
    // #在?前面
    kvstr = href.split('?')[1] || '';
  }
  kvstr.split('&').forEach(kv => {
    const [k, v] = kv.split('=');
    result[k] = v;
  });
  return result;
}
function normalizeUrlParams(needNull = false, url = '') {
  const result = {};
  url = url || window.location.href.split('#')[0];
  let kvstr = url.split('?')[1];
  if (!kvstr) {
    return result;
  }
  kvstr.split('&').forEach(kv => {
    const [k, v] = kv.split('=');
    if (!needNull) {
      if (['null', 'undefined'].includes(v)) return;
    }
    result[k] = v;
  });
  return result;
}
function objectToQuery(obj) {
  let params = [];
  Object.keys(obj).forEach(key => {
    params.push(`${key}=${obj[key]}`);
  });
  return params.join('&');
}
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * 乱序方法
 * @param{Array} arr
 * @return {Array} 乱序之后的数组
 */
function shuffle(arr) {
  let _arr = arr.slice();
  for (let i = 0; i < _arr.length; i++) {
    let j = getRandomInt(0, i);
    let t = _arr[i];
    _arr[i] = _arr[j];
    _arr[j] = t;
  }
  return _arr;
}
function registerMixin(components, mixins) {
  mixins = Array.isArray(mixins) ? mixins : [mixins];
  Object.keys(components).forEach(key => {
    const c = components[key];
    if (!c.mixins) {
      c.mixins = [];
    }
    mixins.forEach(mixin => {
      let m = typeof mixin === 'function' ? mixin(c) : mixin;
      c.mixins.push(m);
    });
  });
}
function once(handler) {
  let isRun = false;
  return function () {
    if (isRun) return;
    handler && handler();
    isRun = true;
  };
}
function addEventListener(dom, event, handler) {
  dom.addEventListener(event, handler);
  return function () {
    dom.removeEventListener(event, handler);
  };
}
function filterParams(data, option) {
  let {
    needNoopStr,
    ignoreKeys
  } = option || {};
  let result = {};
  Object.keys(data).forEach(k => {
    let key = k;
    let val = data[key];
    if (ignoreKeys && ignoreKeys.includes(k)) return;
    let valType = typeof val;
    if (valType === 'boolean' || valType === 'number' || needNoopStr && valType === 'string') {
      result[key] = val;
    } else if (val) {
      result[key] = val;
    }
  });
  return result;
}
function copyText(selector, text) {
  let clipboard = new clipboard__WEBPACK_IMPORTED_MODULE_17___default.a(selector, {
    text(elem) {
      return text;
    }
  });
  return new Promise((resolve, reject) => {
    clipboard.on('success', () => {
      clipboard.destroy();
      resolve(true);
    });
    clipboard.on('error', () => {
      clipboard.destroy();
      reject(false);
    });
  });
}
function downloadFileByUrl(url, downloadName) {
  let link = document.createElement('a');
  link.download = downloadName;
  link.href = url;
  link.click();
}
// 表单序列化
const serialize = data => {
  const list = [];
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join('&');
};
// dataURL转换成blob
const dataURLToBlob = dataurl => {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = window.atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};
function hasValue(val) {
  if (val === 0) return true;
  if (typeof val === 'boolean') return true;
  return !!val;
}
function padLeft(value, char, num = 2) {
  let val = value.toString();
  let len = val.length;
  if (len < num) {
    val = char.repeat(num - len) + val;
  }
  return val;
}
function formatSeconds(value) {
  let secondTime = parseInt(value.toString()); // 秒
  let minuteTime = 0; // 分
  let hourTime = 0; // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = secondTime / 60 | 0;
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = secondTime % 60;
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = minuteTime / 60 | 0;
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = minuteTime % 60;
    }
  }
  let day = 0;
  if (hourTime >= 24) {
    day = hourTime / 24 | 0;
    hourTime = hourTime % 24;
  }
  let result = '';
  result = result + '' + padLeft(secondTime, '0');
  result = padLeft(minuteTime, '0') + ':' + result;
  result = padLeft(hourTime, '0') + ':' + result;
  if (day > 0) {
    result = `${day}天` + result;
  }
  return result;
}
function secondToTime(val, splits = []) {
  const result = formatSeconds(val);
  const vals = result.split(':');
  let res = [];
  let tmp = '';
  while (tmp = vals.pop()) {
    if (tmp === '00') continue;
    res.push(tmp + (splits.pop() || ''));
  }
  return res.reverse().join('');
}
function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  let res = ua.match(/MicroMessenger/i);
  let work = ua.match(/wxwork/i);
  if (!res) return false;
  if (work) {
    if (work[0] === "wxwork") {
      return false;
    }
  }
  return String(res[0]).toUpperCase() == 'micromessenger'.toUpperCase();
}
function getH5Platform() {
  const res = {
    weixin: false,
    alipay: false
  };
  let ua = navigator.userAgent.toLowerCase();
  if (isWeixin()) {
    res.weixin = true;
  } else if (ua.includes('alipayclient')) {
    res.alipay = true;
  }
  return res;
}
function isPC() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'Phone'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  // if (!flag && !window.matchMedia('(min-width: 800px)').matches) {
  //   // fix: 鸿蒙浏览器
  //   return true
  // }
  return flag;
}
function merge(source1, source2, mergeOption) {
  const result = {};
  let keys = Object.keys(source1);
  let keys2 = Object.keys(source2);
  for (const key of keys) {
    const handler = mergeOption === null || mergeOption === void 0 ? void 0 : mergeOption[key];
    if (handler) {
      result[key] = handler(source1[key], source2[key]);
    } else {
      if (hasValue(source1[key])) {
        result[key] = source1[key];
      } else {
        result[key] = source2[key];
      }
    }
  }
  for (const key of keys2) {
    if (!result[key]) {
      result[key] = source2[key];
    }
  }
  return result;
}
function loadScript(url) {
  return new Promise((resolve, reject) => {
    let scriptElement = document.createElement('script');
    scriptElement.src = url;
    scriptElement.onload = function (e) {
      console.log(e);
      resolve(null);
    };
    scriptElement.onerror = function () {
      reject();
    };
    document.body.appendChild(scriptElement);
  });
}
/**
 *
 * @param date1
 * @param date2
 * @param type 年 月 日 时 分 秒 （1 | 2 | 3 | 4 | 5 | 6）
 */
function compareDate(date1, date2, type) {
  const y1 = date1.getFullYear();
  const y2 = date2.getFullYear();
  if (y1 === y2) {
    if (type === 1) return 0;
    const M1 = date1.getMonth() + 1;
    const M2 = date2.getMonth() + 1;
    if (M1 === M2) {
      if (type === 2) return 0;
      const d1 = date1.getDate();
      const d2 = date2.getDate();
      if (d1 === d2) {
        if (type === 3) return 0;
        const h1 = date1.getHours();
        const h2 = date2.getHours();
        if (h1 === h2) {
          if (type === 4) return 0;
          const m1 = date1.getMinutes();
          const m2 = date2.getMinutes();
          if (m1 === m2) {
            if (type === 5) return 0;
            const s1 = date1.getSeconds();
            const s2 = date2.getSeconds();
            return s1 === s2 ? 0 : s1 > s2 ? 1 : -1;
          } else {
            return m1 > m2 ? 1 : -1;
          }
        } else {
          return h1 > h2 ? 1 : -1;
        }
      } else {
        return d1 > d2 ? 1 : -1;
      }
    } else {
      return M1 > M2 ? 1 : -1;
    }
  } else {
    return y1 > y2 ? 1 : -1;
  }
}
function copyProperty(target, source) {
  const keys = Object.keys(target);
  keys.forEach(key => {
    // @ts-ignore
    target[key] = source[key] || target[key];
  });
}
function getComponentFactory(components = {}) {
  return function getComponentName(type) {
    let s = Object.keys(components).find(key => {
      let t = components[key].type;
      if (Array.isArray(t)) {
        return t.includes(type);
      } else {
        return t === type;
      }
    });
    if (!s) {
      return null;
    }
    return components[s];
  };
}
/**
 * 简易判断两个对象是否一致
 * @param val1
 * @param val2
 */
function isSameValue(val1, val2) {
  if (val1 === null && val2 === null) return true;
  if (val1 === undefined && val2 === undefined) return true;
  const val1_type = typeof val1;
  const val2_type = typeof val2;
  if (val1_type !== val2_type) return false;
  if (Array.isArray(val1) && Array.isArray(val2)) {
    if (val1.length !== val2.length) return false;
    return val1.every((item, index) => {
      return isSameValue(item, val2[index]);
    });
  } else if (val1_type === 'object' && val2_type === 'object') {
    const val1_keys = Object.keys(val1);
    const val2_keys = Object.keys(val2);
    const isSame = isSameValue(val1_keys, val2_keys);
    if (!isSame) return false;
    return val1_keys.every(key => {
      const v1 = val1[key];
      const v2 = val2[key];
      return isSameValue(v1, v2);
    });
  }
  return val1 === val2;
}

/**
 * 判断是否为空
 */
function validatenull(val) {
  if (typeof val === 'boolean') {
    return false;
  }
  if (typeof val === 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true;
    return false;
  }
  return false;
}
const keyName = 'wjb' + '-';
/**
 * 存储localStorage
 */
const setStore = (params = {}) => {
  let {
    name,
    content,
    type
  } = params;
  name = keyName + name;
  const obj = {
    dataType: typeof content,
    content: content,
    type: type,
    datetime: new Date().getTime()
  };
  if (type) window.sessionStorage.setItem(name, JSON.stringify(obj));else window.localStorage.setItem(name, JSON.stringify(obj));
};
/**
 * 获取localStorage
 */
const getStore = (params = {}) => {
  let {
    name,
    debug
  } = params;
  name = keyName + name;
  let obj;
  let content;
  obj = window.sessionStorage.getItem(name);
  if (validatenull(obj)) obj = window.localStorage.getItem(name);
  if (validatenull(obj)) return;
  try {
    obj = JSON.parse(obj);
  } catch (e) {
    return obj;
  }
  if (debug) {
    return obj;
  }
  if (obj.dataType === 'string') {
    content = obj.content;
  } else if (obj.dataType === 'number') {
    content = Number(obj.content);
  } else if (obj.dataType === 'boolean') {
    content = obj.content === true;
  } else if (obj.dataType === 'object') {
    content = obj.content;
  }
  return content;
};
/**
 * 删除localStorage
 */
const removeStore = (params = {}) => {
  let {
    name,
    type
  } = params;
  name = keyName + name;
  if (type) {
    window.sessionStorage.removeItem(name);
  } else {
    window.localStorage.removeItem(name);
  }
};
/**
 * 获取全部localStorage
 */
const getAllStore = (params = {}) => {
  const list = [];
  const {
    type
  } = params;
  if (type) {
    for (let i = 0; i <= window.sessionStorage.length; i++) {
      list.push({
        name: window.sessionStorage.key(i),
        content: getStore({
          name: window.sessionStorage.key(i),
          type: 'session'
        })
      });
    }
  } else {
    for (let i = 0; i <= window.localStorage.length; i++) {
      list.push({
        name: window.localStorage.key(i),
        content: getStore({
          name: window.localStorage.key(i)
        })
      });
    }
  }
  return list;
};
/**
 * 清空全部localStorage
 */
const clearStore = (params = {}) => {
  const {
    type
  } = params;
  if (type) {
    window.sessionStorage.clear();
  } else {
    window.localStorage.clear();
  }
};
class PostMessage {
  constructor(targetOrigin) {
    this.targetOrigin = targetOrigin;
    this.targetOrigin = targetOrigin;
  }
  sendMessage(type, data) {
    if (window.top === window) return;
    const message = {
      message: type,
      payload: data
    };
    if (window.top) {
      window.top.postMessage(JSON.stringify(message), this.targetOrigin);
    }
  }
}
const imageFiles = ['.gif', '.png', '.jpg', '.jpeg'];
const docFiles = ['.doc', '.docx', '.pdf', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
const zipFiles = ['.rar', '.zip', '.gzip'];
const videoFiles = ['.mp4', '.m3u8', '.flv', '.f4v', '.webm', '.mov', '.m4v', '.3gp', '.avi', '.wmv'];
const audioFiles = ['.mp3', '.wma', '.wav', '.amr', '.m4a'];
const MB = 1024 * 1024;
const KB = 1024;
const UploadConfig = {
  SM_SIZE: MB * 5,
  LARGE_SIZE: MB * 20
};
const FileErrorCode = {
  MAX_SIZE: 1,
  NO_ALLOW_TYPE: 2
};
function isOnlyImageType(types) {
  if (!types.length) return false;
  if (types.length > imageFiles.length) {
    return false;
  }
  if (types.length === 1 && types[0] === 'img') return true;
  return types.every(t => {
    return imageFiles.includes(t);
  });
}
function checkFileType(file, allowTypes = []) {
  if (allowTypes.length === 0) return true;
  let fileSuffix = file.name.split('.').pop();
  let [, suffix] = file.type.split('/');
  let types = [fileSuffix === null || fileSuffix === void 0 ? void 0 : fileSuffix.toLowerCase(), suffix === null || suffix === void 0 ? void 0 : suffix.toLowerCase(), '.' + (fileSuffix === null || fileSuffix === void 0 ? void 0 : fileSuffix.toLowerCase())];
  return allowTypes.some(type => types.includes(type));
}
function checkFile(file, opt) {
  let error;
  let maxSize = opt.maxSize || Infinity;
  if (opt.unit === 'MB') {
    maxSize = maxSize * MB;
  } else if (opt.unit === 'KB') {
    maxSize = maxSize * KB;
  }
  let allowTypes = opt.allowTypes || [];
  if (!checkFileType(file, allowTypes)) {
    error = {
      code: FileErrorCode.NO_ALLOW_TYPE,
      msg: `不支持的文件类型`
    };
  } else if (file.size > maxSize) {
    error = {
      code: FileErrorCode.MAX_SIZE,
      msg: `文件最大不可超过 ${maxSize / MB | 0}MB`
    };
  }
  return error;
}
function uploadFile(maxSize = Infinity, allowTypes = [], option) {
  let opt;
  if (typeof maxSize === 'object') {
    opt = maxSize;
  } else if (typeof allowTypes === 'object' && !Array.isArray(allowTypes)) {
    opt = allowTypes;
    opt.maxSize = maxSize;
  } else {
    let o = option || {};
    o.maxSize = maxSize;
    o.allowTypes = allowTypes;
    opt = o;
  }
  return new Promise((resolve, reject) => {
    let {
      success,
      error
    } = opt;
    success = success || resolve;
    error = error || reject;
    let inputElement;
    if (opt.el) {
      inputElement = opt.el;
    } else {
      inputElement = document.createElement('input');
      if (opt.accept) {
        inputElement.accept = opt.accept;
      } else if (isOnlyImageType(allowTypes)) {
        inputElement.accept = 'image/*';
      }
      inputElement.type = 'file';
      inputElement.multiple = !!opt.multiple;
    }
    inputElement.onchange = function (event) {
      if (inputElement.files) {
        if (opt.multiple) {
          let files = Array.from(inputElement.files);
          inputElement.value = '';
          if (files) {
            let errorRes = null;
            for (let i = 0, len = files.length; i < len; i++) {
              let file = files[i];
              let err = checkFile(file, opt);
              if (err) {
                errorRes = err;
                break;
              }
            }
            if (errorRes) {
              error(errorRes);
            } else {
              success(files);
            }
          }
        } else {
          let file = inputElement.files[0];
          inputElement.value = '';
          if (file) {
            let err = checkFile(file, opt);
            if (err) {
              error(err);
            } else {
              success(file);
            }
          }
        }
      }
    };
    if (!opt.el) {
      inputElement.click();
    }
  });
}
function stream2Blob(stream) {
  return new Blob([stream], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
}
function downloadFileByStream(stream, responseHeaders) {
  const blob = stream2Blob(stream);
  let contentDisposition = responseHeaders['content-disposition'];
  let patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
  let result = patt.exec(contentDisposition);
  let fileName = result[1];
  const elink = document.createElement('a');
  let reg = /^["](.*)["]$/g;
  elink.download = decodeURI(fileName.replace(reg, '$1'));
  elink.style.display = 'none';
  elink.href = URL.createObjectURL(blob);
  elink.click();
  URL.revokeObjectURL(elink.href); //释放掉blob对象
}
function nameRule(val = '') {
  return /^[\u2E80-\u9FFF]{2,4}$/.test(val);
}
function emailRule(val) {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(val);
}
function phoneRule(val) {
  return /^1[3-9]\d{9}$/.test(val);
}
//匹配正整数
function positiveInteger(val) {
  return /^[1-9]\d*$/.test(val);
}
//匹配正整数+小数
function positiveIntegerAndDigit(val) {
  return /^[0-9]\d*\.?\d{0,2}$/.test(val);
}
function isNum(val) {
  return /^\d+$/.test(val);
}
//匹配整数(带负数)
function integer(val) {
  return /^-?[1-9]\d*$/.test(val);
}
//匹配整数(带负数、小数)
function integerAndDigit(val, digit = 2) {
  let reg = new RegExp(`^-?([0-9]\\d*\\.?\\d{0,${digit}})?$`);
  return reg.test(val);
}
/**
 * 是否是中文+字符
 * @param val
 */
function validateChinese(val) {
  // return !/[A-Za-z]/.test(val)
  return /^[\u2E80-\u9FFF]+$/.test(val);
}
/**
 * 是否是英文+字符
 * @param val
 */
function validateChar(val) {
  return /^\w+$/.test(val);
}
function checkYMD(str) {
  let y = Number(str.substr(0, 4));
  let m = Number(str.substr(4, 2));
  let d = Number(str.substr(6, 2));
  let isLeapYear = y % 4 === 0;
  let has_31 = [1, 3, 5, 7, 8, 10, 12];
  if (d > 31) return false;
  if (d === 31 && !has_31.includes(m)) return false;
  if (isLeapYear) {
    if (m === 2 && d > 29) return false;
  } else {
    if (m === 2 && d > 28) return false;
  }
  let date = new Date();
  if (y > date.getFullYear()) return false;
  if (y === date.getFullYear() && m > date.getMonth() + 1) return false;
  if (y === date.getFullYear() && m === date.getMonth() + 1 && d > date.getDate()) return false;
  if (date.getFullYear() - y > 300) return false;
  return true;
}
function cardid(code) {
  let result = true;
  let msg = '';
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  };
  if (!validatenull(code)) {
    if (code.length === 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = '证件号码格式错误';
      } else if (!city[Number(code.substr(0, 2))]) {
        msg = '地址编码错误';
      } else if (!checkYMD(code.substr(6, 8))) {
        msg = '证件号码校验位错误';
      } else {
        // 18位身份证需要验证最后一位校验位
        let codes = code.split('');
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x'];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = Number(codes[i]);
          wi = factor[i];
          sum += ai * wi;
        }
        if (parity[sum % 11] != codes[17]) {
          msg = '证件号码校验位错误';
        } else {
          result = false;
        }
      }
    } else {
      msg = '证件号码长度不为18位';
    }
  } else {
    msg = '证件号码不能为空';
  }
  return {
    result,
    msg
  };
}
function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}
const ValidateRule = {
  name: nameRule,
  email: emailRule,
  phone: phoneRule,
  positiveInteger: positiveInteger,
  integer: integer,
  positiveIntegerAndDigit,
  integerAndDigit,
  validateChar,
  validateChinese,
  validateIdNumber: cardid,
  isURL,
  isNum
};
function runQueue(queue = [], cb) {
  const step = (index, data) => {
    let result = data;
    // index === queue.length
    if (!queue.length) {
      cb && cb();
      return;
    }
    // let fn = queue[index]
    let fn = queue.shift();
    if (fn) {
      result = fn(result, data => {
        step(index + 1, data);
      });
      if (result instanceof Promise) {
        result.then(r => {
          result = r;
          step(index + 1, r);
        }).catch(() => {
          step(index + 1, null);
        });
      }
    } else {
      step(index + 1, data);
    }
  };
  step(0, undefined);
}
function convertQueueFn(fn) {
  return function (params, cb) {
    let f1 = fn(params);
    if (!(f1 instanceof Promise)) {
      cb && cb(f1);
    }
    return f1;
  };
}
class Queue {
  constructor() {
    this.handleList = [];
    this.start = false;
  }
  use(fn) {
    this.handleList.push(convertQueueFn(fn));
    return this.handleList.length - 1;
  }
  forEach(fn) {
    this.handleList.forEach(f => {
      if (f) {
        fn(f);
      }
    });
  }
  run(cb) {
    if (this.start) return;
    this.start = true;
    runQueue(this.handleList, () => {
      this.start = false;
      this.clear();
      cb && cb();
    });
  }
  clear() {
    this.start = false;
    this.handleList.length = 0;
  }
  getIsRunning() {
    return this.start;
  }
}
const defaultOpt = {
  max: 5
};
function batchProcess(opt = defaultOpt) {
  // const taskList: Array<TaskHandler> = []
  // const cacheList: Array<TaskHandler> = []
  // let isRunning = false
  return function (cb) {};
}
function html2text(html) {
  let divElement = document.createElement('div');
  divElement.innerHTML = html;
  return divElement.innerText;
}
function createStyle(option = {}) {
  const {
    themeColor,
    themeTextColor,
    themeBtnColor,
    themeBtnTextColor,
    coverImage,
    background = {},
    buttonOption = {}
  } = option;
  let styleElement = document.createElement('style');
  const bodyStyles = [['--theme-color', themeColor], ['--theme-text-color', themeTextColor], ['--btn-theme-color', themeBtnColor], ['--btn-theme-text-color', themeBtnTextColor]];
  const coverStyles = [['background-image', coverImage ? `url("${convertUrl(coverImage)}")` : 'none']];
  const bgStyles = [['background-image', background.image ? `url("${convertUrl(background.image)}")` : 'none']];
  const startButtonStyles = [['background-image', buttonOption.bgImage ? `url("${convertUrl(buttonOption.bgImage)}")` : 'none'], ['background-size', 'cover']];
  if (buttonOption.bgImage) {
    startButtonStyles.push(['border', 'none']);
  }
  switch (background.position) {
    case 'center':
      bgStyles.push(['background-size', 'auto']);
      bgStyles.push(['background-position', 'center']);
      bgStyles.push(['background-repeat', 'no-repeat']);
      break;
    case 'repeat':
      bgStyles.push(['background-size', 'auto']);
      bgStyles.push(['background-position', 'left']);
      bgStyles.push(['background-repeat', 'repeat']);
      break;
    case 'stretch':
      bgStyles.push(['background-size', 'cover']);
      bgStyles.push(['background-position', 'left']);
      bgStyles.push(['background-repeat', 'no-repeat']);
      break;
  }
  styleElement.innerHTML = `
            ${createStyleBlock('body', bodyStyles)}
            ${createStyleBlock('.cover-box', coverStyles)}
            ${createStyleBlock('.background-box', bgStyles)}
            ${createStyleBlock('.start-button', startButtonStyles)}
          `;
  let headEl = document.documentElement.getElementsByTagName('head')[0];
  headEl.append(styleElement);
}
function createStyleBlock(name, styles = []) {
  let text = `${name} { \n`;
  for (const [styleName, value] of styles) {
    if (hasValue(value)) {
      text += `${styleName}: ${value};`;
    }
  }
  text += '}';
  return text;
}
const jsapiShareList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'];
const weixin = {
  init: function (success) {
    loadScript('https://res2.wx.qq.com/open/js/jweixin-1.6.0.js').then(() => {
      const url = location.href.split('#')[0];
      getJsSDKSignature(url).then(res => {
        if (!res || !res.data) return;
        let data = res.data;
        wx.config({
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
          // 必填，需要使用的JS接口列表
          'getLocation', 'showMenuItems', 'uploadImage', 'downloadImage', 'hideMenuItems', 'hideAllNonBaseMenuItem', ...jsapiShareList]
        });
        wx.ready(() => {
          success();
        });
      });
    });
  },
  getLocation() {
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        wx.getLocation({
          success: res => {
            resolve({
              lng: res.longitude,
              lat: res.latitude
            });
          },
          error: err => {
            reject(err);
          },
          fail(err) {
            reject({
              message: '接口调用失败',
              err
            });
          },
          cancel(info) {
            reject({
              message: '用户取消',
              err: info,
              userRefuse: true
            });
          }
        });
      });
    });
  }
};
let isLoad = false;
let resolveFns = [];
const alipay = {
  init: function (success) {
    loadScript('https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.inc.min.js').then(() => {
      success();
      isLoad = true;
      // alert('alipay load')
      resolveFns.forEach(h => h());
    });
  },
  getLocation() {
    return new Promise((resolve, reject) => {
      const handler = () => {
        // alert('开始')
        try {
          // @ts-ignore
          ap.getLocation(res => {
            if (res.error) {
              switch (res.error) {
                case 12:
                case 13:
                  reject({
                    message: '定位失败',
                    err: res
                  });
                  break;
                case 14:
                  reject({
                    message: '定位超时',
                    err: res
                  });
                  break;
                case 15:
                  reject({
                    message: '网络错误',
                    err: res
                  });
                  break;
                case 16:
                case 20001:
                case 2001:
                  reject({
                    message: '用户未授权',
                    err: res
                  });
                  break;
                default:
              }
            } else {
              resolve({
                lng: res.longitude,
                lat: res.latitude
              });
            }
          });
        } catch (e) {
          alert('出错了');
          alert(JSON.stringify(e));
        }
      };
      if (!isLoad) {
        resolveFns.push(() => {
          handler();
        });
      } else {
        handler();
      }
    });
  }
};
const H5Platforms = {
  weixin,
  alipay
};
function H5PlatformInit(success) {
  let platformSdk = getPlatformSdk();
  if (platformSdk) {
    platformSdk.init(success);
  } else {
    success();
  }
}
function getPlatformSdk() {
  let platform = getH5Platform();
  if (platform.weixin) {
    return weixin;
  } else if (platform.alipay) {
    return alipay;
  } else {
    return null;
  }
}
const logoSrc = '/assets/img/logo.png';
const linkLogoSrc = '/assets/img/link-logo.png';
function getSurveyById(id, versionId) {
  return reRequest.get(`/wenjuan/wjsurvey/info/${id}`, {
    params: {
      versionId
    }
  });
}
function getJsSDKSignature(url) {
  return reRequest({
    method: 'get',
    url: '/award/jsapi?url=' + encodeURIComponent(url).replace('-', '%2D')
  });
}
function getChannelById(id) {
  if (!id) return Promise.resolve({
    data: {}
  });
  return reRequest.get(`/award/wjchannel/open/${id}`);
}
function getAwardBySurveyId(surveyId, answerChannelId) {
  return reRequest.get(`/award/wjaward/open/${surveyId}`, {
    params: {
      share: 1,
      answerChannelId
    }
  });
}
function getAwardV2BySurveyId(surveyId, answerChannelId) {
  return convertRequest.get('/award/wjaward/openV2', {
    params: {
      surveyId,
      answerChannelId
    }
  });
}
function getAwardInfoByAnswerId(answerId) {
  return convertRequest.get('/award/wjaward/getAwardInfo', {
    params: {
      answerId
    }
  });
}
function getAwardCountBySurveyId(surveyId) {
  return convertRequest.post(`award/wjawardsend/selectAwardInfosByInnerForSurveyId?surveyId=${surveyId}`);
}
// 计算第三方问卷的答题时间
function answeringThirdSurvey(params = {}) {
  return convertRequest.get(`wjsample/thirdAnswer/answeringThirdSurvey`, {
    params
  });
}
function startAnswering(data, params = {}) {
  return reRequest.post('/answering/answer/startAnswering', data, {
    params
  });
}
function startTestAnswering(data, params) {
  return reRequest.post('/answering/answer/startAnsweringTest', data, {
    params
  });
}
function getGeocode(point) {
  let url = `https://restapi.amap.com/v3/geocode/regeo?output=JSON&location=${point}&key=${GD_KEY}&radius=1000&extensions=all`;
  return jsonp(url, null, {});
}
function transFormPoint(lon, lat) {
  let url = `https://restapi.amap.com/v3/assistant/coordinate/convert?locations=${lon},${lat}&coordsys=gps&output=JSON&key=${GD_KEY}`;
  return jsonp(url, null, {});
}
function getPositionList(str) {
  let url = `https://restapi.amap.com/v3/place/text?keywords=${str}&key=${GD_KEY}&types=&city=&children=1&offset=20&page=1&extensions=all`;
  return jsonp(url, null, {});
}
function refreshAnswerAddress(data) {
  return convertRequest.post('/answer/answer/refreshAddress', data);
}
function checkPassword(data) {
  return convertRequest({
    url: '/wenjuan/wjsurveyPassword/checkPassword',
    method: 'POST',
    data
  });
}
function bindingPassword(data) {
  return reRequest({
    url: '/wenjuan/wjsurveyPassword/bindingPassword',
    method: 'POST',
    data
  });
}
function checkAnswer(params) {
  return convertRequest.get('/answering/answer/checkFirstTimeAnswering', {
    params
  });
}
/**
 * 获取下一页的数据或结束答题
 * @param answerId 答卷ID
 * @param {Array} answerContent 提交的答案,
 * @param  currentPageNum 第几页
 * @param overtime 分页是否超时处理
 * @param overallOvertime 答题总时长是否超时
 * @param onlySave 仅保存
 * @return {Promise}
 * @private
 */
function submitAnswer(answerId, answerContent, currentPageNum, overtime, overallOvertime, onlySave) {
  let data = {
    method: 'post',
    url: '/answering/answer/submitAnswer',
    data: {
      id: answerId,
      answerContent,
      overtime,
      overallOvertime,
      onlySave
    },
    timeout: 1000 * 10
  };
  if (hasValue(currentPageNum) && !isNaN(currentPageNum)) {
    data.data.currentPageNum = currentPageNum;
  }
  return reRequest(data);
}
function editAnswer(data) {
  return convertRequest.post('/answer/answer/editAnswerOpen', data);
}
// 编辑调查员后再调用
function addorUpdateWjInvestigator(data) {
  return convertRequest.post('/quota/wjInvestigator/addorUpdateWjInvestigator', data);
}
function editAnswerByAgent(data) {
  return convertRequest.post('/answer/answer/editAnswerByAgent', data);
}
function getAnswerIdByPhone(params) {
  return convertRequest.get('/quota/wjInvestigator/getAnswerIdByPhone', {
    params
  });
}
function updateById(params) {
  return convertRequest.post(`/quota/wjInvestigator/updateById?id=${params.id}&investigatorPhone=${params.investigatorPhone}`);
}
/**
 * 短信验证
 */
function sendSmsCode(data) {
  return convertRequest.post('/answer/answerPhone/sendVerificationCode', data);
}
function validateCode(data) {
  return convertRequest.post('/answer/answerPhone/checkVerificationCode', data);
}
function getImgCode(phoneNumber, t) {
  return `${window.origin}/api/customer/fetchShortMessagePreCode?phoneNumber=${phoneNumber}&t=${t}`;
}
function upload(data) {
  return reRequest({
    url: '/fill/api/v1/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  }).then(res => {
    res.data.url = encodeURIComponent(res.data.url);
    return res;
  });
}
function convertDownloadUrl(url) {
  if (url.startsWith("http")) return url;
  if (url.includes('/fill/api/v1/download?fileName=')) return url;
  return window.origin + '/fill/api/v1/download?fileName=' + url;
}
function getCascaderRegion(parentId) {
  return convertRequest({
    url: '/fill/wjsurveyquestion/region',
    params: {
      pid: parentId
    }
  });
}
function getAnswerHistory(params) {
  return convertRequest.get('/answer/answer/getAnswerHistoryPage', {
    params
  });
}
function getAnswerRes(answerId) {
  return convertRequest.get('/answer/answer/getAnswerRes', {
    params: {
      answerId
    }
  });
}
function getViewAnswer(answerId, currentPageNum = 0, data = {}) {
  // let instance = axios.create({})
  const restData = __rest(data
  // if (token && tenantId) {
  //   instance.interceptors.request.use(config => {
  //     config.headers!['TENANT-ID'] = tenantId
  //     config.headers!['Authorization'] = 'Bearer ' + token
  //     return config
  //   })
  // }
  , ["token", "tenantId"]);
  // if (token && tenantId) {
  //   instance.interceptors.request.use(config => {
  //     config.headers!['TENANT-ID'] = tenantId
  //     config.headers!['Authorization'] = 'Bearer ' + token
  //     return config
  //   })
  // }
  return convertRequest.post('/answering/answer/viewAnswer', Object.assign({
    id: answerId,
    currentPageNum
  }, restData));
}
function getAnswerScore(answerId, ids) {
  return convertRequest.post('/answering/answer/getScore', {
    answerId,
    questionIds: ids
  });
}
function addErrorLog(data) {
  return axios__WEBPACK_IMPORTED_MODULE_18___default.a.post('/answer/answer/addErrLog', data);
}
function convertUrl(url) {
  return convertDownloadUrl(url);
}
function getCanLuck() {
  return convertRequest.get('/wjluck/global_config/query');
}
function getHistoryQuestionAnswer(data) {
  return convertRequest.get('/answer/answer/es/getHistoryQuestionAnswer', {
    params: data
  });
}
function getMoreSurveyList(params) {
  return convertRequest.get('/wenjuan/recommend/displaySurvey', {
    params
  });
}
function getMoreSurveyStatus() {
  return convertRequest.get('/wenjuan/recommend/getOpenStatus').then(res => {
    return res.data.moreSurvey.toString();
  });
}
function getShareAnswer(shareAnswerId) {
  return convertRequest.get('/answer/answer/getAwardSendStatusLogBySurveyId', {
    params: {
      shareAnswerId
    }
  });
}
function bingAnswerAndGetUser(code, accountUserId, surveyId, answerId) {
  return convertRequest.get('/award/updateAnswerByCode', {
    params: {
      wxCode: code,
      accountUserId,
      surveyId,
      answerId
    }
  });
}
function showReportAfterAnswer(surveyId) {
  return convertRequest.get(`/wenjuan/surveyDimension/getDimension/${surveyId}`).then(res => {
    return res.data;
  });
}
function getAnswerDimensionScore(answerId) {
  return convertRequest.get('/answer/answer/getAnswerDimensionScore', {
    params: {
      answerId
    }
  });
}
function bindExtraAward(answerId) {
  return convertRequest.post(`/award/wjaward/bindExtraAward?answerId=${answerId}`);
}
function checkUrl(key) {
  return convertRequest.get(`/award/checkMpKey?checkMpKey=${key}`);
}
function getUserById(id) {
  return convertRequest.get(`/api/customer/getUserInfosByIdsIn?ids=${id}`).then(res => {
    return res[0];
  });
}
function getFileStream(file, downloadName) {
  return window.origin + `/fill/api/v1/downloadWithName?fileName=${file}&downLoadName=${downloadName}`;
}
function updateUserByWxCode(code) {
  return convertRequest.get(`/api/customer/updateHeadUrlByOpenId?code=${code}`);
}
function getOfficialAccountQrcode(answerId) {
  return convertRequest.get('/answering/answer/checkAnswerWxFan', {
    params: {
      id: answerId
    }
  });
}
function getMiniProgramScheme(path, query) {
  return convertRequest.get('/wenjuan/app/getAppScheme', {
    params: {
      path,
      query
    }
  });
}
function invalidMine(data) {
  return convertRequest.post('/answering/answer/invalidMine', data);
}
function getSurveyPoint(surveyId) {
  return convertRequest.post('/award/awardcommunity/pointMall/surveyPoints', [surveyId]).then(res => {
    if (res.data) {
      return res.data[0] || null;
    } else {
      return null;
    }
  });
}
function getAnswerPoint(answerId) {
  return convertRequest.post('/award/awardcommunity/pointMall/surveyAnswerPoints', [answerId]).then(res => {
    if (res.data) {
      return res.data[0] || null;
    } else {
      return null;
    }
  });
}
function receiveAward(data) {
  /**
   * 领取奖励
   */
  return reRequest.post('award/wjaward/answerBindInfo', data);
}
function answerGetAward(answerId) {
  /**
   * 领取红包 或者 抽取奖励
   */
  return reRequest.get('/award/wjaward/answerGetAward', {
    params: {
      answerId
    }
  });
}
function getAnswerChatGPT(answerId) {
  return convertRequest.get('/answer/answer/openai/chatgpt', {
    params: {
      answerId
    }
  });
  // return new Promise((resolve, reject) => {
  //   setTimeout(()=>{
  //     resolve(null)
  //   },3000)
  // })
}
function getUserStoryByAnswerId(answerId, change = false) {
  // return new Promise((resolve, reject) => {
  //   setTimeout(()=>{
  //     resolve(null)
  //   },200)
  // })
  return convertRequest.get('/answer/answer/lanternfestival', {
    params: {
      answerId: answerId,
      change
    }
  });
}
function addLogStory(data) {
  return convertRequest.post('/answer/answer/addLanternfestival', data);
}
// 获取企业是否开启企业定制(权限开放)
function getSpecialSettingStatus(companyId) {
  return convertRequest.get('/api/company/infoReplace/' + companyId);
}
function getPageConfigByKeys(data) {
  return convertRequest.post('/admin/sysConfig/getSysConfig', data);
}
function getSurveyInformedConsent(surveyId) {
  return convertRequest.get('/wenjuanLogic/informedConsent/querySurveyInformedConsent', {
    params: {
      surveyId
    }
  });
}
function getUserInformedConsentSign(params) {
  return convertRequest.get('/answer/informedConsentSign/queryUserInformedConsentSign', {
    params
  });
}
//获取样本追踪答卷
function getSourceAnswer(params) {
  return convertRequest.get('/answer/accountTrace/getSourceAnswer', {
    params
  });
}
// 获取优惠券
function getCoupon(accountUserOpenId, surveyId, answerId) {
  return convertRequest.get('/dispenser/service/getCoupon', {
    params: {
      accountUserOpenId,
      surveyId,
      answerId
    }
  });
}
// 获取历史优惠卷
function getCouponHistory(accountUserOpenId) {
  return convertRequest.get("/dispenser/service/myCoupons", {
    params: {
      accountUserOpenId
    }
  });
}
// 查询趣研局设置
function getCouponSetting(surveyId) {
  return convertRequest.get("/dispenser/service/getSetting", {
    params: {
      surveyId
    }
  });
}
function getSurvey(params) {
  if (params.pure) {
    return getSurveyById(params.surveyId, params.versionId).then(survey => {
      return {
        survey: survey.data ? survey.data : survey,
        lottery: {},
        channel: {}
      };
    });
  }
  return Promise.all([getSurveyById(params.surveyId, params.versionId), params.answerChannelId ? getChannelById(params.answerChannelId) : Promise.resolve({
    data: {}
  }), getAwardV2BySurveyId(params.surveyId, params.answerChannelId), getSurveyInformedConsent(params.surveyId)]).then(res => {
    const [survey, channel, award, informedConsent] = res;
    if (survey.code !== 0 || !channel.data) {
      return Promise.reject(Object.assign(Object.assign({
        survey: survey.data ? survey.data : survey,
        channel: channel === null || channel === void 0 ? void 0 : channel.data
      }, award.data), {
        lottery: award.data
      }));
    }
    return Object.assign(Object.assign({
      survey: survey.data,
      channel: channel.data
    }, award.data), {
      lottery: award.data,
      informedConsent: informedConsent.data
    });
  });
}
// 获取答题换壳状态
function getStatusConfig(companyId, configKeys) {
  if (!companyId || companyId === 'null' || companyId === 'undefined') {
    return Promise.reject({});
  }
  return Promise.all([getSpecialSettingStatus(companyId), getPageConfigByKeys({
    companyId,
    configKeys
  })]).then(res => {
    if (res[0].replacementStatus) {
      return res[1];
    }
    return undefined;
  });
}

// // @ts-ignore
function getFinger() {
  return _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"].load().then(fp => {
    return fp.get().then(result => {
      return result.visitorId;
    });
  });
}
function normalMax(max) {
  let val;
  if (!max) {
    val = Infinity;
  } else if (typeof max === 'string') {
    val = parseFloat(max);
  } else {
    val = max;
  }
  if (val === -1) {
    val = Infinity;
  }
  return val;
}
function normalMin(min) {
  let val;
  if (!min) {
    val = -Infinity;
  } else if (typeof min === 'string') {
    val = parseFloat(min);
  } else {
    val = min;
  }
  if (val === -1) {
    val = -Infinity;
  }
  return val;
}
function checkValidateValue(value, option) {
  const {
    validate,
    min,
    max,
    required,
    message = {},
    allowOtherValue = false
  } = option;
  if (required && !value) {
    if (message.required) {
      return message.required;
    } else {
      return '是必填项';
    }
  } else if (!value) {
    return;
  }
  if (option.regexpRules) {
    const item = option.regexpRules.find(item => {
      const rule = item.rule.trim();
      if (!rule) return false;
      return !new RegExp(rule).test(value);
    });
    if (item) {
      return item.message;
    }
  }
  let minLen = normalMin(min);
  let maxLen = normalMax(max);
  if (validate === ValidateType.NULL || validate === ValidateType.TEXT || validate === ValidateType.PASSWORD || !validate) {
    if (value.length < minLen) {
      return `不能小于${minLen}字符`;
    }
    if (value.length > maxLen) {
      return `不能大于${maxLen}字符`;
    }
  } else if (validate === ValidateType.CHAR) {
    if (!ValidateRule.validateChar(value)) {
      return `请输入英文字符`;
    }
    if (value.length < minLen) {
      return `不能小于${minLen}字符`;
    }
    if (value.length > maxLen) {
      return `不能大于${maxLen}字符`;
    }
  } else if (validate === ValidateType.CHINESE) {
    if (!ValidateRule.validateChinese(value)) {
      return `请输入中文字符`;
    }
    if (value.length < minLen) {
      return `不能小于${minLen}字符`;
    }
    if (value.length > maxLen) {
      return `不能大于${maxLen}字符`;
    }
  } else if (validate === ValidateType.PHONE) {
    if (!ValidateRule.phone(value)) {
      return `手机号码格式不正确`;
    }
  } else if (validate === ValidateType.EMAIL) {
    if (!ValidateRule.email(value)) {
      return `邮箱格式不正确`;
    }
  } else if (validate === ValidateType.ID_NUMBER) {
    if (allowOtherValue) {
      if (!/^\d/.test(value)) {
        return null;
      }
    }
    let err = ValidateRule.validateIdNumber(value);
    if (err.result) {
      return err.msg;
    }
  } else if (validate === ValidateType.WEBSITE) {
    if (!ValidateRule.isURL(value)) {
      return `网址格式不正确`;
    }
  } else if (validate === ValidateType.NUM) {
    if (value === '-' || !ValidateRule.integerAndDigit(value, 100)) {
      return `请输入数字`;
    }
    let digitLen = (value.split('.')[1] || '').length;
    if (option.digit !== -1) {
      if (option.digit) {
        if (option.digit < digitLen) {
          return `仅支持保留${option.digit}位小数`;
        }
      } else if (digitLen) {
        return '不支持小数';
      }
    }
    let v = parseFloat(value);
    if (v > maxLen) {
      return `不能大于${max}`;
    }
    if (v < minLen) {
      return `不能小于${min}`;
    }
  }
}
function initDefaultsTip(option) {
  let {
    validate,
    min,
    max
  } = option;
  max = normalMax(max);
  min = normalMin(min);
  if (validate === ValidateType.PHONE) {
    return '请输入手机号';
  } else if (validate === ValidateType.EMAIL) {
    return '请输入邮箱';
  } else if (validate === ValidateType.ID_NUMBER) {
    return '请输入身份证号';
  } else if (validate === ValidateType.WEBSITE) {
    return '请输入网址';
  } else if (validate === ValidateType.PASSWORD) {
    return '请输入密码';
  } else if (validate === ValidateType.NUM) {
    if (min !== -Infinity && max !== Infinity) {
      return `请输入${option.min}~${option.max}的数值`;
    } else if (min !== -Infinity) {
      return `最小值需≥${option.min}`;
    } else if (max !== Infinity) {
      return `最大值需≤${option.max}`;
    }
    return '请输入数字';
  } else {
    let suffixText = '字';
    if (validate === ValidateType.CHAR) {
      suffixText = '字符';
    } else if (validate === ValidateType.CHINESE) {
      suffixText = '中文';
    }
    if (min !== -Infinity && max !== Infinity) {
      if (option.min === option.max) {
        return `请输入${option.max}个${suffixText}`;
      } else {
        return `请输入${option.min}~${option.max}个${suffixText}`;
      }
    } else if (min !== -Infinity) {
      return `最少输入${option.min}个${suffixText}`;
    } else if (max !== Infinity) {
      return `最多输入${option.max}个${suffixText}`;
    }
    return '';
  }
}
function initContent(content) {
  if (content.allowFileTypes) {
    content.allowFileTypes = content.allowFileTypes.reduce((res, type) => {
      if (type === 'img') {
        res.push(...imageFiles);
      } else {
        res.push(type);
      }
      return res;
    }, []);
  }
  return Object.assign({}, content, {
    fileList: []
  });
}
function checkContent(content) {
  const result = {
    success: true,
    message: ''
  };
  if (content.allowPhotoNum && content.allowPhotoNum > 0) {
    let min = content.allowMinPhotoNum;
    if (content.fileList.length < min) {
      result.success = false;
      result.message = `至少上传${min}个附件`;
      return result;
    }
  }
  return result;
}
function convertInputType(data) {
  let type = 'text';
  let validate = data && data.validate || data || '';
  if (validate === ValidateType.PASSWORD) type = 'password';
  if (validate === ValidateType.PHONE) type = 'number';
  if (typeof data === 'object' && data) {
    data.inputType = type;
    return data;
  } else {
    return type;
  }
}
function rand(items, ids, key) {
  const results = items.slice();
  const list = [];
  const idIndexList = [];
  ids.forEach(id => {
    const index = results.findIndex(item => item[key] === id);
    if (index > -1) {
      list.push(results[index]);
      idIndexList.push(index);
    }
  });
  const _list = shuffle(list);
  for (const idx of idIndexList) {
    results[idx] = _list.shift();
  }
  return results;
}
function randList(items, ids) {
  let finalIds = ids.filter(id => {
    return items.find(r => r.id === id);
  });
  if (finalIds.length) {
    return rand(items, finalIds, 'id');
  } else {
    return shuffle(items);
  }
}
function rowRandList(rows, ids) {
  let finalIds = ids.filter(id => {
    return rows.find(r => r.row_id === id);
  });
  if (finalIds.length) {
    return rand(rows, finalIds, 'row_id');
  } else {
    return shuffle(rows);
  }
}
function getTextFillErrorTip(value = '', opt) {
  const {
    maxLength,
    minLength,
    validate
  } = opt;
  if (maxLength <= 0 && minLength <= 0) return '';
  const currentLen = value.length;
  if (currentLen === 0) return '';
  if (validate === ValidateType.NUM) {
    let val = Number(value);
    if (isNaN(Number(val))) {
      return `请输入数字`;
    }
    if (maxLength >= 0 && val > maxLength) {
      return `最大值不能超过${maxLength}`;
    }
    if (minLength >= 0 && val < minLength) {
      return `最小值不能小于${minLength}`;
    }
  } else {
    if (maxLength >= 0 && currentLen > maxLength) {
      return `您的输入已超过最大输入字数${maxLength}，当前字数为${currentLen}`;
    }
    if (minLength >= 0 && currentLen < minLength) {
      return `您的输入小于最小输入字数${minLength}，当前字数为${currentLen}`;
    }
  }
  return '';
}
function valueByCalc(target, rule, getCache, Vue) {
  const expression = rule.expression.map(item => {
    if (item === 'X') return '*';
    if (item === '&') return '';
    return item;
  }).filter(Boolean);
  const exprToValue = expr => {
    const operate = ['+', '-', '*', '/', '(', ')'];
    const cache = getCache();
    const res = expr.map(item => {
      if (operate.includes(item)) return item;
      const [questionId, optionId, colId] = item.split('.');
      let content = cache.find(item => item.questonId === questionId);
      if (!content) {
        if (rule.calcMethod !== 4 && rule.getCurrentItems) {
          const items = rule.getCurrentItems(item);
          if (!items) return '';
          content = {
            items
          };
        } else {
          return '';
        }
      }
      if (rule.calcMethod === 4) {
        // 选中项个数
        return content.items.length;
      }
      const c = content.items.find(i => i.optionId === optionId || i.rowId === optionId && i.colId === colId || !i.optionId && !i.rowId && !i.colId);
      if (!c) return '';
      return `${c.value}`;
    });
    let val = null;
    try {
      const v = res.join('');
      if (operate.find(o => v.includes(o)) && res.length > 1) {
        val = eval(res.join(' '));
        // + - * / 计算
        if (rule.calcMethod === 2) {
          val = val.toFixed(rule.scale || 0);
        }
      } else {
        val = res.join('');
      }
    } catch (e) {
      // console.log(e)
    }
    return val || '';
  };
  let instance = new Vue({
    data() {
      return {
        value: ''
      };
    }
  });
  let isUserChange = false;
  Object.defineProperty(target, 'value', {
    get() {
      if (!isUserChange) {
        instance.value = exprToValue(expression);
      }
      return instance.value;
    },
    set(v) {
      if (!rule.autoFillEditable) {
        return;
      }
      isUserChange = true;
      instance.value = v;
    },
    enumerable: true,
    configurable: true
  });
}
function getAnswerItemByExpr(content, expr) {
  const [qid, rid, cid] = expr.split('.');
  const c = content.find(c => {
    return c.questonId === qid;
  });
  if (!c) return null;
  if (!rid) return c.items[0];
  return c.items.find(i => {
    if (cid) {
      return i.colId === cid && i.rowId === rid;
    } else {
      return i.optionId === rid;
    }
  });
}
function getExprValueByAnswer(expr, content) {
  const getDigitLength = val => {
    const [, digit] = String(val).split('.');
    return digit ? digit.length : 0;
  };
  const operate = ['+', '-', '*', '/', '(', ')'];
  let maxDigitLen = 0;
  const finalExpr = expr.map(e => {
    if (e === 'X') return '*';
    return e;
  }).map(e => {
    if (operate.includes(e)) return e;
    if (typeof e === 'number') {
      maxDigitLen = Math.max(getDigitLength(e), maxDigitLen);
      return e;
    }
    const item = getAnswerItemByExpr(content, e);
    if (!item) return 0;
    if (isNaN(item.value)) return 0;
    maxDigitLen = Math.max(getDigitLength(item.value), maxDigitLen);
    return Number(item.value);
  }).map(e => {
    if (typeof e !== 'number') return e;
    if (maxDigitLen === 0) return e;
    return e; //* val
  }).join(" ");
  const fn = Function(`
    "use strict";
    return (${finalExpr})
  `);
  try {
    return fn();
  } catch (e) {
    return 0;
  }
}
function defineFillValue(target) {
  let value = '';
  let isUserChange = false;
  Object.defineProperty(target, 'value', {
    get() {
      return value;
    },
    set(v) {
      // @ts-ignore
      if (target.isCalc) {
        if (isUserChange) {
          return;
        }
      } else {
        isUserChange = true;
      }
      value = v;
    },
    enumerable: true,
    configurable: true
  });
}
function getInputPrefixIcon(validate) {
  switch (validate) {
    case ValidateType.EMAIL:
      return 'icon-p-info-email';
    case ValidateType.NUM:
      return 'icon-p-info-number';
    case ValidateType.CHINESE:
      return 'icon-p-info-chinese';
    case ValidateType.WEBSITE:
      return 'icon-p-info-website';
    case ValidateType.CHAR:
      return 'icon-p-info-word';
    case ValidateType.ID_NUMBER:
      return 'icon-p-info-idcard';
    case ValidateType.PHONE:
      return 'icon-p-info-phone';
    case ValidateType.PASSWORD:
      return 'icon-p-info-password';
  }
  return '';
}
let q_id = 0;
function buildMessageToObj(question, msg, enableQuestionIndex) {
  return {
    title: `${enableQuestionIndex ? `第${question.num}题 ` : ''}${question.content.text}`,
    message: msg
  };
}
class Question {
  constructor(id, content, note, question_type, is_required, type, issue) {
    this.required = true;
    this.type = 1;
    this.duration = 0;
    this.q_id = q_id++;
    this.isNoopAnswer = false;
    this.hasValue = false;
    this.hook = {
      created: [],
      mounted: [],
      updated: [],
      submitError: [],
      submitSuccess: [],
      confirm: []
    };
    this.questionErrorList = [];
    this.answerWatchers = [];
    this.vote = null;
    this.showVote = false;
    this.id = id;
    this.content = initContent(content);
    this.note = note;
    this.questionType = question_type;
    this.required = is_required;
    this.type = type;
    this.issue = issue;
    this.groupQuestionKey = '';
    this.groupQuestionId = '';
    this.hasValue = false;
    this.answerWatchers = [];
    this.uploadFileMaxSize = 30;
  }
  setGroupInfo(id, key) {
    this.groupQuestionKey = key;
    this.groupQuestionId = id;
  }
  setValue(value) {
    this.duration = value.duration;
    this.issue.setValue(value.items || []);
    this.content.fileList = (value.activePhotoFiles || []).map(url => {
      return {
        name: url,
        url
      };
    });
  }
  getIssueValue(type) {
    return this.issue.getValue(type);
  }
  clearHook() {
    this.hook.created = [];
    this.hook.updated = [];
    this.hook.mounted = [];
    this.hook.submitError = [];
    this.hook.submitSuccess = [];
  }
  setHook(key, handler) {
    let handlers = this.hook[key];
    if (!handlers) {
      throw new Error(`${key} 错误 支持 created、mounted、updated、submitError、submitSuccess`);
    }
    if (!handlers.includes(handler)) {
      handlers.push(handler);
    }
  }
  runHooks(key, type) {
    let handlers = this.hook[key];
    handlers.forEach(h => h(type));
  }
  getAnswerContent(type) {
    let items;
    if (this.isNoopAnswer) {
      items = [{
        rowId: '',
        colId: '',
        optionId: '',
        value: ''
      }];
    } else {
      items = this.getIssueValue(type);
    }
    return filterParams({
      groupQuestionId: this.groupQuestionId,
      groupQuestionKey: this.groupQuestionKey,
      activePhotoFiles: this.content.fileList.map(res => res.url),
      questonId: this.id,
      questionType: this.questionType,
      duration: this.duration,
      items
    });
  }
  checkAnswer(value, opt = {}) {
    let result = {
      success: true,
      message: ''
    };
    if (this.required && !(value.items instanceof Promise) && !value.items.length) {
      result.success = false;
      if (checkQuotaIsFull(this)) {
        result.message = buildMessageToObj(this, '配额已满，无法继续作答，请联系发布者', opt.enableQuestionIndex);
      } else {
        // result.message = `第${this.num}题 为必答题`
        result.message = buildMessageToObj(this, '为必答题', opt.enableQuestionIndex);
      }
      return result;
    }
    let res = checkContent(this.content);
    if (!res.success) {
      if (res.message) {
        res.message = buildMessageToObj(this, res.message, opt.enableQuestionIndex);
      }
      return res;
    }
    const requiredType = this.setting.requiredType;
    // (requiredType === RequiredType.All) 普通题肯定为 true requiredType 目前只有矩阵题才有可能 为RequiredType.Any
    const required = this.required && requiredType === RequiredType.All;
    let issueCheckResult = this.issue.checkValue(required, Object.assign({
      required: this.required
    }, opt, this.setting || {}));
    if (issueCheckResult) {
      if (issueCheckResult.message) {
        issueCheckResult.message = buildMessageToObj(this, issueCheckResult.message, opt.enableQuestionIndex);
      }
      return issueCheckResult;
    }
    return result;
  }
  convertPrevData() {
    if (this.issue.convertPrevData) {
      this.issue.convertPrevData();
    }
  }
  getCorrectAnswerList() {
    if (!this.setting.enableAnswerScore) return [];
    const issue = this.issue;
    return issue.getCorrectAnswerList(this.answerScore);
  }
  setVote(data) {
    if (this.issue.transformVote) {
      this.issue.transformVote(data);
    }
    this.vote = data;
  }
  pushAnswerWatcher(watcher) {
    this.answerWatchers.push(watcher);
  }
  triggerAnswerWatcher(AnswerContent) {
    this.answerWatchers.forEach(watcher => watcher(AnswerContent));
  }
}
var questionType;
(function (questionType) {
  questionType[questionType["SINGLE_CHOICE"] = 1] = "SINGLE_CHOICE";
  questionType[questionType["MULTIPLE_CHOICE"] = 2] = "MULTIPLE_CHOICE";
  questionType[questionType["LINKAGE"] = 3] = "LINKAGE";
  questionType[questionType["BLANKS"] = 4] = "BLANKS";
  questionType[questionType["MATRIX_SINGLE_CHOICE"] = 5] = "MATRIX_SINGLE_CHOICE";
  questionType[questionType["MATRIX_MULTIPLE_CHOICE"] = 6] = "MATRIX_MULTIPLE_CHOICE";
  questionType[questionType["SINGLE_TEXT_FILL"] = 7] = "SINGLE_TEXT_FILL";
  questionType[questionType["MULTIPLE_TEXT_FILL"] = 8] = "MULTIPLE_TEXT_FILL";
  questionType[questionType["SINGLE_SELECT"] = 12] = "SINGLE_SELECT";
  questionType[questionType["MULTIPLE_SELECT"] = 13] = "MULTIPLE_SELECT";
  questionType[questionType["ONLY_TEXT"] = 20] = "ONLY_TEXT";
  questionType[questionType["SORT"] = 11] = "SORT";
  questionType[questionType["SCALE"] = 21] = "SCALE";
  questionType[questionType["MATRIX_SCALE"] = 9] = "MATRIX_SCALE";
  questionType[questionType["NPS_SCALE"] = 10] = "NPS_SCALE";
  questionType[questionType["CUSTOM_SINGLE_SCALE"] = 15] = "CUSTOM_SINGLE_SCALE";
  questionType[questionType["CUSTOM_MULTIPLE_SCALE"] = 16] = "CUSTOM_MULTIPLE_SCALE";
  questionType[questionType["DATE"] = 17] = "DATE";
  questionType[questionType["UPLOAD_FILE"] = 18] = "UPLOAD_FILE";
  questionType[questionType["HANDWRITING"] = 14] = "HANDWRITING";
  questionType[questionType["CITY_ADDRESS"] = 19] = "CITY_ADDRESS";
  questionType[questionType["MAP"] = 100] = "MAP";
  questionType[questionType["DOWNLOADABLE"] = 112] = "DOWNLOADABLE";
  questionType[questionType["PHONE_VALIDATE"] = 109] = "PHONE_VALIDATE";
  questionType[questionType["CASCADE_REGION"] = 114] = "CASCADE_REGION";
  questionType[questionType["TOTAL"] = 119] = "TOTAL";
  questionType[questionType["MATRIX_AUTO"] = 102] = "MATRIX_AUTO";
  questionType[questionType["MATRIX_SCROLL"] = 103] = "MATRIX_SCROLL";
  questionType[questionType["MATRIX_GRAVITY"] = 104] = "MATRIX_GRAVITY";
  questionType[questionType["MULTIPLE_BLANKS"] = 105] = "MULTIPLE_BLANKS";
  questionType[questionType["MATRIX_COMPOSE"] = 110] = "MATRIX_COMPOSE";
  questionType[questionType["MATRIX_FILL"] = 107] = "MATRIX_FILL";
  questionType[questionType["IMAGE_CHOICE"] = 113] = "IMAGE_CHOICE";
  questionType[questionType["IMAGE_MULTIPLE_CHOICE"] = 117] = "IMAGE_MULTIPLE_CHOICE";
  questionType[questionType["MATRIX_SELECT_CHOICE"] = 106] = "MATRIX_SELECT_CHOICE";
  questionType[questionType["QUESTION_GROUP"] = 115] = "QUESTION_GROUP";
  questionType[questionType["CLASSIFICATION"] = 111] = "CLASSIFICATION";
  questionType[questionType["PAGE_BREAK"] = 108] = "PAGE_BREAK";
  questionType[questionType["NAME"] = 22] = "NAME";
  questionType[questionType["CELLPHONE"] = 23] = "CELLPHONE";
  questionType[questionType["EMAIL"] = 24] = "EMAIL";
  questionType[questionType["REAL_NAME"] = 26] = "REAL_NAME";
  questionType[questionType["GENDER"] = 27] = "GENDER";
  questionType[questionType["PERMANENT_ADDRESS"] = 28] = "PERMANENT_ADDRESS";
  questionType[questionType["DATE_OF_BIRTH"] = 29] = "DATE_OF_BIRTH";
  questionType[questionType["ID_NUMBER"] = 31] = "ID_NUMBER";
  questionType[questionType["AGE_RANGE"] = 32] = "AGE_RANGE";
  questionType[questionType["DOMICILE"] = 33] = "DOMICILE";
  questionType[questionType["EDUCATIONAL_ATTAINMENT"] = 34] = "EDUCATIONAL_ATTAINMENT";
  questionType[questionType["SPECIALITY"] = 35] = "SPECIALITY";
  questionType[questionType["SCHOOL"] = 36] = "SCHOOL";
  questionType[questionType["INDUSTRY"] = 37] = "INDUSTRY";
  questionType[questionType["JOB"] = 38] = "JOB";
  questionType[questionType["MARITAL_STATUS"] = 39] = "MARITAL_STATUS";
  questionType[questionType["MONTHLY_INCOME_RANGE"] = 40] = "MONTHLY_INCOME_RANGE";
  questionType[questionType["POINT_POSITION"] = 42] = "POINT_POSITION";
  questionType[questionType["REPEAT"] = 120] = "REPEAT";
  questionType[questionType["SINGLE_CONTROL"] = -10000] = "SINGLE_CONTROL";
  questionType[questionType["MAX_DIFF"] = 124] = "MAX_DIFF";
})(questionType || (questionType = {}));
const ValidateType = {
  NUM: 'num',
  NULL: null,
  PHONE: 'phone',
  EMAIL: 'email',
  CHAR: 'char',
  CHINESE: 'chinese',
  ID_NUMBER: 'idNumber',
  WEBSITE: 'website',
  TEXT: 'text',
  PASSWORD: 'password' // 密码样式
};
const CascaderStyleType = {
  One: 1,
  Many: 2
};
const RequiredType = {
  All: 0,
  Any: 1
};
var questionSubType;
(function (questionSubType) {
  questionSubType[questionSubType["JUDGE"] = 1] = "JUDGE";
  questionSubType[questionSubType["SHORT_ANSWER"] = 2] = "SHORT_ANSWER";
  questionSubType[questionSubType["NOTICE"] = 3] = "NOTICE";
  questionSubType[questionSubType["STUDENT_ID"] = 4] = "STUDENT_ID";
  questionSubType[questionSubType["JOB_NO"] = 5] = "JOB_NO";
  questionSubType[questionSubType["CLASS"] = 6] = "CLASS";
  questionSubType[questionSubType["DEPARTMENT"] = 7] = "DEPARTMENT";
  questionSubType[questionSubType["VOTE_TEXT"] = 8] = "VOTE_TEXT";
  questionSubType[questionSubType["VOTE_IMAGE"] = 9] = "VOTE_IMAGE";
  questionSubType[questionSubType["WECHAT"] = 10] = "WECHAT";
  questionSubType[questionSubType["GRADE"] = 11] = "GRADE";
  questionSubType[questionSubType["COMPANY"] = 12] = "COMPANY";
  questionSubType[questionSubType["NUMBER_FILL"] = 13] = "NUMBER_FILL";
  questionSubType[questionSubType["SINGLE_FILL"] = 14] = "SINGLE_FILL";
  questionSubType[questionSubType["COUNTRY_REGION"] = 15] = "COUNTRY_REGION";
  questionSubType[questionSubType["PROVINCE_CITY"] = 16] = "PROVINCE_CITY";
  questionSubType[questionSubType["PROVINCE_CITY_AREA"] = 17] = "PROVINCE_CITY_AREA";
  questionSubType[questionSubType["BASE_INFO"] = 18] = "BASE_INFO";
  questionSubType[questionSubType["WORKING_YEARS"] = 19] = "WORKING_YEARS";
  questionSubType[questionSubType["SCORE_SINGLE_CHOICE"] = 20] = "SCORE_SINGLE_CHOICE";
  questionSubType[questionSubType["BASE_INFO_SATISFACTION"] = 21] = "BASE_INFO_SATISFACTION";
})(questionSubType || (questionSubType = {}));
const typeMapping = new Map();
function mapGen(types = [], text, typeMapping) {
  types.forEach(t => {
    typeMapping.set(t, text);
  });
}
const singleTypes = [questionType.SINGLE_CHOICE, questionType.GENDER, questionType.MARITAL_STATUS, questionType.INDUSTRY, questionType.MONTHLY_INCOME_RANGE, questionType.EDUCATIONAL_ATTAINMENT, questionType.AGE_RANGE, questionType.JOB];
const dateTypes = [questionType.DATE, questionType.DATE_OF_BIRTH];
const textTypes = [questionType.SINGLE_TEXT_FILL, questionType.MULTIPLE_TEXT_FILL, questionType.NAME, questionType.EMAIL, questionType.CELLPHONE, questionType.ID_NUMBER, questionType.POINT_POSITION];
const cascaderTypes = [questionType.LINKAGE, questionType.PERMANENT_ADDRESS, questionType.SCHOOL, questionType.DOMICILE, questionType.SPECIALITY];
mapGen(singleTypes, '单选题', typeMapping);
mapGen(dateTypes, '日期题', typeMapping);
mapGen(textTypes, '填空题', typeMapping);
mapGen(cascaderTypes, '级联题', typeMapping);
typeMapping.set(questionType.MULTIPLE_CHOICE, '多选题');
typeMapping.set(questionType.SINGLE_SELECT, '下拉题');
typeMapping.set(questionType.MULTIPLE_SELECT, '下拉题');
typeMapping.set(questionType.MATRIX_SINGLE_CHOICE, '矩阵选择');
typeMapping.set(questionType.MATRIX_MULTIPLE_CHOICE, '矩阵选择');
typeMapping.set(questionType.SORT, '排序题');
typeMapping.set(questionType.SCALE, '量表题');
typeMapping.set(questionType.MATRIX_SCALE, '矩阵量表题');
typeMapping.set(questionType.BLANKS, '横向填空');
typeMapping.set(questionType.ONLY_TEXT, '描述');
typeMapping.set(questionType.NPS_SCALE, 'NPS量表题');
typeMapping.set(questionType.HANDWRITING, '手写签名');
typeMapping.set(questionType.CUSTOM_SINGLE_SCALE, '自定义量表');
typeMapping.set(questionType.CUSTOM_MULTIPLE_SCALE, '自定义量表');
typeMapping.set(questionType.UPLOAD_FILE, '文件上传');
typeMapping.set(questionType.MAP, '地理位置');
typeMapping.set(questionType.MATRIX_SCROLL, '矩阵滑动条');
typeMapping.set(questionType.MATRIX_GRAVITY, '比重题');
typeMapping.set(questionType.MATRIX_AUTO, '自增表格题');
typeMapping.set(questionType.MULTIPLE_BLANKS, '多项填空');
typeMapping.set(questionType.MATRIX_COMPOSE, '表格组合');
typeMapping.set(questionType.IMAGE_CHOICE, '图片选择');
typeMapping.set(questionType.IMAGE_MULTIPLE_CHOICE, '图片选择');
typeMapping.set(questionType.CLASSIFICATION, '分类题');
typeMapping.set(questionType.DOWNLOADABLE, '可下载附件');
typeMapping.set(questionType.PHONE_VALIDATE, '手机验证');
typeMapping.set(questionType.CASCADE_REGION, '行政区划');
typeMapping.set(questionType.QUESTION_GROUP, '问题组');
typeMapping.set(questionType.MATRIX_SELECT_CHOICE, '矩阵下拉');
typeMapping.set(questionType.MATRIX_FILL, '矩阵填空');
typeMapping.set(questionType.PAGE_BREAK, '分页');
typeMapping.set(questionType.CITY_ADDRESS, '城市/地址');
typeMapping.set(questionType.TOTAL, '加总题');
typeMapping.set(questionType.MAX_DIFF, 'MaxDiff');
function transformRichText2Text(html = '', opt = {}) {
  const {
    img = '[图片]',
    video = '[视频]',
    audio = '[音频]'
  } = opt;
  let div = document.createElement('div');
  div.innerHTML = html;
  const data = [['img', img], ['video', video], ['audio', audio], ['iframe', '[音/视频]']];
  for (const [tagName, text] of data) {
    let els = Array.from(div.getElementsByTagName(tagName)).slice();
    for (const el of els) {
      let replaceNode = document.createTextNode(text);
      try {
        el.parentElement.replaceChild(replaceNode, el);
        // div.replaceChild(replaceNode, el)
      } catch (e) {
        console.log(el);
        console.log(replaceNode);
        console.log(tagName, text);
        console.log(e);
      }
    }
  }
  return div.innerText;
}
class Choice {
  constructor(data) {
    this.exclusiveList = []; // 排他项数组
    this.mutex = [];
    this.can_append_item = true;
    this.raw_items = [];
    this.items = []; // 选项数组
    this.is_rand = data.is_rand;
    this.randList = (data.randList || []).filter(Boolean);
    this.min_choice = data.min_choice || -1;
    this.max_choice = data.max_choice || -1;
    this.choice_num_per_row = Math.min(data.choice_num_per_row || 1, 3);
    this.append_items = data.append_items || [];
    this.init(data);
    this.item_groups = this.transformGroups(data.item_groups || []);
    this.mutex = data.enableMutex ? data.mutex || [] : [];
    this.defaultTip = this.initDefaultTip();
    this.enableFilter = data.enableFilter || false;
    this.placeholder = data.placeholder || '';
    this.voteAnswer = [];
    this.autoFillEnable = data.autoFillEnable || false;
    this.autoFillEditable = data.autoFillEditable || false;
    this.autoFill = data.autoFill || [];
    this.readonly = false;
    this.ignoreItems = [];
  }
  initDefaultTip() {
    const min = this.min_choice;
    const max = this.max_choice;
    if (min > 0 && max > 0) {
      if (min === max) {
        return `请选择${min}项`;
      }
      return `请选择${min}~${max}项`;
    } else if (min > 0) {
      return `至少选择${min}项`;
    } else if (max > 0) {
      return `最多选择${max}项`;
    }
  }
  init(data) {
    const items = data.items;
    if (data.other_item && Object.keys(data.other_item).length) {
      items.push(data.other_item);
    }
    this.items = this.normalizeItems(items || []);
    this.raw_items = this.items.slice();
  }
  normalizeItems(items) {
    // let others: any[] = []
    let normal = [];
    let exclusiveList = [];
    items.forEach(item => {
      // 其他项 填空的 value（普通选项没有作用）
      item.value = item.defaultValue || "";
      item.content = initContent(item.content);
      // 用于互斥选项
      item.disabled = false;
      normal.push(item);
      // if (item.is_other_item) {
      //   others.push(item)
      // } else {
      //
      // }
      if (item.is_exclusive) {
        exclusiveList.push(item.id);
      }
      item.inputType = convertInputType(item.validate);
      if (!item.setting) {
        item.setting = {
          enableRelation: false
        };
      }
      // item.errorText = normalizeTips({
      //   validate: item.validate,
      //   min_length: item.minLength, max_length: item.maxLength
      // })
    });
    let results = normal;
    this.exclusiveList = exclusiveList;
    // 选项乱序 其他项保证在最后
    if (this.is_rand) {
      results = randList(results, this.randList);
    }
    return results;
  }
  transformGroups(groups = []) {
    const results = [];
    const ids = [];
    for (let i = 0, len = groups.length; i < len; i++) {
      const group = groups[i];
      const options = [];
      group.item_ids.forEach(id => {
        let item = this.items.find(it => it.id === id);
        if (item) {
          options.push(item);
          ids.push(id);
        }
      });
      if (options.length) {
        let finalOptions = options.slice();
        let item_ids = group.item_ids.slice();
        if (this.is_rand) {
          if (this.randList.length) {
            let finalIds = this.randList.filter(id => {
              return finalOptions.find(r => r.id === id);
            });
            if (finalIds.length) {
              finalOptions = randList(finalOptions, finalIds);
              item_ids = finalOptions.map(item => item.id);
            }
          } else {
            finalOptions = randList(finalOptions, []);
            item_ids = finalOptions.map(item => item.id);
          }
        }
        results.push({
          title: group.title,
          options: finalOptions,
          item_ids: item_ids
        });
      }
    }
    const otherOptions = [];
    this.items.forEach(item => {
      if (!ids.includes(item.id)) {
        otherOptions.push(item);
      }
    });
    if (otherOptions.length) {
      results.push({
        title: '',
        options: otherOptions,
        item_ids: otherOptions.map(item => item.id)
      });
    }
    return results;
  }
  getAnswerContent(id) {
    let item = this.getItemById(id);
    if (!item) return null;
    let value = item.content.text;
    if (item.is_other_item) {
      value = value + '|' + item.value;
    }
    return {
      colId: '',
      optionId: id,
      rowId: '',
      value,
      photos: item.content.fileList.map(s => s.url)
    };
  }
  getItemById(id) {
    return this.items.find(i => i.id === id);
  }
  checkItemValue(id) {
    let item = this.getItemById(id);
    if (!item) return;
    if (this.ignoreItems.find(i => i.id === id)) return;
    let res = checkContent(item.content);
    if (!res.success) {
      return res;
    }
    if (!item.is_other_item) return;
    let err;
    if (item.required || item.value) {
      const allowErrorList = item.allowErrorList || [];
      if (allowErrorList.includes(item.value.toString())) {
        return;
      }
      err = checkValidateValue(item.value, {
        validate: item.validate,
        required: item.required,
        min: item.minLength,
        max: item.maxLength,
        digit: item.digit === -1 ? Infinity : item.digit,
        message: {
          required: '请填写填空内容'
        }
      });
    }
    if (!err) return;
    return {
      message: err,
      success: false,
      item
    };
  }
  getCorrectAnswerList(answerScore) {
    // let ids = (answerScore.optionScoreItems || []).map((i: any) => i.optionId)
    // return this.items.filter(item => {
    //   return ids.includes(item.id)
    // })
    const items = answerScore.optionScoreItems || [];
    const results = [];
    items.forEach(item => {
      let find = this.items.find(i => i.id === item.optionId);
      if (find) {
        const result = {
          id: find.id,
          score: null
        };
        if (answerScore.matchType !== 0) {
          result.score = item.score;
        }
        results.push(result);
      }
    });
    return results;
  }
  transformVote(vote) {
    this.items.forEach(item => {
      vote.oidCountMap[item.id] = vote.oidCountMap[item.id] || 0;
    });
  }
  convertVoteAnswer() {
    const values = this.getValue();
    this.voteAnswer = values.map(item => item.optionId);
  }
  hasVoteFilter() {
    return !!this.voteAnswer.length;
  }
  getVoteAnswerValueText() {
    return this.voteAnswer.map(id => {
      var _a, _b;
      return (_b = (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text;
    }).join(',');
  }
}
class SingleChoice extends Choice {
  constructor(data) {
    super(data);
    this.select = '';
  }
  getValue() {
    let answerContent = this.getAnswerContent(this.select);
    if (!answerContent) return [];
    return [answerContent];
  }
  setValue(data) {
    if (data.length) {
      let item = data[0];
      this.select = item.optionId;
      if (this.select && this.autoFillEnable && !this.autoFillEditable) {
        this.readonly = true;
        this.items.forEach(item => {
          item.disabled = true;
        });
      }
      let i = this.getItemById(item.optionId);
      if (i) {
        if (i.is_other_item) {
          i.value = item.value.split('|')[1];
        }
        i.content.fileList = (item.photos || []).map(url => {
          return {
            name: url,
            url
          };
        });
      }
    }
  }
  checkValue() {
    return this.checkItemValue(this.select);
  }
  isCorrectAnswer(answerScore) {
    let ids = (answerScore.optionScoreItems || []).map(i => i.optionId);
    let matchType = answerScore.matchType || 0;
    function diff(arr1 = [], arr2 = []) {
      if (matchType === 1) {
        return arr1.some(arr => {
          return arr2.includes(arr);
        });
      } else {
        return arr1.every(arr => {
          return arr2.includes(arr);
        });
      }
    }
    return diff(ids, [this.select]);
  }
  getScore(answerScore) {
    if (answerScore.matchType === 0) {
      if (this.isCorrectAnswer(answerScore)) {
        return answerScore.totalScore;
      } else {
        return 0;
      }
    } else {
      const items = answerScore.optionScoreItems || [];
      const find = items.find(i => i.optionId === this.select);
      if (find) {
        return find.score;
      } else {
        return 0;
      }
    }
  }
  getTotalScore(answerScore) {
    if (answerScore.matchType === 0) {
      return answerScore.totalScore;
    } else {
      return Math.max.apply(Math, answerScore.optionScoreItems.map(item => item.score));
    }
  }
  getValueConfirm() {
    const item = this.getItemById(this.select);
    if (!item) return;
    if (!item.is_other_item) return;
    if (item.outOfRange !== 1) return;
    const allowErrorList = item.allowErrorList || [];
    if (allowErrorList.includes(item.value.toString())) {
      return;
    }
    const err = checkValidateValue(item.value, {
      validate: item.validate,
      required: item.required,
      min: item.minLength,
      max: item.maxLength,
      digit: item.digit === -1 ? Infinity : item.digit
    });
    if (!err) return null;
    if (!err.includes('不能')) {
      return null;
    }
    return {
      message: item.outOfRangeMessage
    };
  }
}
class MutChoice extends Choice {
  constructor(data) {
    super(data);
    this.select = [];
    this.conflictValidator = data.conflictValidator || false;
  }
  getValue() {
    return this.items.reduce((res, item) => {
      if (this.select.includes(item.id)) {
        const answerContent = this.getAnswerContent(item.id);
        if (answerContent) {
          res.push(answerContent);
        }
      }
      return res;
    }, []);
    // return this.select.reduce<AnswerContentItem[]>((res, id: string) => {
    //   let answerContent = this.getAnswerContent(id)
    //   if (answerContent) {
    //     res.push(answerContent)
    //   }
    //   return res
    // }, [])
  }
  setValue(data) {
    this.select = data.map(({
      optionId,
      value,
      photos
    }) => {
      let item = this.getItemById(optionId);
      if (item) {
        if (item.is_other_item) {
          item.value = value.split('|')[1];
        }
        item.content.fileList = (photos || []).map(url => {
          return {
            name: url,
            url
          };
        });
        return item.id;
      }
    }).filter(Boolean);
    if (this.select.length && this.autoFillEnable && !this.autoFillEditable) {
      this.readonly = true;
      this.items.forEach(item => {
        item.disabled = true;
      });
    }
  }
  getIsMutex() {
    const ids = this.select;
    return this.mutex.some(item => {
      return item.mutex_group1.length === ids.length && ids.every(id => item.mutex_group1.includes(id)) || item.mutex_group2.length === ids.length && ids.every(id => item.mutex_group2.includes(id));
      // 任一
      // if (item.mutex_type === 2) {
      //   return ids.some(id => item.mutex_group1.includes(id)) || ids.some(id => item.mutex_group2.includes(id))
      // } else {
      //   return (
      //     (item.mutex_group1.length === ids.length && ids.every(id => item.mutex_group1.includes(id))) ||
      //     (item.mutex_group2.length === ids.length && ids.every(id => item.mutex_group2.includes(id)))
      //   )
      // }
    });
  }
  checkValue() {
    let min = normalMin(this.min_choice);
    let max = normalMax(this.max_choice);
    let len = this.select.length;
    if (len > max) {
      return {
        success: false,
        message: `最多选择${max}项`
      };
    }
    // 如果没有选择 最少则不校验 （必答题在外层已经校验了）
    if (len) {
      if (len < min) {
        if (!this.conflictValidator) {
          return {
            success: false,
            message: `最少选择${min}项`
          };
        }
        const items = this.select.map(id => {
          return this.items.find(item => item.id === id);
        });
        const is_exclusive = items.every(item => item.is_exclusive);
        if (!is_exclusive && !this.getIsMutex()) {
          return {
            success: false,
            message: `最少选择${min}项`
          };
        }
      }
    }
    for (let i = 0; i < len; i++) {
      let id = this.select[i];
      let err = this.checkItemValue(id);
      if (err && !err.success) {
        return err;
      }
    }
  }
  isCorrectAnswer(answerScore) {
    let ids = (answerScore.optionScoreItems || []).map(i => i.optionId);
    let matchType = answerScore.matchType || 0;
    function diff(arr1 = [], arr2 = []) {
      if (matchType === 1) {
        return arr1.some(arr => {
          return arr2.includes(arr);
        });
      } else {
        return arr1.every(arr => {
          return arr2.includes(arr);
        }) && arr1.length === arr2.length;
      }
    }
    return diff(ids, this.select);
  }
  getScore(answerScore) {
    if (answerScore.matchType === 0) {
      if (this.isCorrectAnswer(answerScore)) {
        return answerScore.totalScore;
      } else {
        return 0;
      }
    } else {
      return this.select.reduce((res, id) => {
        const items = answerScore.optionScoreItems || [];
        const find = items.find(i => i.optionId === id);
        if (find) {
          res += find.score;
        }
        return res;
      }, 0);
    }
  }
  getTotalScore(answerScore) {
    if (answerScore.matchType === 0) {
      return answerScore.totalScore;
    } else {
      return answerScore.optionScoreItems.reduce((res, item) => {
        return res + item.score;
      }, 0);
    }
  }
  getValueConfirm() {
    let len = this.select.length;
    for (let i = 0; i < len; i++) {
      let id = this.select[i];
      const item = this.getItemById(id);
      if (!item) continue;
      if (!item.is_other_item) continue;
      if (item.outOfRange !== 1) continue;
      const allowErrorList = item.allowErrorList || [];
      if (allowErrorList.includes(item.value.toString())) {
        continue;
      }
      const err = checkValidateValue(item.value, {
        validate: item.validate,
        required: item.required,
        min: item.minLength,
        max: item.maxLength,
        digit: item.digit === -1 ? Infinity : item.digit
      });
      if (!err) continue;
      if (!err.includes('不能')) {
        continue;
      }
      return {
        message: item.outOfRangeMessage
      };
    }
  }
}
function normalGroups(groups = [], level, currentLevel = 1) {
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    if (currentLevel < level) {
      if (group.nextLevelOptions && group.nextLevelOptions.length) {
        normalGroups(group.nextLevelOptions, level, currentLevel + 1);
      }
    } else {
      group.nextLevelOptions = null;
    }
  }
  return groups;
}
class Cascader {
  constructor(data) {
    this.value = [];
    this.inputValue = '';
    this.levels = data.levels || [];
    this.groups = normalGroups(data.groups || [], data.requiredNum || data.levelsNum || 0);
    this.placeholder = this.convertPlaceholder(data.levels);
    this.levelsNum = data.levelsNum || 0;
    this.requiredNum = data.requiredNum || null;
    this.items = this.initFillContext(data.fillContext || []);
    this.styleType = data.styleType || CascaderStyleType.One;
    this.voteAnswer = [];
  }
  initFillContext(items = []) {
    return items.map(item => {
      return Object.assign({}, item, {
        value: null
      });
    });
  }
  convertPlaceholder(levels) {
    return Array.isArray(levels) ? levels.join('/') : levels;
  }
  getValue() {
    const results = [];
    let ids = this.value.slice();
    let groups = this.groups;
    while (ids.length) {
      const id = ids.shift();
      let group = groups.find(item => item.id === id);
      if (group) {
        results.push({
          optionId: group.id,
          value: group.content,
          colId: '',
          rowId: ''
        });
        groups = group.nextLevelOptions || [];
      }
    }
    if (this.items.length && this.requiredNum > results.length) {
      this.items.forEach(item => {
        if (!item.value) return;
        results.push({
          rowId: '',
          colId: '',
          optionId: item.id,
          value: item.value
        });
      });
    }
    return results;
  }
  setValue(data) {
    let value = [];
    let inputs = [];
    data.forEach(item => {
      let find = this.items.find(i => i.id === item.optionId);
      if (find) {
        find.value = item.value;
      } else {
        inputs.push(item.value);
        value.push(item.optionId);
      }
    });
    this.value = value;
    this.inputValue = inputs.join('/');
  }
  checkValue(required) {
    if (!required) return;
    let num = Math.min(this.levelsNum, this.requiredNum);
    let value = this.value.slice();
    let groups = this.groups;
    while (value.length && groups) {
      const id = value.shift();
      let group = groups.find(g => g.id === id);
      if (group) {
        groups = group.nextLevelOptions || [];
      }
    }
    if (this.value.length < num && groups.length) {
      return {
        success: false,
        message: '请填写所有选项'
      };
    }
    let len = this.requiredNum - this.levelsNum;
    if (len > 0) {
      if (!this.items.every(i => i.value)) {
        return {
          success: false,
          message: '输入框不能为空'
        };
      }
    }
  }
  getComponentType() {
    switch (this.styleType) {
      case CascaderStyleType.One:
        return 'Cascader';
      case CascaderStyleType.Many:
        return 'CityAddress';
    }
  }
  convertVoteAnswer() {
    const values = this.getValue();
    this.voteAnswer = values.map(item => item.optionId);
  }
  hasVoteFilter() {
    return !!this.voteAnswer.length;
  }
  toOneArray() {
    return this.getItems(this.groups);
  }
  getItems(groups = []) {
    const results = [];
    for (let i = 0; i < groups.length; i++) {
      let g = groups[i];
      if (g.nextLevelOptions && g.nextLevelOptions.length) {
        const items = this.getItems(g.nextLevelOptions);
        items.forEach(item => {
          results.push({
            text: `${g.content}/${item.text}`,
            id: `${g.id}/${item.id}`
          });
        });
      } else {
        results.push({
          text: g.content,
          id: g.id
        });
      }
    }
    return results;
  }
  getVoteAnswerValueText() {
    const list = this.toOneArray();
    console.log(this.voteAnswer);
    return list.reduce((res, item) => {
      const lastId = item.id.split('/').pop();
      if (this.voteAnswer.includes(lastId)) {
        res += item.text;
      }
      return res;
    }, '');
  }
}
class MatrixChoice {
  constructor(data) {
    this.items = this.normalCols(data.items, data.is_col_rand, data.colRandList || []);
    this.rows = this.normalizeRows(data.rows, data.initRowValue, data.is_row_rand, data.rowRandList || []);
    this.mutex = data.enableMutex ? data.mutex || [] : [];
    this.rowDesc = data.rowDesc || null;
    this.widths = data.widths || [];
  }
  normalCols(items, is_rand, list) {
    let results = items.map(col => {
      col.disabled = false;
      return col;
    });
    if (is_rand) {
      results = randList(results, list);
    }
    return results;
  }
  normalizeRows(rows, defaultsValue, is_rand, list) {
    let results = rows.map(item => {
      let val = typeof defaultsValue === 'function' ? defaultsValue() : defaultsValue;
      return Object.assign({}, item, {
        value: val,
        selected: false,
        cols: this.items.map(i => Object.assign({}, i))
      });
    });
    if (is_rand) {
      results = rowRandList(results, list);
    }
    return results;
  }
}
class MatrixSingleChoice extends MatrixChoice {
  constructor(data) {
    super(Object.assign({}, data, {
      initRowValue: ''
    }));
  }
  getValue() {
    return this.rows.reduce((res, row) => {
      const colId = row.value;
      if (colId) {
        let col = this.items.find(col => col.id === colId);
        let value = row.content.text + ' ' + col.content.text;
        res.push({
          optionId: '',
          rowId: row.row_id,
          colId,
          value
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    data.forEach(({
      colId,
      rowId
    }) => {
      let row = this.rows.find(row => row.row_id === rowId);
      if (row) {
        row.value = colId;
      }
    });
  }
  checkValue(required) {
    if (required) {
      if (this.getValue().length !== this.rows.length) {
        return {
          success: false,
          message: '每个子项都为必选项'
        };
      }
    }
  }
}
class MatrixMultipleChoice extends MatrixChoice {
  constructor(data) {
    super(Object.assign({}, data, {
      initRowValue: () => []
    }));
  }
  getValue() {
    const results = [];
    this.rows.forEach(row => {
      const colIds = row.value;
      let rowText = row.content.text;
      colIds.forEach(colId => {
        let col = this.items.find(col => col.id === colId);
        if (col) {
          results.push({
            optionId: '',
            rowId: row.row_id,
            colId,
            value: rowText + ' ' + col.content.text
          });
        }
      });
    });
    return results;
  }
  setValue(data) {
    data.forEach(({
      colId,
      rowId
    }) => {
      let row = this.rows.find(row => row.row_id === rowId);
      if (row) {
        row.value.push(colId);
      }
    });
  }
  checkValue(required) {
    if (!required) return;
    let items = this.getValue();
    let set = new Set();
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      set.add(item.rowId);
    }
    if (set.size !== this.rows.length) {
      return {
        success: false,
        message: '每个子项都为必选项'
      };
    }
  }
}
class MatrixSelectChoice extends MatrixChoice {
  constructor(data) {
    super(data);
    this.options = this.normalOptions(data.cells || []);
  }
  getValue() {
    return this.options.reduce((results, option) => {
      let item = option.items.find(i => i.id === option.value);
      if (item) {
        results.push({
          colId: option.col_id,
          rowId: option.row_id,
          value: item.content.text,
          optionId: option.value
        });
      }
      return results;
    }, []);
  }
  setValue(data) {
    data.forEach(item => {
      let option = this.options.find(o => o.row_id === item.rowId && o.col_id === item.colId);
      if (option) {
        option.value = item.optionId;
      }
    });
  }
  normalOptions(options = []) {
    return options.map(option => {
      option.value = '';
      return option;
    });
  }
  getCellByRowAndCol(row, col) {
    return this.options.find(o => o.row_id === row.row_id && o.col_id === col.id);
  }
  checkValue(required) {
    if (!required) return;
    if (this.getValue().length !== this.options.length) {
      return {
        success: false,
        message: '每个子项都为必选项'
      };
    }
  }
}
class MatrixFill extends MatrixChoice {
  constructor(data, option) {
    super(data);
    this.autoFillEnable = data.autoFillEnable || false;
    this.autoFillEditable = data.autoFillEditable || false;
    this.autoFill = data.autoFill || [];
    this.complexValidateEnable = data.complexValidateEnable || false;
    this.complexValidate = data.complexValidate || [];
    this.cells = this.normalCells(data.cells || [], option);
    this.setting = data.setting || {
      enableRelation: false
    };
    this.disableCopy = data.disableCopy || false;
  }
  normalCells(cells, option) {
    var _a;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    return cells.map(c => {
      let rule = rules.find(item => item.rowId === c.row_id && item.colId === c.col_id);
      const res = Object.assign({}, c, {
        readonly: false,
        rowId: c.row_id,
        colId: c.col_id
      });
      if (this.autoFillEnable && rule && option.autoFill) {
        // option.autoFill(res,
        //   Object.assign(
        //     {},
        //     rule,
        //     {
        //       autoFillEditable: this.autoFillEditable,
        //       getCurrentItems: (item: string) => {
        //         const [qid, rowId,colId] = item.split('.')
        //         const q_id = (this as any).catchData?.id
        //         if(qid !== q_id) return null
        //         return this.cells.filter(cell=>{
        //           return cell.rowId ===rowId && cell.colId === colId
        //         })
        //       }
        //     })
        // )
        res.readonly = !this.autoFillEditable;
      }
      // } else {
      //   Object.defineProperty(res, 'value', {
      //     writable: true,
      //     value: '',
      //     enumerable: true,
      //     configurable: true
      //   })
      // }
      defineFillValue(res);
      return res;
    });
  }
  setValueByRule(rule, value) {
    const cell = this.cells.find(cell => {
      return cell.rowId === rule.rowId && cell.colId === rule.colId;
    });
    if (!cell) return;
    cell.isCalc = true;
    cell.value = value;
    cell.isCalc = false;
  }
  getCellByRowAndCol(row, col) {
    return this.cells.find(o => o.row_id === row.row_id && o.col_id === col.id);
  }
  getValue() {
    return this.cells.reduce((res, cell) => {
      var _a;
      const val = cell.value;
      if (val) {
        res.push({
          rowId: cell.row_id,
          colId: cell.col_id,
          optionId: (_a = cell.fillContext[0]) === null || _a === void 0 ? void 0 : _a.id,
          value: val
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    var _a;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    this.cells.forEach(cell => {
      let item = data.find(o => o.colId === cell.col_id && o.rowId === cell.row_id);
      if (item) {
        if (this.autoFillEnable && item.value) {
          const colId = item.colId;
          const rowId = item.rowId;
          const rule = rules.find(rule => rule.colId === colId && rule.rowId === rowId);
          if (rule && !this.autoFillEditable) {
            cell.readonly = true;
          }
        }
        cell.isCalc = true;
        cell.value = item.value;
        cell.isCalc = false;
      }
    });
  }
  checkValue(required) {
    if (!required) return;
    let items = this.getValue();
    const finalCells = this.cells.filter(cell => !cell.readonly);
    if (items.length < finalCells.length) {
      return {
        success: false,
        message: '每个子项都为必填项'
      };
    }
  }
  runComplexValidate(answerContent, currentContent) {
    const item = this.complexValidate.find(item => {
      return item.conditions.some(c => {
        const [rid, cid] = c.subCode.split('.');
        const currentValue = currentContent.items.find(i => i.rowId === rid && i.colId === cid);
        if (!currentValue) return false;
        return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
      });
    });
    if (!item) return {
      success: true,
      message: null
    };
    return {
      success: false,
      message: item.alert,
      rule: item
    };
  }
}
class Blanks {
  constructor(data, option) {
    this.autoFillEnable = data.autoFillEnable || false;
    this.autoFillEditable = data.autoFillEditable || false;
    this.autoFill = data.autoFill || [];
    this.items = this.convertFillContent(data.fillContext, data.fillText, option);
    this.numCompareRule = data.numCompareRule;
    this.disableCopy = data.disableCopy || false;
    this.complexValidateEnable = data.complexValidateEnable || false;
    this.complexValidate = data.complexValidate || [];
  }
  convertFillContent(fillContext = [], text = '', option) {
    var _a;
    const FillTextRegExp = /([^_]*)+(_*)/g;
    let contents = fillContext.slice();
    let results = [];
    let execArray;
    let t = text;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    while ((execArray = FillTextRegExp.exec(text)) && contents.length) {
      let val = execArray[0];
      let str = execArray[1];
      let separator = execArray[2];
      t = t.replace(val, '');
      const content = contents.shift();
      let rule = rules.find(item => item.optionId === content.id);
      let res = {
        text: str,
        length: separator.length,
        content: convertInputType(content),
        placeholder: content.placeholder,
        readonly: false
      };
      if (this.autoFillEnable && rule && option.autoFill) {
        res.readonly = !this.autoFillEditable;
      }
      defineFillValue(res);
      results.push(res);
    }
    if (t) {
      results.push({
        text: t,
        length: 0,
        content: null,
        value: ''
      });
    }
    return results;
  }
  getValue() {
    let items = this.items.filter(item => {
      return item.length && item.content;
    });
    return items.reduce((res, item) => {
      if (item.value) {
        res.push({
          colId: '',
          rowId: '',
          optionId: item.content.id,
          value: item.value
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    var _a;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    this.items.forEach(item => {
      if (item.content) {
        let answerContentItem = data.find(d => d.optionId === item.content.id);
        if (answerContentItem) {
          let rule = rules.find(rule => rule.optionId === answerContentItem.optionId);
          item.readonly = !!(rule && answerContentItem.value && this.autoFillEnable && !this.autoFillEditable);
          item.isCalc = true;
          item.value = answerContentItem.value;
          item.isCalc = false;
        }
      }
    });
  }
  checkValue() {
    for (let i = 0; i < this.items.length; i++) {
      let item = this.items[i];
      let content = item.content;
      if (!item.length || !item.content) continue;
      if (item.readonly) continue;
      let err = checkValidateValue(item.value, {
        validate: content.validate,
        min: content.minLength,
        max: content.maxLength,
        required: content.required,
        digit: content.digit
      });
      if (err) {
        return {
          message: `第${i + 1}项 ${err}`,
          success: false,
          item
        };
      }
    }
  }
  runComplexValidate(answerContent, currentContent) {
    const item = this.complexValidate.find(item => {
      return item.conditions.some(c => {
        const currentValue = currentContent.items.find(i => i.optionId === c.subCode);
        if (!currentValue) return false;
        return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
      });
    });
    if (!item) return {
      success: true,
      message: null
    };
    return {
      success: false,
      message: item.alert,
      rule: item
    };
  }
  setValueByRule(rule, value) {
    const cell = this.items.find(cell => {
      return cell.content.id === rule.optionId;
    });
    if (!cell) return;
    cell.isCalc = true;
    cell.value = value;
    cell.isCalc = false;
  }
}
class MultipleBlanks {
  constructor(data, option) {
    this.autoFillEnable = data.autoFillEnable || false;
    this.autoFillEditable = data.autoFillEditable || false;
    this.autoFill = data.autoFill || [];
    this.complexValidateEnable = data.complexValidateEnable || false;
    this.complexValidate = data.complexValidate || [];
    this.fillContext = this.initFillContext(data.fillContext || [], data.is_rand, data.randList || [], option);
    this.setting = data.setting || {
      enableRelation: false
    };
    this.disableCopy = data.disableCopy || false;
    this.ignoreItems = [];
  }
  initFillContext(items, isRand, list, option) {
    var _a;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    let results = items.map(i => {
      i.content = initContent(i.content);
      const res = Object.assign({}, convertInputType(i));
      let rule = rules.find(item => item.optionId === i.id);
      res.prefixIcon = getInputPrefixIcon(res.validate);
      if (this.autoFillEnable && rule) {
        res.readonly = !this.autoFillEditable;
      }
      defineFillValue(res);
      return res;
    });
    if (isRand) {
      results = randList(results, list);
    }
    return results;
  }
  getValue() {
    return this.fillContext.map(item => {
      return {
        rowId: '',
        colId: '',
        optionId: item.id,
        value: item.value,
        photos: item.content.fileList.map(s => s.url)
      };
    }).filter(i => i.value);
  }
  setValue(data) {
    var _a;
    const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
    if (!data) data = [];
    this.fillContext.forEach(item => {
      let find = data.find(d => d.optionId === item.id);
      if (find) {
        let rule = rules.find(rule => rule.optionId === find.optionId);
        item.readonly = !!(rule && find.value && this.autoFillEnable && !this.autoFillEditable);
        item.isCalc = true;
        item.value = find.value;
        item.isCalc = false;
        if (find.photos) {
          item.content.fileList = find.photos.map(i => ({
            name: i,
            url: i
          }));
        }
      }
    });
  }
  checkValue(required) {
    for (let i = 0; i < this.fillContext.length; i++) {
      let item = this.fillContext[i];
      let content = item;
      if (item.readonly) continue;
      if (this.ignoreItems.some(i => i.id === item.id)) continue;
      const allowErrorList = item.allowErrorList || [];
      if (allowErrorList.includes(item.value.toString())) {
        continue;
      }
      let err = checkValidateValue(item.value, {
        validate: content.validate,
        min: content.minLength,
        max: content.maxLength,
        required: item.required,
        digit: content.digit === -1 ? Infinity : content.digit
      });
      if (err) {
        return {
          message: `第${i + 1}项 ${err}`,
          success: false,
          item
        };
      }
      let res = checkContent(content.content);
      if (!res.success) {
        return res;
      }
    }
  }
  setValueByRule(rule, value) {
    const cell = this.fillContext.find(cell => {
      return cell.id === rule.optionId;
    });
    if (!cell) return;
    cell.isCalc = true;
    cell.value = value;
    cell.isCalc = false;
  }
  runComplexValidate(answerContent, currentContent) {
    const item = this.complexValidate.find(item => {
      return item.conditions.some(c => {
        const currentValue = currentContent.items.find(i => i.optionId === c.subCode);
        if (!currentValue) return false;
        return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentValue.value), c.operator);
      });
    });
    if (!item) return {
      success: true,
      message: null
    };
    return {
      success: false,
      message: item.alert,
      rule: item
    };
  }
  getValueConfirm(item) {
    // for (let i = 0; i < this.fillContext.length; i++) {
    //   let item = this.fillContext[i]
    let content = item;
    if (item.readonly) return;
    if (item.outOfRange !== 1) return;
    if (this.ignoreItems.some(i => i.id === item.id)) return;
    if (item.validate !== ValidateType.NUM) return;
    const allowErrorList = item.allowErrorList || [];
    if (allowErrorList.includes(item.value.toString())) {
      return;
    }
    let err = checkValidateValue(item.value, {
      validate: content.validate,
      min: content.minLength,
      max: content.maxLength,
      digit: content.digit === -1 ? Infinity : content.digit
    });
    if (!err) return null;
    if (!err.includes('不能')) {
      return null;
    }
    return {
      message: item.outOfRangeMessage
    };
    // }
  }
}
class TextFill {
  constructor(data) {
    this.value = '';
    this.placeholder = '';
    this.min_length = data.min_length || -Infinity;
    this.max_length = data.max_length || Infinity;
    this.value = data.default_text || '';
    this.digit = hasValue(data.digit) ? parseInt(data.digit) : 2;
    this.rows = data.rows || 1;
    this.validate = data.validate || ValidateType.NULL;
    this.messageValidate = !!data.message_validate;
    this.data_unique = data.data_unique;
    this.inputType = TextFill.convertInputType(data);
    this.isValidateCode = false;
    this.setting = data.setting || {
      enableRelation: false
    };
    this.placeholder = data.placeholder || '';
    this.defaultTip = data.outOfRange !== 1 ? initDefaultsTip({
      validate: this.validate,
      max: this.max_length,
      min: this.min_length,
      digit: this.digit,
      regexpRules: data.enableRegexpValidate ? data.regexpRules || [] : []
    }) : '';
    this.disableCopy = data.disableCopy || false;
    this.allowOtherValue = data.allowOtherValue || false;
    this.autoFillEnable = data.autoFillEnable || false;
    this.autoFillEditable = data.autoFillEditable || false;
    this.outOfRange = data.outOfRange || 0;
    this.outOfRangeMessage = data.outOfRangeMessage || '输入值可能有问题，请再次确认';
    this.autoFill = data.autoFill || [];
    this.complexValidateEnable = data.complexValidateEnable || false;
    this.complexValidate = data.complexValidate || [];
    this.allowErrorList = data.allowErrorList || [];
    this.readonly = false;
    this.regexpRules = data.regexpRules || [];
    this.enableRegexpValidate = data.enableRegexpValidate || false;
  }
  static convertInputType(data) {
    if (data.validate === ValidateType.PASSWORD) return 'password';
    if (data.validate === ValidateType.PHONE) return 'number';
    return data.rows === 1 ? 'input' : 'textarea';
  }
  getValue() {
    if (!this.value) return [];
    return [{
      rowId: '',
      colId: '',
      optionId: '',
      value: this.value
    }];
  }
  setValue(data) {
    var _a, _b;
    if (data.length) {
      const rules = ((_a = this.autoFill[0]) === null || _a === void 0 ? void 0 : _a.fillRules) || [];
      const expression = (((_b = rules[0]) === null || _b === void 0 ? void 0 : _b.expression) || []).filter(Boolean);
      if (expression.length && this.autoFillEnable && !this.autoFillEditable) {
        this.readonly = true;
      }
      this.value = data[0].value;
    }
  }
  check(required) {
    let value = this.value;
    let validate = this.validate;
    if (!value) {
      if (required) {
        throw new Error('内容不能为空');
      } else {
        return true;
      }
    }
    if (validate === ValidateType.PHONE) {
      if (!ValidateRule.phone(value.trim())) {
        throw new Error('手机号不正确');
      }
    } else if (validate === ValidateType.EMAIL) {
      if (ValidateRule.email(value.trim())) {
        throw new Error('邮箱不正确');
      }
    }
  }
  checkValue() {
    if (!this.value) return;
    if (this.allowErrorList.includes(this.value.trim())) return;
    let errormsg = checkValidateValue(this.value, {
      validate: this.validate,
      max: this.max_length,
      min: this.min_length,
      digit: this.digit,
      allowOtherValue: this.allowOtherValue,
      regexpRules: this.enableRegexpValidate ? this.regexpRules : []
    });
    if (errormsg) {
      return {
        success: false,
        message: errormsg
      };
    }
    if (this.messageValidate) {
      if (!this.isValidateCode) {
        return {
          success: false,
          message: '手机号未验证'
        };
      }
    }
  }
  runComplexValidate(answerContent, currentContent) {
    const v = this.complexValidate.find(item => {
      return item.conditions.some(c => {
        if (!currentContent.items.length) return false;
        return calcNumExpress([getExprValueByAnswer(c.rightOptions, answerContent)], Number(currentContent.items[0].value), c.operator);
      });
    });
    if (!v) return {
      success: true,
      message: ''
    };
    return {
      success: false,
      message: v.alert,
      rule: v
    };
  }
  getValueConfirm() {
    if (this.validate !== ValidateType.NUM) return null;
    if (this.outOfRange !== 1) return null;
    if (this.allowErrorList.includes(this.value.trim())) return null;
    let errormsg = checkValidateValue(this.value, {
      validate: this.validate,
      max: this.max_length,
      min: this.min_length,
      digit: this.digit,
      allowOtherValue: this.allowOtherValue
    });
    if (!errormsg) return null;
    if (!errormsg.includes('不能')) {
      return null;
    }
    return {
      message: this.outOfRangeMessage
    };
  }
  setValueByRule(rule, value) {
    this.value = value.toString();
  }
}
class OnlyText {
  checkValue(required) {}
  getValue() {
    return [];
  }
  setValue(data) {}
}
class Scale {
  constructor(data) {
    this.labels = this.initLabels(data.labels || []);
    this.value = null;
    this.items = data.items || [];
    this.firstLabel = this.labels[0];
    this.lastLabel = this.labels[this.labels.length - 1];
    this.show_unknown = data.showUnknown || false;
    this.unknown_text = data.unknownText || '';
    this.show_option_desc = typeof data.show_option_desc === 'boolean' ? data.show_option_desc : true;
    this.show_option_value = typeof data.show_option_value === 'boolean' ? data.show_option_value : true;
    this.activeColor = data.activeColor || 'rgb(39, 117, 232)';
    this.styleType = data.styleType || 1;
  }
  initLabels(labels = []) {
    return labels.map((l, index) => {
      let id = l.id;
      if (!id) {
        id = index + 1;
      }
      l.id = id;
      return l;
    });
  }
  getValue() {
    var _a;
    const str1 = this.labels[0].text;
    const str2 = this.labels[this.labels.length - 1].text;
    if (!this.value) return [];
    const num = (_a = this.labels.find(i => i.id === this.value)) === null || _a === void 0 ? void 0 : _a.num;
    let value = this.value === 'unknown' ? '' : `${num}(${str1}-${str2})`;
    return [{
      optionId: this.items[0].id,
      value,
      colId: '',
      rowId: ''
    }];
  }
  setValue(data) {
    if (!data.length) return;
    const m = data[0].value.match(/(-?\d+)/);
    let value = m ? m[0] : '';
    // let value = parseInt(num) || ''
    let l = this.labels.find(l => l.num.toString() === value.toString());
    if (!l) return;
    this.value = l.id;
  }
  checkValue(required) {}
  getRgbColor(opacity) {
    const color = this.activeColor;
    const reg = /\((.*)\)/;
    let result = color.match(reg);
    if (!result) return color;
    const [r, g, b] = result[1].split(',');
    return `rgba(${r},${g},${b},${opacity})`;
  }
  getActiveColor(activeValue, idx) {
    console.log(activeValue);
    const labels = this.labels;
    const isSelectStyle = this.styleType === 1;
    let findIndex = labels.findIndex(label => label.id === activeValue);
    if (findIndex < idx) return {};
    if (isSelectStyle && findIndex !== idx) return {};
    if (isSelectStyle) {
      return {
        backgroundColor: 'rgb(39, 117, 232)'
      };
    }
    const len = isSelectStyle ? 1 : labels.length;
    return {
      backgroundColor: this.getRgbColor((idx + 1) / len)
    };
  }
  getTotalScore(answerScore) {
    const optionScoreItems = answerScore.optionScoreItems;
    return Math.max.apply(Math, optionScoreItems.map(o => o.score));
  }
  getScore(answerScore) {
    var _a;
    const optionScoreItems = answerScore.optionScoreItems;
    const value = ((_a = this.labels.find(item => item.id === this.value)) === null || _a === void 0 ? void 0 : _a.num) || '';
    const item = optionScoreItems.find(item => String(item.value) === String(value));
    return (item === null || item === void 0 ? void 0 : item.score) || '';
  }
}
class NPSScale extends Scale {}
class CustomScale extends Scale {}
function normalAuxiliaryColumns(cols, items) {
  const results = [];
  items.forEach(item => {
    const col = cols.find(col => col.rowId === item.id);
    if (col) {
      results.push(col);
    } else {
      results.push({
        content: {
          text: '',
          richText: ''
        },
        id: '',
        rowId: item.id
      });
    }
  });
  return results;
}
class MatrixScale extends Scale {
  constructor(data) {
    super(data);
    this.items = this.convertItems(data.items || [], data.is_rand, data.randList || []);
    this.rowDesc = data.rowDesc;
    this.enabledAuxiliaryColumn = data.enabledAuxiliaryColumn || false;
    this.auxiliaryColumns = normalAuxiliaryColumns(data.auxiliaryColumns || [], this.items);
  }
  convertItems(items = [], isRand, list) {
    let results = items.map(item => {
      return Object.assign({}, item, {
        value: null
      });
    });
    if (isRand) {
      results = randList(results, list);
    }
    return results;
  }
  getValue() {
    const str1 = this.labels[0].text;
    const str2 = this.labels[this.labels.length - 1].text;
    return this.items.reduce((res, item) => {
      var _a;
      if (hasValue(item.value)) {
        const num = (_a = this.labels.find(i => i.id === item.value)) === null || _a === void 0 ? void 0 : _a.num;
        const value = item.value === 'unknown' ? '' : `${num}(${str1}-${str2})`;
        res.push({
          colId: '',
          rowId: '',
          optionId: item.id,
          value
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    this.items.forEach(item => {
      let find = data.find(i => i.optionId === item.id);
      if (find) {
        if (find.value === '') {
          item.value = 'unknown';
        } else {
          const val = find.value || "";
          const m = val.match(/(-?\d+)/);
          let num = m ? m[0] : '';
          // let value = parseInt(num) || ''
          let l = this.labels.find(l => l.num.toString() === num.toString());
          item.value = l === null || l === void 0 ? void 0 : l.id;
        }
      }
    });
  }
  checkValue(required) {
    if (required) {
      if (this.getValue().length !== this.items.length) {
        return {
          success: false,
          message: '每个子项都为必选项'
        };
      }
    }
  }
  getTotalScore(answerScore) {
    const optionScoreItems = answerScore.optionScoreItems;
    const len = this.items.length;
    return Math.max.apply(Math, optionScoreItems.map(o => o.score)) * len;
  }
  getScore(answerScore) {
    const optionScoreItems = answerScore.optionScoreItems;
    return this.items.reduce((score, item) => {
      if (!item.value) return score;
      const label = this.labels.find(l => l.id === item.value);
      if (!label) return score;
      const opt = optionScoreItems.find(opt => (opt.value || '').toString() === label.num.toString());
      if (opt) {
        score = score + opt.score;
      }
      return score;
    }, 0);
  }
}
class MatrixCustomScale extends MatrixScale {}
class UploadFile {
  // public min: number
  constructor(data) {
    this.uploadFiles = [];
    this.allowFileTypes = [];
    this.uploadFiles = [];
    this.checkFileType = data.checkFileType || false;
    this.allowFileTypes = data.allowFileTypes || [];
    this.max = normalMax(data.max);
    // this.min = normalMin(data.min)
  }
  getValue() {
    return this.uploadFiles.map(item => {
      return {
        colId: '',
        rowId: '',
        optionId: '',
        value: item.url
      };
    });
  }
  setValue(data) {
    this.uploadFiles = data.map(d => {
      return {
        name: d.value,
        url: d.value
      };
    });
  }
  checkValue() {}
}
class DateTime {
  constructor(data) {
    this.value = '';
    let issue = this.data = data.fillContext[0];
    this.dateType = issue.dateType;
    this.max = issue.maxLength;
    this.range = issue.rangeLength;
    this.min = issue.minLength;
    this.optionId = issue.id;
    this.validateType = issue.validate;
    this.datetimeValue = [];
  }
  getValue() {
    if (this.value) {
      return [{
        optionId: this.optionId,
        rowId: '',
        colId: '',
        value: this.value
      }];
    } else {
      return [];
    }
  }
  setValue(data) {
    if (data.length) {
      let d = data[0];
      this.value = d.value;
    }
  }
  checkValue() {}
}
class Gravity {
  constructor(data) {
    let labels = data.labels;
    this.items = this.transformItems(data.items, data.is_rand);
    this.totalValue = data.total_value || 0;
    this.min = labels[0].num;
    this.max = labels[1].num;
  }
  transformItems(items, isRand) {
    let results = items.map(item => {
      return Object.assign(item, {
        value: 0
      });
    });
    if (isRand) {
      results = shuffle(results);
    }
    return results;
  }
  getValue() {
    return this.items.map(item => {
      return {
        colId: '',
        rowId: '',
        optionId: item.id,
        value: item.value
      };
    });
  }
  setValue(data) {
    data.forEach(item => {
      let find = this.items.find(i => i.id === item.optionId);
      if (find) {
        find.value = item.value;
      }
    });
  }
  checkValue(required) {
    const total = this.items.reduce((res, item) => {
      res += Number(item.value);
      return res;
    }, 0);
    if (!required && total === 0) {
      return;
    }
    if (total < this.totalValue) {
      return {
        success: false,
        message: `总和不到${this.totalValue}`
      };
    } else if (total > this.totalValue) {
      return {
        success: false,
        message: `总和为${this.totalValue}`
      };
    }
  }
}
class Classification {
  constructor(data) {
    this.rows = this.initRows(data.rows, data.is_rand, data.randList || []);
    this.items = this.initItems(data.items);
    this.max = data.max_choice || -1;
    this.min = data.min_choice || -1;
    this.defaultTip = this.initDefaultTip();
  }
  initDefaultTip() {
    const min = this.min;
    const max = this.max;
    if (min > 0 && max > 0) {
      if (min === max) {
        return `请选择${min}项`;
      }
      return `请选择${min}~${max}项`;
    } else if (min > 0) {
      return `至少选择${min}项`;
    } else if (max > 0) {
      return `最多选择${max}项`;
    }
  }
  initItems(items) {
    return items.map(item => {
      return Object.assign({}, item, {
        selects: []
      });
    });
  }
  initRows(rows, isRand, list) {
    let res = rows.map(r => Object.assign({}, r, {
      colId: '',
      checked: false
    }));
    if (isRand) {
      res = rowRandList(res, list);
    }
    return res;
  }
  getValue() {
    return this.items.reduce((res, item) => {
      let colId = item.id;
      let colText = item.content.text;
      item.selects.forEach(row => {
        res.push({
          colId: colId,
          rowId: row.row_id,
          optionId: '',
          value: `${row.content.text} ${colText}`
        });
      });
      return res;
    }, []);
  }
  setValue(data) {
    const selects = [];
    data.forEach(({
      rowId,
      colId
    }) => {
      let item = this.items.find(i => i.id === colId);
      let row = this.rows.find(r => r.row_id === rowId);
      if (item && row) {
        row.colId = item.id;
        selects.push(row.row_id);
        item.selects.push(row);
      }
    });
    this.rows = this.rows.filter(r => !selects.includes(r.row_id));
  }
  checkValue(required, opt) {
    let min = normalMin(this.min);
    let max = normalMax(this.max);
    if (min === -Infinity && max === Infinity) return;
    for (let i = 0; i < this.items.length; i++) {
      let item = this.items[i];
      let len = item.selects.length;
      if (max !== Infinity) {
        if (len > max) {
          return {
            success: false,
            message: `每个分类最多${max}选项`
          };
        }
      }
      if (min !== -Infinity) {
        if (len < min) {
          return {
            success: false,
            message: `每个分类至少${min}选项`
          };
        }
      }
    }
    // let rows = this.rows
    // if (opt.browserInfo?.isPc) {
    //   if (rows.length) {
    //     return {
    //       message: '请对所有选项进行分类',
    //       success: false
    //     }
    //   }
    // } else {
    //   let rs = rows.filter(i => i.colId)
    //   if (rows.length === rs.length || !rs.length) return
    //   return {
    //     message: '请对所有选项进行分类',
    //     success: false
    //   }
    // }
  }
}
class ImageChoice {
  constructor(data) {
    this.items = this.initItems(data.items, data.is_rand, data.randList || []);
    this.voteAnswer = [];
  }
  initItems(items, isRand, list) {
    let res = items.map(item => {
      item.content.image = (item.content.image || []).map(item => {
        return {
          url: convertDownloadUrl(item.url)
        };
      });
      return Object.assign({}, item, {});
    });
    if (isRand) {
      res = randList(res, list);
    }
    return res;
  }
  transformVote(vote) {
    this.items.forEach(item => {
      vote.oidCountMap[item.id] = vote.oidCountMap[item.id] || 0;
    });
  }
  hasVoteFilter() {
    return !!this.voteAnswer.length;
  }
  getVoteAnswerValueText() {
    return this.voteAnswer.map(id => {
      var _a, _b;
      return (_b = (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text;
    }).join(',');
  }
}
class SingleImageChoice extends ImageChoice {
  constructor(data) {
    super(data);
    this.select = '';
  }
  getValue() {
    let item = this.items.find(i => i.id === this.select);
    if (!item) return [];
    return [{
      optionId: this.select,
      colId: '',
      rowId: '',
      value: item.content.text
    }];
  }
  setValue(data) {
    if (data.length) {
      this.select = data[0].optionId;
    }
  }
  checkValue() {}
  convertVoteAnswer() {
    const values = this.getValue();
    this.voteAnswer = values.map(item => item.optionId);
  }
}
class MultipleImageChoice extends ImageChoice {
  constructor(data) {
    super(data);
    this.select = [];
    this.min_choice = data.min_choice || -1;
    this.max_choice = data.max_choice || -1;
    this.defaultTip = this.initDefaultTip();
  }
  initDefaultTip() {
    const min = this.min_choice;
    const max = this.max_choice;
    if (min > 0 && max > 0) {
      if (min === max) {
        return `请选择${min}项`;
      }
      return `请选择${min}~${max}项`;
    } else if (min > 0) {
      return `至少选择${min}项`;
    } else if (max > 0) {
      return `最多选择${max}项`;
    }
  }
  getValue() {
    return this.select.reduce((res, id) => {
      let item = this.items.find(i => i.id === id);
      if (item) {
        res.push({
          optionId: id,
          colId: '',
          rowId: '',
          value: item.content.text
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    this.select = data.map(i => i.optionId);
  }
  checkValue(required) {
    let min = normalMin(this.min_choice);
    let max = normalMax(this.max_choice);
    let len = this.select.length;
    if (len > max) {
      return {
        success: false,
        message: `最多选择${max}项`
      };
    }
    if (len < min) {
      return {
        success: false,
        message: `最少选择${min}项`
      };
    }
  }
  convertVoteAnswer() {
    const values = this.getValue();
    this.voteAnswer = values.map(item => item.optionId);
  }
}

// import { isPC } from '@dygc/shared'
function convertItems(items) {
  return items.map(item => {
    return Object.assign({
      value: '',
      inputType: convertInputType(item.validate),
      setting: {
        enableRelation: false
      }
    }, item);
  });
}
class Sort {
  constructor(data) {
    this.min_choice = normalMin(data.min_choice || -1);
    this.max_choice = normalMax(data.max_choice || -1);
    this.is_rand = data.is_rand || false;
    this.randList = data.randList || [];
    this.items = this.initItems(convertItems(data.items || []), data.is_rand);
    this.value = this.initValue(this.items);
    this.defaultTip = this.initDefaultTip();
    this.ignoreItems = [];
    this.disableChangePosition = data.disableChangePosition || false;
  }
  initValue(items = []) {
    return items.map((item, index) => {
      return Object.assign({}, item, {
        select: false,
        originPosition: index
      });
    });
  }
  initItems(items = [], isRand = false) {
    if (isRand) {
      return randList(items, this.randList);
    } else {
      return items;
    }
  }
  getValue() {
    return this.value.reduce((res, item) => {
      let value = item.content.text;
      if (item.is_other_item) {
        value = `${value}|${item.value}`;
      }
      if (item.select) {
        res.push({
          colId: '',
          rowId: '',
          optionId: item.id,
          value
        });
      }
      return res;
    }, []);
  }
  setValue(data) {
    // if (isPC()) {
    //   this.value = data.map(i => {
    //     let item = this.items.find(item => item.id === i.optionId)
    //     if (item.is_other_item) {
    //       item.value = i.value.split('|')[1]
    //     }
    //     return item
    //   })
    //   this.value.forEach(i => (i.select = true))
    //   this.items = this.items.filter(item => !data.find(i => i.optionId === item.id))
    // } else {
    let value = this.value.slice();
    let v1 = value.filter(i => !data.find(d => d.optionId === i.id));
    let v2 = data.map(d => {
      let item = value.find(i => i.id === d.optionId);
      if (item.is_other_item) {
        item.value = d.value.split('|')[1];
      }
      return item;
    }).filter(Boolean);
    v2.forEach(item => item.select = true);
    this.value = v2.concat(v1);
    // }
  }
  initDefaultTip() {
    if (this.max_choice > 0 && this.max_choice !== Infinity) {
      return `仅选出${this.max_choice}项`;
    }
  }
  checkValue(required) {
    for (let i = 0; i < this.value.length; i++) {
      const item = this.value[i];
      if (!item.select) continue;
      if (!item || !item.is_other_item) continue;
      if (!item.required && !item.value) continue;
      if (this.ignoreItems.find(i => i.id === item.id)) return;
      const allowErrorList = item.allowErrorList || [];
      if (allowErrorList.includes(item.value.toString())) {
        continue;
      }
      const err = checkValidateValue(item.value, {
        validate: item.validate,
        required: item.required,
        min: item.minLength,
        max: item.maxLength,
        digit: item.digit === -1 ? Infinity : item.digit,
        message: {
          required: '请填写填空内容'
        }
      });
      if (!err) continue;
      return {
        message: err,
        success: false,
        item
      };
    }
    let max = this.max_choice;
    if (max === Infinity) return;
    const length = this.getValue().length;
    if (length === 0 && !required) return;
    if (length !== max) {
      return {
        success: false,
        message: `请选出${max}个选项`
      };
    }
  }
  getValueConfirm() {
    for (let i = 0; i < this.value.length; i++) {
      const item = this.value[i];
      if (!item.select) continue;
      if (!item || !item.is_other_item) continue;
      if (!item.required && !item.value) continue;
      if (item.outOfRange !== 1) return;
      const allowErrorList = item.allowErrorList || [];
      if (allowErrorList.includes(item.value.toString())) {
        continue;
      }
      const err = checkValidateValue(item.value, {
        validate: item.validate,
        required: item.required,
        min: item.minLength,
        max: item.maxLength,
        digit: item.digit === -1 ? Infinity : item.digit,
        message: {
          required: '请填写填空内容'
        }
      });
      if (!err) continue;
      if (!err.includes('不能')) {
        return null;
      }
      return {
        message: item.outOfRangeMessage
      };
    }
  }
}
class MatrixScroll extends Gravity {
  constructor(data) {
    super(data);
    let minValue = parseInt(data.labels[0].num);
    let value = parseInt(data.default_value);
    let defaultValue = isNaN(value) ? minValue : value;
    this.items = this.transformScrollItems(data.items, data.is_rand, defaultValue);
    this.labels = data.labels || [];
  }
  transformScrollItems(items = [], isRand, defaultValue) {
    let results = items.map(item => {
      return Object.assign(item, {
        value: defaultValue
      });
    });
    if (isRand) {
      results = shuffle(results);
    }
    return results;
  }
  // @ts-ignore
  checkValue() {}
}
class Compose {
  constructor(data) {
    this.items = this.initItems(data.items, data.is_col_rand, data.colRandList || []);
    this.cells = this.initCells(data.cells);
    this.rows = [];
    this.value = [];
    this.widths = data.widths || [];
  }
  initItems(items = [], isRand = false, list) {
    items = items.map(item => {
      return Object.assign({}, item, {});
    });
    if (isRand) {
      items = randList(items, list);
    }
    return items;
  }
  initCells(cells = []) {
    return cells.map(cell => {
      return Object.assign({}, cell, {});
    });
  }
  getCellByItemId(id) {
    return this.cells.find(c => c.col_id === id);
  }
  addValue(value = []) {
    let values = this.value.slice();
    while (value.length) {
      let val = value.shift();
      values = values.filter(v => {
        return !(v.colId === val.colId && v.rowId === val.rowId);
      });
      values.push(val);
    }
    this.value = values;
  }
  getValueByRowAndCol(row, col) {
    return this.value.find(v => v.rowId === row.row_id && v.colId === col.id);
  }
  getValue() {
    return this.value.filter(v => {
      return this.rows.find(row => row.row_id === v.rowId);
    });
  }
  setValue(data) {
    this.value = data;
    // 有可能文案一样但是id不一致 （重复修改题目导致的）
    this.value.forEach(item => {
      if (!item.optionId) return;
      const cell = this.cells.find(cell => cell.col_id === item.colId);
      if (!cell || !cell.items) return;
      const it = cell.items.find(it => it.id === item.optionId);
      if (it) return;
      const i = cell.items.find(it => it.content.text === item.value);
      if (!i) return;
      item.optionId = i.id;
    });
  }
  checkValue(required) {
    // if (!required) return
    let items = this.getValue();
    // if (items.length !== this.cells.length * this.rows.length) {
    //   return {
    //     success: false,
    //     message: '每个子项都为必选项'
    //   }
    // }
    let flag = false;
    const cols = this.items;
    for (const row of this.rows) {
      cols.forEach(col => {
        let cell = items.find(i => i.colId === col.id && row.row_id === i.rowId);
        row.errMap[col.id] = '';
        if ((!cell || !cell.value) && col.required) {
          row.errMap[col.id] = '内容不能为空';
          flag = true;
        }
      });
    }
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let cell = this.getCellByItemId(item.colId);
      if (cell && cell.cell_type === questionType.SINGLE_TEXT_FILL) {
        let err = checkValidateValue(item.value, {
          max: cell.max_length,
          min: cell.min_length,
          validate: cell.validate,
          digit: cell.digit
        });
        let row = this.rows.find(i => i.row_id === item.rowId);
        if (err) {
          row.errMap[item.colId] = err;
          flag = true;
        }
      }
    }
    if (!flag) return;
    return {
      success: false,
      message: ''
    };
  }
}
class MatrixCompose extends Compose {
  constructor(data) {
    super(data);
    this.rows = this.initRows(data.rows, data.is_row_rand, data.rowRandList || []);
    this.rowDesc = data.rowDesc;
  }
  initRows(rows = [], isRand = false, list) {
    rows = rows.map(row => {
      let ids = this.items.map(item => item.id);
      let errMap = {};
      ids.forEach(id => {
        errMap[id] = '';
      });
      return Object.assign({}, row, {
        errMap
      });
    });
    if (isRand) {
      rows = rowRandList(rows, list);
    }
    return rows;
  }
}
class MatrixAuto extends Compose {
  constructor(data) {
    super(data);
    const default_row_num = data.default_row_num || 2;
    this.can_add_row = data.can_add_row || false;
    this.max_row_num = data.max_row_num || default_row_num;
    this.min_row_num = data.min_row_num || default_row_num;
    this.rows = this.initRows(Math.max(default_row_num, this.min_row_num));
  }
  initRows(default_row_num) {
    let res = [];
    let n = 1;
    let itemIds = this.items.map(i => i.id);
    while (n <= default_row_num) {
      let errMap = {};
      itemIds.forEach(id => {
        errMap[id] = '';
      });
      res.push({
        row_id: n.toString(),
        content: {
          text: n,
          richText: n
        },
        errMap
      });
      n++;
    }
    return res;
  }
  addRow() {
    let n = this.rows.length + 1;
    let itemIds = this.items.map(i => i.id);
    let errMap = {};
    itemIds.forEach(id => {
      errMap[id] = '';
    });
    this.rows.push({
      row_id: n.toString(),
      content: {
        text: n,
        richText: n
      },
      errMap
    });
  }
  deleteRow(index) {
    let item = this.rows[index];
    if (!item) return;
    this.value = this.value.filter(v => v.rowId !== item.row_id);
    this.rows.splice(index, 1);
  }
  setValue(data) {
    super.setValue(data);
    let set = new Set();
    data.forEach(d => {
      set.add(d.rowId);
    });
    this.rows = this.initRows(Math.min(set.size, this.max_row_num));
  }
}
class HandWriting {
  constructor() {
    this.url = '';
  }
  setSignature(signature) {
    this.signature = signature;
  }
  toUrl() {
    let signature = this.signature;
    if (!signature) return Promise.reject();
    if (signature.isEmpty()) return Promise.resolve({
      optionId: '',
      colId: '',
      rowId: '',
      value: ''
    });
    let dataURL = signature.toDataURL('image/png');
    let blob = dataURLToBlob(dataURL);
    const f = new File([blob], Date.now() + '.png');
    let fd = new FormData();
    fd.append('file', f);
    return upload(fd).then(res => {
      let data = res.data;
      return {
        optionId: '',
        colId: '',
        rowId: '',
        value: data.url
      };
    });
  }
  getValue(type) {
    if (type === 'submit') {
      if (this.signature) {
        if (this.signature.isEmpty()) {
          return [{
            colId: "",
            rowId: "",
            optionId: "",
            value: this.url
          }];
        }
        return this.toUrl();
      } else {
        return [{
          colId: "",
          rowId: "",
          optionId: "",
          value: this.url
        }];
      }
    } else {
      return [];
    }
  }
  setValue(data) {
    if (data.length) {
      this.url = data[0].value;
    }
  }
  checkValue(required) {
    var _a;
    if (required && ((_a = this.signature) === null || _a === void 0 ? void 0 : _a.isEmpty()) && !this.url) {
      return {
        success: false,
        message: '不能为空'
      };
    }
  }
}
class CascadeRegion {
  constructor() {
    this.answerValue = [];
  }
  getCascade(pid) {
    return new Promise((resolve, reject) => {
      getCascaderRegion(pid).then(res => {
        let data = res.data;
        data.forEach(item => {
          if (item.next) ;else {
            item.leaf = true;
          }
        });
        resolve(data);
      });
    });
  }
  getValue() {
    return this.answerValue;
  }
  setValue(data) {
    this.answerValue = data;
  }
  checkValue() {}
}
class Downloadable {
  checkValue(required) {}
  getValue(type) {
    return [];
  }
  setValue(data) {}
}
class MapQ {
  constructor(data) {
    this.disallowUpdateLocation = data.disallowUpdateLocation;
    this.disallowInput = data.disallowInput;
    this.displayType = data.displayType;
    this.value = '';
    this.inputValue = '';
    this.list = [];
  }
  changeValue(val) {
    this.value = val.name + '|' + val.entr_location;
  }
  getPoiList(val) {
    return new Promise((resolve, reject) => {
      getPositionList(val).then(res => {
        let pois = res.pois || [];
        let list = pois.map(item => ({
          id: item.id,
          name: item.name,
          entr_location: item.location,
          location: item.location
        }));
        this.list = list;
        resolve(list);
      }).catch(reject);
    });
  }
  checkValue(required) {
    if (this.disallowInput && this.displayType === 0 || this.displayType === 1 && this.disallowInput && !this.disallowUpdateLocation) {
      let values = this.value.split('|');
      values.pop();
      let value = values.join('|');
      let val = this.list.find(item => item.name === value);
      if (!val) {
        return {
          success: false,
          message: '请输入内容'
        };
      }
    }
  }
  getValue(type) {
    let val = this.value;
    if (!val && this.inputValue) {
      val = this.inputValue + '| , ';
    }
    if (!val) return [];
    return [{
      colId: '',
      rowId: '',
      optionId: '',
      value: val
    }];
  }
  setValue(data) {
    if (data.length) {
      let val = data[0].value;
      this.value = val;
      this.inputValue = val.split('|')[0];
    }
  }
}
function convertItems$1(items = [], rangeType, min, max) {
  return items.map(item => {
    const res = Object.assign({
      value: 0,
      selectUnknown: false
    }, item);
    if (rangeType === 1) {
      res.min = min;
      res.max = max;
    }
    res.value = res.min || 0;
    return res;
  });
}
class Total {
  constructor(data) {
    this.items = convertItems$1(data.items || [], data.rangeType, data.min, data.max);
    this.openDifferentRange = data.openDifferentRange || false;
    this.showUnknown = data.showUnknown || false;
    this.unknownText = data.unknownText || '';
    this.showGraticule = data.showGraticule || false; // 是否显示刻度线
    this.graticule = data.graticule || 10; //刻度值
    this.showSum = data.showSum || false; // 是否显示加总项
    this.validate = Object.assign({}, {
      open: false,
      operator: '',
      value: 0
    }, data.validate || {});
  }
  getSum() {
    return this.items.reduce((res, item) => {
      if (item.selectUnknown) return res;
      return res + item.value;
    }, 0);
  }
  checkValue(required, opt) {
    if (this.showUnknown) return;
    if (!this.validate.open) return;
    if (!this.validate.operator) return;
    const sum = this.getSum();
    const value = this.validate.value;
    let message = '';
    switch (this.validate.operator) {
      case SelectType.GT:
        if (sum <= value) {
          message = `加总值需要大于${value}`;
        }
        break;
      case SelectType.LT:
        if (sum >= value) {
          message = `加总值需要小于${value}`;
        }
        break;
      case SelectType.Equal:
        if (value !== sum) {
          message = `加总值需要等于${value}`;
        }
        break;
      case SelectType.NotEqual:
        if (value === sum) {
          message = `加总值需要不等于${value}`;
        }
        break;
      case SelectType.GTEqual:
        if (sum < value) {
          message = `加总值需要大于等于${value}`;
        }
        break;
      case SelectType.LTEqual:
        if (sum > value) {
          message = `加总值需要小于等于${value}`;
        }
        break;
    }
    if (message) {
      return {
        message,
        success: false
      };
    }
  }
  getValue(type) {
    return this.items.map(item => {
      const value = item.selectUnknown ? '' : item.value;
      return {
        optionId: item.id,
        rowId: '',
        colId: '',
        value
      };
    });
  }
  setValue(data) {
    data.forEach(({
      value,
      optionId
    }) => {
      let find = this.items.find(i => i.id === optionId);
      if (find) {
        if (value === '') {
          find.selectUnknown = true;
          find.value = 0;
        } else {
          find.value = value;
        }
      }
    });
  }
}
class MaxDiff {
  constructor(data) {
    this.items = data.items || [];
    this.labelBest = data.labelBest || '最重要';
    this.labelItem = data.labelItem || '';
    this.labelWorst = data.labelWorst || '最不重要';
    this.taskNum = data.taskNum || 0;
    this.numPerTask = data.numPerTask || 0;
    this.align = hasValue(data.align) ? data.align : 0; // 0=左对齐，1=居中，2=右对齐
    this.allowReset = hasValue(data.allowReset) ? data.allowReset : true;
    this.fixedTask = data.fixedTask || false;
    this.extraQue = data.extraQue || {
      content: null
    };
    this.tasks = this.initialTask(data.tasks || []);
    if (!this.tasks.length) {
      this.initTasks();
    }
    this.results = this.initialResults();
  }
  initialTask(tasks) {
    return tasks.map(ids => {
      return ids.map(id => {
        return this.items.find(item => item.id === id);
      });
    });
  }
  initialResults() {
    let results = [];
    this.tasks.forEach((task, index) => {
      results.push({
        taskId: (index + 1).toString(),
        bestId: '',
        worstId: '',
        ids: task.map(t => t.id)
      });
    });
    return results;
  }
  initTasks() {
    const {
      taskNum,
      numPerTask,
      items
    } = this;
    let tasks = [];
    let n = 0;
    for (let i = 0; i < taskNum; i++) {
      let step = n + numPerTask;
      let list = items.slice(n, step);
      if (list.length < numPerTask) {
        let temp = items.filter(item => !list.find(l => l.id === item.id));
        list.push(...temp.slice(0, numPerTask - list.length));
      }
      const task = shuffle(list);
      n = step % items.length;
      tasks.push(task);
    }
    this.tasks = tasks;
  }
  checkValue(required, opt) {
    let isCheckAll;
    if (this.numPerTask === 1) {
      isCheckAll = this.results.every(res => res.bestId || res.worstId);
    } else {
      isCheckAll = this.results.every(res => res.bestId && res.worstId);
    }
    if (isCheckAll) {
      return;
    }
    if (!required) return;
    return {
      success: false,
      message: '请填写全部内容'
    };
  }
  getValue(type) {
    // colId "0=最好，1=最差，2=所有选项，3=后续问题答案"
    return this.results.reduce((results, result) => {
      let worstItem = this.items.find(item => item.id === result.worstId);
      let bestItem = this.items.find(item => item.id === result.bestId);
      if (worstItem) {
        results.push({
          optionId: worstItem.id,
          value: worstItem.content.text,
          rowId: result.taskId,
          colId: '1'
        });
      }
      if (bestItem) {
        results.push({
          optionId: bestItem.id,
          value: bestItem.content.text,
          rowId: result.taskId,
          colId: '0'
        });
      }
      results.push({
        optionId: result.ids.join(','),
        rowId: result.taskId,
        colId: '2',
        value: result.ids.map(id => {
          var _a;
          return (_a = this.items.find(item => item.id === id)) === null || _a === void 0 ? void 0 : _a.content.text;
        }).join(',')
      });
      return results;
    }, []);
  }
  setValue(data) {
    const taskIdMap = {};
    data.forEach(item => {
      if (item.colId === '2') return;
      if (!taskIdMap[item.rowId]) {
        taskIdMap[item.rowId] = [];
      }
      taskIdMap[item.rowId].push(item);
    });
    for (const taskId in taskIdMap) {
      let result = this.results.find(r => r.taskId === taskId);
      if (result) {
        let val = taskIdMap[taskId];
        val.forEach(item => {
          if (item.colId === '0') {
            result.bestId = item.optionId;
          } else if (item.colId === '1') {
            result.worstId = item.optionId;
          }
        });
      }
    }
  }
  getCurrentIndex() {
    if (this.numPerTask === 1) {
      return this.results.findIndex(result => !(result.worstId || result.bestId));
    } else {
      return this.results.findIndex(result => !(result.worstId && result.bestId));
    }
  }
}
const issueMap = new Map();
singleTypes.forEach(type => {
  issueMap.set(type, SingleChoice);
});
textTypes.forEach(t => {
  issueMap.set(t, TextFill);
});
issueMap.set(questionType.SINGLE_CHOICE, SingleChoice);
issueMap.set(questionType.MULTIPLE_CHOICE, MutChoice);
issueMap.set(questionType.SINGLE_SELECT, SingleChoice);
issueMap.set(questionType.MULTIPLE_SELECT, MutChoice);
issueMap.set(questionType.LINKAGE, Cascader);
issueMap.set(questionType.MATRIX_SINGLE_CHOICE, MatrixSingleChoice);
issueMap.set(questionType.MATRIX_MULTIPLE_CHOICE, MatrixMultipleChoice);
issueMap.set(questionType.MATRIX_SELECT_CHOICE, MatrixSelectChoice);
issueMap.set(questionType.BLANKS, Blanks);
issueMap.set(questionType.SINGLE_TEXT_FILL, TextFill);
issueMap.set(questionType.MULTIPLE_TEXT_FILL, TextFill);
issueMap.set(questionType.SCALE, Scale);
issueMap.set(questionType.MATRIX_SCALE, MatrixScale);
issueMap.set(questionType.NPS_SCALE, NPSScale);
issueMap.set(questionType.CUSTOM_SINGLE_SCALE, CustomScale);
issueMap.set(questionType.UPLOAD_FILE, UploadFile);
issueMap.set(questionType.DATE, DateTime);
issueMap.set(questionType.DATE_OF_BIRTH, DateTime);
issueMap.set(questionType.MATRIX_GRAVITY, Gravity);
issueMap.set(questionType.PHONE_VALIDATE, TextFill);
issueMap.set(questionType.IMAGE_CHOICE, SingleImageChoice);
issueMap.set(questionType.IMAGE_MULTIPLE_CHOICE, MultipleImageChoice);
issueMap.set(questionType.CLASSIFICATION, Classification);
issueMap.set(questionType.MATRIX_FILL, MatrixFill);
issueMap.set(questionType.MULTIPLE_BLANKS, MultipleBlanks);
issueMap.set(questionType.SORT, Sort);
issueMap.set(questionType.MATRIX_SCROLL, MatrixScroll);
issueMap.set(questionType.CUSTOM_MULTIPLE_SCALE, MatrixCustomScale);
issueMap.set(questionType.MATRIX_COMPOSE, MatrixCompose);
issueMap.set(questionType.MATRIX_AUTO, MatrixAuto);
issueMap.set(questionType.HANDWRITING, HandWriting);
issueMap.set(questionType.CITY_ADDRESS, Cascader);
issueMap.set(questionType.PERMANENT_ADDRESS, Cascader);
issueMap.set(questionType.DOMICILE, Cascader);
issueMap.set(questionType.SPECIALITY, Cascader);
issueMap.set(questionType.SCHOOL, Cascader);
issueMap.set(questionType.CASCADE_REGION, CascadeRegion);
issueMap.set(questionType.ONLY_TEXT, OnlyText);
issueMap.set(questionType.DOWNLOADABLE, Downloadable);
issueMap.set(questionType.MAP, MapQ);
issueMap.set(questionType.TOTAL, Total);
issueMap.set(questionType.MAX_DIFF, MaxDiff);
function createQuestionFactory(data, isAnswer = false, option = {}) {
  if (!isAnswer) {
    // 做一些非答卷的处理
    if (data.issue.autoFillEnable) {
      // 只有在答题时 自动填充/填空状态才有效
      data.issue.autoFillEnable = false;
    }
  }
  const question = new Question(data.id, data.content, data.note, data.questionType, !!data.required, data.type, createIssueFactory(data.issue, data.questionType, option));
  question.issue.catchData = data;
  question.answerScore = data.answerScore || {};
  if (!data.setting || Object.keys(data.setting).length === 0) {
    // 如果没有 问题设置 或者 问题设置 为空对象 说明是旧版创建的 （旧版 默认是开启问题描述的）
    data.setting = {
      enableNote: true,
      enableFold: false
    };
  }
  question.setting = Object.assign({
    requiredType: RequiredType.All
  }, data.setting || {});
  question.setGroupInfo(data.groupQuestionId, data.groupQuestionKey);
  if (data.isNullQuestion) {
    question.required = false;
    question.isNoopAnswer = true;
  }
  return question;
}
function createIssueFactory(data, type, option) {
  let IssueCtor = issueMap.get(type);
  if (IssueCtor) {
    return new IssueCtor(data, option);
  } else {
    throw new Error(`未找到 questionType 为 ${type} 的类型, ${typeMapping.get(type)}`);
  }
}
function convertQuestionList(list, num, cacheAnswerContent, option) {
  const questions = [];
  for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i];
    let cache = cacheAnswerContent.find(i => i.questonId === item.id);
    let question = createQuestionFactory(item, true, option);
    if (cache) {
      let isMounted = false;
      if (!question.setting.autoFillLastAnswer && cache.items.length && cache.items.every(item => item.value)) {
        question.hasValue = true;
      }
      question.setHook('mounted', () => {
        if (isMounted) return;
        isMounted = true;
        question.setValue(cache);
      });
    }
    if (question.questionType !== questionType.ONLY_TEXT) {
      question.num = num++;
    }
    questions.push(question);
    question.runHooks('created');
  }
  return questions;
}
function appendQuotaText(el, count, disabled) {
  const span = document.createElement('span');
  if (count === 0) {
    span.innerText = `(配额已满)`;
  } else {
    span.innerText = `(剩余${count})`;
  }
  if (disabled) {
    span.style.color = 'rgba(0,0,0,.45)';
  } else {
    span.style.color = 'rgba(0,0,0,.65)';
  }
  span.style.marginLeft = '8px';
  el.append(span);
}
function sendMessage(data) {
  if (window.wx) {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        wx.miniProgram.postMessage({
          data
        });
      }
    });
  }
  if (window.top && window.top !== window) {
    window.top.postMessage(JSON.stringify(data), '*');
    return;
  }
}
function isSameArray(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  return arr1.every(item => arr2.includes(item));
}
/**
 * 计算数学表达式
 * @param val1
 * @param val2
 * @param operator
 */
function calcNumExpress(val1, val2, operator) {
  const [min, max] = val1;
  switch (operator) {
    case 'eq':
      return min === val2;
    case 'ne':
      return min !== val2;
    case 'gt':
      return val2 > min;
    case 'ge':
      return val2 >= min;
    case 'lt':
      return val2 < min;
    case 'le':
      return val2 <= min;
    case 'between':
      return val2 >= min && val2 <= max;
    case 'not_between':
      return val2 < min || val2 > max;
  }
}
/**
 * 获取满足条件的逻辑
 * @param conditions
 * @param values
 */
function getMeetConditionsByValue(conditions, values) {
  return conditions.filter(condition => {
    if (condition.subCode === 'chooseNum') {
      const value = Number(condition.rightOptions[0]);
      if (isNaN(value)) {
        return false;
      }
      return calcNumExpress(condition.rightOptions.map(Number), values.length, condition.operator);
    } else if (condition.subCode === 'num') {
      const v2 = values[0] ? Number(values[0].value) : 0;
      return calcNumExpress(condition.rightOptions.map(Number), v2, condition.operator);
    } else {
      return isSameArray(condition.rightOptions, values.map(item => item.optionId));
    }
  });
}
function resetQuestionListNum(questionList, startNum = 0) {
  let num = startNum;
  for (let i = 0; i < questionList.length; i++) {
    const q = questionList[i];
    if (q.questionType !== questionType.ONLY_TEXT) {
      q.num = num++;
    }
  }
}
function loopList(list, callbackFn, endFn) {
  const step = index => {
    callbackFn(list[index], (f = true) => {
      if (f === false) {
        index--;
      }
      if (index !== list.length - 1) {
        step(index + 1);
      } else {
        endFn();
      }
    });
  };
  step(0);
}
class DB {
  constructor(name, key, version) {
    this.ignoreKeys = [];
    this.name = name;
    this.key = key || 'id';
    this.version = version || 1;
  }
  read(key) {
    return new Promise((resolve, reject) => {
      if (!this.idb) {
        // @ts-ignore
        return resolve(null);
      }
      const db = this.idb;
      const transaction = db.transaction([this.name]);
      let store = transaction.objectStore(this.name);
      let request = store.get(key);
      request.onsuccess = function (ev) {
        const result = request.result;
        if (result) {
          const updateTime = result.updateTime;
          const now = Date.now();
          if (now - updateTime > DB.cacheTime) {
            // @ts-ignore
            return resolve({
              expire: true
            });
          }
          resolve(result.content);
        } else {
          // @ts-ignore
          resolve(null);
          // console.log('未获得数据记录')
        }
      };
      request.onerror = reject;
    });
  }
  add(id, content, time) {
    return new Promise((resolve, reject) => {
      const db = this.idb;
      if (!db) {
        return;
      }
      let store = db.transaction([this.name], 'readwrite').objectStore(this.name);
      let request = store.add({
        id: id,
        updateTime: time ? time : Date.now(),
        content: content
      });
      request.onsuccess = resolve;
      request.onerror = reject;
    });
  }
  update(key, content) {
    return new Promise((resolve, reject) => {
      let db = this.idb;
      if (!db) {
        return resolve(null);
      }
      const request = db.transaction([this.name], 'readwrite').objectStore(this.name).put({
        id: key,
        content,
        updateTime: Date.now()
      });
      request.onsuccess = resolve;
      request.onerror = reject;
    });
  }
  readAll(cb) {
    const db = this.idb;
    if (!db) return;
    let objectStore = db.transaction(this.name).objectStore(this.name);
    const expires = [];
    objectStore.openCursor().onsuccess = function (ev) {
      const result = ev.target.result;
      if (result) {
        const val = result.value;
        if (Date.now() - val.updateTime > DB.cacheTime) {
          expires.push(val);
        }
        result.continue();
      } else {
        cb && cb(expires);
      }
    };
  }
  clearExpireByTime() {
    this.readAll(expires => {
      expires.forEach(item => {
        if (!this.ignoreKeys.includes(item.id)) this.remove(item.id);
      });
    });
  }
  remove(key, cb) {
    let db = this.idb;
    if (!db) return;
    const request = db.transaction(this.name, 'readwrite').objectStore(this.name).delete(key);
    request.onsuccess = function (event) {
      // console.log('数据删除成功')
      cb && cb();
    };
  }
}
DB.cacheTime = 1000 * 60 * 60 * 2;
function openIDB(d) {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open('CACHE_ANSWER', 2);
    request.onerror = function (event) {
      reject({
        msg: 'indexDB 打开失败',
        success: false
      });
    };
    request.onsuccess = function (ev) {
      try {
        let db = request.result;
        d.idb = db;
        d.clearExpireByTime();
        resolve(db);
      } catch (e) {
        reject({
          msg: 'indexDB 打开失败',
          success: false
        });
      }
    };
  });
}
function createAnswerTable(version) {
  // 如果在本库下建表 必须升级版本 ！！！
  const request = window.indexedDB.open('CACHE_ANSWER', version);
  const tables = ['answer', 'finger_survey'];
  request.onupgradeneeded = function () {
    let db = request.result;
    tables.forEach(name => {
      if (!db.objectStoreNames.contains(name)) {
        db.createObjectStore(name, {
          keyPath: 'id'
        });
      }
    });
  };
}
function mergeAnswerContent(cacheContent, answerContent) {
  if (!cacheContent.length) return answerContent;
  if (!answerContent.length) return cacheContent;
  let mainContent = answerContent;
  let subContent = cacheContent;
  const results = mainContent.slice();
  subContent.forEach(content => {
    if (!results.find(r => r.questonId === content.questonId)) {
      results.push(content);
    }
  });
  return results;
}
var AnswerStatus;
(function (AnswerStatus) {
  AnswerStatus[AnswerStatus["OK"] = 0] = "OK";
  AnswerStatus[AnswerStatus["PASS"] = 1] = "PASS";
  AnswerStatus[AnswerStatus["QUALITY"] = 2] = "QUALITY";
  AnswerStatus[AnswerStatus["SCREEN"] = 4] = "SCREEN";
  AnswerStatus[AnswerStatus["INVALID"] = 5] = "INVALID";
  AnswerStatus[AnswerStatus["EXCESS"] = 6] = "EXCESS";
  AnswerStatus[AnswerStatus["AGAIN"] = 3] = "AGAIN";
  AnswerStatus[AnswerStatus["CLOSE"] = -10000] = "CLOSE";
  AnswerStatus[AnswerStatus["ERR1"] = -10001] = "ERR1";
  AnswerStatus[AnswerStatus["REPEAT"] = -10002] = "REPEAT";
  AnswerStatus[AnswerStatus["ERROR"] = 13] = "ERROR";
  AnswerStatus[AnswerStatus["SAMPLE_ANSWER"] = 14] = "SAMPLE_ANSWER";
  AnswerStatus[AnswerStatus["REPEAT_ERROR"] = 15] = "REPEAT_ERROR";
  AnswerStatus[AnswerStatus["SURVEY_ERROR"] = -10003] = "SURVEY_ERROR";
  AnswerStatus[AnswerStatus["SURVEY_DELETE"] = -10004] = "SURVEY_DELETE";
  AnswerStatus[AnswerStatus["UNKNOWN"] = -999999] = "UNKNOWN";
  AnswerStatus[AnswerStatus["IP_REPEAT"] = -10005] = "IP_REPEAT";
  AnswerStatus[AnswerStatus["SURVEY_UN_PUBLISH"] = -10006] = "SURVEY_UN_PUBLISH";
  AnswerStatus[AnswerStatus["SURVEY_OFF"] = -10007] = "SURVEY_OFF";
  AnswerStatus[AnswerStatus["CHANNEL_ERROR"] = -10008] = "CHANNEL_ERROR";
  AnswerStatus[AnswerStatus["NOT_AGREE"] = -10009] = "NOT_AGREE";
})(AnswerStatus || (AnswerStatus = {}));
var ErrorCode;
(function (ErrorCode) {
  ErrorCode[ErrorCode["ONLY_WEIXIN"] = -1000] = "ONLY_WEIXIN";
  ErrorCode[ErrorCode["AWARD_ERROR"] = -1001] = "AWARD_ERROR";
  ErrorCode[ErrorCode["AUTHORIZATION"] = -1002] = "AUTHORIZATION";
  ErrorCode[ErrorCode["FOLLOW"] = -1003] = "FOLLOW";
  ErrorCode[ErrorCode["BREAKPOINT"] = -1004] = "BREAKPOINT";
  ErrorCode[ErrorCode["RESTART"] = -1005] = "RESTART";
  ErrorCode[ErrorCode["PASSWORD"] = 2] = "PASSWORD";
  ErrorCode[ErrorCode["FansNormal"] = 4] = "FansNormal";
  ErrorCode[ErrorCode["FansQr"] = 5] = "FansQr";
  ErrorCode[ErrorCode["FORCE_LOCATION"] = 6] = "FORCE_LOCATION";
  ErrorCode[ErrorCode["SURVEY_CLOSE"] = 8] = "SURVEY_CLOSE";
  ErrorCode[ErrorCode["SURVEY_OFF"] = 9] = "SURVEY_OFF";
  ErrorCode[ErrorCode["SURVEY_UN_PUBLISH"] = 102] = "SURVEY_UN_PUBLISH";
  ErrorCode[ErrorCode["UNKNOWN"] = 1] = "UNKNOWN";
  ErrorCode[ErrorCode["ERROR_MESSAGE_OVERLAY"] = -20000] = "ERROR_MESSAGE_OVERLAY";
  ErrorCode[ErrorCode["AGREE_INFO"] = -30000] = "AGREE_INFO";
})(ErrorCode || (ErrorCode = {}));
var SubmitErrorCode;
(function (SubmitErrorCode) {
  SubmitErrorCode[SubmitErrorCode["ERROR"] = 1] = "ERROR";
  SubmitErrorCode[SubmitErrorCode["SURVEY_ERROR"] = 7] = "SURVEY_ERROR";
  SubmitErrorCode[SubmitErrorCode["SURVEY_DELETE"] = 101] = "SURVEY_DELETE";
  SubmitErrorCode[SubmitErrorCode["ANSWER_DELETE"] = 201] = "ANSWER_DELETE";
})(SubmitErrorCode || (SubmitErrorCode = {}));
var MessageType;
(function (MessageType) {
  MessageType[MessageType["SUCCESS"] = 0] = "SUCCESS";
  MessageType[MessageType["ERROR"] = 1] = "ERROR";
  MessageType[MessageType["WARNING"] = 2] = "WARNING";
})(MessageType || (MessageType = {}));
const textMap = {
  [AnswerStatus.OK]: ['您已完成本次问卷，感谢您的帮助与支持！'],
  [AnswerStatus.PASS]: ['您已完成本次问卷，感谢您的帮助与支持！'],
  [AnswerStatus.CLOSE]: ['抱歉，问卷暂时已关闭。'],
  [AnswerStatus.REPEAT]: ['提交重复内容，答卷无效'],
  [AnswerStatus.EXCESS]: ['问卷暂时已收满，感谢您的参与'],
  [AnswerStatus.ERR1]: ['您已回答过此问卷'],
  [AnswerStatus.SCREEN]: ['对不起，您不属于本次调查的范围。谢谢您的参与！'],
  [AnswerStatus.QUALITY]: ['您不符合该问卷回收条件'],
  [AnswerStatus.INVALID]: ['您不符合该问卷回收条件'],
  [AnswerStatus.ERROR]: ['您不符合该问卷回收条件'],
  [AnswerStatus.UNKNOWN]: ['未知错误'],
  [AnswerStatus.SURVEY_ERROR]: ['非常抱歉，发布者刚刚更新了该问卷，麻烦您刷新后重新回答。'],
  [AnswerStatus.SURVEY_DELETE]: ['非常抱歉，该问卷已被发布者删除'],
  [AnswerStatus.IP_REPEAT]: ['发布人已开启同一 IP 限答一次，您当前所在的 IP 已经回答过该问卷'],
  [AnswerStatus.SAMPLE_ANSWER]: ['抱歉 您的问卷不符合回收条件'],
  [AnswerStatus.REPEAT_ERROR]: ['本问卷已设置重复陷阱题，由于同一道题您前后回答不一致，很遗憾，您不符合回收要求'],
  [AnswerStatus.SURVEY_UN_PUBLISH]: ['当前问卷未发布'],
  [AnswerStatus.SURVEY_OFF]: ['抱歉，问卷已被下架，停止访问。'],
  [AnswerStatus.CHANNEL_ERROR]: ['地址错误，请联系您的发布人'],
  [AnswerStatus.NOT_AGREE]: ['答题已终止，谢谢！']
};
var BoundFailedType;
(function (BoundFailedType) {
  // 超时
  BoundFailedType[BoundFailedType["OVERTIME"] = 1] = "OVERTIME";
  // 未抽中
  BoundFailedType[BoundFailedType["MISS"] = 2] = "MISS";
  // 本答卷已领取过奖励
  BoundFailedType[BoundFailedType["EXCESS"] = 3] = "EXCESS";
  // 此问卷其他答卷已领取过
  BoundFailedType[BoundFailedType["OTHER_EXCESS"] = 4] = "OTHER_EXCESS";
})(BoundFailedType || (BoundFailedType = {}));
var BoundStatus;
(function (BoundStatus) {
  /**
   * 未绑定/未扫码
   */
  BoundStatus[BoundStatus["UNBOUND"] = 0] = "UNBOUND";
  /**
   * 已绑定/已扫码
   */
  BoundStatus[BoundStatus["BOUNDED"] = 1] = "BOUNDED";
  /**
   * 发放成功
   */
  BoundStatus[BoundStatus["SUCCESS2"] = 2] = "SUCCESS2";
  /**
   * 发送失败（超时/基础模块发送失败）
   */
  BoundStatus[BoundStatus["FAILED"] = 3] = "FAILED";
})(BoundStatus || (BoundStatus = {}));

/**
 * TODO 待优化
 */
const cascadeTypes = [questionType.LINKAGE, questionType.SCHOOL, questionType.CITY_ADDRESS, questionType.DOMICILE, questionType.SPECIALITY, questionType.PERMANENT_ADDRESS //常住地
];
const singleChoiceTypes = [
// questionTypeEnum.SINGLE_SELECT, // 下拉单选
questionType.SINGLE_CHOICE, questionType.IMAGE_CHOICE, questionType.AGE_RANGE, questionType.JOB, questionType.MONTHLY_INCOME_RANGE, questionType.MARITAL_STATUS, questionType.EDUCATIONAL_ATTAINMENT, questionType.GENDER, questionType.INDUSTRY //行业
];
let disOrHide = {};
let singleChoiceHandler = function (qs, hide, qsId) {
  qs.issue.items = qs.issue.items.filter(answer => {
    return !hide[qsId].includes(answer.id);
  });
  if (!qs.issue.items.length) {
    qs.isNullQuestion = true;
  }
};
let cascaderHandler = function (qs, hide, qsId) {
  let groups = qs.issue.groups;
  let ids = hide[qsId];
  function delOpt(groups = [], ids = []) {
    let delArr = [];
    for (let i = 0; i < groups.length; i++) {
      let group = groups[i];
      if (group.isNextLevel) {
        let results = delOpt(group.nextLevelOptions, ids);
        if (results) {
          let {
            flag,
            delIds
          } = results;
          if (flag) {
            delIds.forEach(id => {
              let idx = group.nextLevelOptions.findIndex(n => n.id === id);
              group.nextLevelOptions.splice(idx, 1);
            });
          }
          if (!group.nextLevelOptions.length) {
            delArr.push(group.id);
          }
        }
      } else {
        if (ids.includes(group.id)) {
          delArr.push(group.id);
        }
      }
    }
    return {
      delIds: delArr,
      flag: true
    };
  }
  let {
    delIds
  } = delOpt(groups, ids);
  delIds.forEach(id => {
    let idx = groups.findIndex(n => n.id === id);
    groups.splice(idx, 1);
  });
};
singleChoiceTypes.forEach(type => {
  disOrHide[type] = singleChoiceHandler;
});
cascadeTypes.forEach(type => {
  disOrHide[type] = cascaderHandler;
});
const itemTypes = [questionType.SINGLE_CHOICE, questionType.SINGLE_SELECT, questionType.MULTIPLE_CHOICE, questionType.MULTIPLE_SELECT, questionType.IMAGE_MULTIPLE_CHOICE, questionType.IMAGE_CHOICE, questionType.SORT, questionType.TOTAL, questionType.MATRIX_SCALE, questionType.MATRIX_AUTO];
itemTypes.forEach(type => {
  disOrHide[type] = singleChoiceHandler;
});
disOrHide[questionType.MATRIX_SINGLE_CHOICE] = function (qs, hide, qsId) {
  qs.issue.rows = qs.issue.rows.filter(row => {
    return !hide[qsId].includes(row.row_id);
  });
  qs.issue.items = qs.issue.items.filter(col => {
    return !hide[qsId].includes(col.id);
  });
  if (qs.issue.cells) {
    const colIds = qs.issue.items.map(item => item.id);
    const rowIds = qs.issue.rows.map(item => item.row_id);
    qs.issue.cells = qs.issue.cells.filter(cell => {
      if (!cell.row_id) {
        return colIds.includes(cell.col_id);
      }
      return rowIds.includes(cell.row_id) && colIds.includes(cell.col_id);
    });
  }
};
disOrHide[questionType.MATRIX_MULTIPLE_CHOICE] = disOrHide[questionType.MATRIX_SINGLE_CHOICE];
const rowColTypes = [questionType.MATRIX_FILL, questionType.MATRIX_COMPOSE, questionType.CLASSIFICATION];
rowColTypes.forEach(type => {
  disOrHide[type] = disOrHide[questionType.MATRIX_SINGLE_CHOICE];
});
disOrHide[questionType.MULTIPLE_BLANKS] = function (qs, hide, qsId) {
  qs.issue.fillContext = qs.issue.fillContext.filter(answer => {
    return !hide[qsId].includes(answer.id);
  });
  if (!qs.issue.fillContext.length) {
    qs.isNullQuestion = true;
  }
};
/**
 *
 * @param t
 * @param hide
 */
function getCurrentAnswerHide(t, hide) {
  Object.keys(hide).forEach(qsId => {
    if (t.id === qsId) {
      disOrHide[t.questionType](t, hide, qsId);
    }
  });
}
function convertScoreData(data, bus) {
  if (!data || !data.hasReward) return Promise.resolve(data);
  return new Promise((resolve, reject) => {
    var _a;
    getAwardV2BySurveyId(bus.survey.id, (_a = bus.channel) === null || _a === void 0 ? void 0 : _a.id).then(res => {
      const moneyAwards = (res.data.moneyAwards || []).filter(award => {
        return (data.hasSurplusAwardIds || []).includes(award.id);
      });
      if (moneyAwards.length) {
        data.hasReward = moneyAwards.some(award => {
          const sendLimit = award.sendLimit || {};
          const scoreGe = sendLimit.scoreGe;
          if (!scoreGe) return true;
          return data.score >= scoreGe;
        });
      }
      resolve(data);
    }).catch(reject);
  });
}
function sendMessage$1(vm, endData, params, answerContent) {
  let data;
  if (!vm.survey) {
    data = {
      message: 'answerOver',
      payload: {
        success: false,
        code: 30003 // 未知问卷
      }
    };
  } else if (vm.overData.status === AnswerStatus.CLOSE) {
    data = {
      message: 'answerOver',
      payload: {
        success: false,
        code: 30002 // 当前问卷已关闭
      }
    };
  } else if (vm.overData.status < 0) {
    data = {
      message: 'answerOver',
      payload: {
        success: false,
        code: vm.overData.status
      }
    };
  } else {
    if (window.top && window.top !== window) {
      try {
        vm.saveErrorLog('答题结束页面调试', JSON.stringify({
          data: endData,
          params,
          answerContent
        }));
      } catch (e) {}
    }
    data = {
      message: 'answerOver',
      payload: {
        success: true,
        code: vm.overData.status,
        answerId: vm.answerId,
        surveyId: vm.survey.id,
        params: params,
        viewUrl: `${window.location.origin}/mobile?surveyId=${vm.survey.id}&answerChannelId=${vm.channel.id}#/preview/${vm.answerId}`,
        score: endData === null || endData === void 0 ? void 0 : endData.score
      }
    };
  }
  if (window.wx) {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        wx.miniProgram.postMessage({
          data
        });
        if (vm.params.miniprogramType === '1') {
          wx.miniProgram.navigateBack({
            delta: 1
          });
        }
      }
    });
  }
  if (window.top && window.top !== window) {
    window.top.postMessage(JSON.stringify(data), '*');
    return;
  }
}
function setScore(vm, data) {
  if (!vm.isScoreSurvey && !hasValue(data === null || data === void 0 ? void 0 : data.score)) return;
  const closing = vm.closing;
  const score = data.score || 0;
  vm.score = score;
  let scoreEnds = (closing === null || closing === void 0 ? void 0 : closing.otherEnds) || [];
  if (vm.survey.otherSetting.enableInterestingAnswer) {
    scoreEnds = (closing === null || closing === void 0 ? void 0 : closing.funAnswerEnds) || [];
  }
  if (closing && scoreEnds) {
    scoreEnds.forEach(item => {
      if (item.defaults) {
        item.matchRule = Object.assign(Object.assign({}, item.matchRule), {
          min: -Infinity,
          max: Infinity
        });
      }
    });
    scoreEnds.forEach(rawItem => {
      const item = Object.assign({}, rawItem);
      let {
        min,
        max
      } = item.matchRule;
      // min = Number(min)
      // max = Number(max)
      if (min <= score && score <= max && !vm.scoreEnd) {
        vm.scoreEnd = item;
      }
      item.richText = (item.richText || '').replaceAll('[Score]', score);
    });
  }
  if (!vm.scoreEnd) {
    vm.scoreEnd = {
      richText: `<p>提交成功，感谢您的参与！您的得分为：${score}</p>`,
      defaults: true
    };
  } else {
    if (vm.survey.otherSetting.enableInterestingAnswer) {
      if (vm.scoreEnd.testResult && vm.scoreEnd.testResult.trim()) {
        vm.hook.run('resetShare', {
          title: vm.scoreEnd.testResult + '，' + vm.survey.title
        });
      }
    }
    let rawText = vm.scoreEnd.richText;
    let richText = vm.scoreEnd.richText;
    let exp = new RegExp('\\[Score([^\\[.]*)]', 'gi');
    let res = null;
    let results = [];
    while (res = exp.exec(richText)) {
      let g = res[1];
      let raw = res[0];
      results.push({
        group: g,
        raw
      });
    }
    if (!results.length) return;
    let promises = results.map(item => {
      let {
        group,
        raw
      } = item;
      let ids = group.split('+');
      richText = richText.replace(raw, '');
      return getAnswerScore(vm.answerId, ids).then(res => {
        return {
          data: res.data,
          raw
        };
      });
    });
    vm.scoreEnd.richText = richText;
    Promise.all(promises).then(res => {
      res.forEach(item => {
        let score = item.data.totalScore;
        let raw = item.raw;
        rawText = rawText.replace(raw, score);
      });
      vm.scoreEnd.richText = rawText;
    });
  }
}
function checkAgain(vm) {
  if (!vm.survey) return;
  if (vm.isClosed) return;
  checkAnswer(filterParams({
    surveyId: vm.survey.id,
    accountUserFingerprint: vm.accountUserFingerprint,
    accountUserId: vm.params.accountUserId,
    accountUserOpenId: vm.params.accountUserOpenId
  })).then(res => {
    vm.canAnswerAgain = res.code === 0;
  });
}
function initTextTips(vm, isScoreSurvey) {
  let {
    status,
    success,
    tips
  } = vm.overData;
  let closing = vm.closing || {};
  let textTips = [];
  if (success) {
    if (isScoreSurvey) {
      //
      if (!vm.enableDimensionScore) {
        vm.$watch('scoreEnd', val => {
          if (!val) return;
          textTips = vm.answerTextTips = [val.richText];
        }, {
          deep: true,
          immediate: true
        });
      }
    } else {
      if (closing.normalEnd) {
        textTips = [closing.normalEnd.richText];
      } else {
        textTips = tips || textMap[AnswerStatus.OK];
      }
    }
  } else if (status === AnswerStatus.SCREEN || status === AnswerStatus.QUALITY) {
    if (closing.earlyEnd) {
      textTips = [closing.earlyEnd.richText];
    } else {
      textTips = tips || textMap[status];
    }
  } else {
    const otherSettingTips = vm.survey.otherSetting.otherSettingTips || {};
    const getOtherSettingTip = status => {
      const res = otherSettingTips[status];
      if (!res) return null;
      return Array.isArray(res) ? res : [res];
    };
    textTips = tips || getOtherSettingTip(status) || textMap[status] || [];
  }
  vm.answerTextTips = textTips;
}
function getAnswerVote(votes) {
  let n = 1;
  return votes.map(vote => {
    let question = createQuestionFactory(vote.question, true);
    question.num = n++;
    if (vote.answerContentDto.items.length) {
      question.setValue(vote.answerContentDto);
      if (question.setting.enableVoteAnswerFilter) {
        if (question.issue.convertVoteAnswer) {
          question.issue.convertVoteAnswer();
        }
      }
    }
    question.showVote = true;
    question.setVote(vote);
    return question;
  });
}
function answerOver(vm) {
  const params = Object.assign({}, vm.params);
  return function (data, isNormalEnd, answerContent) {
    vm.busOption.scroll.scrollTo(0);
    console.log('答题结束');
    if ((!data || !isNormalEnd) && vm.answerId) {
      getAwardInfoByAnswerId(vm.answerId).then(res => {
        var _a;
        // const award =
        // if (!award.lotteryAward && award.otherLotteryAward) {
        //   award.lotteryAward = award.otherLotteryAward
        // }
        // if(data.hasReward) {
        //   award.hasReward = true
        // }
        // if(data.needAccountUserId) {
        //   award.needAccountUserId = true
        // }
        // if(data.awardIsLottery) {
        //   award.awardIsLottery = true
        // }
        if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.bindAward) {
          res.data.bindAward.boundFailedType = res.data.boundFailedType;
        }
        convertScoreData(Object.assign({
          score: data.score
        }, res.data), vm).then(data => {
          vm.currentAwardData = data;
        });
      });
    } else if (data) {
      convertScoreData({
        awardIsLottery: data.awardIsLottery,
        needAccountUserId: data.needAccountUserId,
        hasReward: data.hasReward,
        bindAward: null,
        hasSurplusAwardIds: data.hasSurplusAwardIds,
        score: data.score
      }, vm).then(data => {
        vm.currentAwardData = data;
      });
    }
    if (data && (data.voteCounts || []).length) {
      vm.voteQuestions = getAnswerVote(data.voteCounts);
    }
    // initTextTips(vm)
    const fn = once(() => {
      if ([AnswerStatus.OK, AnswerStatus.PASS].includes(vm.overData.status)) {
        setScore(vm, data);
      }
      if (!vm.isClosed && vm.overData.status >= 0) {
        checkAgain(vm);
      }
    });
    if (vm.overData) {
      fn();
    }
    vm.$watch('overData', val => {
      if (val) {
        initTextTips(vm, vm.isScoreSurvey || (data === null || data === void 0 ? void 0 : data.score));
        fn();
      }
    }, {
      immediate: true
    });
    if (vm.enableLuck) {
      getCanLuck().then(res => {
        vm.showLuck = !!res.data;
      });
    }
    if (vm.enableMoreSurvey) {
      vm.$answerUtil.getEnv().then(res => {
        var _a;
        let data = {
          displaySize: 5,
          customerId: undefined
        };
        if (!res.miniprogram) {
          data.customerId = (_a = vm.params) === null || _a === void 0 ? void 0 : _a.accountUserId;
        }
        getMoreSurveyList(filterParams(data)).then(res => {
          const list = res.data.records;
          vm.moreSurveyList = list.reduce((res, item) => {
            let price = '';
            const award = item;
            if (award && award.quantity && award.totalAmount) {
              if (award.rdMin && award.rdMax) {
                price = `¥${award.rdMin} - ${award.rdMax}`;
              } else if (award.amount) {
                price = `¥${award.amount}`;
              }
            } else if (award && award.amount) {
              price = `${award.amount}积分`;
            }
            if ((!item.releaseChannel || !item.surveyId) && !item.gmourl) return res;
            res.push({
              title: item.title,
              surveyId: item.surveyId,
              channelId: item.releaseChannel,
              price,
              gmourl: item.gmourl,
              isThirdParty: item.isThirdParty,
              amount: item.amount,
              partakeAmount: item.partakeAmount
            });
            return res;
          }, []);
        }).catch(err => {
          console.log(err);
        });
      });
    }
    // @ts-ignore
    vm.$answerUtil.getCurrentAwardCount();
    // vm.refreshAward()
    //是否显示维度分析报告
    if (vm.isScoreSurvey) {
      showReportAfterAnswer(vm.survey.id).then(res => {
        // 查询不到代表无维度
        if (res) {
          vm.enableDimensionScore = res.showReportAfterAnswer;
          vm.openStandardScore = res.openStandardScore;
          if (vm.enableDimensionScore) {
            getAnswerDimensionScore(vm.answerId).then(res => {
              vm.answerDimensionScore = res.data;
            });
          }
        }
        vm.isWait = false;
      }).catch(() => {
        vm.isWait = false;
      });
    } else {
      vm.isWait = false;
    }
    if (vm.surveyPoint || (vm.params.pageType || '').toString() === '3') {
      vm.answerPoint.pending = true;
      getAnswerPoint(vm.answerId).then(res => {
        vm.answerPoint.pending = false;
        vm.answerPoint.value = res;
      });
    }
    sendMessage$1(vm, data, params, answerContent);
  };
}
function surveyLoad(vm) {
  return function () {
    function getLocationHandler() {
      if (hasValue(vm.userLocationType)) {
        if (vm.userLocationType !== 0) {
          getLocation(vm);
        }
      } else if (vm.enableUserLocation) {
        getLocation(vm);
      }
    }
    console.log('问卷加载完成');
    if (!vm.params.isTest) {
      if (vm.platformSdkFinished) {
        getLocationHandler();
      } else {
        vm.hook.on('platformSdkLoad', getLocationHandler);
      }
    }
    window.addEventListener('message', evt => {
      const data = evt.data;
      if (typeof data !== 'object') return;
      if (data.type !== 'otherSetting') return;
      vm.survey.otherSetting = Object.assign({}, vm.survey.otherSetting, data.value || {});
      // mergeOtherSetting(vm.survey.otherSetting,data.value || {})
    });
  };
}
function refreshAddress(answerId, address, errMessage) {
  if (!address || errMessage) {
    const errMsg = errMessage ? `定位失败-${errMessage}` : '定位失败';
    address = {
      IS_OK: false,
      address: errMsg,
      lng: '0',
      lat: '0',
      adds: errMsg
    };
  }
  refreshAnswerAddress({
    id: answerId,
    surveyRegion: address.adds,
    surveyLon: address.lng,
    surveyLat: address.lat,
    answerAddress: address.address
  });
}
function getLocation(vm) {
  getAddress(vm.currentBrowserInfo).then(res => {
    vm.address = res;
    if (vm.answerId && vm.isStart) {
      if (res.IS_OK) {
        refreshAddress(vm.answerId, res);
      } else {
        if (res.lat && res.lng) {
          refreshAddress(vm.answerId, res);
        } else {
          refreshAddress(vm.answerId, null);
        }
        if (res.convertErrorCode) {
          addErrLog(vm, {
            errTitle: '定位失败',
            errInfo: JSON.stringify({
              infocode: res.convertErrorCode,
              info: res.convertError
            })
          });
        }
      }
    }
  }).catch(err => {
    var _a, _b;
    if (err.userRefuse && vm.userLocationType === 2 && vm.currentBrowserInfo.isWeixin) {
      (_b = (_a = vm.busOption).overlay) === null || _b === void 0 ? void 0 : _b.call(_a, {
        code: ErrorCode.FORCE_LOCATION
      });
    }
    addErrLog(vm, {
      errTitle: '定位失败',
      errInfo: JSON.stringify(err)
    });
    if (vm.answerId && vm.isStart) {
      refreshAddress(vm.answerId, null, err.message);
    }
  });
}
function addErrLog(vm, data) {
  const handler = () => {
    addErrorLog(Object.assign({
      surveyId: vm.survey.id,
      answerId: vm.answerId,
      accountUserFingerprint: vm.accountUserFingerprint,
      accountUserId: vm.params.accountUserId,
      answerUrl: window.location.href
    }, data));
  };
  if (vm.answerId) {
    handler();
  } else {
    vm.errorLogTask.push(handler);
  }
}
function sendMessage$2(vm, data) {
  if (!window.top || window.top === window) {
    return;
  }
  window.top.postMessage(JSON.stringify(data), '*');
  if (vm.currentBrowserInfo.isWeixin) {
    try {
      wx.miniProgram.postMessage(data);
    } catch (e) {
      console.log(e);
    }
  }
}
function answerStart(vm) {
  return function () {
    console.log('开始答题');
    vm.customStartData = {};
    if (vm.errorLogTask.length) {
      vm.errorLogTask.forEach(t => t());
      vm.errorLogTask = [];
    }
    sendMessage$2(vm, {
      message: 'answerStart',
      payload: {
        answerId: vm.answerId,
        surveyId: vm.survey.id,
        params: vm.params,
        code: 0,
        success: true
      }
    });
    if (vm.params.disableSubmit) {
      if (window.top === window) {
        vm.params.disableSubmit = false;
        return;
      }
      // 读取不到window.top!.origin.indexOf('localhost') 暂时注释
      // if (window.top!.origin.indexOf('localhost') < 0) {
      //   if (window.top!.origin !== window.origin) {
      //     vm.params.disableSubmit = false
      //     return
      //   }
      // }
      window.addEventListener('message', evt => {
        if (typeof evt.data !== 'object') return;
        if (evt.data.type !== 'setAnswerContent') return;
        const answerContent = evt.data.answerContent;
        vm.pageList.forEach(q => {
          const answer = answerContent.find(a => a.questonId === q.id);
          if (answer) {
            q.setValue(answer);
          }
        });
      });
      window.addEventListener('message', evt => {
        if (evt.data === 'submit') {
          // @ts-ignore
          vm.submitOrNextPage();
        } else if (evt.data === 'getAnswerContent') {
          // @ts-ignore
          vm.getAnswerContent().then(list => {
            sendMessage$2(vm, {
              message: 'answerContent',
              payload: {
                answerId: vm.answerId,
                surveyId: vm.survey.id,
                answerContent: list,
                success: true
              }
            });
          });
        }
      });
    }
  };
}
function initAnswerUtil(Vue, bus) {
  // @ts-ignore
  Vue.prototype.$answerUtil = new Vue({
    data() {
      return {
        currentAward: null
      };
    },
    methods: {
      onStartMoreSurvey(survey) {
        if (survey.gmourl) {
          // 用于计算答题时间
          answeringThirdSurvey({
            thirdSurveyId: survey.surveyId,
            customerId: bus.params.accountUserId
          });
          window.open(survey.gmourl);
          return;
        }
        const origin = window.location.origin;
        const pathname = window.location.pathname;
        const data = Object.assign(Object.assign({}, bus.params), {
          surveyId: survey.surveyId,
          answerChannelId: survey.channelId
        });
        window.location.replace(`${origin}${pathname}?${objectToQuery(data)}`);
      },
      getCurrentAwardCount() {
        const vm = this;
        if (!bus.survey) return;
        getAwardCountBySurveyId(bus.survey.id).then(res => {
          vm.currentAward = res.data;
        });
      },
      getShareText(bus) {
        const vm = this;
        if (!vm.currentAward) return;
        if (!bus.hadShare) {
          if (vm.currentAward.countForRed) {
            return '分享问卷给好友答题，一起领红包';
          } else {
            return '分享问卷';
          }
        } else {
          if (vm.currentAward.countForShare) {
            if (bus.enableNetManualAudit) {
              //问卷还剩 ${bus.share.quantity} 个分享红包待领取，
              return `问卷还剩 ${vm.currentAward.countForShare} 个分享红包待领取，将问卷分享给好友，好友完成答题且审核通过后，您可收到分享红包~`;
            } else {
              return `问卷还剩 ${vm.currentAward.countForShare} 个分享红包待领取，将问卷分享给好友，好友完成答题后，您可收到分享红包~`;
            }
          } else {
            if (vm.currentAward.countForRed) {
              return '分享问卷给好友答题，一起领红包';
            } else {
              return '分享红包已领完，您可继续分享问卷，邀请好友答题';
            }
          }
        }
      },
      wxAuthorization(pageType) {
        const origin = `${location.origin}/mobile`; //'https://testcloud.treeyee.com/mobile'
        const searchParams = {
          surveyId: bus.survey.id,
          answerChannelId: bus.channel.id,
          companyid: bus.params.companyid,
          checkTimestamp: Date.now().toString(),
          answerId: bus.answerId,
          pageType
        };
        const redirectUri = `${origin}?${objectToQuery(searchParams)}`;
        // @ts-ignore
        const appid = this.$wxAppId || 'wx338f55c8b5822937';
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        location.href = url;
      },
      getShareUrl() {
        const urlParam = {
          surveyId: bus.survey.id,
          answerChannelId: bus.channel.id,
          shareAnswerId: bus.answerId,
          pageType: '1',
          companyid: bus.params.companyid,
          shareAccountUserId: bus.params.accountUserId
        };
        const origin = window.origin;
        const returnUrl = `${origin}/mobile?${Object(_survey_util__WEBPACK_IMPORTED_MODULE_20__[/* convertObjToUrlSearch */ "a"])(urlParam)}`;
        return `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(returnUrl)}`;
      },
      getEnv() {
        if (bus.currentBrowserInfo.isWeixin) {
          return new Promise(resolve => {
            if (window.wx && wx.miniProgram) {
              wx.miniProgram.getEnv(res => {
                resolve({
                  miniprogram: res.miniprogram
                });
              });
            } else {
              resolve({
                miniprogram: false
              });
            }
          });
        } else {
          return Promise.resolve({
            miniprogram: false
          });
        }
      },
      postMessage(data) {
        document.addEventListener('UniAppJSBridgeReady', function () {
          uni.postMessage({
            data
          });
        });
        if (window.uni) {
          uni.postMessage({
            data
          });
        }
        if (window.top && window.top !== window) {
          window.top.postMessage(JSON.stringify(data), '*');
        }
      }
    }
  });
}
function choice(question, value) {
  const items = question.issue.items;
  items.forEach(item => {
    if (Reflect.has(value, item.id)) {
      item.showQuotaCount = true;
      item.count = Math.max(0, value[item.id]);
      if (item.count === 0) {
        item.disabled = true;
      }
    }
  });
}
function initQuotaCount(question, quotaRemainderNumMap) {
  const qid = question.id;
  const value = quotaRemainderNumMap[qid];
  if (!value) return;
  const choiceTypes = [...singleTypes, questionType.MULTIPLE_CHOICE, questionType.MULTIPLE_SELECT, questionType.IMAGE_MULTIPLE_CHOICE];
  if (choiceTypes.includes(question.questionType)) {
    choice(question, value);
  }
}
function choice$1(question) {
  const items = question.issue.items;
  return items.every(item => {
    if (!item.showQuotaCount) return false;
    return item.count === 0;
  });
}
function checkQuotaIsFull(question) {
  const choiceTypes = [...singleTypes, questionType.MULTIPLE_CHOICE, questionType.MULTIPLE_SELECT, questionType.IMAGE_MULTIPLE_CHOICE];
  if (choiceTypes.includes(question.questionType)) {
    return choice$1(question);
  }
  return false;
}

/**
 * 自动填空功能
 */
function initAutoFillWatcher(list, answerContent, cacheAnswerContent) {
  const operate = ['+', '-', '*', '/', '(', ')', 'X', '&'];
  const ids = list.map(q => q.id);
  list.forEach(q => {
    if (!q.issue.autoFillEnable) return;
    const fills = q.issue.autoFill;
    fills.forEach(item => {
      if (item.conditions) {
        if (item.matched === false && item.conditions.length) return;
      } else {
        if (item.matched === false) return;
      }
      // if (item.matched === false && item.conditions?.length) return
      item.fillRules.forEach(rule => {
        if (!rule.expression) return;
        const expression = rule.expression.map(expr => {
          if (expr === 'X') return '*';
          if (expr === '&') return '';
          return expr;
        }).filter(hasValue);
        const watcher = content => {
          var _a, _b;
          const c = mergeAnswerContent(cacheAnswerContent, (answerContent || []).filter(c => !ids.includes(c.questonId)));
          let value;
          switch (rule.calcMethod) {
            case 1:
            case 3:
              value = expression.map(expr => {
                const item = getAnswerItemByExpr(c, expr.toString());
                if (!item) return '';
                return item.value;
              }).join('');
              break;
            case 2:
              const res = getExprValueByAnswer(expression, c);
              if (isNaN(res) || res === Infinity) {
                value = '';
              } else {
                value = res.toFixed(rule.scale).toString();
              }
              break;
            case 4:
              const qid = expression[0];
              const i = c.find(i => {
                return i.questonId === qid;
              });
              if (!i) {
                value = 0;
              } else {
                value = i.items.length;
              }
              break;
          }
          (_b = (_a = q.issue).setValueByRule) === null || _b === void 0 ? void 0 : _b.call(_a, rule, value);
        };
        rule.expression.forEach(expr => {
          if (typeof expr === 'number') return;
          if (operate.includes(expr)) return;
          const [qid] = expr.split('.');
          const question = list.find(q => q.id === qid);
          if (question) {
            question.pushAnswerWatcher(watcher);
          }
        });
        q.setHook('mounted', () => {
          watcher();
        });
      });
    });
  });
}
function initAutoFill(q) {
  if (!q.issue.autoFillEnable) return;
  const fills = q.issue.autoFill;
  if (fills.every(f => f.matched === false)) {
    q.issue.autoFillEditable = true;
  }
}
function initAutoValidate(list, answerContent, cacheAnswerContent) {
  const operate = ['+', '-', '*', '/', '(', ')'];
  const ids = list.map(q => q.id);
  list.forEach(q => {
    var _a;
    if (!q.issue.complexValidateEnable || !((_a = q.issue.complexValidate) === null || _a === void 0 ? void 0 : _a.length)) {
      return;
    }
    const rules = q.issue.complexValidate;
    const handler = () => {
      q.questionErrorList = [];
      const content = mergeAnswerContent(cacheAnswerContent, (answerContent || []).filter(c => !ids.includes(c.questonId)));
      if (!q.issue.runComplexValidate) return;
      const c = content.find(c => c.questonId === q.id);
      if (!c || !c.items.length) return;
      const res = q.issue.runComplexValidate(content, c);
      if (res.success) return;
      const subCode = [q.id, res.rule.conditions[0].subCode].filter(Boolean).join('.');
      q.questionErrorList.push({
        key: subCode,
        message: res.message
      });
    };
    q.setHook('updated', handler);
    rules.forEach(rule => {
      rule.conditions.forEach(c => {
        const expression = c.rightOptions.map(s => {
          if (s === 'X') return '*';
          return s;
        });
        expression.forEach(s => {
          if (typeof s === 'number') return;
          if (operate.includes(s)) return;
          const [qid] = s.split('.');
          const question = list.find(q => q.id === qid);
          if (!question) return;
          question.setHook('updated', handler);
        });
      });
    });
  });
}
function jumpToPage(vm, data) {
  const jumpViewMap = vm.survey.otherSetting.jumpViewMap;
  if (!jumpViewMap) return;
  const status = data.status;
  const s = Object.keys(jumpViewMap).find(s => String(s) === String(status)) || 'default';
  const url = jumpViewMap[s];
  if (!url) return;
  let args = (jumpViewMap.args || []).map(arg => `${arg}=${vm.params[arg]}`).join('&');
  let query = args ? `${url.indexOf('?') > -1 ? '&' : '?'}${args}` : '';
  const src = url + query;
  window.location.replace(src);
}
function beforeAnswerOver(vm) {
  return function (data, isNormalEnd) {
    jumpToPage(vm, data);
  };
}
class Hook {
  constructor() {
    this.hookMap = new Map();
  }
  run(key, ...args) {
    let hooks = this.hookMap.get(key);
    if (!hooks) return;
    const handlers = hooks.slice();
    handlers.forEach(handler => handler(...args));
  }
  on(key, handler) {
    let hooks = this.hookMap.get(key);
    if (!hooks) {
      hooks = [];
    }
    hooks.push(handler);
    this.hookMap.set(key, hooks);
  }
  off(key, handler) {
    if (!handler) {
      this.hookMap.set(key, []);
    } else {
      let hooks = this.hookMap.get(key);
      if (!hooks) {
        hooks = [];
      }
      let index = hooks.findIndex(h => h === handler);
      if (index !== -1) {
        hooks.splice(index, 1);
      }
    }
  }
  clearAll() {
    this.hookMap.clear();
  }
}
const createBaseBusData = urlParams => {
  return {
    // 用户信息
    user: null,
    // 开始答题时会拼接的参数
    customStartData: {},
    closing: null,
    isStart: false,
    isEnd: false,
    isSurveyLoad: false,
    isClosed: false,
    // 路径参数
    params: urlParams,
    // 是否显示上一页按钮
    enablePrePage: false,
    // 是否显示更多按钮
    enableMoreSurvey: false,
    enableMoreShare: true,
    // 是否需要手机号
    enablePhoneAnswer: false,
    // 是否显示开始答题按钮
    enableHomePage: false,
    // 允许提交答卷后预览答卷
    viewableAfterSubmit: false,
    // 是否需要审核
    enableNetManualAudit: false,
    // 滑块验证
    enableVerification: false,
    // 是否显示维度与评分
    enableDimensionScore: false,
    //是否处于获取显示维度与评分的状态
    isWait: true,
    // 答卷维度与评分报告
    answerDimensionScore: {},
    // 是否显示抽奖
    enableLuck: false,
    enableQuestionIndex: false,
    enableQuestionType: false,
    showLuck: false,
    // 有密码时有用
    isCheckPassword: false,
    // 是否可以修改答卷
    editSubmit: false,
    verificationCheck: false,
    showVerification: false,
    // verification
    // 当前答卷信息
    currentAnswerData: null,
    // 当前奖励信息
    currentAwardData: null,
    survey: null,
    answerId: '',
    award: null,
    share: null,
    surveyPoint: null,
    answerPoint: {
      pending: false,
      value: null
    },
    hadAward: false,
    hadShare: false,
    // 红包 || 抽奖 信息
    lottery: null,
    channel: null,
    // 是否是考试问卷
    isScoreSurvey: false,
    scoreEnd: null,
    pageList: [],
    cacheAnswerContent: [],
    answerContent: [],
    loading: false,
    currentCount: 0,
    totalCount: 0,
    isLastPage: false,
    isSoftPage: false,
    currentPageNum: 0,
    overData: null,
    maxAnswerTime: 0,
    minAnswerTime: 0,
    minPageAnswerTime: 0,
    maxPageAnswerTime: 0,
    nextPageBtnDisabled: false,
    submitBtnDisabled: false,
    innerHeight: window.innerHeight,
    address: {},
    currentBrowserInfo: {
      isWeixin: isWeixin(),
      isPc: isPC()
    },
    hook: new Hook(),
    accountUserFingerprint: null,
    // 能否再次答题
    canAnswerAgain: false,
    errorLogTask: [],
    // 是否已经答过
    isAnswering: false,
    // 是否显示答题历史
    hasHistory: false,
    // 是否点击了拆红包（没有啥实质作用 只是看的）
    isOpenReward: false,
    // 是否领取奖励
    isReceive: false,
    // 领奖信息
    receiveInfo: null,
    // 审核失败原因
    auditDescription: '',
    // 答题结束页面的提示语
    answerTextTips: [],
    moreSurveyList: null,
    // 答题的时候是否显示预览
    showPreview: false,
    // 是否已经分享
    currentPageIsShare: false,
    // 是否为软分页
    isSofgPageStart: false,
    // 答题结束页面对 投票题
    voteQuestions: [],
    // 是否为用户切换故事
    isChangeUserStory: false
  };
};
function convertAddress2params(address) {
  return {
    surveyRegion: address.adds,
    surveyLon: address.lng,
    surveyLat: address.lat,
    answerAddress: address.address
  };
}
function initInterceptors(urlParams) {
  const {
    token,
    tenantId
  } = urlParams;
  if (token === 'tenantId' && tenantId === 'token') return;
  if (token && tenantId) {
    setRequestInterceptors(config => {
      config.headers['TENANT-ID'] = tenantId;
      config.headers['Authorization'] = 'Bearer ' + token;
      return config;
    });
  }
}
function Bus(Vue, option) {
  let preDuration = 0;
  let closeLoading = null;
  const urlParams = normalizeUrlParams();
  const queue = new Queue();
  createAnswerTable(2);
  initInterceptors(urlParams);
  setResponseInterceptors(r => r, err => {
    if (!Vue.prototype.$bus.isEnd) {
      if (err.code === "ECONNABORTED" || err.response.status >= 500) {
        option.message(MessageType.WARNING, '请稍后刷新页面重试');
      }
    }
    if (Vue.prototype.$bus.isEnd) {
      const vm = Vue.prototype.$bus;
      addErrorLog({
        surveyId: vm.survey.id,
        answerId: vm.answerId,
        accountUserFingerprint: vm.accountUserFingerprint,
        accountUserId: vm.params.accountUserId,
        answerUrl: window.location.href,
        errTitle: '答题结束页面错误',
        // @ts-ignore
        errInfo: `${err} `
      });
    }
    if (err.response.status === 413 && err.config.url === "/fill/api/v1/upload") {
      option.message(MessageType.WARNING, '上传文件过大，请检查文件重新上传');
    }
    // return Promise.reject(err)
  });
  const bus = Vue.prototype.$bus = new Vue({
    data() {
      return createBaseBusData(urlParams);
    },
    computed: {
      currentPageHasScore() {
        const vm = this;
        return vm.pageList.some(q => {
          return q.setting.enableAnswerScore;
        });
      },
      showAnswerScoreInAnswering() {
        const vm = this;
        return vm.survey.otherSetting.showAnswerScoreInAnswering === 1;
      },
      buttonOption() {
        const vm = this;
        const option = vm.survey.otherSetting.buttonOption;
        const res = {
          startText: '开始答题',
          nextText: '下一页',
          prevText: '上一页',
          submitText: '提交'
        };
        if (vm.showAnswerScoreInAnswering) {
          if (vm.currentPageHasScore) {
            if (!vm.showPreview) {
              res.nextText = res.submitText = '确认';
            }
          }
        }
        copyProperty(res, option || {});
        return res;
      },
      percent() {
        const vm = this;
        if (!vm.totalCount) {
          return 0;
        }
        return Math.ceil(vm.currentCount / vm.totalCount * 100);
      },
      showCopyright() {
        const vm = this;
        const otherSetting = vm.survey.otherSetting || {};
        // if (!Reflect.has(otherSetting, 'disabledCopyright')) return true
        return !otherSetting.disabledCopyright;
      },
      needLogin() {
        const vm = this;
        if (vm.params.answerType === '1') {
          return false;
        } else if (vm.params.accountUserId) {
          return false;
        }
        return true;
      }
    },
    methods: {
      initial(params) {
        const vm = this;
        vm.hook.clearAll();
        const data = createBaseBusData(params);
        Object.keys(data).forEach(key => {
          // @ts-ignore
          vm[key] = data[key];
        });
      },
      initSurvey(data) {
        const vm = this;
        vm.survey = data.survey;
        vm.channel = data.channel;
        // vm.share = data.share
        // vm.hadAward = data.hadAward
        // vm.hadShare = data.hadShare
        // vm.award = data.award
        vm.lottery = data.lottery;
        if (!data.lottery.enableLottery) {
          // 主要是兼容之前红包的写法
          vm.share = data.lottery.share;
          vm.hadAward = data.lottery.hadAward;
          vm.hadShare = data.lottery.hadShare;
          vm.award = data.lottery.award;
        } else {
          if (data.lottery.lotteryAwards.length) {
            // 如果是抽奖 并且有奖品 就不显示 默认抽奖
            vm.enableLuck = vm.survey.otherSetting.enableLuck = false;
          }
        }
        if (data.surveyPoint && data.surveyPoint.limit > 0) {
          vm.surveyPoint = data.surveyPoint;
        }
        this.transformOtherSetting(data.survey.otherSetting);
        if (vm.enableMoreSurvey) {
          getMoreSurveyStatus().then(status => {
            vm.survey.otherSetting.enableMoreSurvey = vm.enableMoreSurvey = status === '1';
          });
        }
      },
      init(data, urlParams) {
        const vm = this;
        this.initSurvey(data);
        getFinger().then(finger => __awaiter(this, void 0, void 0, function* () {
          var _a, _b, _c, _d;
          if (vm.params.accountUserFingerprint) {
            vm.accountUserFingerprint = vm.params.accountUserFingerprint;
          } else if (vm.params.smsMessageId) {
            vm.accountUserFingerprint = vm.params.smsMessageId;
          } else {
            vm.accountUserFingerprint = finger;
          }
          this.initHook();
          vm.closing = data.survey.closing;
          if (data.channel.activeFlag === 0) {
            vm.isEnd = true;
            this.setOverData({
              success: false,
              overText: textMap[AnswerStatus.CLOSE],
              status: AnswerStatus.CLOSE
            });
            vm.isClosed = true;
            vm.isSurveyLoad = true;
            this.closeLoading();
            vm.hook.run('answerOver');
            return;
          }
          if (!vm.params.isTest) {
            if ((vm.survey.otherSetting.isOnlyWeixin || vm.survey.otherSetting.enableInterestingAnswer || vm.survey.otherSetting.enableForceWxAuthorization || ((_a = data.informedConsent) === null || _a === void 0 ? void 0 : _a.needWechatAuth)) && !vm.currentBrowserInfo.isWeixin) {
              (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
                code: ErrorCode.ONLY_WEIXIN,
                data: '您需要在微信中打开才能参与'
              });
              this.closeLoading();
              return;
            }
          }
          if (hasValue(vm.params.shareAccountUserId) && hasValue(vm.params.accountUserId) && vm.params.shareAccountUserId === vm.params.accountUserId) {
            if (vm.params.shareAnswerId) {
              vm.params.answerId = vm.params.shareAnswerId;
              vm.params.shareAnswerId = null;
              vm.params.shareAccountUserId = null;
            }
          }
          if (data.informedConsent) {
            this.closeLoading();
            const isOK = yield this.agreeInfo(data.informedConsent);
            if (!isOK) {
              document.title = data.survey.title;
              vm.isSurveyLoad = true;
              vm.hook.run('surveyLoad');
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.NOT_AGREE],
                status: AnswerStatus.NOT_AGREE
              });
              vm.hook.run('answerOver', {});
              return;
            }
            this.openLoading();
          }
          if ((vm.params.pageType === '1' || vm.params.pageType === '2' || vm.params.shareAccountUserId === vm.params.accountUserId) && vm.params.answerId) {
            getAnswerRes(vm.params.answerId).then(res => {
              vm.answerId = vm.params.answerId;
              let data = res.data;
              this.closeLoading();
              this.transformEndPage(data, false);
              vm.isSurveyLoad = true;
            });
          } else if (vm.survey.otherSetting.enableInterestingAnswer && (!vm.params.accountUserId || !vm.user) && !vm.params.isTest) {
            (_c = option.overlay) === null || _c === void 0 ? void 0 : _c.call(option, {
              code: ErrorCode.AUTHORIZATION
            });
            this.closeLoading();
          } else if (vm.survey.otherSetting.enableForceWxAuthorization && !vm.params.accountUserId && !vm.params.isTest) {
            (_d = option.overlay) === null || _d === void 0 ? void 0 : _d.call(option, {
              code: ErrorCode.AUTHORIZATION
            });
            this.closeLoading();
          } else if (!vm.enableHomePage) {
            this.onStart();
          } else {
            this.checkAnswer();
            this.closeLoading();
            vm.isSurveyLoad = true;
          }
          if (data.survey.surveyCategory.toString() === '1') {
            vm.isScoreSurvey = true;
          }
          document.title = data.survey.title;
          vm.hook.run('surveyLoad');
        }));
      },
      agreeInfo(informedConsent) {
        const data = this;
        return new Promise((resolve, reject) => {
          getUserInformedConsentSign({
            surveyId: data.params.surveyId,
            accountUserFingerprint: data.accountUserFingerprint,
            accountUserId: data.params.accountUserId,
            accountUserOpenId: data.params.accountUserOpenId
          }).then(r => __awaiter(this, void 0, void 0, function* () {
            var _a;
            data.customStartData.informedConsentId = informedConsent.id;
            // 同一用户显示频次。1=提交答卷前仅显示一次，提交答卷后重新显示；2=每次打开均显示；3= 仅显示一次
            if ((informedConsent === null || informedConsent === void 0 ? void 0 : informedConsent.displayFrequencyType) === 3) {
              if (r.data) {
                return resolve(true);
              }
            }
            //
            if ((informedConsent === null || informedConsent === void 0 ? void 0 : informedConsent.displayFrequencyType) === 1) {
              // if (r.data?.relatedAnswerIds) {
              //
              // }
              const finger = this.getLocalCacheKey();
              const answerId = yield this.getLocalCacheAnswerId(data.params.surveyId, finger);
              if (answerId) {
                return resolve(true);
              }
            }
            const vm = (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
              code: ErrorCode.AGREE_INFO,
              data: informedConsent
            });
            if (vm) {
              vm.$on('confirm', (fd, snap) => {
                const promises = [];
                if (fd) {
                  promises.push(upload(fd).then(res => {
                    data.customStartData.signUrl = res.data.url;
                  }));
                }
                if (snap) {
                  promises.push(upload(snap).then(res => {
                    data.customStartData.informedConsentShotUrl = res.data.url;
                  }));
                }
                if (promises.length) {
                  this.openLoading();
                  Promise.all(promises).then(() => {
                    vm.$emit('close');
                    resolve(true);
                  });
                } else {
                  vm.$emit('close');
                  resolve(true);
                }
              });
              vm.$on('cancel', () => {
                vm.$emit('close');
                resolve(false);
              });
            }
          }));
        });
      },
      initError(err) {
        this.initHook();
        const vm = this;
        getFinger().then(finger => {
          var _a;
          if (vm.params.accountUserFingerprint) {
            vm.accountUserFingerprint = vm.params.accountUserFingerprint;
          } else {
            vm.accountUserFingerprint = finger;
          }
          const surveyErrorCode = err.survey.code;
          if (surveyErrorCode === SubmitErrorCode.SURVEY_DELETE) {
            // this.transformEndPage({})
            // this.setOverData({
            //   status: AnswerStatus.UNKNOWN,
            //   success: false,
            //   overText: textMap[AnswerStatus.UNKNOWN]
            // })
            // vm.enableMoreShare = false
            // this.closeLoading()
            // vm.hook.run('answerOver')
            (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
              code: ErrorCode.ERROR_MESSAGE_OVERLAY,
              data: {
                message: "未找到相关问卷信息"
              }
            });
            this.closeLoading();
            return;
          }
          vm.isSurveyLoad = true;
          vm.isEnd = true;
          vm.canAnswerAgain = false;
          this.initSurvey(err);
          if (!err.channel) {
            this.setOverData({
              status: AnswerStatus.CHANNEL_ERROR,
              success: false,
              overText: textMap[AnswerStatus.CHANNEL_ERROR]
            });
            vm.enableMoreShare = false;
            this.closeLoading();
            vm.hook.run('answerOver');
          }
        });
      },
      transformOtherSetting(otherSetting) {
        const vm = this;
        if (!otherSetting) {
          otherSetting = {};
        }
        if (vm.params.isTest) {
          //测试连接【包括电脑、手机、扫码答题】不显示任何广告
          otherSetting.enableLuck = false;
          otherSetting.enableAdsense = vm.survey.otherSetting.enableAdsense = false;
          otherSetting.enableMoreSurvey = false;
        }
        // 没有值的情况下为true
        const defaultsTrue = [
        // 获取地理位置
        'enableUserLocation',
        //结束页是否显示 `更多问卷` 按钮
        'enableMoreSurvey', 'enableQuestionIndex', 'enableQuestionType'];
        defaultsTrue.forEach(key => {
          if (!Reflect.has(otherSetting, key) || otherSetting[key]) {
            vm[key] = true;
          }
        });
        // 值为bool
        const valueIsBools = ['enableNetManualAudit', 'viewableAfterSubmit', 'enablePrePage', 'enablePhoneAnswer', 'enableVerification', 'enableLuck', 'editSubmit', 'enableHomePage'];
        valueIsBools.forEach(key => {
          vm[key] = !!otherSetting[key];
        });
        if (!('progressStatus' in otherSetting)) {
          otherSetting.progressStatus = 1;
        }
        if (otherSetting.themeHeader) {
          const defaults = {
            align: 'left',
            type: 'image'
          };
          otherSetting.themeHeader = Object.assign({}, defaults, otherSetting.themeHeader);
        }
        // 直接赋值
        const assignments = ['maxAnswerTime', 'userLocationType', 'minAnswerTime'];
        assignments.forEach(key => {
          vm[key] = otherSetting[key];
        });
        // @ts-ignore
        vm.$answerUtil.getEnv().then(res => {
          if (res.miniprogram) {
            otherSetting.enableAdsense = vm.survey.otherSetting.enableAdsense = false;
          }
        });
        if (vm.params.from === "app") {
          vm.survey.otherSetting.isOnlyWeixin = false;
          vm.customStartData.skipFansCheck = true;
        }
      },
      onStart(isRestart = false) {
        var _a;
        const vm = this;
        if (vm.enableVerification) {
          if (!vm.verificationCheck) {
            vm.showVerification = true;
            this.closeLoading();
            return;
          }
        }
        const otherSetting = vm.survey.otherSetting || {};
        const passwordType = otherSetting.passwordType;
        if (!vm.isCheckPassword) {
          if (passwordType) {
            (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
              code: ErrorCode.PASSWORD,
              data: passwordType
            });
            this.closeLoading();
            return;
          }
        }
        this.startAnswer(isRestart);
      },
      getAnswerRes() {
        const vm = this;
        return getAnswerRes(vm.answerId).then(res => {
          let data = res.data;
          if (!data) {
            vm.isEnd = true;
            this.setOverData({
              success: false,
              overText: textMap[AnswerStatus.SCREEN],
              status: AnswerStatus.SCREEN
            });
            vm.hook.run('answerOver');
            return;
          }
          if (!this.jumpToEndUrl(true)) return;
          if (!vm.isSurveyLoad) {
            vm.isSurveyLoad = true;
          }
          this.closeLoading();
          vm.auditDescription = data.auditDescription;
          this.transformEndPage(data);
        });
      },
      onStartAnswerByPWD(pwd, property, cb) {
        const vm = this;
        // const passwordType = vm.survey.otherSetting.passwordType
        // if ([3, 4].includes(passwordType)) {
        //   this.openLoading()
        //
        //   checkPassword(
        //     filterParams({
        //       type: passwordType,
        //       surveyId: vm.survey.id,
        //       password: pwd,
        //       property
        //     })
        //   ).then((res: any) => {
        //     if (res.code === 0) {
        //       const handler = () => {
        //         vm.hook.off('answerStart', handler)
        //         vm.hook.off('answerOver', handler)
        //         if (vm.isCheckPassword) return
        //         cb && cb()
        //         if (!vm.isEnd && !vm.params.isTest) {
        //           bindingPassword({
        //             id: res.data,
        //             answerId: vm.answerId
        //           })
        //         }
        //       }
        //       vm.hook.on('answerStart', handler)
        //       vm.hook.on('answerOver', handler)
        //       this.startAnswer()
        //     } else {
        //       this.closeLoading()
        //       option.overlay?.({
        //         code: ErrorCode.PASSWORD,
        //         message:
        //           passwordType === 3
        //             ? '该密码已被使用，请使用其他密码或联系问卷发布者'
        //             : '输入的信息不正确，请确认无误后重新输入或联系问卷发布者'
        //       })
        //       return
        //     }
        //   })
        // } else {
        vm.customStartData.answerPassword = pwd;
        vm.customStartData.answerPasswordProperty = property;
        const handler = () => {
          vm.hook.off('answerStart', handler);
          vm.hook.off('answerOver', handler);
          cb && cb();
          if (vm.isCheckPassword) return;
          // vm.isCheckPassword = true
        };
        vm.hook.on('answerOver', handler);
        vm.hook.on('answerStart', handler);
        this.startAnswer();
        // }
      },
      refreshSurvey() {
        const vm = this;
        this.transformOtherSetting(vm.survey.otherSetting);
        return Promise.all([this.refreshSurveyPoint(), this.refreshAward()]);
      },
      refreshSurveyPoint() {
        var _a;
        const vm = this;
        if ((((_a = vm.channel) === null || _a === void 0 ? void 0 : _a.channelType) || "").toString() !== "2") {
          return Promise.resolve();
        }
        return getSurveyPoint(vm.survey.id).then(surveyPoint => {
          if (surveyPoint && surveyPoint.limit > 0) {
            vm.surveyPoint = surveyPoint;
          } else {
            vm.surveyPoint = undefined;
          }
        });
      },
      refreshAward() {
        const vm = this;
        return getAwardV2BySurveyId(vm.survey.id, vm.params.answerChannelId).then(r => {
          // let data = r.data
          // vm.award = data.award
          // vm.hadAward = data.hadAward
          // vm.share = data.share
          // vm.hadShare = data.hadShare
          const lottery = r.data;
          vm.lottery = lottery;
          if (!lottery.enableLottery) {
            // 主要是兼容之前红包的写法
            vm.share = lottery.share;
            vm.hadAward = lottery.hadAward;
            vm.hadShare = lottery.hadShare;
            vm.award = lottery.award;
          }
        });
      },
      onOverlayCheck(data, body) {
        var _a, _b;
        const bus = this;
        const currentVersionId = hasValue(data.versionId) ? data.versionId : bus.survey.lastReleasedVersionId;
        if (bus.survey.lastReleasedVersionId > currentVersionId) {
          const restart = (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
            code: ErrorCode.RESTART
          });
          if (restart) {
            restart.$on('restart', () => {
              this.openLoading();
              invalidMine(filterParams({
                id: bus.answerId,
                accountUserFingerprint: bus.accountUserFingerprint,
                accountUserId: bus.params.accountUserId,
                accountUserOpenId: bus.params.accountUserOpenId,
                openId: bus.params.openId
              })).then(res => {
                var _a;
                (_a = bus.answerDB) === null || _a === void 0 ? void 0 : _a.remove(bus.answerId);
                this.onStart();
                restart.$emit('close');
              });
            });
          }
          return;
        }
        if (!body.id && (data === null || data === void 0 ? void 0 : data.currentPageNum) === 0) return;
        const count = bus.pageList.reduce((c, q) => {
          if (q.hasValue) {
            c += 1;
          }
          return c;
        }, data.answeredCount || 0);
        if (count <= 0) return;
        const vm = (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
          code: ErrorCode.BREAKPOINT,
          data: count
        });
        if (vm) {
          vm.$on('restart', () => {
            this.openLoading();
            invalidMine(filterParams({
              id: bus.answerId,
              accountUserFingerprint: bus.accountUserFingerprint,
              accountUserId: bus.params.accountUserId,
              openId: bus.params.openId
            })).then(res => {
              var _a;
              (_a = bus.answerDB) === null || _a === void 0 ? void 0 : _a.remove(bus.answerId);
              this.onStart();
              vm.$emit('close');
            });
          });
          vm.$on('continue', () => {
            vm.$emit('close');
          });
        }
      },
      getLocalCacheKey() {
        const vm = this;
        return vm.params.dbKey || vm.params.accountUserId || vm.accountUserFingerprint;
      },
      getLocalCacheAnswerId(surveyId, key) {
        return new Promise((resolve, reject) => {
          const fingerSurveyDB = new DB('finger_survey');
          openIDB(fingerSurveyDB).then(() => {
            fingerSurveyDB.read(surveyId).then(surveyAnswer => {
              if (surveyAnswer && !surveyAnswer.expire) {
                resolve(surveyAnswer[key]);
              } else {
                resolve(null);
              }
            });
          });
        });
      },
      startAnswer(isRestart = false) {
        const vm = this;
        vm.isEnd = false;
        const answerType = vm.params.answerType;
        this.openLoading();
        const fingerSurveyDB = new DB('finger_survey');
        const surveyId = vm.survey.id;
        let startRequest = startAnswering;
        if (vm.params.isTest) {
          startRequest = startTestAnswering;
        }
        const params = {};
        if (vm.params.isTest && vm.params.initiateQuestionId) {
          params.initiateQuestionId = vm.params.initiateQuestionId;
        }
        const finger = this.getLocalCacheKey();
        openIDB(fingerSurveyDB).then(() => {
          vm.surveyAnswerDB = fingerSurveyDB;
          fingerSurveyDB.read(surveyId).then(surveyAnswer => {
            let answerId = undefined;
            if (surveyAnswer && !surveyAnswer.expire) {
              answerId = surveyAnswer[finger];
            }
            let data = Object.assign(Object.assign(Object.assign(Object.assign({
              surveyId: vm.survey.id,
              channel: "0",
              answerChannelId: vm.channel.id,
              accountUserFingerprint: vm.accountUserFingerprint,
              id: answerId,
              answerUrl: window.location.href.split('#')[0] + `&ua=${encodeURIComponent(navigator.userAgent)}`
            }, convertAddress2params(vm.address)), vm.params), vm.customStartData), {
              ua: undefined // 写死就行 用不到 作用是防止分享链接上携带 后端没有多余字段存储 ua 信息 所以 ua 信息存到了 answerUrl 上
            });
            if (!params.isTest && data.versionId) {
              data.versionId = '';
            }
            if (!vm.currentBrowserInfo.isWeixin) {
              data.token = '';
              if (vm.params.answerType !== '1' && !vm.currentBrowserInfo.isPc) {
                data.accountUserId = '';
              }
              data.accountUsername = '';
              data.accountUserWxNickname = '';
            }
            if (answerType === 'investigator') {
              data.channel = '14';
              delete data.id;
            } else if (answerType === 'investigatorAdd') {
              data.channel = '13';
              delete data.id;
            } else if (answerType === 'customer') {
              data.channel = '20';
              delete data.id;
            } else if (answerType === 'customerAdd') {
              data.channel = '19';
              delete data.id;
            }
            startRequest(filterParams(data), params).then(res => {
              const answerDB = new DB('answer');
              // answerDB.clearExpireByTime()
              // fingerSurveyDB.clearExpireByTime()
              const flag = this.transformStartResponse(res);
              if (!flag) return;
              if (!res.data) {
                this.transformEndPage({});
                this.setOverData({
                  success: false,
                  overText: textMap[AnswerStatus.ERROR],
                  status: AnswerStatus.ERROR
                });
                this.closeLoading();
                return;
              }
              vm.overData = {
                answerCertificate: res.data.answerCertificate,
                score: res.data.score
              };
              openIDB(answerDB).then(() => {
                this.initAnswerList(res, answerId);
                if (!vm.answerId || vm.isEnd || vm.isAnswering) {
                  this.closeLoading();
                  return;
                }
                answerDB.read(vm.answerId).then(content => {
                  if (content) {
                    vm.cacheAnswerContent = content;
                  } else {
                    answerDB.add(vm.answerId, []);
                    vm.cacheAnswerContent = [];
                  }
                  this.transformNextPage(res.data);
                  if (!isRestart) {
                    this.onOverlayCheck(res.data, filterParams(data));
                  }
                }).catch(err => {
                  this.transformNextPage(res.data);
                  if (!isRestart) {
                    this.onOverlayCheck(res.data, filterParams(data));
                  }
                });
                this.closeLoading();
                if (!surveyAnswer) {
                  fingerSurveyDB.add(surveyId, {
                    [finger]: vm.answerId
                  });
                } else if (surveyAnswer.expire) {
                  fingerSurveyDB.ignoreKeys.push(surveyId);
                  fingerSurveyDB.update(surveyId, {
                    [finger]: vm.answerId
                  });
                } else if (answerId !== res.data.id) {
                  fingerSurveyDB.update(surveyId, {
                    [finger]: vm.answerId
                  });
                }
                vm.answerDB = answerDB;
              });
            }).catch(err => {
              this.saveErrorLog('开始答题接口错误', JSON.stringify(err.message));
              this.closeLoading();
              return Promise.reject(err);
            });
          });
        }).catch(() => {
          let data = Object.assign(Object.assign(Object.assign({
            surveyId: vm.survey.id,
            channel: '0',
            answerChannelId: vm.channel.id,
            accountUserFingerprint: vm.accountUserFingerprint,
            answerUrl: window.location.href.split('#')[0]
          }, convertAddress2params(vm.address)), vm.params), vm.customStartData);
          if (answerType === 'investigator') {
            data.channel = '14';
            delete data.id;
          } else if (answerType === 'investigatorAdd') {
            data.channel = '13';
            delete data.id;
          } else if (answerType === 'customer') {
            data.channel = '20';
            delete data.id;
          } else if (answerType === 'customerAdd') {
            data.channel = '19';
            delete data.id;
          }
          startRequest(filterParams(data), params).then(res => {
            const flag = this.transformStartResponse(res);
            if (!flag) return;
            this.initAnswerList(res);
            this.transformNextPage(res.data);
            if (!isRestart) {
              this.onOverlayCheck(res.data, filterParams(data));
            }
            this.closeLoading();
          }).catch(err => {
            this.closeLoading();
            return Promise.reject(err);
          });
        });
      },
      setOverData(data, sync = false) {
        const vm = this;
        if (sync) {
          vm.overData = data;
        } else {
          vm.$nextTick(() => {
            vm.overData = data;
          });
        }
      },
      transformStartResponse(res) {
        const vm = this;
        if (!res) {
          vm.busOption.message(MessageType.WARNING, '请稍后刷新页面重试');
          return;
        }
        if (res.code === 0) return true;
        this.closeLoading();
        if (res.code === AnswerStatus.SAMPLE_ANSWER) {
          this.transformEndPage(res.data);
          this.setOverData({
            success: false,
            overText: textMap[AnswerStatus.SAMPLE_ANSWER],
            status: AnswerStatus.SAMPLE_ANSWER
          });
        } else if (res.code === ErrorCode.SURVEY_UN_PUBLISH) {
          this.transformEndPage({});
          this.setOverData({
            success: false,
            overText: textMap[AnswerStatus.SURVEY_UN_PUBLISH],
            status: AnswerStatus.SURVEY_UN_PUBLISH
          });
        } else if (res.code === ErrorCode.SURVEY_CLOSE) {
          this.transformEndPage({});
          this.setOverData({
            success: false,
            overText: textMap[AnswerStatus.CLOSE],
            status: AnswerStatus.CLOSE
          });
        } else if (res.code === ErrorCode.SURVEY_OFF) {
          this.transformEndPage({});
          this.setOverData({
            success: false,
            overText: textMap[AnswerStatus.SURVEY_OFF],
            status: AnswerStatus.SURVEY_OFF
          });
        } else if (res.code === ErrorCode.UNKNOWN) {
          if (res.data && res.data.id) {
            return true;
          }
          this.transformEndPage({});
          this.setOverData({
            success: false,
            status: AnswerStatus.UNKNOWN,
            tips: res.msg ? [res.msg] : null
          });
        } else {
          return true;
        }
        vm.isStart = true;
        vm.isSurveyLoad = true;
        return;
      },
      initAnswerList(res, answerId) {
        var _a, _b, _c;
        let vm = this;
        const {
          code,
          msg
        } = res;
        if (code === ErrorCode.FansNormal) {
          const popupTip = {
            code: ErrorCode.FansNormal,
            message: '只允许在微信中作答，分享链接到微信中打开'
          };
          (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, popupTip);
          return;
        } else if (code === ErrorCode.FansQr) {
          const popupTip = {
            code: ErrorCode.FansQr,
            message: vm.currentBrowserInfo.isWeixin ? vm.survey.otherSetting.enabledUserStory ? '扫码关注后生成故事' : '只有公众号粉丝可作答' : '只允许在微信中作答，分享链接到微信中打开',
            data: res.data.id,
            showClose: true
          };
          const fansVm = (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, popupTip);
          fansVm.$on('close', () => {
            vm.customStartData.skipFansCheck = true;
            this.startAnswer();
          });
          return;
        } else if (code === ErrorCode.PASSWORD) {
          (_c = option.overlay) === null || _c === void 0 ? void 0 : _c.call(option, {
            code: ErrorCode.PASSWORD,
            message: '输入的信息不正确，请确认无误后重新输入或联系问卷发布者'
          });
          return;
        } else if (code !== 0) {
          if (msg === '此答卷已完成答题或被甄别，请勿重复提交' || code === SubmitErrorCode.ANSWER_DELETE) {
            this.removeCache(answerId, vm.survey.id);
            this.startAnswer();
            return;
          } else {
            // const answerId = res.data?.id
            if (code === 3) {
              vm.isAnswering = true;
              // vm.isOpenReward = true
              if (!vm.isSurveyLoad) {
                vm.isSurveyLoad = true;
              }
              // vm.canAnswerAgain = false
              this.closeLoading();
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.IP_REPEAT],
                status: AnswerStatus.IP_REPEAT
              });
              // vm.overData =
              vm.hook.run('answerOver');
            } else if (code === 1 && res.data && res.data.id) {
              vm.answerId = res.data.id;
              vm.isAnswering = true;
              // vm.isOpenReward = true
              this.getAnswerRes();
              const voteCounts = res.data.voteCounts || [];
              if (voteCounts.length > 0) {
                vm.voteQuestions = getAnswerVote(voteCounts);
              }
              this.removeCache();
            } else if (code === SubmitErrorCode.SURVEY_ERROR) {
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.SURVEY_ERROR],
                status: AnswerStatus.SURVEY_ERROR
              });
              if (!vm.isSurveyLoad) {
                vm.isSurveyLoad = true;
              }
              vm.hook.run('answerOver');
            } else if (code === SubmitErrorCode.SURVEY_DELETE) {
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.SURVEY_DELETE],
                status: AnswerStatus.SURVEY_DELETE
              });
              if (!vm.isSurveyLoad) {
                vm.isSurveyLoad = true;
              }
              vm.hook.run('answerOver');
            } else if (code === SubmitErrorCode.SURVEY_DELETE) {
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.SURVEY_DELETE],
                status: AnswerStatus.SURVEY_DELETE
              });
              if (!vm.isSurveyLoad) {
                vm.isSurveyLoad = true;
              }
              vm.hook.run('answerOver');
            } else {
              vm.isEnd = true;
              this.setOverData({
                success: false,
                overText: textMap[AnswerStatus.UNKNOWN],
                status: AnswerStatus.UNKNOWN
              });
              if (!vm.isSurveyLoad) {
                vm.isSurveyLoad = true;
              }
              vm.hook.run('answerOver');
            }
            return;
          }
        }
        if (!vm.isSurveyLoad) {
          vm.isSurveyLoad = true;
        }
        vm.loading = false;
        vm.answerId = res.data.id;
        vm.isStart = true;
        vm.verificationCheck = false; // 重置回去 方便以后其他验证
        if (res.data.isFinished) {
          vm.isEnd = true;
          this.removeCache();
          this.transformEndPage(res.data);
          return;
        }
        vm.hook.run('answerStart');
        this.initAnswerTimer(res.data.surveyStartTime, res.data.currentSystemTime || Date.now());
        preDuration = Date.now();
      },
      onVerificationSuccess() {
        let vm = this;
        vm.verificationCheck = true;
        vm.showVerification = false;
        this.onStart();
      },
      onVerificationClose() {
        let vm = this;
        vm.showVerification = false;
      },
      getAnswerContent() {
        const vm = this;
        let promises = [];
        let answerList = [];
        for (let i = 0, len = vm.pageList.length; i < len; i++) {
          let q = vm.pageList[i];
          let content = q.getAnswerContent('submit');
          if (content.items instanceof Promise) {
            promises.push(content.items.then(res => {
              content.items = [res];
            }));
          }
          answerList.push(content);
        }
        if (promises.length) {
          return Promise.all(promises).then(() => {
            return answerList;
          });
        } else {
          return Promise.resolve(answerList);
        }
      },
      checkAnswerContent(answerContent = []) {
        const vm = this;
        vm.pageList.forEach(q => {
          if (q.issue.ignoreItems) {
            q.issue.ignoreItems = [];
          }
        });
        return new Promise((resolve, reject) => {
          if (!answerContent.length) {
            return resolve(null);
          }
          loopList(answerContent, (content, d) => {
            var _a, _b;
            const q_id = content.questonId;
            const q = vm.pageList.find(q => q.id === q_id);
            const checkResult = q.checkAnswer(content, {
              browserInfo: vm.currentBrowserInfo,
              enableQuestionIndex: vm.enableQuestionIndex
            });
            if (!checkResult.success) {
              const confirmInfo = q.issue.getValueConfirm ? checkResult.item ? q.issue.getValueConfirm(checkResult.item) : null : null;
              if (!confirmInfo) {
                return resolve(Object.assign({
                  question: q
                }, checkResult));
              } else {
                vm.busOption.scroll.scrollToQuestion(q);
                vm.busOption.confirm(confirmInfo.message, {
                  confirm() {
                    if (checkResult.item) {
                      q.issue.ignoreItems.push(checkResult.item);
                      d(false);
                    } else {
                      d();
                    }
                    q.runHooks('confirm', true);
                  },
                  close() {
                    vm.busOption.scroll.scrollToQuestion(q);
                    q.runHooks('confirm', false);
                  }
                });
                return;
              }
            }
            if (q.issue.complexValidateEnable && q.issue.complexValidate.length) {
              const res = (_b = (_a = q.issue).runComplexValidate) === null || _b === void 0 ? void 0 : _b.call(_a, mergeAnswerContent(vm.answerContent || [], answerContent), content);
              if (!res.success) {
                return resolve(Object.assign({
                  question: q
                }, res));
              }
            }
            d();
          }, () => {
            resolve(null);
          });
        });
      },
      submitOrNextPage() {
        const vm = this;
        if (vm.loading) return;
        console.log("提交答案----submitOrNextPage");
        // 答题时长超时字段 overallOvertime
        // 强制提交字段 forceSubmit
        let overallOvertime = vm.overallOvertime || false;
        let forceSubmit = vm.forceSubmit || overallOvertime;
        this.getAnswerContent().then(list => __awaiter(this, void 0, void 0, function* () {
          var _a, _b;
          const result = yield this.checkAnswerContent(list);
          if (!overallOvertime && !forceSubmit) {
            if (result && !result.success) {
              (_a = result.question) === null || _a === void 0 ? void 0 : _a.runHooks('submitError');
              if (result.message) {
                option.message(MessageType.WARNING, result.message, this);
                if (vm.params.answerType !== 'investigatorAdd') {
                  (_b = option.scroll) === null || _b === void 0 ? void 0 : _b.scrollToQuestion(result.question);
                }
              }
              return;
            }
          }
          if (!vm.forceSubmit) {
            if (vm.showAnswerScoreInAnswering) {
              if (vm.currentPageHasScore) {
                if (!vm.showPreview) {
                  vm.showPreview = true;
                  return;
                } else {
                  vm.showPreview = false;
                }
              }
            }
          }
          this.openLoading();
          vm.overallOvertime = vm.forceSubmit = false;
          queue.use(() => {
            return this.onSubmitAnswer(list, forceSubmit, overallOvertime);
          });
          queue.run();
        }));
        // let promises: Promise<any>[] = []
        // let answerList: any = []
        // let error: { success: boolean; message: string } | null = null
        // let errorQuestion: any = null
        // for (let i = 0, len = vm.pageList.length; i < len; i++) {
        //   let q = vm.pageList[i]
        //   let content = q.getAnswerContent('submit')
        //   if (content.items instanceof Promise) {
        //     promises.push(
        //       content.items.then((res: any) => {
        //         content.items = [res]
        //       })
        //     )
        //   }
        //   answerList.push(content)
        //   let flag = q.checkAnswer(content, {
        //     browserInfo: vm.currentBrowserInfo,
        //     enableQuestionIndex: vm.enableQuestionIndex
        //   })
        //   if (!flag.success) {
        //     error = flag
        //     errorQuestion = q
        //     break
        //   } else {
        //     q.runHooks('submitSuccess')
        //   }
        // }
        // if (!overallOvertime && !forceSubmit) {
        //   if (error && !error.success) {
        //     // this.closeLoading()
        //     errorQuestion?.runHooks('submitError')
        //     if (error.message) {
        //       option.message(MessageType.WARNING, error.message, this)
        //       if (vm.params.answerType !== 'investigatorAdd') {
        //         option.scroll?.scrollToQuestion(errorQuestion)
        //       }
        //     }
        //     return
        //   }
        // }
        // if (!vm.forceSubmit) {
        //   if (vm.showAnswerScoreInAnswering) {
        //     if (vm.currentPageHasScore) {
        //       if (!vm.showPreview) {
        //         vm.showPreview = true
        //         return
        //       } else {
        //         vm.showPreview = false
        //       }
        //     }
        //   }
        // }
        // this.openLoading()
        // vm.overallOvertime = vm.forceSubmit = false
        // if (promises.length) {
        //   Promise.all(promises).then(res => {
        //     this.onSubmitAnswer(answerList, forceSubmit, overallOvertime)
        //   })
        // } else {
        //   this.onSubmitAnswer(answerList, forceSubmit, overallOvertime)
        // }
      },
      showPrevPage() {
        const vm = this;
        if (vm.showAnswerScoreInAnswering) {
          vm.showPreview = true;
        }
        if (!vm.params.disableClearAnswer) {
          vm.cacheAnswerContent = vm.cacheAnswerContent.filter(item => {
            return !vm.pageList.find(q => q.id === item.questonId);
          });
          if (vm.answerDB) {
            vm.answerDB.update(vm.answerId, vm.cacheAnswerContent);
          }
        }
        vm.currentPageNum--;
        this.openLoading();
        this.onSubmitAnswer(null, false, false, true);
      },
      onOnlySave() {
        const vm = this;
        if (vm.loading) return;
        this.getAnswerContent().then(list => {
          queue.use(() => {
            return this.onSubmitAnswer(list, false, false, false, true);
          });
          queue.run();
        });
        // let promises: Promise<any>[] = []
        // let answerList: any = []
        // for (let i = 0, len = vm.pageList.length; i < len; i++) {
        //   let q = vm.pageList[i]
        //   let content = q.getAnswerContent('submit')
        //   if (content.items instanceof Promise) {
        //     promises.push(
        //       content.items.then((res: any) => {
        //         content.items = [res]
        //       })
        //     )
        //   }
        //   answerList.push(content)
        // }
        // if (promises.length) {
        //   Promise.all(promises).then(res => {
        //     this.onSubmitAnswer(answerList, false, false, false, true)
        //   })
        // } else {
        //   this.onSubmitAnswer(answerList, false, false, false, true)
        // }
      },
      onSubmitAnswer(data, forceSubmit, overallOvertime, isPrev = false, onlySave = false) {
        const vm = this;
        const answerContent = data;
        return submitAnswer(vm.answerId, answerContent, vm.currentPageNum, forceSubmit, overallOvertime, onlySave).then(res => {
          try {
            if (res.code !== 0) {
              switch (res.code) {
                case SubmitErrorCode.ERROR:
                  this.setOverData({
                    status: AnswerStatus.UNKNOWN,
                    success: false
                  });
                  break;
                case SubmitErrorCode.SURVEY_ERROR:
                  this.setOverData({
                    status: AnswerStatus.SURVEY_ERROR,
                    success: false
                  });
                  break;
                case SubmitErrorCode.SURVEY_DELETE:
                  this.setOverData({
                    status: AnswerStatus.SURVEY_DELETE,
                    success: false
                  });
                  break;
                default:
                  break;
              }
              {
                // TODO 待优化
                vm.isEnd = true;
                vm.hook.run('answerOver');
                this.closeLoading();
                clearInterval(vm.overallOvertimer);
                clearInterval(vm.maxPageTimer);
              }
              return;
            }
            if (onlySave) {
              return;
            }
            const data = res.data;
            const status = data.status;
            if (status === AnswerStatus.AGAIN) {
              option.message(MessageType.ERROR, '已开启智能质控，请认真答题。');
              submitAnswer(vm.answerId, null).then(res => {
                var _a;
                (_a = vm.answerDB) === null || _a === void 0 ? void 0 : _a.remove(vm.answerId, () => {
                  vm.cacheAnswerContent = [];
                  const answerContent = res.data.answerContent || [];
                  if (!answerContent.length && vm.showPreview) {
                    vm.showPreview = false;
                  }
                  this.transformNextPage(res.data);
                  this.closeLoading();
                });
              });
              return;
            } else if (!data.isFinished) {
              const answerContent = res.data.answerContent || [];
              if (!answerContent.length && vm.showPreview) {
                vm.showPreview = false;
              }
              this.transformNextPage(res.data, isPrev);
              this.closeLoading();
              return;
            }
            if (vm.overallOvertimer) {
              clearInterval(vm.overallOvertimer);
            }
            this.removeCache();
            this.transformEndPage(data, true, answerContent);
          } catch (e) {
            // @ts-ignore
            return Promise.reject({
              res,
              err: e.message
            });
          }
        }).catch(res => {
          this.closeLoading();
          this.saveErrorLog("提交答案错误", JSON.stringify(res));
          console.log(res);
        });
      },
      saveErrorLog(title, info) {
        const vm = this;
        addErrorLog({
          surveyId: vm.survey.id,
          answerId: vm.answerId,
          accountUserFingerprint: vm.accountUserFingerprint,
          accountUserId: vm.params.accountUserId,
          answerUrl: window.location.href,
          errTitle: title,
          // @ts-ignore
          errInfo: info
        });
      },
      transformNextPage(data, isPrev = false) {
        var _a;
        if (data.isFinished) {
          this.removeCache();
          return this.transformEndPage(data);
        }
        const vm = this;
        vm.currentCount = data.answeredCount;
        vm.totalCount = data.totalCount;
        vm.isLastPage = data.isLastPage;
        vm.isSoftPage = data.isSoftPage;
        vm.currentPageNum = data.currentPageNum;
        vm.answerContent = data.answerContent;
        this.removeCurrentListHook();
        if (vm.survey.otherSetting.enablePagePerQuestion) {
          let pagePerMinTime = 0;
          let pagePerMaxTime = 0;
          if (vm.survey.otherSetting.enablePagePerMinTime) {
            pagePerMinTime = vm.survey.otherSetting.pagePerMinTime;
          }
          if (vm.survey.otherSetting.enablePagePerMaxTime) {
            pagePerMaxTime = vm.survey.otherSetting.pagePerMaxTime;
          }
          this.initPageAnswerTimer({
            isSoftPage: false,
            minPageAnswerTime: pagePerMinTime,
            maxPageAnswerTime: pagePerMaxTime
          });
        } else {
          this.initPageAnswerTimer(data);
        }
        // console.log(data.partialHideMap)
        if (data.answerContent && data.answerContent.length) {
          if (vm.showAnswerScoreInAnswering) {
            if (vm.currentPageHasScore) {
              vm.showPreview = true;
            }
          }
        }
        try {
          if (!data || !data.nextPage.length) {
            this.saveErrorLog("未返回题目信息", JSON.stringify({
              res: data
            }));
            vm.closeLoading();
            this.submitOrNextPage();
            return;
          }
          // vm.currentPageCacheContent = vm.cacheAnswerContent || []
          // mergeAnswerContent(
          //   (vm.cacheAnswerContent || []).filter(item=>item.questionType!==questionType.MAX_DIFF),
          //   data.answerContent || []
          // )
          vm.pageList = convertQuestionList(data.nextPage.map(q => {
            getCurrentAnswerHide(q, data.partialHideMap);
            initQuotaCount(q, data.quotaRemainderNumMap || {});
            initAutoFill(q);
            return q;
          }), data.answeredCount + 1, mergeAnswerContent((vm.cacheAnswerContent || []).filter(item => item.questionType !== questionType.MAX_DIFF), data.answerContent || []), {
            autoFill: (target, rule) => {
              return valueByCalc(target, rule, () => {
                return mergeAnswerContent((vm.cacheAnswerContent || []).filter(item => item.questionType !== questionType.MAX_DIFF), data.answerContent || []);
              }, Vue);
            }
          }).map(q => {
            if (isPrev) {
              q.setHook('created', () => {
                q.convertPrevData();
              });
            }
            q.setHook('updated', type => {
              if (type && type === 'file') {
                return;
              }
              if (q.duration === 0) {
                let currentDate = Date.now();
                q.duration = currentDate - preDuration;
                preDuration = currentDate;
              }
              if (!q.showVote) {
                q.showVote = true;
              }
              console.log('updated');
            });
            if (q.setting.enableVoteNum) {
              const votes = data.voteCounts || [];
              let vote = votes.find(vote => vote.questionId === q.id);
              if (vote) {
                q.setVote(vote);
              }
            }
            if (vm.survey.otherSetting.uploadFileMaxSize) {
              q.uploadFileMaxSize = vm.survey.otherSetting.uploadFileMaxSize;
            }
            return q;
          });
          initAutoFillWatcher(vm.pageList, data.answerContent, vm.cacheAnswerContent);
          initAutoValidate(vm.pageList, data.answerContent, vm.cacheAnswerContent);
          if (vm.params.updateAndSave) {
            vm.pageList.forEach(q => {
              let timer = null;
              q.setHook('updated', () => {
                if (timer != null) {
                  clearTimeout(timer);
                }
                timer = setTimeout(() => {
                  this.onOnlySave();
                  timer = null;
                });
              });
            });
          }
        } catch (e) {
          addErrorLog({
            surveyId: vm.survey.id,
            answerId: vm.answerId,
            accountUserFingerprint: vm.accountUserFingerprint,
            accountUserId: vm.params.accountUserId,
            answerUrl: window.location.href,
            errTitle: '问题解析失败',
            // @ts-ignore
            errInfo: `${JSON.stringify({
              err: e.message,
              res: data
            })} `
          });
        }
        (_a = option.scroll) === null || _a === void 0 ? void 0 : _a.scrollTo(0);
      },
      /**
       *
       * @param data
       * @param isNormalEnd 是否正常结束进入此方法
       * @param answerContent 答题结束时提交的答案（没啥用 就是存一下）
       */
      transformEndPage(data, isNormalEnd = false, answerContent) {
        let vm = this;
        const status = data.status;
        const isOk = status === AnswerStatus.OK || status === AnswerStatus.PASS;
        if (!this.jumpToEndUrl(isOk)) return;
        this.removeCurrentListHook();
        vm.pageList = [];
        this.closeLoading();
        vm.hook.run('beforeAnswerOver', data, isNormalEnd);
        vm.$nextTick(() => {
          var _a;
          vm.currentAnswerData = data;
          let overData;
          if (data.isDuplicateAnswer) {
            overData = {
              success: false,
              overText: textMap[AnswerStatus.REPEAT],
              status: AnswerStatus.REPEAT
            };
          } else {
            overData = {
              success: isOk,
              overText: textMap[status] || [],
              hasReward: data.hasReward,
              awardYuanAmount: data.awardYuanAmount,
              allowAwardWithoutFollow: data.allowAwardWithoutFollow,
              answerCertificate: data.answerCertificate || ((_a = vm.overData) === null || _a === void 0 ? void 0 : _a.answerCertificate),
              score: data.score,
              status
            };
          }
          vm.hasHistory = !!data.hasHistory;
          vm.overData = overData;
          vm.isEnd = true;
          if (vm.survey.otherSetting.enabledUserStory) {
            vm.closeLoading();
            vm.openLoading("调研ai正在努力为您生成故事…");
            getUserStoryByAnswerId(vm.answerId, vm.isChangeUserStory).then(res => {
              const users = (res.data.wxMessageVos || []).map(item => {
                return {
                  weixinNickName: item.weixinNickName,
                  answerContent: item.content,
                  answerId: item.answerId,
                  weixinHeadimgurl: item.photo
                };
              });
              if (vm.closing) {
                const list = vm.closing.funAnswerEnds || [];
                if (res.data.story) {
                  data.score = 50;
                  list.forEach(item => {
                    item.posterContent = res.data.story;
                    item.users = users;
                    item.posterContentInfo = {
                      x: 25,
                      y: 200,
                      horizontal: 220,
                      vertical: 240
                    };
                    item.usersInfo = {
                      x: 10,
                      y: 455,
                      horizontal: 250,
                      vertical: 170
                    };
                    item.nextAnswerId = res.data.answerId;
                  });
                  setTimeout(() => {
                    vm.hook.run('resetShare', {
                      desc: `一起脑洞大开，玩转三重奖励~`
                    });
                  }, 20);
                } else {
                  list.forEach(item => {
                    item.users = users;
                    item.usersInfo = {
                      x: 10,
                      y: 170,
                      horizontal: 250,
                      vertical: 170
                    };
                    item.nextAnswerId = res.data.answerId;
                    item.posterContent = '';
                    item.posterContentInfo = null;
                  });
                  setTimeout(() => {
                    vm.hook.run('resetShare', {
                      desc: `我的故事元素：${users[0].answerContent}，请输入你的`
                    });
                  }, 20);
                }
              }
              vm.scoreEnd = null;
              vm.$nextTick(() => {
                vm.closeLoading();
                vm.hook.run('answerOver', data, isNormalEnd);
              });
            }).catch(() => {
              vm.closeLoading();
              vm.hook.run('answerOver', data, isNormalEnd);
            });
          } else if (vm.survey.otherSetting.enabledChatGPT) {
            vm.closeLoading();
            vm.openLoading("调研ai正在努力为您撰写祝福语…");
            getAnswerChatGPT(vm.answerId).then(res => {
              if (vm.closing) {
                let result = res.data;
                if (/\^https/.test(result)) {
                  result = `<img src="${result}">`;
                }
                result = result.replaceAll("\n\n", "\n");
                result = result.replaceAll('\n', '<br/>');
                const list = vm.closing.funAnswerEnds || [];
                list.forEach(item => {
                  item.posterContent = result;
                  item.posterContentInfo = {
                    x: 55,
                    y: 155,
                    horizontal: 170,
                    vertical: 170
                  };
                });
              }
              vm.closeLoading();
              vm.hook.run('answerOver', data, isNormalEnd);
            }).catch(() => {
              vm.closeLoading();
              vm.hook.run('answerOver', data, isNormalEnd);
            });
          } else {
            vm.hook.run('answerOver', data, isNormalEnd, answerContent);
          }
        });
        clearInterval(vm.overallOvertimer);
        clearInterval(vm.maxPageTimer);
      },
      jumpToEndUrl(status = true) {
        var _a, _b, _c, _d;
        let vm = this;
        if (vm.survey.otherSetting.enableWebpageJump && ((_b = (_a = vm.closing) === null || _a === void 0 ? void 0 : _a.normalEnd) === null || _b === void 0 ? void 0 : _b.jumpUrl) && status) {
          let reg = /^http[s]{0,1}:\/\/([\w.]+\/?)\S*/i;
          let url = (_d = (_c = vm.closing) === null || _c === void 0 ? void 0 : _c.normalEnd) === null || _d === void 0 ? void 0 : _d.jumpUrl;
          if (!reg.test(url)) url = 'https://' + url;
          location.href = url;
          return false;
        }
        return true;
      },
      removeCurrentListHook() {
        const vm = this;
        for (const q of vm.pageList) {
          q.clearHook();
        }
      },
      removeCache(answerId, surveyId) {
        const vm = this;
        vm.cacheAnswerContent = [];
        const surveyAnswerDB = new DB('finger_survey');
        const answerDB = new DB('answer');
        openIDB(surveyAnswerDB).then(() => {
          surveyAnswerDB.remove(surveyId || vm.survey.id);
          surveyAnswerDB.clearExpireByTime();
        });
        openIDB(answerDB).then(() => {
          answerDB.remove(answerId || vm.answerId);
          answerDB.clearExpireByTime();
        });
      },
      convertAwardAmountText(data) {
        let randomRedEnvelope = !!data.randomRedEnvelope;
        if (!randomRedEnvelope) return data.amount + '元';
        let min = data.rdMin;
        let max = data.rdMax;
        let text;
        if (max && min) {
          text = `${min}~${max}元`;
        } else if (max) {
          text = `${max}元及以下`;
        } else if (min) {
          text = `${min}元及以上`;
        } else {
          text = '随机金额';
        }
        return text;
      },
      convertTimeByStartTime(startTime, currentSystemTime, time) {
        if (!time) return 0;
        const maxTime = 60 * 60 * 24 * 365;
        if (!startTime) {
          if (time > maxTime) return 0;
          return time;
        }
        let d = new Date(startTime);
        let n = new Date(currentSystemTime);
        time = time - ((n.getTime() - d.getTime()) / 1000 | 0);
        if (time > maxTime) return 0;
        return time;
      },
      initMinAnswerTimer(time) {
        let vm = this;
        vm.minAnswerTime = Math.min(time, vm.minAnswerTime);
        if (!time) return;
        if (time <= 0) {
          return;
        }
        vm.submitBtnDisabled = true;
        vm.minAnswerTimer = setInterval(() => {
          if (--vm.minAnswerTime <= 0) {
            vm.submitBtnDisabled = false;
            clearInterval(vm.minAnswerTimer);
          }
        }, 1000);
      },
      initMaxAnswerTimer(time) {
        let vm = this;
        vm.maxAnswerTime = Math.min(time, vm.maxAnswerTime);
        if (!time) return;
        if (time <= 0) {
          vm.overallOvertime = true;
          this.submitOrNextPage();
          return;
        }
        vm.overallOvertimer = setInterval(() => {
          if (--vm.maxAnswerTime <= 0) {
            // clearInterval(this.runMaxTime)
            // clearInterval(this.runMinTime)
            vm.overallOvertime = true;
            this.submitOrNextPage();
            clearInterval(vm.overallOvertimer);
          }
        }, 1000);
        console.log(time);
      },
      initAnswerTimer(surveyStartTime, currentSystemTime) {
        let vm = this;
        this.initMaxAnswerTimer(this.convertTimeByStartTime(surveyStartTime, currentSystemTime, vm.maxAnswerTime));
        this.initMinAnswerTimer(this.convertTimeByStartTime(surveyStartTime, currentSystemTime, vm.minAnswerTime));
      },
      initPageAnswerTimer(data) {
        const vm = this;
        if (data.isSoftPage) {
          vm.isSofgPageStart = true;
        } else {
          if (vm.isSofgPageStart) {
            vm.isSofgPageStart = false;
            if (vm.minPageAnswerTime > 0) {
              vm.nextPageBtnDisabled = true;
            }
            return;
          }
          vm.isSofgPageStart = false;
        }
        vm.minPageAnswerTime = Number(data.minPageAnswerTime);
        vm.maxPageAnswerTime = Number(data.maxPageAnswerTime);
        clearInterval(vm.minPageTimer);
        if (vm.minPageAnswerTime > 0) {
          if (!vm.isSofgPageStart) {
            vm.nextPageBtnDisabled = true;
          }
          vm.minPageTimer = setInterval(() => {
            vm.minPageAnswerTime--;
            if (vm.minPageAnswerTime <= 0) {
              vm.nextPageBtnDisabled = false;
              clearInterval(vm.minPageTimer);
              vm.minPageTimer = null;
            }
          }, 1000);
        }
        clearInterval(vm.maxPageTimer);
        if (vm.maxPageAnswerTime > 0) {
          vm.maxPageTimer = setInterval(() => {
            vm.maxPageAnswerTime--;
            if (vm.maxPageAnswerTime <= 0) {
              vm.forceSubmit = true;
              this.submitOrNextPage();
              clearInterval(vm.maxPageTimer);
              vm.maxPageTimer = null;
            }
          }, 1000);
        }
      },
      checkAnswer() {
        const vm = this;
        if (vm.params.isTest) return;
        checkAnswer(filterParams({
          surveyId: vm.params.surveyId,
          id: vm.params.answerId,
          accountUserFingerprint: vm.accountUserFingerprint,
          accountUserId: vm.params.accountUserId,
          answerUrl: window.location.href.split('#')[0],
          accountUserOpenId: vm.params.accountUserOpenId
        })).then(res => {
          var _a, _b;
          let data = res;
          const {
            code
          } = data;
          if (code === 0) {
            return;
          } else if (code === 3) {
            vm.isAnswering = true;
            // vm.isOpenReward = true
            if (!vm.isSurveyLoad) {
              vm.isSurveyLoad = true;
            }
            // vm.canAnswerAgain = false
            this.closeLoading();
            vm.isEnd = true;
            this.setOverData({
              success: false,
              overText: textMap[AnswerStatus.IP_REPEAT],
              status: AnswerStatus.IP_REPEAT
            });
            vm.hook.run('answerOver');
            return;
          } else if (code === ErrorCode.FansNormal) {
            (_a = option.overlay) === null || _a === void 0 ? void 0 : _a.call(option, {
              code: ErrorCode.FansNormal,
              message: '只允许在微信中作答，分享链接到微信中打开'
            });
            return;
          } else if (code === ErrorCode.FansQr) {
            (_b = option.overlay) === null || _b === void 0 ? void 0 : _b.call(option, {
              code: ErrorCode.FansQr,
              message: vm.currentBrowserInfo.isWeixin ? '只有公众号粉丝可作答' : '只允许在微信中作答，分享链接到微信中打开',
              data: data.data
            });
            return;
          }
          if (data.data) {
            vm.isAnswering = true;
            vm.answerId = res.data;
            // vm.isOpenReward = true
            this.getAnswerRes();
          }
          // vm.isEnd = true
          // vm.overData = {
          //   success: true,
          //   overText: textMap[AnswerStatus.ERR1],
          //   status: AnswerStatus.ERR1
          // }
        }).catch(err => {
          if (err.message) ;
        });
      },
      initHook() {
        const vm = this;
        vm.hook.on('surveyLoad', surveyLoad(vm));
        vm.hook.on('answerStart', answerStart(vm));
        vm.hook.on('answerOver', answerOver(vm));
        vm.hook.on('beforeAnswerOver', beforeAnswerOver(vm));
      },
      openLoading(text = "loading") {
        const vm = this;
        if (vm.loading) return;
        const load = option.loading(text);
        vm.loading = true;
        closeLoading = () => {
          load.close();
          vm.loading = false;
          closeLoading = null;
        };
      },
      closeLoading() {
        if (closeLoading) {
          closeLoading();
        }
      },
      getUrl(pageType) {
        const vm = this;
        /**
         * pageType 1(分享) 2(领奖) 3(积分)
         */
        const origin = window.location.origin;
        const params = vm.params;
        const survey = vm.survey;
        const answerId = vm.answerId;
        if (!survey || !answerId) return;
        const answerChannelId = vm.channel.id;
        const url = `${origin}/mobile?surveyId=${survey.id}&answerId=${answerId}&answerChannelId=${answerChannelId}${params.companyid ? '&companyid=' + params.companyid : ''}&pageType=${pageType}&share=1&shareAnswerId=${answerId}&t=${Date.now()}`;
        return `${origin}/transfer?redirect_type=answer&redirect_url=${encodeURIComponent(url)}&pageType=${pageType}`;
      },
      receiveAward(data) {
        const vm = this;
        this.openLoading();
        let params = Object.assign(Object.assign({}, data), {
          accountUserId: vm.params.accountUserId,
          answerId: vm.answerId,
          id: vm.currentAwardData.bindAward.id
        });
        receiveAward(filterParams(params)).then(r => {
          if (r.code !== 0) {
            return Promise.reject({
              message: r.msg
            });
          }
          if (r.data.boundFailedType === BoundFailedType.OTHER_EXCESS) {
            return Promise.reject({
              message: "同一手机号码只允许领奖一次"
            });
          }
          // vm.isReceive = true
          // vm.receiveInfo = data
          vm.currentAwardData.bindAward = r.data;
          // vm.busOption.message(MessageType.WARNING,"很遗憾，您没有在15分钟内领取奖品，奖品已失效。")
          // vm.busOption.message(MessageType.WARNING,"此手机号码已经中过奖，无法重复使用!")
        }).catch(err => {
          vm.busOption.message(MessageType.ERROR, err.message);
        }).finally(() => {
          this.closeLoading();
        });
      },
      drawRewards() {
        const vm = this;
        return new Promise((resolve, reject) => {
          answerGetAward(vm.answerId).then(res => {
            if (res.data.boundFailedType === BoundFailedType.OVERTIME) {
              vm.currentAwardData.hasReward = false;
              return Promise.reject({
                message: "很遗憾，您没有在15分钟内领取奖品，奖品已失效。"
              });
            } else {
              resolve(res);
            }
          }).catch(err => {
            vm.busOption.message(MessageType.ERROR, err.message);
            reject(err);
          });
        });
      }
    },
    created() {
      const vm = this;
      vm.busOption = option;
      H5PlatformInit(() => {
        vm.platformSdkFinished = true;
        vm.hook.run('platformSdkLoad');
        //通过模板创建问卷(微信小程序)使用 uni
        loadScript(`${window.origin}/assets/js/uni.webview.js`).then(() => {});
      });
      // if (!vm.params.accountUserId) {
      // const userInfo = getStore({ name: 'ENTRANCE_USER_INFO' })
      // if (userInfo) {
      //   vm.params.accountUserId = userInfo.baseId
      // }
      // }
    }
  });
  initAnswerUtil(Vue, bus);
  Vue.config.errorHandler = function (err, vm, info) {
    var _a;
    addErrorLog({
      surveyId: bus.survey.id,
      answerId: bus.answerId,
      accountUserFingerprint: bus.accountUserFingerprint,
      accountUserId: bus.params.accountUserId,
      answerUrl: window.location.href,
      errTitle: '未捕获错误',
      // @ts-ignore
      errInfo: `${(_a = vm === null || vm === void 0 ? void 0 : vm.$options) === null || _a === void 0 ? void 0 : _a.name}-${info || ''}-${err.message} `
    });
  };
}
function busGetters(args = []) {
  const res = {};
  args.forEach(key => {
    res[key] = function (vm) {
      return vm.$bus[key];
    };
  });
  return res;
}
function convertLocation(longitude, latitude) {
  return new Promise((resolve, reject) => {
    transFormPoint(longitude, latitude).then(res => {
      let point = res;
      if (String(res.status) === '0') {
        return resolve({
          lng: longitude,
          lat: latitude,
          address: '定位失败-坐标转换失败',
          adds: '定位失败-坐标转换失败',
          IS_OK: false,
          convertError: res.info,
          convertErrorCode: res.infocode
        });
      }
      getGeocode(point.locations).then(res => {
        if (String(res.status) === '0') {
          return resolve({
            lng: longitude,
            lat: latitude,
            address: '定位失败-坐标转换失败',
            adds: '定位失败-坐标转换失败',
            IS_OK: false,
            convertError: res.info,
            convertErrorCode: res.infocode
          });
        }
        let [lng, lat] = point.locations.split(',');
        let formattedAddress = res.regeocode.formatted_address;
        let address = Array.isArray(formattedAddress) ? '' : formattedAddress;
        let {
          country,
          province,
          district,
          city
        } = res.regeocode.addressComponent;
        let arr;
        if (city.toString().trim()) {
          arr = [country, province, city, district];
        } else {
          arr = [country, province, district];
        }
        let currentPoint = {
          adds: arr.join(';'),
          address,
          lng,
          lat,
          IS_OK: true
        };
        resolve(currentPoint);
      });
    });
  });
}
function defaultBrowser() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject({
        message: '未支持接口',
        err: {}
      });
    }
    navigator.geolocation.getCurrentPosition(function success(position) {
      let latitude = position.coords.latitude;
      let longitude = position.coords.longitude;
      convertLocation(longitude, latitude).then(resolve, reject);
    }, err => {
      console.log(err);
      let message = '';
      let userRefuse = false;
      if (err.code === 1) {
        message = '无权限';
        userRefuse = true;
      } else if (err.code === 3) {
        message = '获取位置超时';
      } else {
        message = '接口异常';
      }
      reject({
        message,
        userRefuse,
        err
      });
    }, {
      maximumAge: 10 * 1000,
      timeout: 60 * 1000,
      enableHighAccuracy: false
    });
  });
}
function getAddress(browserInfo) {
  return new Promise((resolve, reject) => {
    let platformSdk = getPlatformSdk();
    if (platformSdk) {
      platformSdk.getLocation().then(res => {
        convertLocation(res.lng, res.lat).then(resolve, reject);
      }).catch(reject);
    } else {
      defaultBrowser().then(resolve, reject);
    }
  });
}
const componentMap = new Map();
singleTypes.forEach(type => {
  componentMap.set(type, 'SingleChoice');
});
textTypes.forEach(t => {
  componentMap.set(t, 'TextFill');
});
componentMap.set(questionType.ONLY_TEXT, '');
componentMap.set(questionType.SINGLE_CHOICE, 'SingleChoice');
componentMap.set(questionType.MULTIPLE_CHOICE, 'MultipleChoice');
componentMap.set(questionType.SINGLE_SELECT, 'SingleSelectChoice');
componentMap.set(questionType.MULTIPLE_SELECT, 'MultipleSelectChoice');
componentMap.set(questionType.LINKAGE, 'Cascader');
componentMap.set(questionType.MATRIX_SINGLE_CHOICE, 'MatrixSingleChoice');
componentMap.set(questionType.MATRIX_MULTIPLE_CHOICE, 'MatrixMultipleChoice');
componentMap.set(questionType.MATRIX_SELECT_CHOICE, 'MatrixSelectChoice');
componentMap.set(questionType.BLANKS, 'Blanks');
componentMap.set(questionType.SINGLE_TEXT_FILL, 'TextFill');
componentMap.set(questionType.MULTIPLE_TEXT_FILL, 'TextFill');
componentMap.set(questionType.SCALE, 'Scale');
componentMap.set(questionType.NPS_SCALE, 'NPSScale');
componentMap.set(questionType.CUSTOM_SINGLE_SCALE, 'CustomSingleScale');
componentMap.set(questionType.MATRIX_AUTO, 'MatrixAuto');
componentMap.set(questionType.MATRIX_COMPOSE, 'MatrixCompose');
componentMap.set(questionType.MATRIX_GRAVITY, 'MatrixGravity');
componentMap.set(questionType.MATRIX_SCROLL, 'MatrixScroll');
componentMap.set(questionType.MULTIPLE_BLANKS, 'MultipleBlanks');
componentMap.set(questionType.IMAGE_CHOICE, 'SingleImageChoice');
componentMap.set(questionType.IMAGE_MULTIPLE_CHOICE, 'MultipleImageChoice');
componentMap.set(questionType.MATRIX_FILL, 'MatrixFill');
componentMap.set(questionType.DATE, 'DateQ');
componentMap.set(questionType.DATE_OF_BIRTH, 'DateQ');
componentMap.set(questionType.UPLOAD_FILE, 'UploadFile');
componentMap.set(questionType.HANDWRITING, 'HandWriting');
componentMap.set(questionType.CITY_ADDRESS, 'CityAddress');
componentMap.set(questionType.PERMANENT_ADDRESS, 'CityAddress');
componentMap.set(questionType.DOMICILE, 'CityAddress');
componentMap.set(questionType.SPECIALITY, 'Cascader');
componentMap.set(questionType.SCHOOL, 'Cascader');
componentMap.set(questionType.MAP, 'MapQ');
componentMap.set(questionType.DOWNLOADABLE, 'Downloadable');
componentMap.set(questionType.PHONE_VALIDATE, 'TextFill');
componentMap.set(questionType.CASCADE_REGION, 'CascadeRegion');
componentMap.set(questionType.IMAGE_CHOICE, 'ImageChoice');
componentMap.set(questionType.CLASSIFICATION, 'Classification');
componentMap.set(questionType.SORT, 'Sort');
componentMap.set(questionType.MATRIX_SCALE, 'MatrixScale');
componentMap.set(questionType.CUSTOM_MULTIPLE_SCALE, 'MatrixScale');
componentMap.set(questionType.TOTAL, 'Total');
componentMap.set(questionType.MAX_DIFF, 'MaxDiff');
function answerMixin(option = {}) {
  const changeExpr = option.changeExpr;
  const changeDelay = option.changeDelay;
  return {
    props: {
      question: {
        type: Object,
        default: () => ({})
      },
      nested: {
        // 有可能是表格嵌套的组件
        type: Boolean,
        default: false
      },
      view: {
        // 是否是预览
        type: Boolean,
        default: false
      }
    },
    computed: {
      issue() {
        let vm = this;
        return vm.question.issue;
      },
      showVoteProgress() {
        let vm = this;
        if (vm.nested) return false;
        const setting = vm.question.setting || {};
        if (!setting.enableVoteNum) return false;
        return vm.question.showVote;
      }
    },
    created() {
      if (!changeExpr) return;
      let vm = this;
      if (vm.nested) return;
      if (!changeDelay) {
        if (vm.question.disabledProgress) {
          return;
        }
        vm.initProgressWatcher();
      }
    },
    methods: {
      update() {
        let vm = this;
        const question = vm.question;
        if (question.groupQuestionId) return; // 问题组不更新前端缓存
        const answerContent = vm.$bus.cacheAnswerContent;
        let index = answerContent.findIndex(item => item.questonId === question.id);
        if (index > -1) {
          answerContent.splice(index, 1);
        }
        const content = question.getAnswerContent('update');
        answerContent.push(content);
        question.triggerAnswerWatcher(answerContent);
        if (vm.$bus.answerDB) {
          if (vm.changeTimer) clearTimeout(vm.changeTimer);
          vm.changeTimer = setTimeout(() => {
            vm.$bus.answerDB.update(vm.$bus.answerId, answerContent);
            vm.changeTimer = null;
          }, 300);
        }
      },
      initProgressWatcher() {
        let vm = this;
        if (vm.initWatcherFinished) return;
        let question = vm.question;
        let unwatch;
        const changeHandler = () => {
          const isPageProgress = vm.$bus.survey.otherSetting.progressStatus === 2;
          if (isPageProgress) {
            question._progress = true;
            if (!vm.$bus.pageList.every(item => item._progress)) {
              return;
            }
          }
          unwatch && unwatch();
          unwatch = null;
          question.runChange = null;
          // 修改进度条
          vm.$bus.currentCount++;
          this.runPreWatchers();
          if (isPageProgress) {
            vm.$bus.pageList.forEach(item => {
              item.runChange && item.runChange();
            });
          }
        };
        unwatch = vm.$watch(changeExpr, changeHandler);
        question.runChange = changeHandler;
        vm.$watch(changeExpr, () => {
          this.update();
          const items = question.getIssueValue('update');
          if (!items.length) {
            vm.$bus.currentCount--;
            unwatch = vm.$watch(changeExpr, changeHandler);
          }
          question.runHooks('updated');
        });
        vm.$watch('question.content.fileList', () => {
          this.update();
          question.runHooks('updated', 'file');
        });
        vm.initWatcherFinished = true;
      },
      runPreWatchers() {
        let vm = this;
        const pageList = vm.$bus.pageList;
        let index = pageList.findIndex(item => item.id === vm.question.id);
        if (index === -1) return;
        index--; // 当前的不需要执行
        while (index > -1) {
          const q = pageList[index];
          // 已经执行过了 直接退出
          if (q.runChange === null) break;
          if (!q.required) {
            q.runChange && q.runChange();
          }
          index--;
        }
      }
    },
    mounted() {
      let vm = this;
      if (vm.nested) return;
      vm.question.runHooks('mounted');
    },
    beforeMount() {
      const vm = this;
      if (vm.question.disabledProgress) {
        vm.$watch(changeExpr, () => {
          vm.question.runHooks('updated');
        });
        vm.$watch('question.content.fileList', () => {
          vm.question.runHooks('updated', 'file');
        });
        return;
      }
      if (changeDelay) {
        vm.initProgressWatcher();
      }
    }
  };
}
var Blanks$1 = {
  changeExpr: 'changeExpr',
  name: 'Blanks',
  computed: {
    items() {
      // @ts-ignore
      const items = this.issue.items;
      return items.filter(i => i.content);
    },
    changeExpr() {
      // @ts-ignore
      return this.items.map(i => {
        return i.value;
      }).join('-');
    },
    questionErrorText() {
      // @ts-ignore
      return this.question.questionErrorList.map(i => i.message).join('');
    }
  },
  methods: {
    disableCopyMsg() {
      const bus = this.$bus;
      bus.busOption.message(MessageType.WARNING, '禁止复制粘贴');
    },
    onCopy(evt) {
      // @ts-ignore
      if (this.issue.disableCopy) {
        evt.preventDefault();
        this.disableCopyMsg();
        return false;
      }
    },
    onPaste(evt) {
      // @ts-ignore
      if (this.issue.disableCopy) {
        evt.preventDefault();
        this.disableCopyMsg();
        return false;
      }
    },
    onCut(evt) {
      // @ts-ignore
      if (this.issue.disableCopy) {
        evt.preventDefault();
        this.disableCopyMsg();
        return false;
      }
    }
  }
};
function getBus(vm) {
  return vm.$bus;
}
function getPreview(vm) {
  return vm;
}
function getEditSubmitAnswerFn(bus) {
  const params = bus.params;
  if (params.editType === 'agent') return editAnswerByAgent;
  return editAnswer;
}
var answerPreview = {
  data() {
    return {
      list: [],
      isView: true,
      isLastPage: true,
      currentPageNum: 0,
      answeredCount: 0,
      // surveyTitle: '',
      // survey: null,
      isScoreSurvey: false,
      isEditAnswer: false,
      answerId: '',
      pageError: false,
      pageErrorMsg: '页面错误'
    };
  },
  computed: Object.assign({
    showPrevBtn() {
      const vm = getPreview(this);
      return vm.currentPageNum > 1;
    },
    showNextBtn() {
      const vm = getPreview(this);
      return !vm.isLastPage;
    },
    surveyTitle() {
      const vm = getPreview(this);
      const survey = vm.survey || {};
      return survey.titlex || survey.title;
    },
    disableSubmitButton() {
      return false;
    },
    enableQuestionIndex() {
      const vm = getBus(this);
      return vm.enableQuestionIndex;
    }
  }, busGetters(['editSubmit', 'survey', 'params'])),
  created() {
    const vm = this;
    // @ts-ignore
    vm.answerId = this.$route.params.id;
    vm.currentPageNum = 0;
    const bus = getBus(this);
    bus.openLoading();
    if (!bus.accountUserFingerprint) {
      getFinger().then(res => {
        if (bus.params.accountUserFingerprint) {
          bus.accountUserFingerprint = bus.params.accountUserFingerprint;
        } else {
          bus.accountUserFingerprint = res;
        }
        // @ts-ignore
        getSurvey(bus.params).then(res => {
          bus.initSurvey(Object.assign({}, res));
          // 编辑调查员时没有answerid，就去创建一个（调查员库）
          if (vm.answerId === 'null') {
            // @ts-ignore
            this.createStartAnswering();
          } else {
            // @ts-ignore
            this.getNextPage();
          }
        });
      });
    } else {
      // @ts-ignore
      this.getNextPage();
    }
  },
  methods: {
    onEditAnswer() {
      const vm = getPreview(this);
      vm.isEditAnswer = true;
    },
    getAnswerContent(list = []) {
      return new Promise((resolve, reject) => {
        const bus = getBus(this);
        const answerList = [];
        const promises = [];
        for (let i = 0, len = list.length; i < len; i++) {
          let q = list[i];
          let content = q.getAnswerContent('submit');
          if (content.items instanceof Promise) {
            promises.push(content.items.then(res => {
              content.items = [res];
            }));
          }
          answerList.push(content);
          let flag = q.checkAnswer(content, {
            browserInfo: bus.currentBrowserInfo
          });
          if (!flag.success) {
            return reject(Object.assign({
              customError: true
            }, flag, {
              question: q
            }));
          }
        }
        if (promises.length) {
          Promise.all(promises).then(() => {
            resolve(answerList);
          });
        } else {
          resolve(answerList);
        }
      });
    },
    onSubmitEdit() {
      const vm = getPreview(this);
      const bus = getBus(this);
      bus.openLoading();
      this.getAnswerContent(vm.list).then(answerContent => {
        let data = {
          accountUserFingerprint: bus.accountUserFingerprint,
          accountUserId: bus.params.accountUserId,
          id: vm.answerId,
          answerContent
        };
        const fn = getEditSubmitAnswerFn(bus);
        fn(filterParams(data)).then(res => {
          bus.closeLoading();
          vm.isEditAnswer = false;
          if (res.code !== 0) {
            if (res.msg) {
              bus.busOption.message(MessageType.ERROR, res.msg, this);
            } else {
              bus.busOption.message(MessageType.ERROR, '未知错误', this);
            }
          }
          vm.currentPageNum--;
          sendMessage({
            message: "previewSubmit",
            payload: {
              answerId: vm.answerId,
              success: true
            }
          });
          this.getNextPage();
        }).catch(err => {
          var _a;
          bus.closeLoading();
          if (err.customError) {
            bus.busOption.message(MessageType.WARNING, err.message, this);
            (_a = bus.busOption.scroll) === null || _a === void 0 ? void 0 : _a.scrollToQuestion(err.question);
          }
        });
      }).catch(err => {
        var _a;
        bus.closeLoading();
        if (err.customError) {
          bus.busOption.message(MessageType.WARNING, err.message, this);
          (_a = bus.busOption.scroll) === null || _a === void 0 ? void 0 : _a.scrollToQuestion(err.question);
        }
      });
    },
    getPrevPage() {
      const vm = getPreview(this);
      vm.currentPageNum--;
      vm.currentPageNum--;
      this.getNextPage();
    },
    getNextPage() {
      const vm = getPreview(this);
      let answerId = vm.answerId;
      const bus = getBus(this);
      let urlParams = bus.params;
      bus.openLoading();
      getViewAnswer(answerId, vm.currentPageNum, {
        accountUserFingerprint: bus.accountUserFingerprint,
        accountUserId: urlParams.accountUserId,
        token: urlParams.token,
        tenantId: urlParams.tenantId,
        editType: urlParams.editType
      }).then(res => {
        if (res.code !== 0) {
          return Promise.reject(res);
        }
        bus.closeLoading();
        vm.currentPageNum++;
        let data = res.data;
        vm.answeredCount = data.answeredCount;
        vm.list = convertQuestionList(data.nextPage.map(q => {
          getCurrentAnswerHide(q, data.partialHideMap);
          return q;
        }), data.answeredCount + 1, data.answerContent);
        vm.isLastPage = data.isLastPage;
      }).catch(err => {
        if (err.code) {
          bus.closeLoading();
          vm.pageErrorMsg = err.msg;
          addErrorLog({
            surveyId: vm.survey.id,
            answerId: vm.answerId,
            accountUserFingerprint: bus.accountUserFingerprint,
            accountUserId: bus.params.accountUserId,
            answerUrl: window.location.href,
            errTitle: err.msg,
            errInfo: JSON.stringify({
              token: urlParams.token,
              tenantId: urlParams.tenantId
            })
          });
        }
        vm.pageError = true;
      });
    }
  }
};
function getEdit(vm) {
  return vm;
}
function getBus$1(vm) {
  return vm.$bus;
}
function getAnswerContent(list = [], bus, vm) {
  return new Promise((resolve, reject) => {
    const answerList = [];
    const promises = [];
    for (let i = 0, len = list.length; i < len; i++) {
      let q = list[i];
      let content = q.getAnswerContent('submit');
      if (content.items instanceof Promise) {
        promises.push(content.items.then(res => {
          content.items = [res];
        }));
      }
      answerList.push(content);
      let flag = q.checkAnswer(content, {
        browserInfo: bus.currentBrowserInfo
      });
      if (!flag.success) {
        // 调查员修改，增加报错提示
        if (bus.params.editType === 'investigator') {
          vm.sendMessage(flag);
        }
        return reject(Object.assign({
          customError: true
        }, {
          flag
        }, {
          question: q
        }));
      }
    }
    if (promises.length) {
      Promise.all(promises).then(() => {
        resolve(answerList);
      });
    } else {
      resolve(answerList);
    }
  });
}
var investigatorMixin = {
  data() {
    return {
      againPhone: false,
      oldAnswerContent: []
    };
  },
  watch: {
    isEditAnswer(val) {
      const vm = getEdit(this);
      const bus = getBus$1(this);
      if (val) getAnswerContent(vm.list, bus, vm).then(oldAnswerContent => {
        vm.oldAnswerContent = oldAnswerContent;
      });
    }
  },
  methods: {
    // 发送报错提示信息
    sendMessage(flag) {
      const bus = getBus$1(this);
      bus.busOption.message(MessageType.WARNING, flag.message, this);
    },
    // 点击提交事件
    onSubmitEdit() {
      const vm = getEdit(this);
      // 调查员先判断手机号是否重复
      getAnswerIdByPhone({
        investigatorPhone: vm.list[1].issue.value
      }).then(res => {
        if (res.data === null) {
          this.investigatorEdit(1, 0);
        } else {
          vm.againPhone = true;
        }
      });
    },
    // 编辑调查员
    investigatorEdit(nullValueRule, differentValueRule) {
      return __awaiter(this, void 0, void 0, function* () {
        const vm = getEdit(this);
        const bus = getBus$1(this);
        yield getAnswerContent(vm.list, bus, vm).then(answerContent => __awaiter(this, void 0, void 0, function* () {
          if (vm.againPhone) {
            this.saveOldData(answerContent, nullValueRule, differentValueRule);
          }
          yield updateById({
            id: bus.params.id,
            investigatorPhone: answerContent[1].items[0].value
          }).finally(() => {
            let data = {
              accountUserFingerprint: bus.accountUserFingerprint,
              accountUserId: bus.params.accountUserId,
              id: vm.answerId,
              answerContent
            };
            editAnswer(filterParams(data)).finally(() => {
              let data = {
                differentValueRule: differentValueRule,
                nullValueRule: nullValueRule,
                surveyId: vm.survey.id,
                recordSource: 1,
                answerId: vm.answerId,
                investigatorName: answerContent[0].items[0].value,
                investigatorPhone: answerContent[1].items[0].value
              };
              this.updateInvestigator(data, () => {
                bus.busOption.message(MessageType.SUCCESS, '编辑成功', this);
                if (window.top && window.top !== window) {
                  window.top.postMessage(JSON.stringify({
                    message: 'closeEdit'
                  }), '*');
                }
              });
            });
          });
        }));
      });
    },
    // 手机号重复时，根据设置保存数据
    saveOldData(answerContent, nullValueRule, differentValueRule) {
      const vm = getEdit(this);
      answerContent.forEach((item, index) => {
        if (item.items.length === 0 && nullValueRule === 1) {
          // 编辑值为空，保留旧数据
          answerContent[index] = vm.oldAnswerContent[index];
        } else if (vm.oldAnswerContent[index].items.length > 0 && differentValueRule === 1) {
          // 更改数据后，保留旧数据
          answerContent[index] = vm.oldAnswerContent[index];
        }
      });
    },
    // 将改动与调查员数据绑定
    updateInvestigator(data, fun) {
      const bus = getBus$1(this);
      addorUpdateWjInvestigator(data).then(() => {
        fun();
      }).catch(() => {
        bus.busOption.message(MessageType.ERROR, '编辑失败', this);
      });
    },
    // 调查员编辑没有答卷时，创建答卷（调查员库）
    createStartAnswering() {
      const bus = getBus$1(this);
      let data = {
        surveyId: bus.params.surveyId,
        channel: '13',
        answerChannelId: bus.params.answerChannelId,
        accountUserFingerprint: bus.accountUserFingerprint,
        answerUrl: window.location.href.split('#')[0],
        companyid: bus.params.companyid,
        tenantId: bus.params.tenantId
      };
      startAnswering(filterParams(data), {}).then(res => {
        if (res.code !== 0) return;
        let nextPage = res.data.nextPage;
        let answerContent = nextPage.map((item, index) => {
          return {
            activePhotoFiles: [],
            duration: 200,
            items: [{
              colId: '',
              optionId: '',
              rowId: '',
              value: index === 0 ? decodeURI(bus.params.investigatorName) : index === 1 ? bus.params.investigatorPhone : ''
            }],
            questionType: item.questionType,
            questonId: item.id
          };
        });
        this.createSubmitAnswer(res.data.id, answerContent);
      }).catch(err => {
        console.log(err);
      });
    },
    // 调查员编辑没有答卷时的提交以及绑定（调查员库）
    createSubmitAnswer(answerId, data) {
      const bus = getBus$1(this);
      submitAnswer(answerId, data, 0, false, false).then(res => {
        if (res.code !== 0) return;
        let data = {
          answerId: res.data.id,
          differentValueRule: 0,
          nullValueRule: 1,
          recordSource: 1,
          investigatorName: decodeURI(bus.params.investigatorName),
          investigatorPhone: bus.params.investigatorPhone,
          surveyId: bus.params.surveyId
        };
        this.updateInvestigator(data, () => {
          // 创建答卷后刷新页面
          if (window.top && window.top !== window) {
            window.top.postMessage(JSON.stringify({
              message: 'reload'
            }), '*');
          }
        });
      }).catch(err => {
        console.log(err);
      });
    }
  }
};


/***/ }),

/***/ "c54a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__("f3b3");

/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
exports.default = {
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      propName = (0, _util.kebabCase)(propName); // compatible with camel case
      if (props[propName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
      if (events[eventName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};

/***/ }),

/***/ "c5d6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_QTable_vue_vue_type_style_index_0_id_b7de0f60_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("05ee");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_QTable_vue_vue_type_style_index_0_id_b7de0f60_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_QTable_vue_vue_type_style_index_0_id_b7de0f60_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c64c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var isCallable = __webpack_require__("0d52");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "c76d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_VoteProgress_vue_vue_type_style_index_0_id_16e76e8a_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3505");
/* harmony import */ var _node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_VoteProgress_vue_vue_type_style_index_0_id_16e76e8a_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_registry_npmmirror_com_mini_css_extract_plugin_0_9_0_webpack_4_28_4_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_pnpm_registry_npmmirror_com_css_loader_3_6_0_webpack_4_28_4_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_pnpm_registry_npmmirror_com_postcss_loader_3_0_0_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_pnpm_registry_npmmirror_com_sass_loader_8_0_2_node_sass_4_14_1_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_pnpm_registry_npmmirror_com_cache_loader_4_1_0_webpack_4_28_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_pnpm_registry_npmmirror_com_vue_loader_15_11_1_nl733cueh6kngwrfuxx6f6mp5u_node_modules_vue_loader_lib_index_js_vue_loader_options_VoteProgress_vue_vue_type_style_index_0_id_16e76e8a_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c7b3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");
var settle = __webpack_require__("3ac8");
var cookies = __webpack_require__("df1b");
var buildURL = __webpack_require__("2d7b");
var buildFullPath = __webpack_require__("7588");
var parseHeaders = __webpack_require__("9ebc");
var isURLSameOrigin = __webpack_require__("b7d9");
var createError = __webpack_require__("5794");
var defaults = __webpack_require__("64cb");
var Cancel = __webpack_require__("641f");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "c93d":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {

    'use strict';

    var root = window;

    // default options
    var DEFAULTS = {
        // placement of the popper
        placement: 'bottom',

        gpuAcceleration: true,

        // shift popper from its origin by the given amount of pixels (can be negative)
        offset: 0,

        // the element which will act as boundary of the popper
        boundariesElement: 'viewport',

        // amount of pixel used to define a minimum distance between the boundaries and the popper
        boundariesPadding: 5,

        // popper will try to prevent overflow following this order,
        // by default, then, it could overflow on the left and on top of the boundariesElement
        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],

        // the behavior used by flip to change the placement of the popper
        flipBehavior: 'flip',

        arrowElement: '[x-arrow]',

        arrowOffset: 0,

        // list of functions used to modify the offsets before they are applied to the popper
        modifiers: [ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],

        modifiersIgnored: [],

        forceAbsolute: false
    };

    /**
     * Create a new Popper.js instance
     * @constructor Popper
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement|Object} popper
     *      The HTML element used as popper, or a configuration used to generate the popper.
     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
     * @param {Object} options
     * @param {String} [options.placement=bottom]
     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
     *      left(-start, -end)`
     *
     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
     *      reference element.
     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
     *
     * @param {Boolean} [options.gpuAcceleration=true]
     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
     *      browser to use the GPU to accelerate the rendering.
     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
     *
     * @param {Number} [options.offset=0]
     *      Amount of pixels the popper will be shifted (can be negative).
     *
     * @param {String|Element} [options.boundariesElement='viewport']
     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
     *      of the defined boundaries (except if `keepTogether` is enabled)
     *
     * @param {Number} [options.boundariesPadding=5]
     *      Additional padding for the boundaries
     *
     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
     *      this means that the last ones will never overflow
     *
     * @param {String|Array} [options.flipBehavior='flip']
     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
     *      its axis (`right - left`, `top - bottom`).
     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
     *
     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
     *      to this array to edit the offsets and placement.
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Array} [options.modifiersIgnored=[]]
     *      Put here any built-in modifier name you want to exclude from the modifiers list
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Boolean} [options.removeOnDestroy=false]
     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
     */
    function Popper(reference, popper, options) {
        this._reference = reference.jquery ? reference[0] : reference;
        this.state = {};

        // if the popper variable is a configuration object, parse it to generate an HTMLElement
        // generate a default popper if is not defined
        var isNotDefined = typeof popper === 'undefined' || popper === null;
        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
        if (isNotDefined || isConfig) {
            this._popper = this.parse(isConfig ? popper : {});
        }
        // otherwise, use the given HTMLElement as popper
        else {
            this._popper = popper.jquery ? popper[0] : popper;
        }

        // with {} we create a new object with the options inside it
        this._options = Object.assign({}, DEFAULTS, options);

        // refactoring modifiers' list
        this._options.modifiers = this._options.modifiers.map(function(modifier){
            // remove ignored modifiers
            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;

            // set the x-placement attribute before everything else because it could be used to add margins to the popper
            // margins needs to be calculated to get the correct popper offsets
            if (modifier === 'applyStyle') {
                this._popper.setAttribute('x-placement', this._options.placement);
            }

            // return predefined modifier identified by string or keep the custom one
            return this.modifiers[modifier] || modifier;
        }.bind(this));

        // make sure to apply the popper position before any computation
        this.state.position = this._getPosition(this._popper, this._reference);
        setStyle(this._popper, { position: this.state.position, top: 0 });

        // fire the first update to position the popper in the right place
        this.update();

        // setup event listeners, they will take care of update the position in specific situations
        this._setupEventListeners();
        return this;
    }


    //
    // Methods
    //
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */
    Popper.prototype.destroy = function() {
        this._popper.removeAttribute('x-placement');
        this._popper.style.left = '';
        this._popper.style.position = '';
        this._popper.style.top = '';
        this._popper.style[getSupportedPropertyName('transform')] = '';
        this._removeEventListeners();

        // remove the popper if user explicity asked for the deletion on destroy
        if (this._options.removeOnDestroy) {
            this._popper.remove();
        }
        return this;
    };

    /**
     * Updates the position of the popper, computing the new offsets and applying the new style
     * @method
     * @memberof Popper
     */
    Popper.prototype.update = function() {
        var data = { instance: this, styles: {} };

        // store placement inside the data object, modifiers will be able to edit `placement` if needed
        // and refer to _originalPlacement to know the original value
        data.placement = this._options.placement;
        data._originalPlacement = this._options.placement;

        // compute the popper and reference offsets and put them inside data.offsets
        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);

        // get boundaries
        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);

        data = this.runModifiers(data, this._options.modifiers);

        if (typeof this.state.updateCallback === 'function') {
            this.state.updateCallback(data);
        }
    };

    /**
     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onCreate = function(callback) {
        // the createCallbacks return as first argument the popper instance
        callback(this);
        return this;
    };

    /**
     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
     * used to style popper and its arrow.
     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onUpdate = function(callback) {
        this.state.updateCallback = callback;
        return this;
    };

    /**
     * Helper used to generate poppers from a configuration file
     * @method
     * @memberof Popper
     * @param config {Object} configuration
     * @returns {HTMLElement} popper
     */
    Popper.prototype.parse = function(config) {
        var defaultConfig = {
            tagName: 'div',
            classNames: [ 'popper' ],
            attributes: [],
            parent: root.document.body,
            content: '',
            contentType: 'text',
            arrowTagName: 'div',
            arrowClassNames: [ 'popper__arrow' ],
            arrowAttributes: [ 'x-arrow']
        };
        config = Object.assign({}, defaultConfig, config);

        var d = root.document;

        var popper = d.createElement(config.tagName);
        addClassNames(popper, config.classNames);
        addAttributes(popper, config.attributes);
        if (config.contentType === 'node') {
            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
        }else if (config.contentType === 'html') {
            popper.innerHTML = config.content;
        } else {
            popper.textContent = config.content;
        }

        if (config.arrowTagName) {
            var arrow = d.createElement(config.arrowTagName);
            addClassNames(arrow, config.arrowClassNames);
            addAttributes(arrow, config.arrowAttributes);
            popper.appendChild(arrow);
        }

        var parent = config.parent.jquery ? config.parent[0] : config.parent;

        // if the given parent is a string, use it to match an element
        // if more than one element is matched, the first one will be used as parent
        // if no elements are matched, the script will throw an error
        if (typeof parent === 'string') {
            parent = d.querySelectorAll(config.parent);
            if (parent.length > 1) {
                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
            }
            if (parent.length === 0) {
                throw 'ERROR: the given `parent` doesn\'t exists!';
            }
            parent = parent[0];
        }
        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
        // the first one will be used as parent
        if (parent.length > 1 && parent instanceof Element === false) {
            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
            parent = parent[0];
        }

        // append the generated popper to its parent
        parent.appendChild(popper);

        return popper;

        /**
         * Adds class names to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} classes
         */
        function addClassNames(element, classNames) {
            classNames.forEach(function(className) {
                element.classList.add(className);
            });
        }

        /**
         * Adds attributes to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} attributes
         * @example
         * addAttributes(element, [ 'data-info:foobar' ]);
         */
        function addAttributes(element, attributes) {
            attributes.forEach(function(attribute) {
                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
            });
        }

    };

    /**
     * Helper used to get the position which will be applied to the popper
     * @method
     * @memberof Popper
     * @param config {HTMLElement} popper element
     * @param reference {HTMLElement} reference element
     * @returns {String} position
     */
    Popper.prototype._getPosition = function(popper, reference) {
        var container = getOffsetParent(reference);

        if (this._options.forceAbsolute) {
            return 'absolute';
        }

        // Decide if the popper will be fixed
        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
        var isParentFixed = isFixed(reference, container);
        return isParentFixed ? 'fixed' : 'absolute';
    };

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper
     * @access private
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    Popper.prototype._getOffsets = function(popper, reference, placement) {
        placement = placement.split('-')[0];
        var popperOffsets = {};

        popperOffsets.position = this.state.position;
        var isParentFixed = popperOffsets.position === 'fixed';

        //
        // Get reference element position
        //
        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);

        //
        // Get popper sizes
        //
        var popperRect = getOuterSizes(popper);

        //
        // Compute offsets of popper
        //

        // depending by the popper placement we have to compute its offsets slightly differently
        if (['right', 'left'].indexOf(placement) !== -1) {
            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
            if (placement === 'left') {
                popperOffsets.left = referenceOffsets.left - popperRect.width;
            } else {
                popperOffsets.left = referenceOffsets.right;
            }
        } else {
            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
            if (placement === 'top') {
                popperOffsets.top = referenceOffsets.top - popperRect.height;
            } else {
                popperOffsets.top = referenceOffsets.bottom;
            }
        }

        // Add width and height to our offsets object
        popperOffsets.width   = popperRect.width;
        popperOffsets.height  = popperRect.height;

        return {
            popper: popperOffsets,
            reference: referenceOffsets
        };
    };


    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._setupEventListeners = function() {
        // NOTE: 1 DOM access here
        this.state.updateBound = this.update.bind(this);
        root.addEventListener('resize', this.state.updateBound);
        // if the boundariesElement is window we don't need to listen for the scroll event
        if (this._options.boundariesElement !== 'window') {
            var target = getScrollParent(this._reference);
            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
            if (target === root.document.body || target === root.document.documentElement) {
                target = root;
            }
            target.addEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = target;
        }
    };

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._removeEventListeners = function() {
        // NOTE: 1 DOM access here
        root.removeEventListener('resize', this.state.updateBound);
        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = null;
        }
        this.state.updateBound = null;
    };

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper
     * @access private
     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
     * @param {Number} padding - Boundaries padding
     * @param {Element} boundariesElement - Element used to define the boundaries
     * @returns {Object} Coordinates of the boundaries
     */
    Popper.prototype._getBoundaries = function(data, padding, boundariesElement) {
        // NOTE: 1 DOM access here
        var boundaries = {};
        var width, height;
        if (boundariesElement === 'window') {
            var body = root.document.body,
                html = root.document.documentElement;

            height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
            width = Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );

            boundaries = {
                top: 0,
                right: width,
                bottom: height,
                left: 0
            };
        } else if (boundariesElement === 'viewport') {
            var offsetParent = getOffsetParent(this._popper);
            var scrollParent = getScrollParent(this._popper);
            var offsetParentRect = getOffsetRect(offsetParent);

            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
            var getScrollTopValue = function (element) {
                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
            }
            var getScrollLeftValue = function (element) {
                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
            }

            // if the popper is fixed we don't have to substract scrolling from the boundaries
            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);

            boundaries = {
                top: 0 - (offsetParentRect.top - scrollTop),
                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
                left: 0 - (offsetParentRect.left - scrollLeft)
            };
        } else {
            if (getOffsetParent(this._popper) === boundariesElement) {
                boundaries = {
                    top: 0,
                    left: 0,
                    right: boundariesElement.clientWidth,
                    bottom: boundariesElement.clientHeight
                };
            } else {
                boundaries = getOffsetRect(boundariesElement);
            }
        }
        boundaries.left += padding;
        boundaries.right -= padding;
        boundaries.top = boundaries.top + padding;
        boundaries.bottom = boundaries.bottom - padding;
        return boundaries;
    };


    /**
     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
     * @method
     * @memberof Popper
     * @access public
     * @param {Object} data
     * @param {Array} modifiers
     * @param {Function} ends
     */
    Popper.prototype.runModifiers = function(data, modifiers, ends) {
        var modifiersToRun = modifiers.slice();
        if (ends !== undefined) {
            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
        }

        modifiersToRun.forEach(function(modifier) {
            if (isFunction(modifier)) {
                data = modifier.call(this, data);
            }
        }.bind(this));

        return data;
    };

    /**
     * Helper used to know if the given modifier depends from another one.
     * @method
     * @memberof Popper
     * @param {String} requesting - name of requesting modifier
     * @param {String} requested - name of requested modifier
     * @returns {Boolean}
     */
    Popper.prototype.isModifierRequired = function(requesting, requested) {
        var index = getArrayKeyIndex(this._options.modifiers, requesting);
        return !!this._options.modifiers.slice(0, index).filter(function(modifier) {
            return modifier === requested;
        }).length;
    };

    //
    // Modifiers
    //

    /**
     * Modifiers list
     * @namespace Popper.modifiers
     * @memberof Popper
     * @type {Object}
     */
    Popper.prototype.modifiers = {};

    /**
     * Apply the computed styles to the popper element
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The same data object
     */
    Popper.prototype.modifiers.applyStyle = function(data) {
        // apply the final offsets to the popper
        // NOTE: 1 DOM access here
        var styles = {
            position: data.offsets.popper.position
        };

        // round top and left to avoid blurry text
        var left = Math.round(data.offsets.popper.left);
        var top = Math.round(data.offsets.popper.top);

        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
        // we automatically use the supported prefixed version if needed
        var prefixedProperty;
        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles.top = 0;
            styles.left = 0;
        }
        // othwerise, we use the standard `left` and `top` properties
        else {
            styles.left =left;
            styles.top = top;
        }

        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        Object.assign(styles, data.styles);

        setStyle(this._popper, styles);

        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
        // NOTE: 1 DOM access here
        this._popper.setAttribute('x-placement', data.placement);

        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
            setStyle(data.arrowElement, data.offsets.arrow);
        }

        return data;
    };

    /**
     * Modifier used to shift the popper on the start or end of its reference element side
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.shift = function(data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftVariation = placement.split('-')[1];

        // if shift shiftVariation is specified, run the modifier
        if (shiftVariation) {
            var reference = data.offsets.reference;
            var popper = getPopperClientRect(data.offsets.popper);

            var shiftOffsets = {
                y: {
                    start:  { top: reference.top },
                    end:    { top: reference.top + reference.height - popper.height }
                },
                x: {
                    start:  { left: reference.left },
                    end:    { left: reference.left + reference.width - popper.width }
                }
            };

            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';

            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
        }

        return data;
    };


    /**
     * Modifier used to make sure the popper does not overflows from it's boundaries
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.preventOverflow = function(data) {
        var order = this._options.preventOverflowOrder;
        var popper = getPopperClientRect(data.offsets.popper);

        var check = {
            left: function() {
                var left = popper.left;
                if (popper.left < data.boundaries.left) {
                    left = Math.max(popper.left, data.boundaries.left);
                }
                return { left: left };
            },
            right: function() {
                var left = popper.left;
                if (popper.right > data.boundaries.right) {
                    left = Math.min(popper.left, data.boundaries.right - popper.width);
                }
                return { left: left };
            },
            top: function() {
                var top = popper.top;
                if (popper.top < data.boundaries.top) {
                    top = Math.max(popper.top, data.boundaries.top);
                }
                return { top: top };
            },
            bottom: function() {
                var top = popper.top;
                if (popper.bottom > data.boundaries.bottom) {
                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
                }
                return { top: top };
            }
        };

        order.forEach(function(direction) {
            data.offsets.popper = Object.assign(popper, check[direction]());
        });

        return data;
    };

    /**
     * Modifier used to make sure the popper is always near its reference
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.keepTogether = function(data) {
        var popper  = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var f = Math.floor;

        if (popper.right < f(reference.left)) {
            data.offsets.popper.left = f(reference.left) - popper.width;
        }
        if (popper.left > f(reference.right)) {
            data.offsets.popper.left = f(reference.right);
        }
        if (popper.bottom < f(reference.top)) {
            data.offsets.popper.top = f(reference.top) - popper.height;
        }
        if (popper.top > f(reference.bottom)) {
            data.offsets.popper.top = f(reference.bottom);
        }

        return data;
    };

    /**
     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
     * Requires the `preventOverflow` modifier before it in order to work.
     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.flip = function(data) {
        // check if preventOverflow is in the list of modifiers before the flip modifier.
        // otherwise flip would not work as expected.
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
            return data;
        }

        if (data.flipped && data.placement === data._originalPlacement) {
            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
            return data;
        }

        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';

        var flipOrder = [];
        if(this._options.flipBehavior === 'flip') {
            flipOrder = [
                placement,
                placementOpposite
            ];
        } else {
            flipOrder = this._options.flipBehavior;
        }

        flipOrder.forEach(function(step, index) {
            if (placement !== step || flipOrder.length === index + 1) {
                return;
            }

            placement = data.placement.split('-')[0];
            placementOpposite = getOppositePlacement(placement);

            var popperOffsets = getPopperClientRect(data.offsets.popper);

            // this boolean is used to distinguish right and bottom from top and left
            // they need different computations to get flipped
            var a = ['right', 'bottom'].indexOf(placement) !== -1;

            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
            if (
                a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) ||
                !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])
            ) {
                // we'll use this boolean to detect any flip loop
                data.flipped = true;
                data.placement = flipOrder[index + 1];
                if (variation) {
                    data.placement += '-' + variation;
                }
                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;

                data = this.runModifiers(data, this._options.modifiers, this._flip);
            }
        }.bind(this));
        return data;
    };

    /**
     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
     * The offsets will shift the popper on the side of its reference element.
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.offset = function(data) {
        var offset = this._options.offset;
        var popper  = data.offsets.popper;

        if (data.placement.indexOf('left') !== -1) {
            popper.top -= offset;
        }
        else if (data.placement.indexOf('right') !== -1) {
            popper.top += offset;
        }
        else if (data.placement.indexOf('top') !== -1) {
            popper.left -= offset;
        }
        else if (data.placement.indexOf('bottom') !== -1) {
            popper.left += offset;
        }
        return data;
    };

    /**
     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.arrow = function(data) {
        var arrow  = this._options.arrowElement;
        var arrowOffset = this._options.arrowOffset;

        // if the arrowElement is a string, suppose it's a CSS selector
        if (typeof arrow === 'string') {
            arrow = this._popper.querySelector(arrow);
        }

        // if arrow element is not found, don't run the modifier
        if (!arrow) {
            return data;
        }

        // the arrow element must be child of its popper
        if (!this._popper.contains(arrow)) {
            console.warn('WARNING: `arrowElement` must be child of its popper element!');
            return data;
        }

        // arrow depends on keepTogether in order to work
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
            return data;
        }

        var arrowStyle  = {};
        var placement   = data.placement.split('-')[0];
        var popper      = getPopperClientRect(data.offsets.popper);
        var reference   = data.offsets.reference;
        var isVertical  = ['left', 'right'].indexOf(placement) !== -1;

        var len         = isVertical ? 'height' : 'width';
        var side        = isVertical ? 'top' : 'left';
        var translate   = isVertical ? 'translateY' : 'translateX';
        var altSide     = isVertical ? 'left' : 'top';
        var opSide      = isVertical ? 'bottom' : 'right';
        var arrowSize   = getOuterSizes(arrow)[len];

        //
        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
        //

        // top/left side
        if (reference[opSide] - arrowSize < popper[side]) {
            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
        }
        // bottom/right side
        if (reference[side] + arrowSize > popper[opSide]) {
            data.offsets.popper[side] += (reference[side] + arrowSize) - popper[opSide];
        }

        // compute center of the popper
        var center = reference[side] + (arrowOffset || (reference[len] / 2) - (arrowSize / 2));

        var sideValue = center - popper[side];

        // prevent arrow from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
        arrowStyle[side] = sideValue;
        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

        data.offsets.arrow = arrowStyle;
        data.arrowElement = arrow;

        return data;
    };


    //
    // Helpers
    //

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
        // NOTE: 1 DOM access here
        var _display = element.style.display, _visibility = element.style.visibility;
        element.style.display = 'block'; element.style.visibility = 'hidden';
        var calcWidthToForceRepaint = element.offsetWidth;

        // original method
        var styles = root.getComputedStyle(element);
        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };

        // reset element styles
        element.style.display = _display; element.style.visibility = _visibility;
        return result;
    }

    /**
     * Get the opposite placement of the given one/
     * @function
     * @ignore
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
        var hash = {left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
        return placement.replace(/left|right|bottom|top/g, function(matched){
            return hash[matched];
        });
    }

    /**
     * Given the popper offsets, generate an output similar to getBoundingClientRect
     * @function
     * @ignore
     * @argument {Object} popperOffsets
     * @returns {Object} ClientRect like output
     */
    function getPopperClientRect(popperOffsets) {
        var offsets = Object.assign({}, popperOffsets);
        offsets.right = offsets.left + offsets.width;
        offsets.bottom = offsets.top + offsets.height;
        return offsets;
    }

    /**
     * Given an array and the key to find, returns its index
     * @function
     * @ignore
     * @argument {Array} arr
     * @argument keyToFind
     * @returns index or null
     */
    function getArrayKeyIndex(arr, keyToFind) {
        var i = 0, key;
        for (key in arr) {
            if (arr[key] === keyToFind) {
                return i;
            }
            i++;
        }
        return null;
    }

    /**
     * Get CSS computed property of the given element
     * @function
     * @ignore
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
        // NOTE: 1 DOM access here
        var css = root.getComputedStyle(element, null);
        return css[property];
    }

    /**
     * Returns the offset parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent;
        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
    }

    /**
     * Returns the scrolling parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {
            return element;
        }

        if (parent === root.document) {
            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
            // greater than 0 and return the proper element
            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
                return root.document.body;
            } else {
                return root.document.documentElement;
            }
        }

        // Firefox want us to check `-x` and `-y` variations as well
        if (
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
        ) {
            // If the detected scrollParent is body, we perform an additional check on its parentNode
            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
            // fixes issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @function
     * @ignore
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
        if (element === root.document.body) {
            return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
            return true;
        }
        return element.parentNode ? isFixed(element.parentNode) : element;
    }

    /**
     * Set the style to the given popper
     * @function
     * @ignore
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
     */
    function setStyle(element, styles) {
        function is_numeric(n) {
            return (n !== '' && !isNaN(parseFloat(n)) && isFinite(n));
        }
        Object.keys(styles).forEach(function(prop) {
            var unit = '';
            // add unit if the value is numeric and is one of the following
            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
                unit = 'px';
            }
            element.style[prop] = styles[prop] + unit;
        });
    }

    /**
     * Check if the given variable is a function
     * @function
     * @ignore
     * @argument {*} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get the position of the given element, relative to its offset parent
     * @function
     * @ignore
     * @param {Element} element
     * @return {Object} position - Coordinates of the element and its `scrollTop`
     */
    function getOffsetRect(element) {
        var elementRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
            left: element.offsetLeft,
            top: element.offsetTop
        };

        elementRect.right = elementRect.left + elementRect.width;
        elementRect.bottom = elementRect.top + elementRect.height;

        // position
        return elementRect;
    }

    /**
     * Get bounding client rect of given element
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
        var rect = element.getBoundingClientRect();

        // whether the IE version is lower than 11
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;

        // fix ie document bounding top always 0 bug
        var rectTop = isIE && element.tagName === 'HTML'
            ? -element.scrollTop
            : rect.top;

        return {
            left: rect.left,
            top: rectTop,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.right - rect.left,
            height: rect.bottom - rectTop
        };
    }

    /**
     * Given an element and one of its parents, return the offset
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @return {Object} rect
     */
    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
        var elementRect = getBoundingClientRect(element);
        var parentRect = getBoundingClientRect(parent);

        if (fixed) {
            var scrollParent = getScrollParent(parent);
            parentRect.top += scrollParent.scrollTop;
            parentRect.bottom += scrollParent.scrollTop;
            parentRect.left += scrollParent.scrollLeft;
            parentRect.right += scrollParent.scrollLeft;
        }

        var rect = {
            top: elementRect.top - parentRect.top ,
            left: elementRect.left - parentRect.left ,
            bottom: (elementRect.top - parentRect.top) + elementRect.height,
            right: (elementRect.left - parentRect.left) + elementRect.width,
            width: elementRect.width,
            height: elementRect.height
        };
        return rect;
    }

    /**
     * Get the prefixed supported property name
     * @function
     * @ignore
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase)
     */
    function getSupportedPropertyName(property) {
        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
            if (typeof root.document.body.style[toCheck] !== 'undefined') {
                return toCheck;
            }
        }
        return null;
    }

    /**
     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
     * objects to a target object. It will return the target object.
     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
     * @function
     * @ignore
     */
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function(target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }

    return Popper;
}));


/***/ }),

/***/ "ca07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__("37d8");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "cdb3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayToReversed = __webpack_require__("db11");
var ArrayBufferViewCore = __webpack_require__("799f");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});


/***/ }),

/***/ "ced4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d080":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("7630");
var hasOwn = __webpack_require__("80a8");
var toIndexedObject = __webpack_require__("2703");
var indexOf = __webpack_require__("8e6f").indexOf;
var hiddenKeys = __webpack_require__("099b");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "d1cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d246":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

/***/ }),

/***/ "d7d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "da05":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 96);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "el-button",
      class: [
        _vm.type ? "el-button--" + _vm.type : "",
        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
        {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/button/src/button.vue"
/* harmony default export */ var src_button = (component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */
src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);

/***/ })

/******/ });

/***/ }),

/***/ "db11":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__("2e86");

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};


/***/ }),

/***/ "db2d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    },
    empty: {
      description: '暂无数据'
    }
  }
};

/***/ }),

/***/ "db93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__("2648").version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "df1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "e043":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("f938");
var isNullOrUndefined = __webpack_require__("01da");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "e2a4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("0d52");
var $documentAll = __webpack_require__("f385");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "e4be":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("e2a4");
var classof = __webpack_require__("37cd");
var wellKnownSymbol = __webpack_require__("eebc");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ "e63d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "e7d4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__("eed0");
var store = __webpack_require__("f499");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "eb0a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("37cd");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ "eb72":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("2f9c");
var isCallable = __webpack_require__("0d52");
var isObject = __webpack_require__("e2a4");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ee1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "ee94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+@vue+cli-service@4.5.19_vgqb3v6m2ynwvuzumqmye2vzna/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/components/PreviewQuestion.vue?vue&type=template&id=1dfc97bc
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "question-item bg-white box-border px-10 py-4"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    class: {
      'unknown-wrap': _vm.question.issue.show_unknown
    }
  }, [_c('div', {
    ref: "title",
    staticClass: "q-title leading-22 break-words",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('div', {
    staticClass: "q-desc-wrap",
    class: [_vm.isOverFlowNote ? 'pb-8' : '']
  }, [_vm.showNote ? _c('div', {
    ref: "note",
    staticClass: "q-desc break-words leading-22 pl-5",
    class: _vm.getNoteClass
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.note)
    }
  })]) : _vm._e(), _vm.isOverFlowNote ? _c('div', {
    staticClass: "operate-btn cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.isOpenNote = !_vm.isOpenNote;
      }
    }
  }, [_c('span', {
    staticClass: "text-theme"
  }, [_vm._v(_vm._s(_vm.isOpenNote ? '收起' : '展开'))]), _c('span', [_c('i', {
    class: _vm.isOpenNote ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
  })])]) : _vm._e()]), _c('div', {
    ref: "qContent",
    staticClass: "q-content pl-7.5 mt-3"
  }, [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "question": _vm.question,
      "view": ""
    }
  })], 1), _vm.content.allowPhotoNum && _vm.content.allowPhotoNum > 0 ? [_c('div', {
    staticClass: "pl-7.5"
  }, [_c('adapter-upload-files', {
    attrs: {
      "content": _vm.content
    }
  })], 1)] : _vm._e(), _vm.hasAnswerScore ? _c('div', {
    staticClass: "pl-7.5 mt-2"
  }, [_c('div', {
    staticClass: "bg-card-bg-gray py-4 px-4 mt-2 leading-18 rounded-small"
  }, [!_vm.isCorrectAnswer ? _c('div', [_c('span', {
    staticClass: "correct-answer correct-error text-danger"
  }, [_vm._v("回答错误 +0分")])]) : _c('div', [_c('span', {
    staticClass: "text-green-theme"
  }, [_vm._v("回答正确 " + _vm._s(_vm.score > 0 ? '+' + _vm.score : _vm.score) + "分")])]), _vm.answerScore.answerAnalysis ? _c('div', [_c('span', {
    staticClass: "text"
  }, [_vm._v("答案解析：")]), _c('span', {
    staticClass: "analysis",
    domProps: {
      "innerHTML": _vm._s(_vm.answerScore.answerAnalysis)
    }
  })]) : _vm._e()])]) : _vm._e()], 2)]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/PreviewQuestion.vue?vue&type=template&id=1dfc97bc

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/components/QuestionItem.vue?vue&type=template&id=418222d6
var QuestionItemvue_type_template_id_418222d6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "question-item bg-white box-border px-10 py-4",
    attrs: {
      "data-id": _vm.question.q_id
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    class: {
      'unknown-wrap': _vm.question.issue.show_unknown
    }
  }, [_c('div', {
    ref: "title",
    staticClass: "q-title leading-22 break-words",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('div', {
    staticClass: "q-desc-wrap",
    class: [_vm.isOverFlowNote ? 'pb-8' : '']
  }, [_vm.showNote ? _c('div', {
    ref: "note",
    staticClass: "q-desc break-words leading-22 pl-5",
    class: _vm.getNoteClass
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.note)
    }
  })]) : _vm._e(), _vm.isOverFlowNote ? _c('div', {
    staticClass: "operate-btn cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.isOpenNote = !_vm.isOpenNote;
      }
    }
  }, [_c('span', {
    staticClass: "text-theme"
  }, [_vm._v(_vm._s(_vm.isOpenNote ? '收起' : '展开'))]), _c('span', [_c('i', {
    class: _vm.isOpenNote ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
  })])]) : _vm._e()]), _c('div', {
    ref: "qContent",
    staticClass: "q-content pl-5 mt-3"
  }, [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "question": _vm.question
    }
  })], 1), _vm.content.allowPhotoNum && _vm.content.allowPhotoNum > 0 ? [_c('div', {
    staticClass: "pl-5"
  }, [_c('adapter-upload-files', {
    attrs: {
      "content": _vm.content
    }
  })], 1)] : _vm._e()], 2)]);
};
var QuestionItemvue_type_template_id_418222d6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/QuestionItem.vue?vue&type=template&id=418222d6

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+core-js@3.33.2/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("58f3");

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/packages/dygc/dist/dygc.esm-bundler.js
var dygc_esm_bundler = __webpack_require__("c512");

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleChoice.vue?vue&type=template&id=a784a754
var SingleChoicevue_type_template_id_a784a754_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "single-choice"
  }, [_c('el-radio-group', {
    staticClass: "w-full",
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, _vm._l(_vm.issue.item_groups, function (group, index) {
    return _c('div', {
      key: index,
      staticClass: "items-group mb-4 last:mb-0"
    }, [_c('div', {
      staticClass: "cg-title text-base mb-2"
    }, [_c('span', [_vm._v(" " + _vm._s(group.title))])]), _c('ul', {
      staticClass: "cg-content",
      style: _vm.gridStyle
    }, _vm._l(group.options, function (item) {
      return _c('li', {
        key: item.id,
        staticClass: "mb-2 last:mb-0"
      }, [_c('single-choice-item', {
        class: {
          checked: _vm.issue.select === item.id
        },
        attrs: {
          "item": item,
          "selected": _vm.issue.select === item.id,
          "correct-answer-list": _vm.correctAnswerList,
          "question-id": _vm.question.id,
          "question-type": _vm.question.questionType,
          "enable-relation": item.setting.enableRelation
        },
        on: {
          "click": function ($event) {
            _vm.issue.select = item.id;
          }
        },
        scopedSlots: _vm._u([{
          key: "vote",
          fn: function () {
            return [_vm.showVoteProgress && _vm.changeExpr ? _c('vote-progress', {
              attrs: {
                "vote": _vm.question.vote,
                "label": item.id,
                "checked": _vm.issue.select === item.id,
                "selected": !!_vm.issue.select
              }
            }) : _vm._e()];
          },
          proxy: true
        }], null, true)
      })], 1);
    }), 0)]);
  }), 0)], 1);
};
var SingleChoicevue_type_template_id_a784a754_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/SingleChoice.vue?vue&type=template&id=a784a754

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/SingleChoiceItem.vue?vue&type=template&id=cc91cad8&scoped=true
var SingleChoiceItemvue_type_template_id_cc91cad8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "single-choice-item choice-item cursor-pointer flex-1"
  }, [_c('div', [_c('adapter-radio', {
    staticClass: "px-3 py-2.5",
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.item.id,
      "rich-text": _vm.itemText,
      "tip": _vm.item.tips
    }
  }, [_c('div', {
    ref: "text",
    staticClass: "text-medium leading-base",
    domProps: {
      "innerHTML": _vm._s(_vm.itemText)
    }
  })])], 1), _vm.selected ? [_vm.item.is_other_item ? _c('relation-input', {
    staticClass: "mt-1 px-3 pb-2",
    attrs: {
      "type": _vm.item.inputType,
      "option-id": _vm.item.id,
      "question-id": _vm.questionId,
      "question-type": _vm.questionType,
      "enable-relation": _vm.enableRelation,
      "max-length": _vm.item.maxLength,
      "min-length": _vm.item.minLength,
      "validate": _vm.item.validate,
      "enabled-error-tip": _vm.enabledErrorTip,
      "allow-error-list": _vm.item.allowErrorList,
      "placeholder": _vm.item.placeholder
    },
    model: {
      value: _vm.item.value,
      callback: function ($$v) {
        _vm.$set(_vm.item, "value", $$v);
      },
      expression: "item.value"
    }
  }) : _vm._e(), _c('adapter-upload-files', {
    staticClass: "mb-2",
    attrs: {
      "content": _vm.item.content
    }
  })] : _vm._e(), _vm._t("vote")], 2), _vm.correctAnswerList.length ? _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm.correct ? [_c('div', {
    staticClass: "flex flex-col text-center py-2"
  }, [_vm.correct.score ? _c('span', {
    staticClass: "text-theme-black-450 text-medium"
  }, [_vm._v(_vm._s(_vm.correct.score) + "分")]) : _vm._e(), _c('span', {
    staticClass: "text-green-theme text-medium"
  }, [_vm._v("正确答案")])])] : _vm._e()], 2) : _vm._e()]);
};
var SingleChoiceItemvue_type_template_id_cc91cad8_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/SingleChoiceItem.vue?vue&type=template&id=cc91cad8&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/AdapterUploadFiles.vue?vue&type=template&id=7c6e14f6
var AdapterUploadFilesvue_type_template_id_7c6e14f6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShow ? _c('upload-files', {
    attrs: {
      "max": _vm.content.allowPhotoNum,
      "min": _vm.content.allowMinPhotoNum,
      "allow-types": _vm.content.allowFileTypes
    },
    model: {
      value: _vm.content.fileList,
      callback: function ($$v) {
        _vm.$set(_vm.content, "fileList", $$v);
      },
      expression: "content.fileList"
    }
  }) : _vm._e();
};
var AdapterUploadFilesvue_type_template_id_7c6e14f6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/AdapterUploadFiles.vue?vue&type=template&id=7c6e14f6

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/UploadFiles.vue?vue&type=template&id=1531687a
var UploadFilesvue_type_template_id_1531687a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "upload-file"
  }, [_c('input', {
    ref: "uploadEl",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": `upload-file-${_vm.fid}`,
      "multiple": ""
    }
  }), _c('div', [_c('ul', {
    staticClass: "mt-2"
  }, _vm._l(_vm.value, function (file, index) {
    return _c('li', {
      key: file.url,
      staticClass: "mb-2 last:mb-0 relative"
    }, [_c('file-item', {
      staticClass: "upload-file-item",
      attrs: {
        "file": file,
        "view": _vm.view
      },
      on: {
        "remove": function ($event) {
          return _vm.removeFile(index);
        }
      }
    })], 1);
  }), 0)]), _vm.showUploadBtn ? _c('div', {
    staticClass: "before-file-upload mt-2"
  }, [_c('label', {
    staticClass: "block py-2 cursor-pointer",
    attrs: {
      "for": `upload-file-${_vm.fid}`
    }
  }, [_c('span', [_vm._v("上传附件（" + _vm._s(_vm.text) + _vm._s(_vm.uploadFileMaxSize) + "M以内）")])])]) : _vm._e()]);
};
var UploadFilesvue_type_template_id_1531687a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/UploadFiles.vue?vue&type=template&id=1531687a

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/theme-chalk/loading.css
var loading = __webpack_require__("8053");

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/theme-chalk/base.css
var base = __webpack_require__("63ff");

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/loading.js
var lib_loading = __webpack_require__("86db");
var lib_loading_default = /*#__PURE__*/__webpack_require__.n(lib_loading);

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/theme-chalk/message.css
var message = __webpack_require__("68c4");

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/message.js
var lib_message = __webpack_require__("680d");
var lib_message_default = /*#__PURE__*/__webpack_require__.n(lib_message);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/FileItem.vue?vue&type=template&id=63bb33c3&scoped=true
var FileItemvue_type_template_id_63bb33c3_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container",
    on: {
      "click": _vm.onClick
    }
  }, [!_vm.isImage ? _c('div', {
    staticClass: "truncate text-theme"
  }, [_vm._v(_vm._s(_vm.fileName))]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.fileUrl,
      "width": "120"
    },
    on: {
      "load": _vm.onLoad
    }
  })]), !_vm.view ? _c('div', {
    staticClass: "cancel-file cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.removeFile.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "cancel-icon"
  })]) : _vm._e()]);
};
var FileItemvue_type_template_id_63bb33c3_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/FileItem.vue?vue&type=template&id=63bb33c3&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!/root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/image/src/image-viewer.vue?vue&type=template&id=726a07b0
var image_viewervue_type_template_id_726a07b0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c('div', {
    ref: "el-image-viewer__wrapper",
    staticClass: "el-image-viewer__wrapper",
    style: {
      'z-index': _vm.viewerZIndex
    },
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "el-image-viewer__mask",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.handleMaskClick.apply(null, arguments);
      }
    }
  }), _c('span', {
    staticClass: "el-image-viewer__btn el-image-viewer__close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), !_vm.isSingle ? [_c('span', {
    staticClass: "el-image-viewer__btn el-image-viewer__prev",
    class: {
      'is-disabled': !_vm.infinite && _vm.isFirst
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _c('span', {
    staticClass: "el-image-viewer__btn el-image-viewer__next",
    class: {
      'is-disabled': !_vm.infinite && _vm.isLast
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])] : _vm._e(), _c('div', {
    staticClass: "el-image-viewer__btn el-image-viewer__actions"
  }, [_c('div', {
    staticClass: "el-image-viewer__actions__inner"
  }, [_c('i', {
    staticClass: "el-icon-zoom-out",
    on: {
      "click": function ($event) {
        return _vm.handleActions('zoomOut');
      }
    }
  }), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function ($event) {
        return _vm.handleActions('zoomIn');
      }
    }
  }), _c('i', {
    staticClass: "el-image-viewer__actions__divider"
  }), _c('i', {
    class: _vm.mode.icon,
    on: {
      "click": _vm.toggleMode
    }
  }), _c('i', {
    staticClass: "el-image-viewer__actions__divider"
  }), _c('i', {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function ($event) {
        return _vm.handleActions('anticlocelise');
      }
    }
  }), _c('i', {
    staticClass: "el-icon-refresh-right",
    on: {
      "click": function ($event) {
        return _vm.handleActions('clocelise');
      }
    }
  })])]), _c('div', {
    staticClass: "el-image-viewer__canvas"
  }, _vm._l(_vm.urlList, function (url, i) {
    return i === _vm.index ? _c('img', {
      key: url,
      ref: "img",
      refInFor: true,
      staticClass: "el-image-viewer__img",
      style: _vm.imgStyle,
      attrs: {
        "src": _vm.currentImg
      },
      on: {
        "load": _vm.handleImgLoad,
        "error": _vm.handleImgError,
        "mousedown": _vm.handleMouseDown
      }
    }) : _vm._e();
  }), 0)], 2)]);
};
var image_viewervue_type_template_id_726a07b0_staticRenderFns = [];

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/image/src/image-viewer.vue?vue&type=template&id=726a07b0

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/dom.js
/* istanbul ignore next */



const isServer = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer;
const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
const trim = function(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
const camelCase = function(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
const on = (function() {
  if (!isServer && document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
const off = (function() {
  if (!isServer && document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
const once = function(el, event, fn) {
  var listener = function() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
const getStyle = ieVersion < 9 ? function(element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function(element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if (typeof styleName === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

const isScroll = (el, vertical) => {
  if (isServer) return;

  const determinedDirection = vertical !== null && vertical !== undefined;
  const overflow = determinedDirection
    ? vertical
      ? getStyle(el, 'overflow-y')
      : getStyle(el, 'overflow-x')
    : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

const getScrollContainer = (el, vertical) => {
  if (isServer) return;

  let parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

const isInContainer = (el, container) => {
  if (isServer || !el || !container) return false;

  const elRect = el.getBoundingClientRect();
  let containerRect;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom &&
    elRect.bottom > containerRect.top &&
    elRect.right > containerRect.left &&
    elRect.left < containerRect.right;
};

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/types.js


function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

/**
 *  - Inspired:
 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
 */
let isFunction = (functionToCheck) => {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

if ( true && typeof Int8Array !== 'object' && (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer || typeof document.childNodes !== 'function')) {
  isFunction = function(obj) {
    return typeof obj === 'function' || false;
  };
}



const isUndefined = (val)=> {
  return val === void 0;
};

const isDefined = (val) => {
  return val !== undefined && val !== null;
};

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/util.js



const util_hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return util_hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (let key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

const getValueByPath = function(object, prop) {
  prop = prop || '';
  const paths = prop.split('.');
  let current = object;
  let result = null;
  for (let i = 0, j = paths.length; i < j; i++) {
    const path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  let keyArr = path.split('.');
  let i = 0;
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    let key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

const generateId = function() {
  return Math.floor(Math.random() * 10000);
};

const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

const escapeRegexpString = (value = '') => String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

// TODO: use native Array.find, Array.findIndex when IE support is dropped
const arrayFindIndex = function(arr, pred) {
  for (let i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

const arrayFind = function(arr, pred) {
  const idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
const coerceTruthyValueToArray = function(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

const isIE = function() {
  return !external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer && !isNaN(Number(document.documentMode));
};

const isEdge = function() {
  return !external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

const isFirefox = function() {
  return !external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

const autoprefixer = function(style) {
  if (typeof style !== 'object') return style;
  const rules = ['transform', 'transition', 'animation'];
  const prefixes = ['ms-', 'webkit-'];
  rules.forEach(rule => {
    const value = style[rule];
    if (rule && value) {
      prefixes.forEach(prefix => {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

const kebabCase = function(str) {
  const hyphenateRE = /([^-])([A-Z])/g;
  return str
    .replace(hyphenateRE, '$1-$2')
    .replace(hyphenateRE, '$1-$2')
    .toLowerCase();
};

const capitalize = function(str) {
  if (!isString(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const looseEqual = function(a, b) {
  const isObjectA = isObject(a);
  const isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

const arrayEquals = function(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (let i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

const isEqual = function(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

const isEmpty = function(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]': {
      return !val.size;
    }
    // Plain Object
    case '[object Object]': {
      return !Object.keys(val).length;
    }
  }

  return false;
};

function rafThrottle(fn) {
  let locked = false;
  return function(...args) {
    if (locked) return;
    locked = true;
    window.requestAnimationFrame(_ => {
      fn.apply(this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

const isMac = function() {
  return !external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer && /macintosh|mac os x/i.test(navigator.userAgent);
};

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/merge.js
/* harmony default export */ var merge = (function(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
});;

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/popup/popup-manager.js



let hasModal = false;
let hasInitZIndex = false;
let popup_manager_zIndex;

const getModal = function() {
  if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer) return;
  let modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function() {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

const instances = {};

const PopupManager = {
  modalFade: true,

  getInstance: function(id) {
    return instances[id];
  },

  register: function(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function() {
    const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    const instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function(id, zIndex, dom, modalClass, modalFade) {
    if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    const modalStack = this.modalStack;

    for (let i = 0, j = modalStack.length; i < j; i++) {
      const item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    const modalDom = getModal();

    addClass(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      addClass(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      let classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(item => addClass(modalDom, item));
    }
    setTimeout(() => {
      removeClass(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function(id) {
    const modalStack = this.modalStack;
    const modalDom = getModal();

    if (modalStack.length > 0) {
      const topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          let classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(item => removeClass(modalDom, item));
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (let i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        addClass(modalDom, 'v-modal-leave');
      }
      setTimeout(() => {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        removeClass(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get() {
    if (!hasInitZIndex) {
      popup_manager_zIndex = popup_manager_zIndex || (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return popup_manager_zIndex;
  },
  set(value) {
    popup_manager_zIndex = value;
  }
});

const getTopPopup = function() {
  if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    const topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    const instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function(event) {
    if (event.keyCode === 27) {
      const topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose
          ? topPopup.handleClose()
          : (topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close());
      }
    }
  });
}

/* harmony default export */ var popup_manager = (PopupManager);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/scrollbar-width.js


let scrollBarWidth;

/* harmony default export */ var scrollbar_width = (function() {
  if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  const outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
});;

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/popup/index.js






let idSeed = 1;

let popup_scrollBarWidth;

/* harmony default export */ var popup = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    popup_manager.register(this._popupId, this);
  },

  beforeDestroy() {
    popup_manager.deregister(this._popupId);
    popup_manager.closeModal(this._popupId);

    this.restoreBodyStyle();
  },

  data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },

  watch: {
    visible(val) {
      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick(() => {
            this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open(options) {
      if (!this.rendered) {
        this.rendered = true;
      }

      const props = merge({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      const openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(() => {
          this._openTimer = null;
          this.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },

    doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      const dom = this.$el;

      const modal = props.modal;

      const zIndex = props.zIndex;
      if (zIndex) {
        popup_manager.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          popup_manager.closeModal(this._popupId);
          this._closing = false;
        }
        popup_manager.openModal(this._popupId, popup_manager.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !hasClass(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt(getStyle(document.body, 'paddingRight'), 10);
          }
          popup_scrollBarWidth = scrollbar_width();
          let bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          let bodyOverflowY = getStyle(document.body, 'overflowY');
          if (popup_scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + popup_scrollBarWidth + 'px';
          }
          addClass(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = popup_manager.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },

    doAfterOpen() {
      this._opening = false;
    },

    close() {
      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      const closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },

    doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },

    doAfterClose() {
      popup_manager.closeModal(this._popupId);
      this._closing = false;
    },

    restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        removeClass(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
});



// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!/root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/image/src/image-viewer.vue?vue&type=script&lang=js



const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};
const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';
/* harmony default export */ var image_viewervue_type_script_lang_js = ({
  name: 'elImageViewer',
  props: {
    urlList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      index: this.initialIndex,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    };
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg() {
      return this.urlList[this.index];
    },
    imgStyle() {
      const {
        scale,
        deg,
        offsetX,
        offsetY,
        enableTransition
      } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    },
    viewerZIndex() {
      const nextZIndex = popup_manager.nextZIndex();
      return this.zIndex > nextZIndex ? this.zIndex : nextZIndex;
    }
  },
  watch: {
    index: {
      handler: function (val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  methods: {
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = e => {
        e.stopPropagation();
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.hide();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      };
      this._mouseWheelHandler = rafThrottle(e => {
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', this._keyDownHandler);
      on(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall() {
      off(document, 'keydown', this._keyDownHandler);
      off(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown(e) {
      if (this.loading || e.button !== 0) return;
      const {
        offsetX,
        offsetY
      } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', this._dragHandler);
      on(document, 'mouseup', ev => {
        off(document, 'mousemove', this._dragHandler);
      });
      e.preventDefault();
    },
    handleMaskClick() {
      if (this.maskClosable) {
        this.hide();
      }
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading) return;
      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions(action, options = {}) {
      if (this.loading) return;
      const {
        zoomRate,
        rotateDeg,
        enableTransition
      } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const {
        transform
      } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  },
  mounted() {
    this.deviceSupportInstall();
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
    // add tabindex then wrapper can be focusable via Javascript
    // focus wrapper so arrow key can't cause inner scroll behavior underneath
    this.$refs['el-image-viewer__wrapper'].focus();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/image/src/image-viewer.vue?vue&type=script&lang=js
 /* harmony default export */ var src_image_viewervue_type_script_lang_js = (image_viewervue_type_script_lang_js); 
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/image/src/image-viewer.vue





/* normalize component */

var component = normalizeComponent(
  src_image_viewervue_type_script_lang_js,
  image_viewervue_type_template_id_726a07b0_render,
  image_viewervue_type_template_id_726a07b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var image_viewer = (component.exports);
// CONCATENATED MODULE: ./src/assets/js/factory.js


let vms = [];
function closeAllOverlay() {
  vms.forEach(vm => {
    vm.$emit('close');
  });
  vms.length = 0;
}
function createPopup(PopupComp, props, option = {}) {
  const {
    closeName = 'close',
    ...opts
  } = option;
  let Ctor = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend(PopupComp);
  let vm = new Ctor({
    el: document.createElement('div'),
    propsData: props || {},
    ...opts
  });
  vm.$on(closeName, () => {
    document.body.removeChild(vm.$el);
    vm.$destroy();
  });
  document.body.append(vm.$el);
  vms.push(vm);
  return vm;
}
// CONCATENATED MODULE: ./src/assets/js/preview-image.js


function handler(event) {
  const vm = createPopup(image_viewer, {
    zIndex: 3000,
    initialIndex: 0,
    urlList: [event.target.src],
    onClose: () => {
      vm.$emit('close');
    }
  });
  event.preventDefault();
  event.stopPropagation();
}
function previewHandler(evt) {
  if (evt.target.tagName.toLowerCase() !== 'img') {
    return;
  }
  handler(evt);
}
function previewImage(el) {
  el.removeEventListener('click', previewHandler);
  el.addEventListener('click', previewHandler, true);
  // let imgList = el.getElementsByTagName('img')
  // for (let i = 0; i < imgList.length; i++) {
  //   const img = imgList[i]
  //   img.onclick = handler
  // }
}
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/FileItem.vue?vue&type=script&lang=js


/* harmony default export */ var FileItemvue_type_script_lang_js = ({
  name: 'FileItem',
  props: {
    file: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fileName() {
      return this.convertFileName(this.file.name);
    },
    fileUrl() {
      return Object(dygc_esm_bundler["h" /* convertDownloadUrl */])(this.file.url);
    },
    isImage() {
      const suffix = this.file.url.split('.').pop();
      return dygc_esm_bundler["q" /* imageFiles */].includes('.' + suffix.toLowerCase());
    }
  },
  methods: {
    onClick() {
      if (!this.view) return;
      if (this.isImage) {
        return;
      }
      let strs = this.fileName.split('.');
      strs.pop();
      window.open(Object(dygc_esm_bundler["k" /* getFileStream */])(this.file.url, strs.join('.')));
    },
    onLoad() {
      previewImage(this.$refs.container);
    },
    convertFileName(filename = '') {
      filename = decodeURIComponent(filename);
      const splits = filename.split('/');
      filename = splits.pop();
      if (filename.indexOf('_') > -1) {
        let [, ...names] = filename.split('_');
        filename = names.join('_');
      }
      return filename;
    },
    removeFile() {
      this.$emit('remove');
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/FileItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_FileItemvue_type_script_lang_js = (FileItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/FileItem.vue





/* normalize component */

var FileItem_component = normalizeComponent(
  components_FileItemvue_type_script_lang_js,
  FileItemvue_type_template_id_63bb33c3_scoped_true_render,
  FileItemvue_type_template_id_63bb33c3_scoped_true_staticRenderFns,
  false,
  null,
  "63bb33c3",
  null
  
)

/* harmony default export */ var FileItem = (FileItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/UploadFiles.vue?vue&type=script&lang=js









let _fid = 0;
/* harmony default export */ var UploadFilesvue_type_script_lang_js = ({
  name: 'UploadFiles',
  components: {
    FileItem: FileItem
  },
  props: {
    uploadFileMaxSize: {
      type: Number,
      default: 30
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    allowTypes: {
      type: Array,
      default: () => []
    },
    checkFileType: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: () => []
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    view: {
      default: false
    }
  },
  data() {
    return {
      fid: _fid++
    };
  },
  computed: {
    showUploadBtn() {
      let max = this.max;
      return max > this.value.length;
    },
    text() {
      let max = this.max;
      let min = this.min || -1;
      if (max < 0) {
        return '';
      }
      if (min <= 0) {
        return '上限' + max + '个，每个';
      } else {
        return '至少上传' + min + '个附件，' + '上限' + max + '个，每个';
      }
    }
  },
  methods: {
    removeFile(index) {
      let value = this.value.slice();
      value.splice(index, 1);
      this.$emit('input', value);
    },
    uploadFile() {
      console.log("文件上传");
      Object(dygc_esm_bundler["x" /* uploadFile */])({
        maxSize: this.uploadFileMaxSize,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
        multiple: true,
        success: files => {
          if (files.length > this.max) {
            lib_message_default.a.warning(`最多上传${this.max}个文件`);
            return;
          }
          const load = lib_loading_default.a.service({
            text: '正在上传',
            background: 'rgba(0,0,0,0.65)'
          });
          const promises = [];
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let fd = new FormData();
            fd.append('file', file);
            promises.push(Object(dygc_esm_bundler["w" /* upload */])(fd));
          }
          Promise.all(promises).then(res => {
            let value = this.value.slice();
            res.forEach(item => {
              value.push({
                name: item.data.url,
                url: item.data.url
              });
            });
            this.$emit('input', value);
            load.close();
          }).catch(err => {
            load.close();
          });
        },
        error: err => {
          if (err.code === dygc_esm_bundler["a" /* FileErrorCode */].NO_ALLOW_TYPE) {
            lib_message_default()({
              type: 'warning',
              message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件`
            });
          } else {
            lib_message_default()({
              type: 'warning',
              message: err.msg
            });
          }
        }
      });
    },
    init() {
      Object(dygc_esm_bundler["x" /* uploadFile */])({
        maxSize: this.uploadFileMaxSize,
        unit: 'MB',
        allowTypes: this.checkFileType ? this.allowTypes : [],
        el: this.$refs.uploadEl,
        multiple: true,
        success: files => {
          if (files.length > this.max) {
            lib_message_default.a.warning(`最多上传${this.max}个文件`);
            return;
          }
          const load = lib_loading_default.a.service({
            text: '正在上传',
            background: 'rgba(0,0,0,0.65)'
          });
          const promises = [];
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let fd = new FormData();
            fd.append('file', file);
            promises.push(Object(dygc_esm_bundler["w" /* upload */])(fd));
          }
          Promise.all(promises).then(res => {
            let value = this.value.slice();
            res.forEach(item => {
              value.push({
                name: item.data.url,
                url: item.data.url
              });
            });
            this.$emit('input', value);
            load.close();
          }).catch(err => {
            load.close();
          });
        },
        error: err => {
          if (err.code === dygc_esm_bundler["a" /* FileErrorCode */].NO_ALLOW_TYPE) {
            lib_message_default()({
              type: 'warning',
              message: `文件类型错误，仅允许上传${this.allowTypes.join('、')}格式文件`
            });
          } else {
            lib_message_default()({
              type: 'warning',
              message: err.msg
            });
          }
        }
      });
    }
  },
  mounted() {
    this.init();
  }
});
// CONCATENATED MODULE: ./src/questions/components/UploadFiles.vue?vue&type=script&lang=js
 /* harmony default export */ var components_UploadFilesvue_type_script_lang_js = (UploadFilesvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/UploadFiles.vue





/* normalize component */

var UploadFiles_component = normalizeComponent(
  components_UploadFilesvue_type_script_lang_js,
  UploadFilesvue_type_template_id_1531687a_render,
  UploadFilesvue_type_template_id_1531687a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UploadFiles = (UploadFiles_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/AdapterUploadFiles.vue?vue&type=script&lang=js

/* harmony default export */ var AdapterUploadFilesvue_type_script_lang_js = ({
  name: 'AdapterUploadFiles',
  components: {
    UploadFiles: UploadFiles
  },
  props: {
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isShow() {
      return !!this.content.allowPhotoNum;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/AdapterUploadFiles.vue?vue&type=script&lang=js
 /* harmony default export */ var components_AdapterUploadFilesvue_type_script_lang_js = (AdapterUploadFilesvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/AdapterUploadFiles.vue





/* normalize component */

var AdapterUploadFiles_component = normalizeComponent(
  components_AdapterUploadFilesvue_type_script_lang_js,
  AdapterUploadFilesvue_type_template_id_7c6e14f6_render,
  AdapterUploadFilesvue_type_template_id_7c6e14f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AdapterUploadFiles = (AdapterUploadFiles_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Adapter/AdapterRadio.vue?vue&type=template&id=de45fb62
var AdapterRadiovue_type_template_id_de45fb62_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex cursor-pointer items-baseline adapter-radio",
    class: _vm.textColorClass,
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('el-radio', {
    ref: "radio",
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.label
    }
  }, [_c('span')]), _vm.view ? [_c('div', {
    staticClass: "absolute inset-0 z-10"
  })] : _vm._e()], 2), _c('div', {
    staticClass: "flex-1"
  }, [_vm._t("default")], 2), _vm.tip ? _c('div', [_c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": _vm.tip,
      "popper-class": "answer-tooltip"
    }
  }, [_c('span', {
    staticClass: "text-medium ml-1"
  }, [_c('i', {
    staticClass: "el-icon-question"
  }), _vm.answerTipIconText ? _c('span', {
    staticClass: "text-small text-theme-black-350"
  }, [_vm._v(_vm._s(_vm.answerTipIconText))]) : _vm._e()])])], 1) : _vm._e()]);
};
var AdapterRadiovue_type_template_id_de45fb62_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterRadio.vue?vue&type=template&id=de45fb62

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Adapter/AdapterRadio.vue?vue&type=script&lang=js
/* harmony default export */ var AdapterRadiovue_type_script_lang_js = ({
  name: 'AdapterRadio',
  inject: {
    view: {
      default: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: null,
      default: ''
    },
    richText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    isCorrect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    answerTipIconText() {
      var _this$$bus$survey;
      if (!this.$bus) return '';
      return (_this$$bus$survey = this.$bus.survey) === null || _this$$bus$survey === void 0 || (_this$$bus$survey = _this$$bus$survey.otherSetting) === null || _this$$bus$survey === void 0 ? void 0 : _this$$bus$survey.answerTipIconText;
    },
    textColorClass() {
      return this.disabled ? 'text-theme-black-450' : 'text-theme-black-850';
    }
  },
  methods: {
    onClick() {
      if (this.view) return;
      const radio = this.$refs.radio;
      radio.model = radio.isDisabled ? radio.model : radio.label;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterRadio.vue?vue&type=script&lang=js
 /* harmony default export */ var Adapter_AdapterRadiovue_type_script_lang_js = (AdapterRadiovue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterRadio.vue





/* normalize component */

var AdapterRadio_component = normalizeComponent(
  Adapter_AdapterRadiovue_type_script_lang_js,
  AdapterRadiovue_type_template_id_de45fb62_render,
  AdapterRadiovue_type_template_id_de45fb62_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AdapterRadio = (AdapterRadio_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/RelationInput.vue?vue&type=template&id=5298c57a
var RelationInputvue_type_template_id_5298c57a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative"
  }, [_c('el-input', _vm._b({
    ref: "reference",
    attrs: {
      "type": _vm.inputType,
      "value": _vm.value,
      "placeholder": _vm.placeholderValue,
      "clearable": "",
      "autocomplete": _vm.autocomplete
    },
    on: {
      "input": _vm.onInput,
      "change": _vm.onChange,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    },
    nativeOn: {
      "copy": function ($event) {
        return _vm.onCopy.apply(null, arguments);
      },
      "paste": function ($event) {
        return _vm.onPaste.apply(null, arguments);
      },
      "cut": function ($event) {
        return _vm.onCut.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_vm._t("append")];
      },
      proxy: true
    }], null, true)
  }, 'el-input', _vm.$attrs, false)), _vm.enableRelation && _vm.visible && _vm.selectList.length ? _c('el-select-dropdown', {
    ref: "popper"
  }, [_c('ul', _vm._l(_vm.selectList, function (item) {
    return _c('li', {
      key: item,
      staticClass: "py-2 px-3 cursor-pointer hover:bg-theme-gray text-medium"
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.onSelect(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))])])]);
  }), 0)]) : _vm._e(), _vm.showErrorTip ? _c('div', {
    staticClass: "mt-2 p-2 danger-box"
  }, [_vm._v(" " + _vm._s(_vm.errorTip) + " ")]) : _vm._e()], 1);
};
var RelationInputvue_type_template_id_5298c57a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/RelationInput.vue?vue&type=template&id=5298c57a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!/root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/select/src/select-dropdown.vue?vue&type=template&id=f2dd7c0c
var select_dropdownvue_type_template_id_f2dd7c0c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "el-select-dropdown el-popper",
    class: [{
      'is-multiple': _vm.$parent.multiple
    }, _vm.popperClass],
    style: {
      minWidth: _vm.minWidth
    }
  }, [_vm._t("default")], 2);
};
var select_dropdownvue_type_template_id_f2dd7c0c_staticRenderFns = [];

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/select/src/select-dropdown.vue?vue&type=template&id=f2dd7c0c

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+element-ui@2.15.14_vue@2.7.16/node_modules/element-ui/src/utils/vue-popper.js



const PopperJS = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.prototype.$isServer ? function() {} : __webpack_require__("c93d");
const stop = e => e.stopPropagation();

/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */
/* harmony default export */ var vue_popper = ({
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },

  data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },

    showPopper(val) {
      if (this.disabled) return;
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },

  methods: {
    createPopper() {
      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      const options = this.popperOptions;
      const popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      let reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference &&
        this.$slots.reference &&
        this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(_ => {
        this.$emit('created', this);
        this.resetTransformOrigin();
        this.$nextTick(this.updatePopper);
      });
      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }
      this.popperJS._popper.style.zIndex = popup_manager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },

    updatePopper() {
      const popperJS = this.popperJS;
      if (popperJS) {
        popperJS.update();
        if (popperJS._popper) {
          popperJS._popper.style.zIndex = popup_manager.nextZIndex();
        }
      } else {
        this.createPopper();
      }
    },

    doDestroy(forceDestroy) {
      /* istanbul ignore if */
      if (!this.popperJS || (this.showPopper && !forceDestroy)) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },

    destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },

    resetTransformOrigin() {
      if (!this.transformOrigin) return;
      let placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      let placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
      let origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string'
        ? this.transformOrigin
        : ['top', 'bottom'].indexOf(placement) > -1 ? `center ${ origin }` : `${ origin } center`;
    },

    appendArrow(element) {
      let hash;
      if (this.appended) {
        return;
      }

      this.appended = true;

      for (let item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      const arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }
      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },

  beforeDestroy() {
    this.doDestroy(true);
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },

  // call destroy in keep-alive mode
  deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
});

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!/root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/select/src/select-dropdown.vue?vue&type=script&lang=js

/* harmony default export */ var select_dropdownvue_type_script_lang_js = ({
  name: 'ElSelectDropdown',
  componentName: 'ElSelectDropdown',
  mixins: [vue_popper],
  props: {
    placement: {
      default: 'bottom-start'
    },
    boundariesPadding: {
      default: 0
    },
    popperOptions: {
      default() {
        return {
          gpuAcceleration: false
        };
      }
    },
    visibleArrow: {
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      minWidth: ''
    };
  },
  computed: {
    popperClass() {
      return this.$parent.popperClass;
    }
  },
  watch: {
    '$parent.inputWidth'() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },
  mounted() {
    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', () => {
      if (this.$parent.visible) this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/select/src/select-dropdown.vue?vue&type=script&lang=js
 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js = (select_dropdownvue_type_script_lang_js); 
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/packages/select/src/select-dropdown.vue





/* normalize component */

var select_dropdown_component = normalizeComponent(
  src_select_dropdownvue_type_script_lang_js,
  select_dropdownvue_type_template_id_f2dd7c0c_render,
  select_dropdownvue_type_template_id_f2dd7c0c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
// CONCATENATED MODULE: ./src/questions/text-fill/disableCopyMixin.js



const openMessage = function () {
  let msg = null;
  return function () {
    if (msg) return;
    msg = lib_message_default()({
      message: '禁止复制粘贴',
      type: 'warning',
      onClose: () => {
        msg = null;
      }
    });
  };
}();
/* harmony default export */ var disableCopyMixin = ({
  methods: {
    onCopy(evt) {
      if (this.disableCopy) {
        evt.preventDefault();
        openMessage();
        return false;
      }
    },
    onPaste(evt) {
      if (this.disableCopy) {
        evt.preventDefault();
        openMessage();
        return false;
      }
    },
    onCut(evt) {
      if (this.disableCopy) {
        evt.preventDefault();
        openMessage();
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/RelationInput.vue?vue&type=script&lang=js



/* harmony default export */ var RelationInputvue_type_script_lang_js = ({
  name: 'RelationInput',
  components: {
    ElSelectDropdown: select_dropdown
  },
  mixins: [disableCopyMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    questionId: {
      type: String,
      default: ''
    },
    optionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disableCopy: {
      type: Boolean,
      default: false
    },
    minLength: {
      type: Number,
      default: -1
    },
    maxLength: {
      type: Number,
      default: -1
    },
    validate: {
      type: String,
      default: null
    },
    enabledErrorTip: {
      type: Boolean,
      default: true
    },
    allowErrorList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      selectList: []
    };
  },
  computed: {
    showErrorTip() {
      if (!this.enabledErrorTip) return false;
      return !!this.errorTip.length;
    },
    errorTip() {
      if (!this.value) return '';
      if (this.allowErrorList.includes(this.value.toString().trim())) return '';
      return Object(dygc_esm_bundler["p" /* getTextFillErrorTip */])(this.value, {
        maxLength: this.maxLength,
        minLength: this.minLength,
        validate: this.validate
      });
    },
    placeholderValue() {
      if (this.placeholder) return this.placeholder;
      return '请输入';
    },
    inputType() {
      const type = this.type;
      if (type === 'number') return 'text';
      return type;
    },
    autocomplete() {
      if (this.inputType === 'password') {
        return 'new-password';
      } else {
        return 'off';
      }
    }
  },
  methods: {
    onSelect(item) {
      this.$emit('input', item);
      this.visible = false;
    },
    onInput(event) {
      this.$emit('input', event);
    },
    onBlur() {
      setTimeout(() => {
        this.visible = false;
      }, 200);
    },
    onChange(e) {
      this.$emit('change', e);
    },
    onFocus() {
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.popper) this.$refs.popper.$emit('updatePopper');
      });
    },
    searchHandler(val) {
      const tmp = this.tmp = Math.random() * 100000;
      Object(dygc_esm_bundler["m" /* getHistoryQuestionAnswer */])({
        surveyId: this.$bus.survey.id,
        questionId: this.questionId,
        questionType: this.questionType,
        optionId: this.optionId,
        keyWord: val
      }).then(res => {
        if (tmp !== this.tmp) return;
        this.selectList = res.data;
        this.$nextTick(() => {
          this.$refs.popper.$emit('updatePopper');
        });
      });
    }
  },
  watch: {
    value(val) {
      if (!this.enableRelation) return;
      if (!val.trim()) {
        this.selectList = [];
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.searchHandler(val);
      }, 200);
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/RelationInput.vue?vue&type=script&lang=js
 /* harmony default export */ var components_RelationInputvue_type_script_lang_js = (RelationInputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/RelationInput.vue





/* normalize component */

var RelationInput_component = normalizeComponent(
  components_RelationInputvue_type_script_lang_js,
  RelationInputvue_type_template_id_5298c57a_render,
  RelationInputvue_type_template_id_5298c57a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RelationInput = (RelationInput_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/SingleChoiceItem.vue?vue&type=script&lang=js




/* harmony default export */ var SingleChoiceItemvue_type_script_lang_js = ({
  name: 'SingleChoiceItem',
  components: {
    RelationInput: RelationInput,
    AdapterRadio: AdapterRadio,
    AdapterUploadFiles: AdapterUploadFiles
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    },
    correctAnswerList: {
      type: Array,
      default: () => []
    },
    questionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enabledErrorTip() {
      if (this.item.validate !== dygc_esm_bundler["c" /* ValidateType */].NUM) return true;
      return this.item.outOfRange !== 1;
    },
    disabled() {
      if (this.item.showQuotaCount) {
        if (this.item.count === 0) return true;
      }
      return this.item.disabled;
    },
    itemText() {
      const content = this.item.content;
      return content.richText || content.text;
    },
    correct() {
      return this.correctAnswerList.find(i => i.id === this.item.id);
    },
    isCorrect() {
      return !!this.correctAnswerList.find(i => i.id === this.item.id);
    }
  },
  methods: {
    initAppendText() {
      const el = this.$refs.text;
      if (!el) return;
      if (this.item.showQuotaCount) {
        Object(dygc_esm_bundler["e" /* appendQuotaText */])(el, this.item.count, this.disabled);
      }
    }
  },
  mounted() {
    this.initAppendText();
  }
});
// CONCATENATED MODULE: ./src/questions/components/SingleChoiceItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SingleChoiceItemvue_type_script_lang_js = (SingleChoiceItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/SingleChoiceItem.vue





/* normalize component */

var SingleChoiceItem_component = normalizeComponent(
  components_SingleChoiceItemvue_type_script_lang_js,
  SingleChoiceItemvue_type_template_id_cc91cad8_scoped_true_render,
  SingleChoiceItemvue_type_template_id_cc91cad8_scoped_true_staticRenderFns,
  false,
  null,
  "cc91cad8",
  null
  
)

/* harmony default export */ var SingleChoiceItem = (SingleChoiceItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/VoteProgress.vue?vue&type=template&id=16e76e8a&scoped=true
var VoteProgressvue_type_template_id_16e76e8a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vote-progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "show-text": false,
      "stroke-width": 4
    }
  }), _c('div', {
    staticClass: "progress-text-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.count) + " 票")]), _c('span', [_vm._v(_vm._s(_vm.percentage) + "%")])])], 1);
};
var VoteProgressvue_type_template_id_16e76e8a_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/VoteProgress.vue?vue&type=template&id=16e76e8a&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/VoteProgress.vue?vue&type=script&lang=js
/* harmony default export */ var VoteProgressvue_type_script_lang_js = ({
  name: 'VoteProgress',
  props: {
    vote: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    percentage() {
      if (this.total === 0) return 0;
      return Number((this.count / this.total * 100).toFixed(0));
    },
    total() {
      let res = this.vote.totalNum;
      if (this.selected) res += 1;
      return res;
    },
    count() {
      let current = this.vote.oidCountMap[this.label] || 0;
      if (this.checked) {
        current += 1;
      }
      return current;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/VoteProgress.vue?vue&type=script&lang=js
 /* harmony default export */ var components_VoteProgressvue_type_script_lang_js = (VoteProgressvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/questions/components/VoteProgress.vue?vue&type=style&index=0&id=16e76e8a&prod&scoped=true&lang=scss
var VoteProgressvue_type_style_index_0_id_16e76e8a_prod_scoped_true_lang_scss = __webpack_require__("c76d");

// CONCATENATED MODULE: ./src/questions/components/VoteProgress.vue






/* normalize component */

var VoteProgress_component = normalizeComponent(
  components_VoteProgressvue_type_script_lang_js,
  VoteProgressvue_type_template_id_16e76e8a_scoped_true_render,
  VoteProgressvue_type_template_id_16e76e8a_scoped_true_staticRenderFns,
  false,
  null,
  "16e76e8a",
  null
  
)

/* harmony default export */ var VoteProgress = (VoteProgress_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleChoice.vue?vue&type=script&lang=js


/* harmony default export */ var SingleChoicevue_type_script_lang_js = ({
  name: 'SingleChoice',
  components: {
    VoteProgress: VoteProgress,
    SingleChoiceItem: SingleChoiceItem
  },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select);
      if (item) {
        return item.id + item.value + item.content.fileList.length;
      } else {
        return '';
      }
    },
    correctAnswerList() {
      if (!this.view) return [];
      return this.question.getCorrectAnswerList();
    },
    gridStyle() {
      if (this.issue.choice_num_per_row < 2) {
        return '';
      } else {
        return `
          display:grid;
          grid-template-columns:repeat(${this.issue.choice_num_per_row}, 1fr);
          grid-column-gap: 20px;
        `;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/SingleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_SingleChoicevue_type_script_lang_js = (SingleChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/SingleChoice.vue





/* normalize component */

var SingleChoice_component = normalizeComponent(
  choice_SingleChoicevue_type_script_lang_js,
  SingleChoicevue_type_template_id_a784a754_render,
  SingleChoicevue_type_template_id_a784a754_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SingleChoice = (SingleChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleChoice.vue?vue&type=template&id=b3f20ac0
var MultipleChoicevue_type_template_id_b3f20ac0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "multiple-choice"
  }, [_c('el-checkbox-group', {
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, _vm._l(_vm.issue.item_groups, function (group, index) {
    return _c('div', {
      key: index,
      staticClass: "items-group mb-4 last:mb-0"
    }, [_c('div', {
      staticClass: "cg-title text-base mb-2"
    }, [_c('span', [_vm._v(" " + _vm._s(group.title))])]), _c('ul', {
      staticClass: "cg-content",
      style: _vm.gridStyle
    }, _vm._l(group.options, function (item) {
      return _c('li', {
        key: item.id,
        staticClass: "mb-2 last:mb-0"
      }, [_c('multiple-choice-item', {
        class: {
          checked: _vm.issue.select.includes(item.id)
        },
        attrs: {
          "item": item,
          "selected": _vm.issue.select.includes(item.id),
          "correct-answer-list": _vm.correctAnswerList,
          "question-id": _vm.question.id,
          "question-type": _vm.question.questionType,
          "enable-relation": item.setting.enableRelation,
          "exclusiveIds": _vm.exclusiveIds,
          "max": _vm.issue.max_choice
        },
        scopedSlots: _vm._u([{
          key: "vote",
          fn: function () {
            return [_vm.showVoteProgress && _vm.changeExpr ? _c('vote-progress', {
              attrs: {
                "vote": _vm.question.vote,
                "label": item.id,
                "checked": _vm.issue.select.includes(item.id),
                "selected": !!_vm.issue.select.length
              }
            }) : _vm._e()];
          },
          proxy: true
        }], null, true)
      })], 1);
    }), 0)]);
  }), 0)], 1);
};
var MultipleChoicevue_type_template_id_b3f20ac0_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/MultipleChoice.vue?vue&type=template&id=b3f20ac0

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MultipleChoiceItem.vue?vue&type=template&id=5325ad42
var MultipleChoiceItemvue_type_template_id_5325ad42_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "multiple-choice-item choice-item flex-1"
  }, [_c('adapter-checkbox', _vm._b({
    staticClass: "px-3 py-2.5",
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.item.id,
      "rich-text": _vm.itemText,
      "tip": _vm.item.tips
    }
  }, 'adapter-checkbox', _vm.$attrs, false), [_c('div', {
    ref: "text",
    staticClass: "text-medium leading-base",
    domProps: {
      "innerHTML": _vm._s(_vm.itemText)
    }
  })]), _vm.selected ? [_vm.item.is_other_item ? _c('relation-input', {
    staticClass: "mt-1 px-3 pb-2",
    attrs: {
      "type": _vm.item.inputType,
      "option-id": _vm.item.id,
      "question-id": _vm.questionId,
      "question-type": _vm.questionType,
      "enable-relation": _vm.enableRelation,
      "max-length": _vm.item.maxLength,
      "min-length": _vm.item.minLength,
      "validate": _vm.item.validate,
      "enabled-error-tip": _vm.enabledErrorTip,
      "allow-error-list": _vm.item.allowErrorList,
      "placeholder": _vm.item.placeholder
    },
    model: {
      value: _vm.item.value,
      callback: function ($$v) {
        _vm.$set(_vm.item, "value", $$v);
      },
      expression: "item.value"
    }
  }) : _vm._e(), _c('adapter-upload-files', {
    staticClass: "mb-2",
    attrs: {
      "content": _vm.item.content
    }
  })] : _vm._e(), _vm._t("vote")], 2), _vm.correctAnswerList.length ? _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm.correct ? [_c('div', {
    staticClass: "flex flex-col text-center py-2"
  }, [_vm.correct.score ? _c('span', {
    staticClass: "text-theme-black-450 text-medium"
  }, [_vm._v(_vm._s(_vm.correct.score) + "分")]) : _vm._e(), _c('span', {
    staticClass: "text-green-theme text-medium"
  }, [_vm._v("正确答案")])])] : _vm._e()], 2) : _vm._e()]);
};
var MultipleChoiceItemvue_type_template_id_5325ad42_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/MultipleChoiceItem.vue?vue&type=template&id=5325ad42

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Adapter/AdapterCheckbox.vue?vue&type=template&id=3384c796
var AdapterCheckboxvue_type_template_id_3384c796_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex cursor-pointer items-baseline",
    class: _vm.textColorClass,
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('el-checkbox', {
    ref: "checkbox",
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.label
    },
    nativeOn: {
      "change": function ($event) {
        $event.stopPropagation();
        return _vm.onClick.apply(null, arguments);
      }
    }
  }, [_c('span')]), _c('div', {
    staticClass: "absolute inset-0 z-10"
  })], 1), _c('div', {
    staticClass: "flex-1"
  }, [_vm._t("default")], 2), _vm.tip ? _c('div', [_c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": _vm.tip,
      "popper-class": "answer-tooltip"
    }
  }, [_c('span', {
    staticClass: "text-medium ml-1"
  }, [_c('i', {
    staticClass: "el-icon-question"
  }), _vm.answerTipIconText ? _c('span', {
    staticClass: "text-small text-theme-black-350"
  }, [_vm._v(_vm._s(_vm.answerTipIconText))]) : _vm._e()])])], 1) : _vm._e()]);
};
var AdapterCheckboxvue_type_template_id_3384c796_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterCheckbox.vue?vue&type=template&id=3384c796

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Adapter/AdapterCheckbox.vue?vue&type=script&lang=js




/* harmony default export */ var AdapterCheckboxvue_type_script_lang_js = ({
  name: 'AdapterCheckbox',
  inject: {
    view: {
      default: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: null,
      default: ''
    },
    richText: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    isCorrect: {
      type: Boolean,
      default: false
    },
    exclusiveIds: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: -1
    }
  },
  computed: {
    answerTipIconText() {
      var _this$$bus$survey;
      if (!this.$bus) return '';
      return (_this$$bus$survey = this.$bus.survey) === null || _this$$bus$survey === void 0 || (_this$$bus$survey = _this$$bus$survey.otherSetting) === null || _this$$bus$survey === void 0 ? void 0 : _this$$bus$survey.answerTipIconText;
    },
    textColorClass() {
      return this.disabled ? 'text-theme-black-450' : 'text-theme-black-850';
    }
  },
  methods: {
    onClick(v) {
      if (this.disabled || this.view) return;
      const checkbox = this.$refs.checkbox;
      let list = checkbox.model.slice();
      let index = list.indexOf(this.label);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(this.label);
      }
      const exclusiveIds = this.exclusiveIds.slice();
      if (exclusiveIds.includes(this.label)) {
        if (index > -1) {
          list = [];
        } else {
          list = [this.label];
        }
      } else {
        list = list.filter(id => !exclusiveIds.includes(id));
      }
      let max = this.max;
      if (max && max > 0) {
        if (list.length > max) {
          lib_message_default.a.warning(`最多选择${max}项`);
          return;
        }
      }
      checkbox.model = list;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterCheckbox.vue?vue&type=script&lang=js
 /* harmony default export */ var Adapter_AdapterCheckboxvue_type_script_lang_js = (AdapterCheckboxvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/Adapter/AdapterCheckbox.vue





/* normalize component */

var AdapterCheckbox_component = normalizeComponent(
  Adapter_AdapterCheckboxvue_type_script_lang_js,
  AdapterCheckboxvue_type_template_id_3384c796_render,
  AdapterCheckboxvue_type_template_id_3384c796_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AdapterCheckbox = (AdapterCheckbox_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MultipleChoiceItem.vue?vue&type=script&lang=js




/* harmony default export */ var MultipleChoiceItemvue_type_script_lang_js = ({
  name: 'MultipleChoiceItem',
  components: {
    RelationInput: RelationInput,
    AdapterCheckbox: AdapterCheckbox,
    AdapterUploadFiles: AdapterUploadFiles
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    },
    correctAnswerList: {
      type: Array,
      default: () => []
    },
    questionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enabledErrorTip() {
      if (this.item.validate !== dygc_esm_bundler["c" /* ValidateType */].NUM) return true;
      return this.item.outOfRange !== 1;
    },
    disabled() {
      if (this.item.showQuotaCount) {
        if (this.item.count === 0) return true;
      }
      return this.item.disabled;
    },
    itemText() {
      const content = this.item.content;
      return content.richText || content.text;
    },
    correct() {
      return this.correctAnswerList.find(i => i.id === this.item.id);
    },
    isCorrect() {
      return !!this.correctAnswerList.find(i => i.id === this.item.id);
    }
  },
  methods: {
    initAppendText() {
      const el = this.$refs.text;
      if (!el) return;
      if (this.item.showQuotaCount) {
        Object(dygc_esm_bundler["e" /* appendQuotaText */])(el, this.item.count, this.disabled);
      }
    }
  },
  mounted() {
    this.initAppendText();
  }
});
// CONCATENATED MODULE: ./src/questions/components/MultipleChoiceItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_MultipleChoiceItemvue_type_script_lang_js = (MultipleChoiceItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/MultipleChoiceItem.vue





/* normalize component */

var MultipleChoiceItem_component = normalizeComponent(
  components_MultipleChoiceItemvue_type_script_lang_js,
  MultipleChoiceItemvue_type_template_id_5325ad42_render,
  MultipleChoiceItemvue_type_template_id_5325ad42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleChoiceItem = (MultipleChoiceItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleChoice.vue?vue&type=script&lang=js


/* harmony default export */ var MultipleChoicevue_type_script_lang_js = ({
  name: 'MultipleChoice',
  components: {
    VoteProgress: VoteProgress,
    MultipleChoiceItem: MultipleChoiceItem
  },
  changeExpr: 'changeExpr',
  computed: {
    exclusiveIds() {
      return this.issue.items.filter(i => i.is_exclusive).map(i => i.id);
    },
    correctAnswerList() {
      if (!this.view) return [];
      return this.question.getCorrectAnswerList();
    },
    changeExpr() {
      return this.issue.select.map(id => {
        let item = this.issue.getItemById(id);
        if (item) {
          return item.id + item.value + item.content.fileList.length;
        } else {
          return '';
        }
      }).join('-');
    },
    gridStyle() {
      if (this.issue.choice_num_per_row < 2) {
        return '';
      } else {
        return `
          display:grid;
          grid-template-columns:repeat(${this.issue.choice_num_per_row}, 1fr);
          grid-column-gap: 20px;
        `;
      }
    }
  },
  methods: {
    mutexHandler(group1, group2, type) {
      let list = this.issue.select;
      function isSame(id) {
        return list.includes(id);
      }
      let g1 = group1[type](isSame);
      let g2 = group2[type](isSame);
      let mutexArray = [];
      if (g1) {
        mutexArray = group2;
      } else if (g2) {
        mutexArray = group1;
      } else {}
      this.issue.items.forEach(item => {
        if (item.disabled) return;
        item.disabled = mutexArray.includes(item.id);
        if (item.disabled) {
          let idx = list.findIndex(id => item.id === id);
          if (idx > -1) {
            list.splice(idx, 1);
          }
        }
      });
    },
    transMutex() {
      this.issue.mutex.forEach(mutex => {
        let type = mutex.mutex_type;
        let group1 = mutex.mutex_group1;
        let group2 = mutex.mutex_group2;
        if (type === 1) {
          this.mutexHandler(group1, group2, 'every');
        } else if (type === 2) {
          this.mutexHandler(group1, group2, 'some');
        }
      });
    }
  },
  watch: {
    'issue.select'() {
      if (this.issue.mutex.length) {
        this.issue.items.forEach(item => {
          item.disabled = false;
        });
        this.transMutex();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/MultipleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_MultipleChoicevue_type_script_lang_js = (MultipleChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/MultipleChoice.vue





/* normalize component */

var MultipleChoice_component = normalizeComponent(
  choice_MultipleChoicevue_type_script_lang_js,
  MultipleChoicevue_type_template_id_b3f20ac0_render,
  MultipleChoicevue_type_template_id_b3f20ac0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleChoice = (MultipleChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/Cascader.vue?vue&type=template&id=72b951a4
var Cascadervue_type_template_id_72b951a4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cascader relative"
  }, [_c('el-cascader', {
    staticClass: "w-3/4",
    attrs: {
      "options": _vm.issue.groups,
      "props": _vm.prop,
      "placeholder": _vm.issue.placeholder,
      "clearable": _vm.question.required,
      "popper-class": "linkage-popper",
      "filterable": ""
    },
    model: {
      value: _vm.issue.value,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "value", $$v);
      },
      expression: "issue.value"
    }
  }), _vm.issue.levelsNum < _vm.issue.requiredNum ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.issue.items, function (item) {
    return _c('el-input', {
      key: item.id,
      attrs: {
        "placeholder": "详细地址"
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    });
  }), 1) : _vm._e(), _vm.view ? _c('div', {
    staticClass: "absolute inset-0 z-50"
  }) : _vm._e(), _vm.showVoteProgress ? _c('div', {
    staticClass: "vote-answer vote-answering-wrapper"
  }, [_vm.voteItems.length ? [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._v(" 投票排名 ")])] : _vm._e(), _c('choice-vote-content', {
    attrs: {
      "items": _vm.voteItems
    }
  }), _vm.voteItems.length > 5 ? [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.onShowMoreRank
    }
  }, [_vm._v("查看更多排名")])] : _vm._e()], 2) : _vm._e()], 1);
};
var Cascadervue_type_template_id_72b951a4_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/cascader/Cascader.vue?vue&type=template&id=72b951a4

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/Cascade.vue?vue&type=template&id=4eb8a75b&scoped=true
var Cascadevue_type_template_id_4eb8a75b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('choice-vote-content', {
    attrs: {
      "items": _vm.items
    }
  }), _vm.items.length > 5 ? _c('div', {
    staticClass: "mt-3"
  }, [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.onShowMoreRank
    }
  }, [_vm._v("查看更多排名")])], 1) : _vm._e()], 1);
};
var Cascadevue_type_template_id_4eb8a75b_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/vote/Cascade.vue?vue&type=template&id=4eb8a75b&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/ChoiceVoteContent.vue?vue&type=template&id=cd0ee6ce&scoped=true
var ChoiceVoteContentvue_type_template_id_cd0ee6ce_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "choice-vote"
  }, _vm._l(_vm.showItems, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "choice-vote-item"
    }, [_c('div', {
      staticClass: "vote-rank-box"
    }, [item.num < 4 ? _c('img', {
      attrs: {
        "src": '/assets/img/vote/' + item.num + '.png',
        "width": "20"
      }
    }) : [_c('span', [_vm._v(_vm._s(item.num))])]], 2), _c('div', {
      staticClass: "choice-vote-content"
    }, [_c('div', {
      staticClass: "choice-vote-title"
    }, [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]), _c('div', {
      staticClass: "vote-num-box"
    }, [_c('span', {
      staticClass: "vote-num"
    }, [_vm._v(_vm._s(item.voteNum))]), _c('span', [_vm._v("票")])])]), _c('div', [_c('custom-progress', {
      attrs: {
        "percentage": item.percentage
      }
    })], 1)])]);
  }), 0);
};
var ChoiceVoteContentvue_type_template_id_cd0ee6ce_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/vote/ChoiceVoteContent.vue?vue&type=template&id=cd0ee6ce&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/CustomProgress.vue?vue&type=template&id=57f151d0
var CustomProgressvue_type_template_id_57f151d0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "custom-progress-wrapper"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "show-text": false,
      "stroke-width": 8
    }
  }), _c('div', {
    staticClass: "percentage"
  }, [_vm._v(" " + _vm._s(_vm.percentage) + "% ")])], 1);
};
var CustomProgressvue_type_template_id_57f151d0_staticRenderFns = [];

// CONCATENATED MODULE: ./src/vote/CustomProgress.vue?vue&type=template&id=57f151d0

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/CustomProgress.vue?vue&type=script&lang=js
/* harmony default export */ var CustomProgressvue_type_script_lang_js = ({
  name: 'CustomProgress',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  }
});
// CONCATENATED MODULE: ./src/vote/CustomProgress.vue?vue&type=script&lang=js
 /* harmony default export */ var vote_CustomProgressvue_type_script_lang_js = (CustomProgressvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/vote/CustomProgress.vue?vue&type=style&index=0&id=57f151d0&prod&lang=scss
var CustomProgressvue_type_style_index_0_id_57f151d0_prod_lang_scss = __webpack_require__("68a8");

// CONCATENATED MODULE: ./src/vote/CustomProgress.vue






/* normalize component */

var CustomProgress_component = normalizeComponent(
  vote_CustomProgressvue_type_script_lang_js,
  CustomProgressvue_type_template_id_57f151d0_render,
  CustomProgressvue_type_template_id_57f151d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomProgress = (CustomProgress_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/ChoiceVoteContent.vue?vue&type=script&lang=js

/* harmony default export */ var ChoiceVoteContentvue_type_script_lang_js = ({
  name: 'ChoiceVoteContent',
  components: {
    CustomProgress: CustomProgress
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showCount: {
      type: Number,
      default: 5
    }
  },
  computed: {
    showItems() {
      if (this.showCount < 0) return this.items;
      return this.items.slice(0, this.showCount);
    }
  }
});
// CONCATENATED MODULE: ./src/vote/ChoiceVoteContent.vue?vue&type=script&lang=js
 /* harmony default export */ var vote_ChoiceVoteContentvue_type_script_lang_js = (ChoiceVoteContentvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vote/ChoiceVoteContent.vue





/* normalize component */

var ChoiceVoteContent_component = normalizeComponent(
  vote_ChoiceVoteContentvue_type_script_lang_js,
  ChoiceVoteContentvue_type_template_id_cd0ee6ce_scoped_true_render,
  ChoiceVoteContentvue_type_template_id_cd0ee6ce_scoped_true_staticRenderFns,
  false,
  null,
  "cd0ee6ce",
  null
  
)

/* harmony default export */ var ChoiceVoteContent = (ChoiceVoteContent_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/ChoiceMoreRank.vue?vue&type=template&id=d024de70&scoped=true
var ChoiceMoreRankvue_type_template_id_d024de70_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "visible": true,
      "width": "520px",
      "custom-class": "theme-dialog",
      "title": _vm.question.content.text
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "vote-answer",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('choice-vote-content', {
    attrs: {
      "items": _vm.items,
      "show-count": -1
    }
  })], 1)]);
};
var ChoiceMoreRankvue_type_template_id_d024de70_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/vote/ChoiceMoreRank.vue?vue&type=template&id=d024de70&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/ChoiceMoreRank.vue?vue&type=script&lang=js


/* harmony default export */ var ChoiceMoreRankvue_type_script_lang_js = ({
  name: 'ChoiceMoreRank',
  components: {
    ChoiceVoteContent: ChoiceVoteContent,
    CustomProgress: CustomProgress
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    question: {
      type: Object,
      default: () => ({})
    }
  }
});
// CONCATENATED MODULE: ./src/vote/ChoiceMoreRank.vue?vue&type=script&lang=js
 /* harmony default export */ var vote_ChoiceMoreRankvue_type_script_lang_js = (ChoiceMoreRankvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vote/ChoiceMoreRank.vue





/* normalize component */

var ChoiceMoreRank_component = normalizeComponent(
  vote_ChoiceMoreRankvue_type_script_lang_js,
  ChoiceMoreRankvue_type_template_id_d024de70_scoped_true_render,
  ChoiceMoreRankvue_type_template_id_d024de70_scoped_true_staticRenderFns,
  false,
  null,
  "d024de70",
  null
  
)

/* harmony default export */ var ChoiceMoreRank = (ChoiceMoreRank_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/vote/Cascade.vue?vue&type=script&lang=js




/* harmony default export */ var Cascadevue_type_script_lang_js = ({
  name: 'Cascade',
  components: {
    ChoiceVoteContent: ChoiceVoteContent
  },
  type: [dygc_esm_bundler["r" /* questionType */].LINKAGE],
  props: {
    question: {
      type: Object
    }
  },
  computed: {
    items() {
      return this.getVoteItems();
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        question: this.question,
        items: this.items
      });
    },
    getVoteItems() {
      const results = this.getAllVoteItems(this.question.vote);
      const ids = this.question.issue.voteAnswer;
      if (!ids.length) return results;
      return results.filter(item => {
        const lastId = item.id.split('/').pop();
        return ids.includes(lastId);
      });
    },
    getAllVoteItems(vote) {
      const items = this.question.issue.toOneArray();
      return items.map(item => {
        const id = item.id.split('/').pop();
        item.content = {
          richText: item.text
        };
        const voteNum = vote.oidCountMap[id] || 0;
        let percentage = vote.totalNum ? Number((voteNum / vote.totalNum * 100).toFixed(0)) : 0;
        return Object.assign({}, item, {
          percentage,
          voteNum
        });
      }).sort((a, b) => b.voteNum - a.voteNum).map((item, index) => {
        return Object.assign({}, item, {
          num: index + 1
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./src/vote/Cascade.vue?vue&type=script&lang=js
 /* harmony default export */ var vote_Cascadevue_type_script_lang_js = (Cascadevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vote/Cascade.vue





/* normalize component */

var Cascade_component = normalizeComponent(
  vote_Cascadevue_type_script_lang_js,
  Cascadevue_type_template_id_4eb8a75b_scoped_true_render,
  Cascadevue_type_template_id_4eb8a75b_scoped_true_staticRenderFns,
  false,
  null,
  "4eb8a75b",
  null
  
)

/* harmony default export */ var Cascade = (Cascade_component.exports);
// CONCATENATED MODULE: ./src/questions/cascader/vote.js



/* harmony default export */ var vote = ({
  mixins: [Cascade],
  computed: {
    voteItems() {
      const vote = this.question.vote;
      const oidCountMap = Object.assign({}, vote.oidCountMap);
      const val = this.issue.value.slice();
      val.forEach(id => {
        oidCountMap[id] = (oidCountMap[id] || 0) + 1;
      });
      const data = {
        ...vote,
        oidCountMap,
        totalNum: vote.totalNum + 1
      };
      return this.getAllVoteItems(data);
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        question: this.question,
        items: this.voteItems
      });
    }
  }
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/Cascader.vue?vue&type=script&lang=js

/* harmony default export */ var Cascadervue_type_script_lang_js = ({
  name: 'Cascader',
  changeExpr: 'issue.value',
  mixins: [vote],
  data() {
    return {
      prop: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'content',
        children: 'nextLevelOptions'
      }
    };
  }
});
// CONCATENATED MODULE: ./src/questions/cascader/Cascader.vue?vue&type=script&lang=js
 /* harmony default export */ var cascader_Cascadervue_type_script_lang_js = (Cascadervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/cascader/Cascader.vue





/* normalize component */

var Cascader_component = normalizeComponent(
  cascader_Cascadervue_type_script_lang_js,
  Cascadervue_type_template_id_72b951a4_render,
  Cascadervue_type_template_id_72b951a4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Cascader = (Cascader_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixSingleChoice.vue?vue&type=template&id=4250de04&scoped=true
var MatrixSingleChoicevue_type_template_id_4250de04_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-single-choice"
  }, [_c('q-table', {
    attrs: {
      "view": _vm.view,
      "rows": _vm.issue.rows,
      "columns": _vm.issue.items,
      "row-desc": _vm.issue.rowDesc,
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        row,
        col
      }) {
        return [_c('div', {
          staticClass: "use-hover",
          on: {
            "click": function ($event) {
              row.value = col.id;
            }
          }
        }, [_c('el-radio', {
          attrs: {
            "label": col.id,
            "name": row.row_id,
            "value": row.value
          }
        }, [_c('span')])], 1)];
      }
    }])
  })], 1);
};
var MatrixSingleChoicevue_type_template_id_4250de04_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixSingleChoice.vue?vue&type=template&id=4250de04&scoped=true

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+core-js@3.33.2/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("4aa6");

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MatrixTable.vue?vue&type=template&id=7e76cd0a&scoped=true
var MatrixTablevue_type_template_id_7e76cd0a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-table', {
    attrs: {
      "border": "",
      "data": _vm.rows
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_c('span', {
          staticClass: "inline-block rich-text break-words",
          domProps: {
            "innerHTML": _vm._s(row.content.richText || row.content.text)
          }
        })];
      }
    }])
  }), _vm._l(_vm.columns, function (column, index) {
    return _c('el-table-column', {
      key: column.id,
      attrs: {
        "column-key": column.id
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          row
        }) {
          return [_vm._t("content", null, {
            "row": row,
            "col": column
          })];
        }
      }], null, true)
    }, [_c('template', {
      slot: "header"
    }, [column.required ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")]) : _vm._e(), _c('section', {
      staticClass: "inline-block rich-text break-words",
      domProps: {
        "innerHTML": _vm._s(column.content.richText || column.content.text)
      }
    })])], 2);
  })], 2);
};
var MatrixTablevue_type_template_id_7e76cd0a_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/MatrixTable.vue?vue&type=template&id=7e76cd0a&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MatrixTable.vue?vue&type=script&lang=js
/* harmony default export */ var MatrixTablevue_type_script_lang_js = ({
  name: 'MatrixTable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/MatrixTable.vue?vue&type=script&lang=js
 /* harmony default export */ var components_MatrixTablevue_type_script_lang_js = (MatrixTablevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/MatrixTable.vue





/* normalize component */

var MatrixTable_component = normalizeComponent(
  components_MatrixTablevue_type_script_lang_js,
  MatrixTablevue_type_template_id_7e76cd0a_scoped_true_render,
  MatrixTablevue_type_template_id_7e76cd0a_scoped_true_staticRenderFns,
  false,
  null,
  "7e76cd0a",
  null
  
)

/* harmony default export */ var MatrixTable = (MatrixTable_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/QTable.vue?vue&type=template&id=b7de0f60
var QTablevue_type_template_id_b7de0f60_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "q-table-wrapper"
  }, [_c('div', [_c('table', {
    staticClass: "q-table",
    class: {
      'q-table-border': _vm.border
    },
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', {
    ref: "tableHead"
  }, [_c('tr', [!_vm.disabledRow ? _c('th', {
    key: "first"
  }, [_vm.rowDesc ? [_c('div', {
    style: _vm.getColStyle(0),
    domProps: {
      "innerHTML": _vm._s(_vm.rowDesc.richText)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._l(_vm.columns, function (col, index) {
    return _c('th', {
      key: col.id,
      staticClass: "relative",
      style: _vm.getColStyle(index + 1)
    }, [_c('div', {
      style: _vm.getColStyle(index + 1)
    }, [_vm.hasColumnHeader ? [_vm._t("column-header", null, {
      "col": col
    })] : [_c('div', {
      staticClass: "column-title-wrap"
    }, [_c('div', {
      class: [col.required && _vm.showRequired ? 'pl-4 relative' : '']
    }, [col.required && _vm.showRequired ? _c('span', {
      staticClass: "text-red absolute left-0 top-0 py-2",
      staticStyle: {
        "left": "4px"
      }
    }, [_vm._v("*")]) : _vm._e(), _c('div', {
      staticClass: "p-2",
      domProps: {
        "innerHTML": _vm._s(col.content.richText)
      }
    })])])]], 2)]);
  })], 2)]), _c('tbody', _vm._l(_vm.rows, function (row, index) {
    return _c('tr', {
      key: row[_vm.rowKey],
      ref: "tr",
      refInFor: true
    }, [!_vm.disabledRow ? _c('td', {
      key: row[_vm.rowKey],
      staticClass: "relative"
    }, [_c('div', {
      staticClass: "row-title-wrap py-2",
      style: _vm.getColStyle(0)
    }, [_c('div', {
      staticClass: "px-2",
      domProps: {
        "innerHTML": _vm._s(row.content.richText)
      }
    })])]) : _vm._e(), _vm._l(row.cols || _vm.columns, function (item, colIndex) {
      return _c('td', {
        key: item.id,
        staticClass: "table-content",
        class: {
          relative: _vm.view
        }
      }, [_vm._t("content", null, {
        "row": row,
        "col": item,
        "colIndex": colIndex,
        "rowIndex": index
      }), _vm.view ? [_c('div', {
        staticClass: "absolute inset-0 z-30"
      })] : _vm._e()], 2);
    })], 2);
  }), 0)])]), !_vm.disabledRow ? _c('div', {
    ref: "fixedLeftCol",
    staticClass: "absolute left-0 top-0 bg-white z-10 max-w-full overflow-x-auto"
  }, [_c('table', {
    staticClass: "q-table",
    class: {
      'q-table-border': _vm.border
    },
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    ref: "fixedHead",
    style: _vm.getColStyle(0)
  }, [_vm.rowDesc ? [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.rowDesc.richText)
    }
  })] : [_c('span')]], 2)])]), _c('tbody', _vm._l(_vm.rows, function (row) {
    return _c('tr', {
      key: row[_vm.rowKey],
      ref: "fixedTr",
      refInFor: true
    }, [!_vm.disabledRow ? _c('td', {
      key: row[_vm.rowKey],
      staticClass: "relative"
    }, [_c('div', {
      staticClass: "row-title-wrap py-2",
      style: _vm.getColStyle(0)
    }, [_c('div', {
      staticClass: "px-2",
      domProps: {
        "innerHTML": _vm._s(row.content.richText)
      }
    })])]) : _vm._e()]);
  }), 0)])]) : _vm._e()])]);
};
var QTablevue_type_template_id_b7de0f60_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/QTable.vue?vue&type=template&id=b7de0f60

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/QTable.vue?vue&type=script&lang=js

/* harmony default export */ var QTablevue_type_script_lang_js = ({
  name: 'QTable',
  props: {
    disabledRow: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    border: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: String,
      default: 'row_id'
    },
    showRequired: {
      type: Boolean,
      default: false
    },
    view: {
      type: Boolean,
      default: false
    },
    rowDesc: {
      type: Object,
      default: null
    },
    widths: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasColumnHeader() {
      return this.$scopedSlots['column-header'];
    },
    hasColumnContent() {
      return this.$scopedSlots['column-content'];
    }
  },
  methods: {
    getColStyle(idx) {
      const width = this.widths[idx];
      if (!width) {
        if (idx === 0) {
          return {
            width: '200px'
          };
        } else {
          return {
            whiteSpace: 'nowrap'
          };
        }
      }
      return {
        width: width
      };
    },
    initTable() {
      if (this.disabledRow) return;
      this.$refs.fixedHead.style.height = this.getHeaderHeight() - 1 + 'px';
      const trs = this.$refs.tr;
      const fixedTrs = this.$refs.fixedTr;
      for (let i = 0; i < trs.length; i++) {
        let tr = trs[i];
        let fixedTr = fixedTrs[i];
        const s = tr.currentStyle ? tr.currentStyle : window.getComputedStyle(tr, null);
        fixedTr.style.height = parseFloat(s.height) + 1 + 'px';
      }
    },
    getHeaderHeight() {
      const headEl = this.$refs.tableHead;
      const s = headEl.currentStyle ? headEl.currentStyle : window.getComputedStyle(headEl, null);
      return parseFloat(s.height);
    },
    getRowsHeight() {
      const trs = this.$refs.tr;
      const results = [];
      for (let i = 0; i < trs.length; i++) {
        let tr = trs[i];
        const s = tr.currentStyle ? tr.currentStyle : window.getComputedStyle(tr, null);
        results.push(parseFloat(s.height) + 1);
      }
      return results;
    }
  },
  mounted() {
    this.initTable();
    const promises = [];
    let imgList = this.$refs.tableHead.getElementsByTagName('img');
    for (let i = 0; i < imgList.length; i++) {
      const img = imgList[i];
      promises.push(new Promise(resolve => {
        img.onload = function () {
          resolve();
        };
      }));
    }
    if (promises.length) {
      Promise.all(promises).then(() => {
        this.initTable();
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/QTable.vue?vue&type=script&lang=js
 /* harmony default export */ var components_QTablevue_type_script_lang_js = (QTablevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/questions/components/QTable.vue?vue&type=style&index=0&id=b7de0f60&prod&lang=scss
var QTablevue_type_style_index_0_id_b7de0f60_prod_lang_scss = __webpack_require__("c5d6");

// CONCATENATED MODULE: ./src/questions/components/QTable.vue






/* normalize component */

var QTable_component = normalizeComponent(
  components_QTablevue_type_script_lang_js,
  QTablevue_type_template_id_b7de0f60_render,
  QTablevue_type_template_id_b7de0f60_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QTable = (QTable_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixSingleChoice.vue?vue&type=script&lang=js



/* harmony default export */ var MatrixSingleChoicevue_type_script_lang_js = ({
  name: 'MatrixSingleChoice',
  components: {
    QTable: QTable,
    MatrixTable: MatrixTable
  },
  changeExpr: 'isSelectAll',
  computed: {
    isSelectAll() {
      return this.issue.rows.reduce((prev, item) => {
        return prev + '-' + item.value;
      }, '');
    }
  },
  methods: {
    changeValue(val, row) {
      row.value = val;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixSingleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixSingleChoicevue_type_script_lang_js = (MatrixSingleChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixSingleChoice.vue





/* normalize component */

var MatrixSingleChoice_component = normalizeComponent(
  matrix_MatrixSingleChoicevue_type_script_lang_js,
  MatrixSingleChoicevue_type_template_id_4250de04_scoped_true_render,
  MatrixSingleChoicevue_type_template_id_4250de04_scoped_true_staticRenderFns,
  false,
  null,
  "4250de04",
  null
  
)

/* harmony default export */ var MatrixSingleChoice = (MatrixSingleChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixMultipleChoice.vue?vue&type=template&id=0a649e42
var MatrixMultipleChoicevue_type_template_id_0a649e42_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-multiple-choice"
  }, [_c('q-table', {
    attrs: {
      "view": _vm.view,
      "rows": _vm.issue.rows,
      "columns": _vm.issue.items,
      "row-desc": _vm.issue.rowDesc,
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        row,
        col
      }) {
        return [_c('div', {
          staticClass: "relative use-hover"
        }, [_c('el-checkbox', {
          attrs: {
            "label": col.id,
            "name": row.row_id,
            "value": row.value,
            "disabled": col.disabled
          },
          nativeOn: {
            "click": function ($event) {
              return _vm.mutSelectHandler(row, col);
            }
          }
        }, [_c('span')]), _c('div', {
          staticClass: "absolute cursor-pointer inset-0 z-10",
          on: {
            "click": function ($event) {
              return _vm.mutSelectHandler(row, col);
            }
          }
        })], 1)];
      }
    }])
  })], 1);
};
var MatrixMultipleChoicevue_type_template_id_0a649e42_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixMultipleChoice.vue?vue&type=template&id=0a649e42

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixMultipleChoice.vue?vue&type=script&lang=js




/* harmony default export */ var MatrixMultipleChoicevue_type_script_lang_js = ({
  name: 'MatrixMultipleChoice',
  components: {
    QTable: QTable,
    MatrixTable: MatrixTable
  },
  changeExpr: 'isSelectAll',
  computed: {
    isSelectAll() {
      return this.issue.rows.reduce((prev, item) => {
        return prev + '-' + item.value.join('-');
      }, '');
    }
  },
  methods: {
    mutSelectHandler(row, col) {
      let checkList = row.value;
      let findIdx = checkList.findIndex(id => id === col.id);
      if (findIdx !== -1) {
        checkList.splice(findIdx, 1);
      } else {
        checkList.push(col.id);
      }
      let mutex = this.issue.mutex;
      if (mutex.length) {
        row.cols.forEach(col => col.disabled = false);
        mutex.forEach(item => {
          if (item.row_id === row.row_id) {
            let type = '';
            if (item.mutex_type === 1) {
              type = 'every';
            } else if (item.mutex_type === 2) {
              type = 'some';
            }
            this.mutexHandler(item.mutex_group1, item.mutex_group2, row, type);
          }
        });
      }
      row.selects = checkList;
    },
    mutexHandler(group1, group2, row, type) {
      let list = row.value;
      function isSame(id) {
        return list.includes(id);
      }
      let g1 = group1[type](isSame);
      let g2 = group2[type](isSame);
      let mutexArray = [];
      if (g1) {
        mutexArray = group2;
      } else if (g2) {
        mutexArray = group1;
      } else {}
      row.cols.forEach(item => {
        if (item.disabled) return;
        item.disabled = mutexArray.includes(item.id);
        if (item.disabled) {
          let idx = list.findIndex(id => item.id === id);
          if (idx > -1) {
            list.splice(idx, 1);
          }
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      // TODO
      // 临时修改
      this.issue.rows.forEach(row => {
        let val = row.value.slice();
        row.value = [];
        val.forEach(id => {
          let find = row.cols.find(i => i.id === id);
          if (find) {
            this.mutSelectHandler(row, find);
          }
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixMultipleChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixMultipleChoicevue_type_script_lang_js = (MatrixMultipleChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixMultipleChoice.vue





/* normalize component */

var MatrixMultipleChoice_component = normalizeComponent(
  matrix_MatrixMultipleChoicevue_type_script_lang_js,
  MatrixMultipleChoicevue_type_template_id_0a649e42_render,
  MatrixMultipleChoicevue_type_template_id_0a649e42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MatrixMultipleChoice = (MatrixMultipleChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleSelectChoice.vue?vue&type=template&id=987d71f6&scoped=true
var SingleSelectChoicevue_type_template_id_987d71f6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "single-select-choice relative"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.placeholder,
      "filterable": _vm.issue.enableFilter
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    },
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "fixed-width-select",
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "label": item.text,
        "value": item.id
      }
    });
  }), 1), _vm.selectItem && _vm.selectItem.is_other_item ? [_c('el-input', {
    staticClass: "mt-2",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: _vm.selectItem.value,
      callback: function ($$v) {
        _vm.$set(_vm.selectItem, "value", $$v);
      },
      expression: "selectItem.value"
    }
  })] : _vm._e(), _vm.view ? _c('div', {
    staticClass: "absolute inset-0 z-50"
  }) : _vm._e(), _vm.showVoteProgress && _vm.changeExpr ? _c('div', {
    staticClass: "vote-answer vote-answering-wrapper"
  }, [_vm.voteItems.length ? [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._v(" 投票排名 ")])] : _vm._e(), _c('choice-vote-content', {
    attrs: {
      "items": _vm.voteItems
    }
  }), _vm.voteItems.length > 5 ? [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.onShowMoreRank
    }
  }, [_vm._v("查看更多排名")])] : _vm._e()], 2) : _vm._e()], 2);
};
var SingleSelectChoicevue_type_template_id_987d71f6_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/SingleSelectChoice.vue?vue&type=template&id=987d71f6&scoped=true

// CONCATENATED MODULE: ./src/questions/choice/select-vote.js




/* harmony default export */ var select_vote = ({
  components: {
    ChoiceVoteContent: ChoiceVoteContent
  },
  computed: {
    voteItems() {
      const results = [];
      let {
        oidCountMap,
        totalNum
      } = this.question.vote;
      const select = Array.isArray(this.issue.select) ? this.issue.select : [this.issue.select];
      totalNum += 1;
      oidCountMap = Object.assign({}, oidCountMap);
      select.forEach(id => {
        oidCountMap[id] = oidCountMap[id] + 1;
      });
      this.issue.items.forEach(item => {
        const voteNum = oidCountMap[item.id] || 0;
        let percentage = totalNum ? Number((voteNum / totalNum * 100).toFixed(0)) : 0;
        results.push({
          ...item,
          voteNum,
          percentage
        });
      });
      return results.sort((a, b) => b.voteNum - a.voteNum).map((item, index) => {
        return {
          ...item,
          num: index + 1
        };
      });
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        items: this.voteItems,
        question: this.question
      });
    }
  }
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleSelectChoice.vue?vue&type=script&lang=js


/* harmony default export */ var SingleSelectChoicevue_type_script_lang_js = ({
  name: 'SingleSelectChoice',
  changeExpr: 'changeExpr',
  mixins: [select_vote],
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select);
      if (item) {
        return item.id + item.value;
      } else {
        return '';
      }
    },
    selectItem() {
      return this.issue.items.find(i => i.id === this.issue.select);
    },
    items() {
      return this.issue.items.map(item => {
        return {
          id: item.id,
          text: Object(dygc_esm_bundler["v" /* transformRichText2Text */])(item.content.richText)
        };
      });
    },
    placeholder() {
      return this.issue.placeholder || '请选择';
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/SingleSelectChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_SingleSelectChoicevue_type_script_lang_js = (SingleSelectChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/SingleSelectChoice.vue





/* normalize component */

var SingleSelectChoice_component = normalizeComponent(
  choice_SingleSelectChoicevue_type_script_lang_js,
  SingleSelectChoicevue_type_template_id_987d71f6_scoped_true_render,
  SingleSelectChoicevue_type_template_id_987d71f6_scoped_true_staticRenderFns,
  false,
  null,
  "987d71f6",
  null
  
)

/* harmony default export */ var SingleSelectChoice = (SingleSelectChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleSelectChoice.vue?vue&type=template&id=792382ab
var MultipleSelectChoicevue_type_template_id_792382ab_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "multiple-select-choice relative"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "multiple": "",
      "filterable": _vm.issue.enableFilter
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    },
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "fixed-width-select",
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "label": item.text,
        "value": item.id
      }
    });
  }), 1), _vm.selectOtherItems.length ? [_c('ul', {
    staticClass: "mt-2"
  }, _vm._l(_vm.selectOtherItems, function (item) {
    return _c('li', {
      key: item.length
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    }), _c('el-input', {
      staticClass: "mt-2",
      attrs: {
        "placeholder": "请输入"
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    })], 1);
  }), 0)] : _vm._e(), _vm.view ? _c('div', {
    staticClass: "absolute inset-0 z-50"
  }) : _vm._e(), _vm.showVoteProgress && _vm.issue.select.length ? _c('div', {
    staticClass: "vote-answer vote-answering-wrapper"
  }, [_vm.voteItems.length ? [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._v(" 投票排名 ")])] : _vm._e(), _c('choice-vote-content', {
    attrs: {
      "items": _vm.voteItems
    }
  }), _vm.voteItems.length > 5 ? [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.onShowMoreRank
    }
  }, [_vm._v("查看更多排名")])] : _vm._e()], 2) : _vm._e()], 2);
};
var MultipleSelectChoicevue_type_template_id_792382ab_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/MultipleSelectChoice.vue?vue&type=template&id=792382ab

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleSelectChoice.vue?vue&type=script&lang=js


/* harmony default export */ var MultipleSelectChoicevue_type_script_lang_js = ({
  name: 'MultipleSelectChoice',
  changeExpr: 'issue.select',
  mixins: [select_vote],
  computed: {
    selectOtherItems() {
      return this.issue.select.map(id => {
        return this.issue.getItemById(id);
      }).filter(i => i.is_other_item);
    },
    items() {
      return this.issue.items.map(item => {
        return {
          id: item.id,
          text: Object(dygc_esm_bundler["v" /* transformRichText2Text */])(item.content.richText)
        };
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/MultipleSelectChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_MultipleSelectChoicevue_type_script_lang_js = (MultipleSelectChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/MultipleSelectChoice.vue





/* normalize component */

var MultipleSelectChoice_component = normalizeComponent(
  choice_MultipleSelectChoicevue_type_script_lang_js,
  MultipleSelectChoicevue_type_template_id_792382ab_render,
  MultipleSelectChoicevue_type_template_id_792382ab_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleSelectChoice = (MultipleSelectChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixSelectChoice.vue?vue&type=template&id=15e73974&scoped=true
var MatrixSelectChoicevue_type_template_id_15e73974_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-select-choice"
  }, [_c('q-table', {
    attrs: {
      "view": _vm.view,
      "columns": _vm.issue.items,
      "rows": _vm.issue.rows,
      "row-desc": _vm.issue.rowDesc,
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        row,
        col
      }) {
        return [_c('matrix-select-content', {
          attrs: {
            "option": _vm.issue.getCellByRowAndCol(row, col)
          }
        })];
      }
    }])
  })], 1);
};
var MatrixSelectChoicevue_type_template_id_15e73974_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixSelectChoice.vue?vue&type=template&id=15e73974&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MatrixSelectContent.vue?vue&type=template&id=d30d94d6&scoped=true
var MatrixSelectContentvue_type_template_id_d30d94d6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-select', {
    model: {
      value: _vm.option.value,
      callback: function ($$v) {
        _vm.$set(_vm.option, "value", $$v);
      },
      expression: "option.value"
    }
  }, _vm._l(_vm.option.items, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.content.text
      }
    });
  }), 1);
};
var MatrixSelectContentvue_type_template_id_d30d94d6_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/MatrixSelectContent.vue?vue&type=template&id=d30d94d6&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/MatrixSelectContent.vue?vue&type=script&lang=js
/* harmony default export */ var MatrixSelectContentvue_type_script_lang_js = ({
  name: 'MatrixSelectContent',
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/MatrixSelectContent.vue?vue&type=script&lang=js
 /* harmony default export */ var components_MatrixSelectContentvue_type_script_lang_js = (MatrixSelectContentvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/MatrixSelectContent.vue





/* normalize component */

var MatrixSelectContent_component = normalizeComponent(
  components_MatrixSelectContentvue_type_script_lang_js,
  MatrixSelectContentvue_type_template_id_d30d94d6_scoped_true_render,
  MatrixSelectContentvue_type_template_id_d30d94d6_scoped_true_staticRenderFns,
  false,
  null,
  "d30d94d6",
  null
  
)

/* harmony default export */ var MatrixSelectContent = (MatrixSelectContent_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixSelectChoice.vue?vue&type=script&lang=js



/* harmony default export */ var MatrixSelectChoicevue_type_script_lang_js = ({
  name: 'MatrixSelectChoice',
  components: {
    QTable: QTable,
    MatrixSelectContent: MatrixSelectContent,
    MatrixTable: MatrixTable
  },
  changeExpr: 'selectAllIds',
  computed: {
    selectAllIds() {
      return this.issue.options.map(item => item.value);
    }
  },
  created() {
    console.log('MatrixSelectChoice');
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixSelectChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixSelectChoicevue_type_script_lang_js = (MatrixSelectChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixSelectChoice.vue





/* normalize component */

var MatrixSelectChoice_component = normalizeComponent(
  matrix_MatrixSelectChoicevue_type_script_lang_js,
  MatrixSelectChoicevue_type_template_id_15e73974_scoped_true_render,
  MatrixSelectChoicevue_type_template_id_15e73974_scoped_true_staticRenderFns,
  false,
  null,
  "15e73974",
  null
  
)

/* harmony default export */ var MatrixSelectChoice = (MatrixSelectChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/Blanks.vue?vue&type=template&id=0b5bcc4a
var Blanksvue_type_template_id_0b5bcc4a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "blanks"
  }, [_vm._l(_vm.issue.items, function (item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(" " + _vm._s(item.text) + " "), item.length && item.content ? _c('span', {
      staticClass: "blanks-opt-wrap"
    }, [(item.content.inputType === 'number' ? 'text' : item.content.inputType) === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.value,
        expression: "item.value"
      }],
      staticClass: "blanks-input",
      style: {
        width: item.length * 10 + 'px'
      },
      attrs: {
        "readonly": _vm.view || item.readonly,
        "placeholder": item.placeholder,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.value) ? _vm._i(item.value, null) > -1 : item.value
      },
      on: {
        "copy": _vm.onCopy,
        "paste": _vm.onPaste,
        "cut": _vm.onCut,
        "change": function ($event) {
          var $$a = item.value,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(item, "value", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(item, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(item, "value", $$c);
          }
        }
      }
    }) : (item.content.inputType === 'number' ? 'text' : item.content.inputType) === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.value,
        expression: "item.value"
      }],
      staticClass: "blanks-input",
      style: {
        width: item.length * 10 + 'px'
      },
      attrs: {
        "readonly": _vm.view || item.readonly,
        "placeholder": item.placeholder,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(item.value, null)
      },
      on: {
        "copy": _vm.onCopy,
        "paste": _vm.onPaste,
        "cut": _vm.onCut,
        "change": function ($event) {
          return _vm.$set(item, "value", null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.value,
        expression: "item.value"
      }],
      staticClass: "blanks-input",
      style: {
        width: item.length * 10 + 'px'
      },
      attrs: {
        "readonly": _vm.view || item.readonly,
        "placeholder": item.placeholder,
        "type": item.content.inputType === 'number' ? 'text' : item.content.inputType
      },
      domProps: {
        "value": item.value
      },
      on: {
        "copy": _vm.onCopy,
        "paste": _vm.onPaste,
        "cut": _vm.onCut,
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(item, "value", $event.target.value);
        }
      }
    }), item.content.required ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")]) : _vm._e()]) : _vm._e()]);
  }), _vm.questionErrorText ? [_c('div', {
    staticClass: "text-danger mt-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.questionErrorText))])])] : _vm._e()], 2);
};
var Blanksvue_type_template_id_0b5bcc4a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/text-fill/Blanks.vue?vue&type=template&id=0b5bcc4a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/Blanks.vue?vue&type=script&lang=js


/* harmony default export */ var Blanksvue_type_script_lang_js = ({
  changeExpr: 'changeExpr',
  name: 'Blanks',
  mixins: [disableCopyMixin],
  computed: {
    items() {
      const items = this.issue.items;
      return items.filter(i => i.content);
    },
    changeExpr() {
      return this.items.map(i => {
        return i.value;
      }).join('-');
    },
    disableCopy() {
      return this.issue.disableCopy;
    },
    questionErrorText() {
      return this.question.questionErrorList.map(i => i.message).join('');
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/questions/text-fill/Blanks.vue?vue&type=script&lang=js
 /* harmony default export */ var text_fill_Blanksvue_type_script_lang_js = (Blanksvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/text-fill/Blanks.vue





/* normalize component */

var Blanks_component = normalizeComponent(
  text_fill_Blanksvue_type_script_lang_js,
  Blanksvue_type_template_id_0b5bcc4a_render,
  Blanksvue_type_template_id_0b5bcc4a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Blanks = (Blanks_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/TextFill.vue?vue&type=template&id=dfb11208
var TextFillvue_type_template_id_dfb11208_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "text-fill",
    class: {
      'base-input-width': !_vm.nested
    }
  }, [_c('relation-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": _vm.issue.rows > 1 ? 'textarea' : _vm.inputType,
      "rows": _vm.issue.rows,
      "resize": "none",
      "enable-relation": _vm.issue.setting.enableRelation,
      "question-id": _vm.question.id,
      "question-type": _vm.question.questionType,
      "prefix-icon": _vm.prefixIcon ? 'iconfont ' + _vm.prefixIcon : '',
      "disable-copy": _vm.issue.disableCopy,
      "readonly": _vm.view || _vm.issue.readonly,
      "min-length": _vm.issue.min_length,
      "max-length": _vm.issue.max_length,
      "validate": _vm.issue.validate,
      "enabled-error-tip": _vm.enabledErrorTip,
      "allow-error-list": _vm.issue.allowErrorList
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    },
    scopedSlots: _vm._u([_vm.issue.messageValidate ? {
      key: "append",
      fn: function () {
        return [!_vm.issue.isValidateCode ? _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.openDialog
          }
        }, [_vm.countDown > 0 ? [_c('span', [_vm._v(_vm._s(_vm.countDown) + "秒后重试")])] : [_c('span', [_vm._v("发送验证码")])]], 2) : [_c('el-button', {
          attrs: {
            "disabled": "",
            "type": "primary"
          }
        }, [_vm._v("已验证")])]];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.issue.value,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "value", $$v);
      },
      expression: "issue.value"
    }
  }), _vm.issue.messageValidate ? [!_vm.issue.isValidateCode ? [_vm.msgFlag ? _c('el-input', {
    staticClass: "mt-2",
    attrs: {
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.onValidate
          }
        }, [_c('span', [_vm._v("验证")])])];
      },
      proxy: true
    }], null, false, 465370426),
    model: {
      value: _vm.msgCode,
      callback: function ($$v) {
        _vm.msgCode = $$v;
      },
      expression: "msgCode"
    }
  }) : _vm._e()] : [_c('span', [_vm._v("当前手机号已验证，更换手机号")]), _c('span', {
    staticClass: "text-theme",
    on: {
      "click": _vm.sendAgain
    }
  }, [_vm._v("重新验证")])]] : _vm._e(), _vm.questionErrorText ? [_c('div', {
    staticClass: "text-danger mt-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.questionErrorText))])])] : _vm._e(), _c('el-dialog', {
    attrs: {
      "visible": _vm.codePopup,
      "width": "700px",
      "title": "获取验证码"
    },
    on: {
      "update:visible": function ($event) {
        _vm.codePopup = $event;
      }
    }
  }, [_vm.codePopup ? _c('div', {
    staticClass: "mb-5"
  }, [_c('code-input', {
    ref: "codeInput",
    attrs: {
      "src": _vm.imgCodeUrl
    },
    on: {
      "refresh": _vm.onRefresh,
      "finished": _vm.onFinished
    }
  })], 1) : _vm._e()])], 2);
};
var TextFillvue_type_template_id_dfb11208_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/text-fill/TextFill.vue?vue&type=template&id=dfb11208

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/theme-chalk/message-box.css
var message_box = __webpack_require__("a1e9");

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/dygc-ui@1.0.22_vue@2.7.16/node_modules/dygc-ui/lib/message-box.js
var lib_message_box = __webpack_require__("fe7c");
var lib_message_box_default = /*#__PURE__*/__webpack_require__.n(lib_message_box);

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+core-js@3.33.2/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("178e");

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/CodeInput.vue?vue&type=template&id=9e856404&scoped=true
var CodeInputvue_type_template_id_9e856404_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "code-input"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.src,
      "alt": "验证码",
      "height": "60"
    }
  }), _c('span', {
    staticClass: "text-theme cursor-pointer ml-5",
    on: {
      "click": function ($event) {
        return _vm.$emit('refresh');
      }
    }
  }, [_vm._v("刷新")])]), _c('input', {
    ref: "input",
    staticClass: "h-0",
    attrs: {
      "type": "text"
    },
    on: {
      "input": _vm.onInput,
      "blur": _vm.onBlurHandler
    }
  }), _c('div', {
    on: {
      "click": _vm.onFocus
    }
  }, [_c('ul', {
    staticClass: "code-input__wrap relative"
  }, _vm._l(_vm.values, function (item, idx) {
    return _c('li', {
      key: idx,
      staticClass: "code-input__item text-center",
      class: {
        'code-input__focus': idx === _vm.activeIndex
      }
    }, [_c('span', [_vm._v(_vm._s(item))])]);
  }), 0)])]);
};
var CodeInputvue_type_template_id_9e856404_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/CodeInput.vue?vue&type=template&id=9e856404&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/CodeInput.vue?vue&type=script&lang=js
/* harmony default export */ var CodeInputvue_type_script_lang_js = ({
  name: 'CodeInput',
  props: {
    src: {
      type: String,
      required: true
    },
    len: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      activeIndex: 0,
      values: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.values = new Array(this.len);
    },
    onFocus() {
      this.$refs.input.focus();
      this.activeIndex = this.values.filter(Boolean).length;
    },
    onInput(event) {
      let value = event.target.value;
      let vals = value.split('').filter(x => x.toString().trim());
      let flag = true;
      for (let i = 0; i < this.values.length; i++) {
        if (vals[i]) {
          this.values[i] = vals[i];
        } else {
          this.values[i] = '';
          flag = false;
          this.activeIndex = i;
          break;
        }
      }
      if (flag) {
        let val = this.values.join('');
        this.activeIndex = -1;
        event.target.value = val;
        this.$emit('finished', val);
      }
      this.values.__ob__.dep.notify();
    },
    clear() {
      this.init();
    },
    onBlurHandler() {
      this.$refs.input.focus();
    }
  },
  mounted() {
    this.$refs.input.focus();
  }
});
// CONCATENATED MODULE: ./src/questions/components/CodeInput.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CodeInputvue_type_script_lang_js = (CodeInputvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/questions/components/CodeInput.vue?vue&type=style&index=0&id=9e856404&prod&scoped=true&lang=scss
var CodeInputvue_type_style_index_0_id_9e856404_prod_scoped_true_lang_scss = __webpack_require__("776a");

// CONCATENATED MODULE: ./src/questions/components/CodeInput.vue






/* normalize component */

var CodeInput_component = normalizeComponent(
  components_CodeInputvue_type_script_lang_js,
  CodeInputvue_type_template_id_9e856404_scoped_true_render,
  CodeInputvue_type_template_id_9e856404_scoped_true_staticRenderFns,
  false,
  null,
  "9e856404",
  null
  
)

/* harmony default export */ var CodeInput = (CodeInput_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/TextFill.vue?vue&type=script&lang=js










const SUCCESS = 0; // 成功
const REPEAT_SEND = 1; //当前答案已经验证过此手机号
const ERROR = 2; // 失败 短信数量为0或基础模块出错
/* harmony default export */ var TextFillvue_type_script_lang_js = ({
  name: 'TextFill',
  components: {
    RelationInput: RelationInput,
    CodeInput: CodeInput
  },
  changeExpr: 'issue.value',
  data() {
    return {
      randomStr: Date.now(),
      codePopup: false,
      countDown: 0,
      msgCode: '',
      msgFlag: false
    };
  },
  computed: {
    enabledErrorTip() {
      if (this.issue.validate !== dygc_esm_bundler["c" /* ValidateType */].NUM) return true;
      return this.issue.outOfRange !== 1;
    },
    questionErrorText() {
      var _this$question$questi;
      if (!this.question.questionErrorList) return '';
      return (_this$question$questi = this.question.questionErrorList.find(err => err.key === this.question.id)) === null || _this$question$questi === void 0 ? void 0 : _this$question$questi.message;
    },
    showErrorTip() {
      return !!this.errorTip.length;
    },
    errorTip() {
      return this.issue.getErrorTip();
    },
    imgCodeUrl() {
      return Object(dygc_esm_bundler["n" /* getImgCode */])(this.issue.value.trim(), this.randomStr);
    },
    inputType() {
      const type = this.issue.inputType;
      return type === 'password' ? type : 'text';
    },
    prefixIcon() {
      return Object(dygc_esm_bundler["o" /* getInputPrefixIcon */])(this.question.issue.validate);
    },
    placeholder() {
      return this.issue.placeholder || '请输入';
    }
  },
  methods: {
    onRefresh() {
      this.randomStr = Date.now();
    },
    onFinished(val) {
      console.log(val);
      this.imgCode = val;
      this.sendSmsCode();
    },
    repeatPhone() {
      this.question.issue.isValidateCode = true;
      this.oldPhone = '';
    },
    sendSmsCode() {
      if (!this.imgCode) {
        return;
      }
      if (this.__disabled) return;
      let answerId = this.$bus.answerId;
      let surveyId = this.$bus.survey.id;
      let phone = this.issue.value;
      let unique = this.issue.data_unique;
      let questionId = this.question.id;
      if (this.oldPhone === phone) {
        this.repeatPhone();
        this.codePopup = false;
        return;
      }
      this.__disabled = true;
      Object(dygc_esm_bundler["t" /* sendSmsCode */])({
        answerId,
        surveyId,
        phone,
        unique,
        questionId,
        preCode: this.imgCode
      }).then(res => {
        let data = res.data;
        if (data === SUCCESS) {
          this.countDown = 60;
          this.openCountDown();
          this.msgFlag = true;
          this.codePopup = false;
        } else if (data === REPEAT_SEND) {
          this.repeatPhone();
          this.codePopup = false;
        } else if (data === ERROR) {
          this.codePopup = false;
          if (res.msg === '答题确认短信余额不足') {
            this.issue.messageValidate = false;
            return;
          } else {
            this.$refs.codeInput.clear();
            this.$nextTick(() => {
              lib_message_default()({
                message: res.msg,
                type: 'warning'
              });
            });
          }
          this.imgCode = '';
        } else {
          if (res.msg === '短信发送失败，同一手机号每天最多发送5次') {
            // this.question.issue.messageValidate = false
            this.codePopup = false;
          }
          if (res.code === 1) {
            lib_message_default()({
              message: res.msg,
              type: 'warning'
            });
            this.codePopup = false;
          }
        }
        this.$nextTick(() => {
          this.__disabled = false;
        });
      }).catch(err => {});
    },
    onValidate() {
      // let rootVm = this.rootVm
      let answerId = this.$bus.answerId;
      let surveyId = this.$bus.survey.id;
      let issue = this.issue;
      let code = this.msgCode.trim();
      let phone = issue.value.trim();
      if (!code) {
        lib_message_default()({
          message: '请输入验证码',
          type: 'warning'
        });
        return;
      }
      if (this.validate) return;
      this.validate = true;
      Object(dygc_esm_bundler["y" /* validateCode */])({
        phone,
        answerId,
        surveyId,
        code,
        preCode: this.imgCode
      }).then(res => {
        let {
          code
        } = res;
        if (code === 0) {
          issue.isValidateCode = true;
        } else if (code === 1) {
          lib_message_default()({
            message: res.msg,
            type: 'warning'
          });
        } else {}
        this.validate = false;
      }).catch(err => {
        this.validate = false;
      });
    },
    openCountDown() {
      this.countDownTimer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          this.clearCountDown();
        }
      }, 1000);
    },
    clearCountDown() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
      this.countDown = 0;
    },
    openDialog() {
      console.log('xxx');
      try {
        if (!this.issue.value) {
          throw new Error('手机号不能为空');
        }
        this.issue.check(this.question.required);
        this.codePopup = true;
      } catch (e) {
        lib_message_default()({
          message: e.message,
          type: 'warning'
        });
      }
    },
    sendAgain() {
      lib_message_box_default.a.alert('您确定要重新验证吗', {
        title: '重新验证'
      }).then(() => {
        let phone = this.issue.value;
        this.oldPhone = phone;
        this.issue.isValidateCode = false;
        this.issue.value = '';
        this.msgFlag = false;
        this.msgCode = '';
        this.clearCountDown();
      });
    }
  },
  created() {
    if (this.question.setHook) {
      // fix 有可能是 矩阵题嵌入的组件 question 与正常的不一致
      this.question.setHook('confirm', isOK => {
        if (isOK) return;
        this.$refs.input.$refs.reference.focus();
      });
    }
  },
  beforeDestroy() {
    this.clearCountDown();
  }
});
// CONCATENATED MODULE: ./src/questions/text-fill/TextFill.vue?vue&type=script&lang=js
 /* harmony default export */ var text_fill_TextFillvue_type_script_lang_js = (TextFillvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/text-fill/TextFill.vue





/* normalize component */

var TextFill_component = normalizeComponent(
  text_fill_TextFillvue_type_script_lang_js,
  TextFillvue_type_template_id_dfb11208_render,
  TextFillvue_type_template_id_dfb11208_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextFill = (TextFill_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/Scale.vue?vue&type=template&id=1e04d0b8
var Scalevue_type_template_id_1e04d0b8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "scale"
  }, [_c('div', {
    style: _vm.scaleStyle
  }, [_c('ul', {
    staticClass: "flex justify-between"
  }, _vm._l(_vm.issue.labels, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "scale-item",
      style: _vm.getActiveColor(_vm.issue.value, index),
      on: {
        "click": function ($event) {
          return _vm.onChange(item);
        }
      }
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.num))])])]);
  }), 0), _c('div', {
    staticClass: "flex justify-between box-border mt-4 text-black text-opacity-85 text-small"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.issue.firstLabel.text))]), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.issue.lastLabel.text))])]), _vm.issue.show_unknown ? _c('div', {
    key: "unknown",
    staticClass: "unknown-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "unknown"
    },
    model: {
      value: _vm.issue.value,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "value", $$v);
      },
      expression: "issue.value"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.unknown_text))])])], 1) : _vm._e()])]);
};
var Scalevue_type_template_id_1e04d0b8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/scale/Scale.vue?vue&type=template&id=1e04d0b8

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/Scale.vue?vue&type=script&lang=js
/* harmony default export */ var Scalevue_type_script_lang_js = ({
  name: 'NPSScale',
  changeExpr: 'issue.value',
  computed: {
    scaleStyle() {
      return {
        width: Math.min(this.issue.labels.length * 90, 690) + 'px'
      };
    }
  },
  methods: {
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx);
    },
    onChange(item) {
      if (this.view) return;
      this.issue.value = item.id;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/scale/Scale.vue?vue&type=script&lang=js
 /* harmony default export */ var scale_Scalevue_type_script_lang_js = (Scalevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/scale/Scale.vue





/* normalize component */

var Scale_component = normalizeComponent(
  scale_Scalevue_type_script_lang_js,
  Scalevue_type_template_id_1e04d0b8_render,
  Scalevue_type_template_id_1e04d0b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Scale = (Scale_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixCompose.vue?vue&type=template&id=fd3589f4&scoped=true
var MatrixComposevue_type_template_id_fd3589f4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-compose"
  }, [_c('q-table', {
    ref: "table",
    attrs: {
      "view": _vm.view,
      "rows": _vm.issue.rows,
      "columns": _vm.issue.items,
      "show-required": "",
      "row-desc": _vm.issue.rowDesc,
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        row,
        col
      }) {
        return [_c('div', [_c('compose-item', {
          attrs: {
            "row": row,
            "col": col,
            "cell": _vm.issue.getCellByItemId(col.id),
            "cache-value": _vm.issue.getValueByRowAndCol(row, col)
          },
          on: {
            "change": _vm.onChangeValue
          }
        }), row.errMap[col.id] ? [_c('div', [_c('span', {
          staticClass: "text-red mt-1 text-small"
        }, [_vm._v(_vm._s(row.errMap[col.id]))])])] : _vm._e()], 2)];
      }
    }])
  })], 1);
};
var MatrixComposevue_type_template_id_fd3589f4_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixCompose.vue?vue&type=template&id=fd3589f4&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/ComposeItem.vue?vue&type=template&id=27452982
var ComposeItemvue_type_template_id_27452982_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "nested": "",
      "question": {
        issue: _vm.issue
      }
    },
    on: {
      "change": _vm.onChangeValue
    }
  })], 1);
};
var ComposeItemvue_type_template_id_27452982_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/ComposeItem.vue?vue&type=template&id=27452982

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/ComposeItem.vue?vue&type=script&lang=js




/* harmony default export */ var ComposeItemvue_type_script_lang_js = ({
  name: 'ComposeItem',
  components: {
    TextFill: TextFill,
    SingleSelectChoice: SingleSelectChoice,
    MultipleSelectChoice: MultipleSelectChoice
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    col: {
      type: Object,
      default: () => ({})
    },
    cell: {
      type: Object,
      default: () => ({})
    },
    cacheValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      issue: null
    };
  },
  computed: {
    componentName() {
      return dygc_esm_bundler["g" /* componentMap */].get(this.cell.cell_type);
    }
  },
  created() {
    let cell = this.cell;
    this.issue = Object(dygc_esm_bundler["j" /* createIssueFactory */])(cell, cell.cell_type);
  },
  methods: {
    onChangeValue() {
      let value = this.issue.getValue();
      if (!value.length) {
        value = [];
      }
      let rowId = this.row.row_id;
      let colId = this.col.id;
      value = value.map(val => {
        return Object.assign({}, val, {
          rowId,
          colId
        });
      });
      this.$emit('change', value);
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.cacheValue) {
        this.issue.setValue([this.cacheValue]);
      }
    });
  }
});
// CONCATENATED MODULE: ./src/questions/components/ComposeItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ComposeItemvue_type_script_lang_js = (ComposeItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/ComposeItem.vue





/* normalize component */

var ComposeItem_component = normalizeComponent(
  components_ComposeItemvue_type_script_lang_js,
  ComposeItemvue_type_template_id_27452982_render,
  ComposeItemvue_type_template_id_27452982_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ComposeItem = (ComposeItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixCompose.vue?vue&type=script&lang=js



/* harmony default export */ var MatrixComposevue_type_script_lang_js = ({
  name: 'MatrixCompose',
  changeExpr: 'issue.value',
  components: {
    QTable: QTable,
    ComposeItem: ComposeItem,
    MatrixTable: MatrixTable
  },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice());
      setTimeout(() => {
        this.$refs.table.initTable();
      }, 30);
    }
  },
  created() {
    this.question.setHook('submitError', () => {
      this.$nextTick(() => {
        this.$refs.table.initTable();
      });
    });
    this.question.setHook('submitSuccess', () => {
      this.$nextTick(() => {
        this.$refs.table.initTable();
      });
    });
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixCompose.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixComposevue_type_script_lang_js = (MatrixComposevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixCompose.vue





/* normalize component */

var MatrixCompose_component = normalizeComponent(
  matrix_MatrixComposevue_type_script_lang_js,
  MatrixComposevue_type_template_id_fd3589f4_scoped_true_render,
  MatrixComposevue_type_template_id_fd3589f4_scoped_true_staticRenderFns,
  false,
  null,
  "fd3589f4",
  null
  
)

/* harmony default export */ var MatrixCompose = (MatrixCompose_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixAuto.vue?vue&type=template&id=40505edf
var MatrixAutovue_type_template_id_40505edf_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-auto max-w-full",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_c('q-table', {
    staticStyle: {
      "padding-right": "30px"
    },
    attrs: {
      "view": _vm.view,
      "disabled-row": "",
      "rows": _vm.issue.rows,
      "columns": _vm.issue.items,
      "show-required": "",
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        col,
        row,
        rowIndex,
        colIndex
      }) {
        return [_c('div', {
          staticClass: "relative"
        }, [_c('compose-item', {
          attrs: {
            "row": row,
            "col": col,
            "cell": _vm.issue.getCellByItemId(col.id),
            "cache-value": _vm.issue.getValueByRowAndCol(row, col)
          },
          on: {
            "change": _vm.onChangeValue
          }
        }), rowIndex === _vm.issue.rows.length - 1 && colIndex === _vm.issue.items.length - 1 ? [_vm.issue.rows.length > _vm.issue.min_row_num ? [_c('div', {
          staticClass: "absolute",
          staticStyle: {
            "right": "-40px",
            "top": "2px"
          }
        }, [_c('span', {
          staticClass: "text-red cursor-pointer text-large",
          on: {
            "click": function ($event) {
              return _vm.onDeleteRow(rowIndex);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-remove"
        })])])] : _vm._e()] : _vm._e(), row.errMap[col.id] ? [_c('div', [_c('span', {
          staticClass: "text-red mt-1 text-small"
        }, [_vm._v(_vm._s(row.errMap[col.id]))])])] : _vm._e()], 2)];
      }
    }])
  }), _vm.issue.can_add_row && _vm.issue.rows.length < _vm.issue.max_row_num ? [_c('div', {
    staticClass: "text-center text-medium",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._m(0)])] : _vm._e()], 2);
};
var MatrixAutovue_type_template_id_40505edf_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cursor-pointer text-theme-text-gray py-1.5 border border-border-gray border-dashed mt-2 hover:border-theme hover:text-theme"
  }, [_c('span', [_vm._v("+ 继续填写")])]);
}];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixAuto.vue?vue&type=template&id=40505edf

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixAuto.vue?vue&type=script&lang=js



/* harmony default export */ var MatrixAutovue_type_script_lang_js = ({
  name: 'MatrixAuto',
  changeExpr: 'issue.value',
  components: {
    QTable: QTable,
    ComposeItem: ComposeItem,
    MatrixTable: MatrixTable
  },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice());
    },
    addRow() {
      this.issue.addRow();
    },
    onDeleteRow(index) {
      this.issue.deleteRow(index);
    }
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixAuto.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixAutovue_type_script_lang_js = (MatrixAutovue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixAuto.vue





/* normalize component */

var MatrixAuto_component = normalizeComponent(
  matrix_MatrixAutovue_type_script_lang_js,
  MatrixAutovue_type_template_id_40505edf_render,
  MatrixAutovue_type_template_id_40505edf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MatrixAuto = (MatrixAuto_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixGravity.vue?vue&type=template&id=65e02232
var MatrixGravityvue_type_template_id_65e02232_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-gravity"
  }, [_vm._l(_vm.issue.items, function (item, index) {
    return _c('div', {
      key: item.id,
      attrs: {
        "view": _vm.view
      }
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "option-title",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]), _c('div', {
      staticClass: "option-slider flex-1 ml-5"
    }, [_c('el-slider', {
      ref: "elSlider",
      refInFor: true,
      attrs: {
        "value": item.value,
        "show-input": "",
        "max": _vm.issue.max,
        "min": _vm.issue.min
      },
      on: {
        "input": function ($event) {
          return _vm.onSliderChange($event, item, index);
        }
      }
    })], 1)])]);
  }), _c('div', {
    staticClass: "text-right mt-2"
  }, [_vm._v(" 比重总和： "), _c('span', {
    class: {
      'text-red': _vm.isError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currentValue))])])])], 2);
};
var MatrixGravityvue_type_template_id_65e02232_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixGravity.vue?vue&type=template&id=65e02232

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixGravity.vue?vue&type=script&lang=js

/* harmony default export */ var MatrixGravityvue_type_script_lang_js = ({
  name: 'MatrixGravity',
  changeExpr: 'currentValue',
  computed: {
    isError() {
      return this.getCurrentValue() !== this.totalValue;
    },
    totalValue() {
      return this.issue.totalValue;
    },
    currentValue() {
      return this.getCurrentValue();
    }
  },
  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0;
        }
        return preValue + parseInt(item.value);
      }, 0);
    },
    onSliderChange(value, item, index) {
      item.value = value;
      /* const items = this.issue.items
       if (items.length === 2) {
         if (items.every(item => item.value == '0') && value == '0') {
           // TODO
         } else {
           items.forEach(item => {
             item.value = this.issue.max - parseInt(value)
           })
         }
         item.value = value
       } else {
         let v = this.issue.totalValue - this.getCurrentValue(item)
         item.value = value
         this.$nextTick(() => {
           item.value = Math.min(v, value)
         })
       }*/
    }
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixGravity.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixGravityvue_type_script_lang_js = (MatrixGravityvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixGravity.vue





/* normalize component */

var MatrixGravity_component = normalizeComponent(
  matrix_MatrixGravityvue_type_script_lang_js,
  MatrixGravityvue_type_template_id_65e02232_render,
  MatrixGravityvue_type_template_id_65e02232_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MatrixGravity = (MatrixGravity_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixScroll.vue?vue&type=template&id=2174176a
var MatrixScrollvue_type_template_id_2174176a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-scroll"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "140px"
    }
  }), _c('div', {
    staticClass: "flex-1 flex justify-between ml-5",
    staticStyle: {
      "padding-right": "160px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.firstLabel.text))]), _c('span', [_vm._v(_vm._s(_vm.lastLabel.text))])])]), _vm._l(_vm.issue.items, function (item, index) {
    return _c('div', {
      key: item.id
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "option-title",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]), _c('div', {
      staticClass: "option-slider flex-1 ml-5"
    }, [_c('el-slider', {
      ref: "elSlider",
      refInFor: true,
      attrs: {
        "value": item.value,
        "show-input": "",
        "max": _vm.issue.max,
        "min": _vm.issue.min
      },
      on: {
        "input": function ($event) {
          return _vm.onSliderChange($event, item, index);
        }
      }
    })], 1)])]);
  })], 2);
};
var MatrixScrollvue_type_template_id_2174176a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixScroll.vue?vue&type=template&id=2174176a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixScroll.vue?vue&type=script&lang=js

/* harmony default export */ var MatrixScrollvue_type_script_lang_js = ({
  name: 'MatrixScroll',
  changeExpr: 'currentValue',
  computed: {
    currentValue() {
      return this.getCurrentValue();
    },
    firstLabel() {
      return this.issue.labels[0];
    },
    lastLabel() {
      const labels = this.issue.labels;
      return labels[labels.length - 1];
    }
  },
  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0;
        }
        return preValue + parseInt(item.value);
      }, 0);
    },
    onSliderChange(value, item, index) {
      item.value = value;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixScroll.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixScrollvue_type_script_lang_js = (MatrixScrollvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixScroll.vue





/* normalize component */

var MatrixScroll_component = normalizeComponent(
  matrix_MatrixScrollvue_type_script_lang_js,
  MatrixScrollvue_type_template_id_2174176a_render,
  MatrixScrollvue_type_template_id_2174176a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MatrixScroll = (MatrixScroll_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/MultipleBlanks.vue?vue&type=template&id=56e38e38
var MultipleBlanksvue_type_template_id_56e38e38_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "multiple-blanks"
  }, _vm._l(_vm.issue.fillContext, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "mb-2 last:mb-0"
    }, [_c('div', {
      staticClass: "mb-1 leading-base",
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    }), _c('div', {
      staticClass: "base-input-width"
    }, [_c('relation-input', {
      attrs: {
        "question-type": _vm.question.questionType,
        "question-id": _vm.question.id,
        "option-id": item.id,
        "type": item.inputType,
        "enable-relation": _vm.issue.setting.enableRelation,
        "disable-copy": _vm.issue.disableCopy,
        "readonly": _vm.view || item.readonly,
        "placeholder": item.placeholder,
        "prefix-icon": item.prefixIcon ? 'iconfont ' + item.prefixIcon : ''
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    })], 1), _vm.errorList[index] ? [_c('div', {
      staticClass: "text-danger mt-1"
    }, [_c('span', [_vm._v(_vm._s(_vm.errorList[index]))])])] : _vm._e()], 2);
  }), 0);
};
var MultipleBlanksvue_type_template_id_56e38e38_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/text-fill/MultipleBlanks.vue?vue&type=template&id=56e38e38

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/text-fill/MultipleBlanks.vue?vue&type=script&lang=js

/* harmony default export */ var MultipleBlanksvue_type_script_lang_js = ({
  name: 'MultipleBlanks',
  components: {
    RelationInput: RelationInput
  },
  changeExpr: 'changeExpr',
  data() {
    return {
      errorList: []
    };
  },
  computed: {
    changeExpr() {
      return this.issue.fillContext.map(item => item.value + item.content.fileList.length).join('-');
    }
  },
  created() {
    this.errorList = new Array(this.issue.fillContext.length);
  },
  watch: {
    'question.questionErrorList'(list) {
      this.errorList = new Array(this.issue.fillContext.length);
      this.issue.fillContext.forEach((item, index) => {
        const key = `${this.question.id}.${item.id}`;
        const i = list.find(i => i.key === key);
        if (!i) return;
        this.errorList[index] = i.message;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/text-fill/MultipleBlanks.vue?vue&type=script&lang=js
 /* harmony default export */ var text_fill_MultipleBlanksvue_type_script_lang_js = (MultipleBlanksvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/text-fill/MultipleBlanks.vue





/* normalize component */

var MultipleBlanks_component = normalizeComponent(
  text_fill_MultipleBlanksvue_type_script_lang_js,
  MultipleBlanksvue_type_template_id_56e38e38_render,
  MultipleBlanksvue_type_template_id_56e38e38_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleBlanks = (MultipleBlanks_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleImageChoice.vue?vue&type=template&id=3c9d7c68&scoped=true
var SingleImageChoicevue_type_template_id_3c9d7c68_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "single-image-choice"
  });
};
var SingleImageChoicevue_type_template_id_3c9d7c68_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/SingleImageChoice.vue?vue&type=template&id=3c9d7c68&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/SingleImageChoice.vue?vue&type=script&lang=js
/* harmony default export */ var SingleImageChoicevue_type_script_lang_js = ({
  name: 'SingleImageChoice'
});
// CONCATENATED MODULE: ./src/questions/choice/SingleImageChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_SingleImageChoicevue_type_script_lang_js = (SingleImageChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/SingleImageChoice.vue





/* normalize component */

var SingleImageChoice_component = normalizeComponent(
  choice_SingleImageChoicevue_type_script_lang_js,
  SingleImageChoicevue_type_template_id_3c9d7c68_scoped_true_render,
  SingleImageChoicevue_type_template_id_3c9d7c68_scoped_true_staticRenderFns,
  false,
  null,
  "3c9d7c68",
  null
  
)

/* harmony default export */ var SingleImageChoice = (SingleImageChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleImageChoice.vue?vue&type=template&id=2bd69ca7
var MultipleImageChoicevue_type_template_id_2bd69ca7_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "multiple-image-choice"
  }, [_c('el-checkbox-group', {
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, [_c('ul', _vm._l(_vm.issue.items, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "image-choice-box"
    }, [_c('image-choice-item', {
      class: {
        checked: _vm.issue.select.includes(item.id)
      },
      attrs: {
        "item": item
      },
      scopedSlots: _vm._u([{
        key: "vote",
        fn: function () {
          return [_vm.showVoteProgress && _vm.issue.select.length ? _c('vote-progress', {
            attrs: {
              "vote": _vm.question.vote,
              "label": item.id,
              "checked": _vm.issue.select.includes(item.id),
              "selected": !!_vm.issue.select.length
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [[_c('adapter-checkbox', {
      attrs: {
        "label": item.id,
        "rich-text": item.content.richText,
        "max": _vm.issue.max_choice
      }
    }, [_c('div', {
      ref: "text",
      refInFor: true,
      staticClass: "text-theme-black-850 text-medium leading-base",
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })])]], 2)], 1);
  }), 0)])], 1);
};
var MultipleImageChoicevue_type_template_id_2bd69ca7_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/MultipleImageChoice.vue?vue&type=template&id=2bd69ca7

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/ImageChoiceItem.vue?vue&type=template&id=7e6f488f
var ImageChoiceItemvue_type_template_id_7e6f488f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "image-choice-item"
  }, [_c('div', {
    staticClass: "mb-2 image-wrap"
  }, _vm._l(_vm.item.content.image, function (img) {
    return _c('el-image', {
      key: img.url,
      attrs: {
        "src": img.url,
        "preview-src-list": [img.url]
      }
    });
  }), 1), _c('div', {
    staticClass: "px-3 py-2.5"
  }, [_vm._t("default")], 2), _vm._t("vote")], 2);
};
var ImageChoiceItemvue_type_template_id_7e6f488f_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/ImageChoiceItem.vue?vue&type=template&id=7e6f488f

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/ImageChoiceItem.vue?vue&type=script&lang=js
/* harmony default export */ var ImageChoiceItemvue_type_script_lang_js = ({
  name: 'ImageChoiceItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/ImageChoiceItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_ImageChoiceItemvue_type_script_lang_js = (ImageChoiceItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/ImageChoiceItem.vue





/* normalize component */

var ImageChoiceItem_component = normalizeComponent(
  components_ImageChoiceItemvue_type_script_lang_js,
  ImageChoiceItemvue_type_template_id_7e6f488f_render,
  ImageChoiceItemvue_type_template_id_7e6f488f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ImageChoiceItem = (ImageChoiceItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/MultipleImageChoice.vue?vue&type=script&lang=js



/* harmony default export */ var MultipleImageChoicevue_type_script_lang_js = ({
  changeExpr: 'issue.select',
  name: 'MultipleImageChoice',
  components: {
    VoteProgress: VoteProgress,
    AdapterCheckbox: AdapterCheckbox,
    ImageChoiceItem: ImageChoiceItem
  }
});
// CONCATENATED MODULE: ./src/questions/choice/MultipleImageChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_MultipleImageChoicevue_type_script_lang_js = (MultipleImageChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/MultipleImageChoice.vue





/* normalize component */

var MultipleImageChoice_component = normalizeComponent(
  choice_MultipleImageChoicevue_type_script_lang_js,
  MultipleImageChoicevue_type_template_id_2bd69ca7_render,
  MultipleImageChoicevue_type_template_id_2bd69ca7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleImageChoice = (MultipleImageChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixFill.vue?vue&type=template&id=5072fd3a
var MatrixFillvue_type_template_id_5072fd3a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "matrix-fill"
  }, [_c('q-table', {
    ref: "table",
    attrs: {
      "view": _vm.view,
      "columns": _vm.issue.items,
      "rows": _vm.issue.rows,
      "row-desc": _vm.issue.rowDesc,
      "widths": _vm.issue.widths
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function ({
        row,
        col
      }) {
        return [_c('fill', {
          attrs: {
            "option": _vm.issue.getCellByRowAndCol(row, col),
            "question-type": _vm.question.questionType,
            "question-id": _vm.question.id,
            "question": _vm.question,
            "enable-relation": _vm.issue.setting.enableRelation,
            "disable-copy": _vm.issue.disableCopy
          }
        })];
      }
    }])
  })], 1);
};
var MatrixFillvue_type_template_id_5072fd3a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/matrix/MatrixFill.vue?vue&type=template&id=5072fd3a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Fill.vue?vue&type=template&id=502e29c8
var Fillvue_type_template_id_502e29c8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('relation-input', {
    attrs: {
      "option-id": _vm.option.fillContext[0].id,
      "question-id": _vm.questionId,
      "question-type": _vm.questionType,
      "enable-relation": _vm.enableRelation,
      "disable-copy": _vm.disableCopy,
      "readonly": _vm.option.readonly
    },
    model: {
      value: _vm.option.value,
      callback: function ($$v) {
        _vm.$set(_vm.option, "value", $$v);
      },
      expression: "option.value"
    }
  }), _vm.errorText ? [_c('div', {
    staticClass: "text-danger mt-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorText))])])] : _vm._e()], 2);
};
var Fillvue_type_template_id_502e29c8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/Fill.vue?vue&type=template&id=502e29c8

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/Fill.vue?vue&type=script&lang=js

/* harmony default export */ var Fillvue_type_script_lang_js = ({
  name: 'Fill',
  components: {
    RelationInput: RelationInput
  },
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    questionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    },
    disableCopy: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    errorText() {
      var _this$question$questi;
      const key = `${this.question.id}.${this.option.rowId}.${this.option.colId}`;
      return (_this$question$questi = this.question.questionErrorList.find(i => i.key === key)) === null || _this$question$questi === void 0 ? void 0 : _this$question$questi.message;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/Fill.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Fillvue_type_script_lang_js = (Fillvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/Fill.vue





/* normalize component */

var Fill_component = normalizeComponent(
  components_Fillvue_type_script_lang_js,
  Fillvue_type_template_id_502e29c8_render,
  Fillvue_type_template_id_502e29c8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Fill = (Fill_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/matrix/MatrixFill.vue?vue&type=script&lang=js



/* harmony default export */ var MatrixFillvue_type_script_lang_js = ({
  name: 'MatrixFill',
  components: {
    QTable: QTable,
    Fill: Fill,
    MatrixTable: MatrixTable
  },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      return this.issue.cells.map(i => i.value).filter(Boolean).join('-');
    }
  },
  watch: {
    'question.questionErrorList'() {
      this.$nextTick(() => {
        this.$refs.table.initTable();
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/matrix/MatrixFill.vue?vue&type=script&lang=js
 /* harmony default export */ var matrix_MatrixFillvue_type_script_lang_js = (MatrixFillvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/matrix/MatrixFill.vue





/* normalize component */

var MatrixFill_component = normalizeComponent(
  matrix_MatrixFillvue_type_script_lang_js,
  MatrixFillvue_type_template_id_5072fd3a_render,
  MatrixFillvue_type_template_id_5072fd3a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MatrixFill = (MatrixFill_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/UploadFile.vue?vue&type=template&id=6278d676
var UploadFilevue_type_template_id_6278d676_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "upload-file"
  }, [_c('upload-files', {
    attrs: {
      "min": _vm.issue.min,
      "max": _vm.issue.max,
      "check-file-type": _vm.issue.checkFileType,
      "allow-types": _vm.issue.allowFileTypes,
      "upload-file-max-size": _vm.question.uploadFileMaxSize
    },
    model: {
      value: _vm.issue.uploadFiles,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "uploadFiles", $$v);
      },
      expression: "issue.uploadFiles"
    }
  })], 1);
};
var UploadFilevue_type_template_id_6278d676_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/UploadFile.vue?vue&type=template&id=6278d676

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/UploadFile.vue?vue&type=script&lang=js

/* harmony default export */ var UploadFilevue_type_script_lang_js = ({
  name: 'UploadFile',
  changeExpr: 'issue.uploadFiles',
  components: {
    UploadFiles: UploadFiles
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/UploadFile.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_UploadFilevue_type_script_lang_js = (UploadFilevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/UploadFile.vue





/* normalize component */

var UploadFile_component = normalizeComponent(
  specific_format_UploadFilevue_type_script_lang_js,
  UploadFilevue_type_template_id_6278d676_render,
  UploadFilevue_type_template_id_6278d676_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UploadFile = (UploadFile_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/DateQ.vue?vue&type=template&id=4ec4c4be
var DateQvue_type_template_id_4ec4c4be_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "date-q"
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": _vm.typeFormat,
      "format": _vm.typeFormat,
      "type": _vm.dateType,
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions,
      "disabled": _vm.view
    },
    on: {
      "change": _vm.onChangeYmd
    },
    model: {
      value: _vm.ymdValue,
      callback: function ($$v) {
        _vm.ymdValue = $$v;
      },
      expression: "ymdValue"
    }
  }), _vm.showTimePicker ? _c('el-time-picker', {
    attrs: {
      "disabled": _vm.disabledTimePicker,
      "value-format": _vm.timeFormat,
      "format": _vm.timeFormat,
      "picker-options": _vm.timeOptions,
      "placeholder": "选择时间"
    },
    on: {
      "change": _vm.onChangeTimeValue
    },
    model: {
      value: _vm.timeValue,
      callback: function ($$v) {
        _vm.timeValue = $$v;
      },
      expression: "timeValue"
    }
  }) : _vm._e()], 1);
};
var DateQvue_type_template_id_4ec4c4be_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/DateQ.vue?vue&type=template&id=4ec4c4be

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/DateQ.vue?vue&type=script&lang=js

/* harmony default export */ var DateQvue_type_script_lang_js = ({
  name: 'DateQ',
  changeExpr: 'issue.value',
  data() {
    const issue = this.question.issue;
    let min = new Date(issue.min || '1900-01-01');
    let max = new Date(issue.max || '9012-12-31');
    if (issue.validateType === 'relativeTime') {
      let d = new Date();
      min = new Date(d.getTime() + issue.min * 1000 * 60 * 60 * 24);
      max = new Date(min.getTime() + issue.range * 1000 * 60 * 60 * 24);
    }
    return {
      ymdValue: '',
      timeValue: '',
      pickerOptions: {
        disabledDate(date) {
          let c1 = Object(dygc_esm_bundler["f" /* compareDate */])(date, min, 3);
          if (c1 < 0) return true;
          let c2 = Object(dygc_esm_bundler["f" /* compareDate */])(date, max, 3);
          if (c2 > 0) return true;
        }
      },
      timeOptions: null,
      timeFormat: '',
      min,
      max
    };
  },
  computed: {
    dateType() {
      switch (this.issue.dateType) {
        case 'year':
          return 'year';
        case 'month':
          return 'month';
        default:
          return 'date';
      }
    },
    typeFormat() {
      switch (this.issue.dateType) {
        case 'year':
          return 'yyyy';
        case 'month':
          return 'yyyy-MM';
        default:
          return 'yyyy-MM-dd';
      }
    },
    showTimePicker() {
      return ['分', '秒'].includes(this.issue.dateType);
    },
    disabledTimePicker() {
      return !this.ymdValue || this.view;
    }
  },
  methods: {
    onChangeYmd() {
      this.initTimeOptions();
      if (!this.showTimePicker) {
        this.issue.value = this.ymdValue;
      }
    },
    onChangeTimeValue() {
      this.issue.value = `${this.ymdValue} ${this.timeValue}`;
    },
    initTimeOptions() {
      let selectableRange = '00:00:00 - 23:59:59';
      let ymd = new Date(this.ymdValue);
      let min = this.min;
      let max = this.max;
      let cmin = Object(dygc_esm_bundler["f" /* compareDate */])(ymd, this.min, 3);
      let cmax = Object(dygc_esm_bundler["f" /* compareDate */])(ymd, this.max, 3);
      const minStr = `${min.getHours()}:${min.getMinutes()}:${min.getSeconds()}`;
      const maxStr = `${max.getHours()}:${max.getMinutes()}:${max.getSeconds()}`;
      if (Object(dygc_esm_bundler["f" /* compareDate */])(this.min, this.max) === 0) {
        selectableRange = `${minStr} - ${maxStr}`;
      } else if (cmin === 0) {
        selectableRange = `${minStr} - 23:59:59`;
      } else if (cmax === 0) {
        selectableRange = `00:00:00 - ${maxStr}`;
      }
      if (this.issue.dateType === '分') {
        this.timeOptions = {
          selectableRange,
          format: 'HH:mm'
        };
        this.timeFormat = 'HH:mm';
      } else {
        this.timeOptions = {
          selectableRange,
          format: 'HH:mm:ss'
        };
        this.timeFormat = 'HH:mm:ss';
      }
    }
  },
  created() {
    this.initTimeOptions();
  },
  mounted() {
    if (this.issue.value) {
      const [ymd, time] = this.issue.value.split(' ');
      this.ymdValue = ymd;
      this.timeValue = time || '';
    }
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/DateQ.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_DateQvue_type_script_lang_js = (DateQvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/DateQ.vue





/* normalize component */

var DateQ_component = normalizeComponent(
  specific_format_DateQvue_type_script_lang_js,
  DateQvue_type_template_id_4ec4c4be_render,
  DateQvue_type_template_id_4ec4c4be_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DateQ = (DateQ_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/ImageChoice.vue?vue&type=template&id=7a9cb5aa
var ImageChoicevue_type_template_id_7a9cb5aa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('el-radio-group', {
    model: {
      value: _vm.issue.select,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "select", $$v);
      },
      expression: "issue.select"
    }
  }, [_c('ul', _vm._l(_vm.issue.items, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "image-choice-box"
    }, [_c('image-choice-item', {
      class: {
        checked: _vm.issue.select === item.id
      },
      attrs: {
        "item": item
      },
      scopedSlots: _vm._u([{
        key: "vote",
        fn: function () {
          return [_vm.showVoteProgress && _vm.issue.select ? _c('vote-progress', {
            attrs: {
              "vote": _vm.question.vote,
              "label": item.id,
              "checked": _vm.issue.select === item.id,
              "selected": !!_vm.issue.select
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [[_c('adapter-radio', {
      attrs: {
        "label": item.id,
        "rich-text": item.content.richText
      }
    }, [_c('div', {
      ref: "text",
      refInFor: true,
      staticClass: "text-theme-black-850 text-medium leading-base",
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })])]], 2)], 1);
  }), 0)])], 1);
};
var ImageChoicevue_type_template_id_7a9cb5aa_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/ImageChoice.vue?vue&type=template&id=7a9cb5aa

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/ImageChoice.vue?vue&type=script&lang=js



/* harmony default export */ var ImageChoicevue_type_script_lang_js = ({
  changeExpr: 'issue.select',
  name: 'ImageChoice',
  components: {
    VoteProgress: VoteProgress,
    AdapterRadio: AdapterRadio,
    ImageChoiceItem: ImageChoiceItem
  }
});
// CONCATENATED MODULE: ./src/questions/choice/ImageChoice.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_ImageChoicevue_type_script_lang_js = (ImageChoicevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/ImageChoice.vue





/* normalize component */

var ImageChoice_component = normalizeComponent(
  choice_ImageChoicevue_type_script_lang_js,
  ImageChoicevue_type_template_id_7a9cb5aa_render,
  ImageChoicevue_type_template_id_7a9cb5aa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ImageChoice = (ImageChoice_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/Classification.vue?vue&type=template&id=cfd2b9fa
var Classificationvue_type_template_id_cfd2b9fa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container",
    staticClass: "classification clearfix draggable-group select-none"
  }, [_c('div', {
    staticClass: "option-wrap"
  }, [_c('div', {
    staticClass: "classification-box"
  }, [_vm._m(0), _c('draggable', {
    attrs: {
      "disabled": _vm.view,
      "group": _vm.question.id,
      "ghost-class": "ghost",
      "chosen-class": "chosen"
    },
    model: {
      value: _vm.issue.rows,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "rows", $$v);
      },
      expression: "issue.rows"
    }
  }, [_c('transition-group', {
    attrs: {
      "tag": "ul"
    }
  }, _vm._l(_vm.issue.rows, function (item) {
    return _c('li', {
      key: item.row_id,
      staticClass: "classification-item"
    }, [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })])]);
  }), 0)], 1)], 1)]), _c('div', {
    staticClass: "category-wrap"
  }, [_c('div', {
    staticClass: "classification-box"
  }, [_vm._m(1), _c('ul', _vm._l(_vm.issue.items, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "category-box relative mb-2 last:mb-0"
    }, [_c('div', {
      staticClass: "category-title"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]), _c('div', {
      staticClass: "relative"
    }, [_c('draggable', {
      staticClass: "px-2",
      attrs: {
        "disabled": _vm.view,
        "group": _vm.question.id,
        "ghost-class": "ghost",
        "chosen-class": "chosen"
      },
      model: {
        value: item.selects,
        callback: function ($$v) {
          _vm.$set(item, "selects", $$v);
        },
        expression: "item.selects"
      }
    }, [_c('transition-group', {
      staticClass: "category-content",
      attrs: {
        "tag": "div"
      }
    }, _vm._l(item.selects, function (opt) {
      return _c('div', {
        key: opt.row_id,
        staticClass: "classification-item"
      }, [_c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(opt.content.richText)
        }
      })])]);
    }), 0)], 1), !item.selects.length ? _c('div', {
      key: "category-empty",
      staticClass: "category-empty"
    }, [_c('span', [_vm._v("拖入此处")])]) : _vm._e()], 1)]);
  }), 0)])])]);
};
var Classificationvue_type_template_id_cfd2b9fa_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "classification-title"
  }, [_c('span', [_vm._v("选项区")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "classification-title"
  }, [_c('span', [_vm._v("分类区")])]);
}];

// CONCATENATED MODULE: ./src/questions/choice/Classification.vue?vue&type=template&id=cfd2b9fa

// EXTERNAL MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/vuedraggable@2.24.3/node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("4366");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/Classification.vue?vue&type=script&lang=js


/* harmony default export */ var Classificationvue_type_script_lang_js = ({
  name: 'Classification',
  changeExpr: 'changeExpr',
  components: {
    draggable: vuedraggable_umd_default.a
  },
  data() {
    return {};
  },
  computed: {
    changeExpr() {
      let items = this.issue.items;
      return items.map(item => {
        return item.selects.map(i => i.row_id).join(',');
      }).join('-');
    }
  },
  created() {},
  methods: {},
  watch: {
    changeExpr() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          previewImage(this.$refs.container);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/Classification.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_Classificationvue_type_script_lang_js = (Classificationvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/Classification.vue





/* normalize component */

var Classification_component = normalizeComponent(
  choice_Classificationvue_type_script_lang_js,
  Classificationvue_type_template_id_cfd2b9fa_render,
  Classificationvue_type_template_id_cfd2b9fa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Classification = (Classification_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/NPSScale.vue?vue&type=template&id=5a0568da
var NPSScalevue_type_template_id_5a0568da_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nps-scale"
  }, [_c('div', {
    staticClass: "relative",
    style: _vm.scaleStyle
  }, [_c('ul', {
    staticClass: "flex justify-between"
  }, _vm._l(_vm.issue.labels, function (item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "scale-item",
      style: _vm.issue.getActiveColor(_vm.issue.value, index),
      on: {
        "click": function ($event) {
          return _vm.onChange(item);
        }
      }
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.num))])])]);
  }), 0), _c('div', {
    staticClass: "text-small clearfix mt-2 text-theme-black-450"
  }, [_c('span', {
    staticClass: "float-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.firstLabel.text))])]), _c('span', {
    staticClass: "float-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.lastLabel.text))])])])]), _vm.issue.show_unknown ? _c('div', {
    key: "unknown",
    staticClass: "unknown-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "unknown"
    },
    model: {
      value: _vm.issue.value,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "value", $$v);
      },
      expression: "issue.value"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.unknown_text))])])], 1) : _vm._e()]);
};
var NPSScalevue_type_template_id_5a0568da_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/scale/NPSScale.vue?vue&type=template&id=5a0568da

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/NPSScale.vue?vue&type=script&lang=js
/* harmony default export */ var NPSScalevue_type_script_lang_js = ({
  name: 'NPSScale',
  changeExpr: 'issue.value',
  computed: {
    scaleStyle() {
      return {
        width: Math.min(this.issue.labels.length * 90, 690) + 'px'
      };
    }
  },
  methods: {
    onChange(item) {
      if (this.view) return;
      this.issue.value = item.id;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/scale/NPSScale.vue?vue&type=script&lang=js
 /* harmony default export */ var scale_NPSScalevue_type_script_lang_js = (NPSScalevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/scale/NPSScale.vue





/* normalize component */

var NPSScale_component = normalizeComponent(
  scale_NPSScalevue_type_script_lang_js,
  NPSScalevue_type_template_id_5a0568da_render,
  NPSScalevue_type_template_id_5a0568da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NPSScale = (NPSScale_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/MatrixScale.vue?vue&type=template&id=0940c748&scoped=true
var MatrixScalevue_type_template_id_0940c748_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container"
  }, [_c('div', [_c('div', {
    staticClass: "flex mb-2"
  }, [_c('div', {
    ref: "headLabel",
    staticClass: "scale-label"
  }), _c('div', {
    staticClass: "scale-head-text"
  }, [_vm._l(_vm.issue.labels, function (i, idx) {
    return _c('div', {
      key: idx,
      staticClass: "scale-label-value-wrapper",
      style: {
        width: _vm.scaleItemWidth
      }
    }, [_c('div', {
      staticClass: "scale-head-text-item"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(i.text)
      }
    })])]);
  }), _vm.issue.enabledAuxiliaryColumn ? [_c('div', {
    staticClass: "inline-block",
    style: {
      width: _vm.auxiliaryWidth + 20 + 'px'
    }
  })] : _vm._e(), _vm.issue.show_unknown ? _c('div', {
    staticClass: "scale-label-value-wrapper",
    style: {
      width: _vm.scaleItemWidth
    }
  }, [_c('div', {
    staticClass: "scale-head-text-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.unknown_text))])])]) : _vm._e()], 2)]), _vm._l(_vm.issue.items, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "flex mb-2 last:mb-0"
    }, [_c('div', {
      ref: "labels",
      refInFor: true,
      staticClass: "scale-label",
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    }), _c('div', {
      staticClass: "scale-value flex-1"
    }, _vm._l(_vm.issue.labels, function (i, idx) {
      return _c('div', {
        key: idx,
        staticClass: "scale-label-value-wrapper",
        style: {
          width: _vm.scaleItemWidth
        }
      }, [_c('div', {
        staticClass: "scale-value-item",
        style: _vm.getActiveColor(item.value, idx),
        on: {
          "click": function ($event) {
            return _vm.onChange(item, i.id);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(i.num))])])]);
    }), 0), _vm.issue.enabledAuxiliaryColumn ? [_c('div', {
      ref: "auxiliary",
      refInFor: true,
      staticClass: "ml-5",
      domProps: {
        "innerHTML": _vm._s(_vm.issue.auxiliaryColumns[index].content.richText)
      }
    })] : _vm._e(), _vm.issue.show_unknown ? _c('div', {
      staticClass: "scale-value"
    }, [_c('div', {
      staticClass: "scale-label-value-wrapper",
      style: {
        width: _vm.scaleItemWidth
      }
    }, [_c('div', {
      staticClass: "scale-value-item",
      style: {
        backgroundColor: item.value === 'unknown' ? _vm.issue.activeColor : ''
      },
      on: {
        "click": function ($event) {
          return _vm.onChange(item, 'unknown');
        }
      }
    }, [_c('br'), _c('span')])])]) : _vm._e()], 2);
  })], 2)]);
};
var MatrixScalevue_type_template_id_0940c748_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/scale/MatrixScale.vue?vue&type=template&id=0940c748&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/MatrixScale.vue?vue&type=script&lang=js

/* harmony default export */ var MatrixScalevue_type_script_lang_js = ({
  name: 'MatrixScale',
  components: {
    QTable: QTable
  },
  changeExpr: 'isSelectAll',
  data() {
    return {
      width: 0,
      labelWidth: 0,
      auxiliaryWidth: 0
    };
  },
  computed: {
    scaleItemWidth() {
      const labelWidth = this.labelWidth;
      const auxiliaryWidth = this.auxiliaryWidth;
      let labelMarginRight = 20;
      let len = this.issue.labels.length;
      if (this.issue.show_unknown) {
        len += 1;
      }
      if (this.issue.enabledAuxiliaryColumn) {
        labelMarginRight = labelMarginRight * 2;
      }
      return Math.floor((this.width - labelWidth - auxiliaryWidth - labelMarginRight) / len) + 'px';
    },
    isSelectAll() {
      let val = this.issue.items.every(item => item.value !== null);
      if (!val) return 'false';
      return this.issue.items.map(i => i.value).join('-');
    },
    enableAnswerScore() {
      return this.question.setting.enableAnswerScore;
    }
  },
  methods: {
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx);
    },
    init() {
      this.width = this.$refs.container.clientWidth;
      let labels = this.$refs.labels;
      let labelWidth = 0;
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        labelWidth = Math.max(labelWidth, Math.min(label.clientWidth, 200));
      }
      labelWidth += 10;
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        label.style.width = labelWidth + 'px';
      }
      this.$refs.headLabel.style.width = labelWidth + 'px';
      this.labelWidth = labelWidth;
      if (this.issue.enabledAuxiliaryColumn) {
        let auxiliarys = this.$refs.auxiliary;
        let auxiliaryWidth = 0;
        for (let i = 0; i < auxiliarys.length; i++) {
          const auxiliary = auxiliarys[i];
          auxiliaryWidth = Math.max(auxiliaryWidth, Math.min(auxiliary.clientWidth, 200));
        }
        this.auxiliaryWidth = auxiliaryWidth + 10;
        for (let i = 0; i < auxiliarys.length; i++) {
          const auxiliary = auxiliarys[i];
          auxiliary.style.width = auxiliaryWidth + 'px';
        }
      }
      // if (!this.issue.show_unknown) return
      //
      // let headerHeight = this.$refs.qTable.getHeaderHeight()
      // this.$refs.tableHead.style.height = headerHeight + 'px'
      //
      // let rowsHeight = this.$refs.qTable.getRowsHeight()
      // const rows = this.$refs.tr
      // for (let i = 0; i < rowsHeight.length; i++) {
      //   const rowHeight = rowsHeight[i]
      //   rows[i].style.height = rowHeight + 'px'
      // }
    },
    getScore(value) {
      const optionScoreItems = this.question.answerScore.optionScoreItems;
      const opt = optionScoreItems.find(opt => (opt.value || '').toString() === value.toString());
      if (opt) {
        return `${opt.score}分`;
      } else {
        return '';
      }
    },
    onChange(item, value) {
      if (this.view) return;
      item.value = value;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  }
});
// CONCATENATED MODULE: ./src/questions/scale/MatrixScale.vue?vue&type=script&lang=js
 /* harmony default export */ var scale_MatrixScalevue_type_script_lang_js = (MatrixScalevue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/questions/scale/MatrixScale.vue?vue&type=style&index=0&id=0940c748&prod&lang=scss&scoped=true
var MatrixScalevue_type_style_index_0_id_0940c748_prod_lang_scss_scoped_true = __webpack_require__("b4db");

// CONCATENATED MODULE: ./src/questions/scale/MatrixScale.vue






/* normalize component */

var MatrixScale_component = normalizeComponent(
  scale_MatrixScalevue_type_script_lang_js,
  MatrixScalevue_type_template_id_0940c748_scoped_true_render,
  MatrixScalevue_type_template_id_0940c748_scoped_true_staticRenderFns,
  false,
  null,
  "0940c748",
  null
  
)

/* harmony default export */ var MatrixScale = (MatrixScale_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/Sort.vue?vue&type=template&id=a7f70fb6
var Sortvue_type_template_id_a7f70fb6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sort"
  }, [_c('div', _vm._l(_vm.issue.value, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "sort-item-wrap",
      class: {
        'sort-select-item': item.select,
        'text-ccc': _vm.disabled
      },
      on: {
        "click": function ($event) {
          return _vm.onChangeState(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "sort-num",
      class: {
        'sort-select': item.select
      }
    }, [_c('span', [item.select ? [_vm._v(" " + _vm._s(index + 1) + " ")] : _vm._e()], 2)]), _c('div', {
      staticClass: "sort-item"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    }), item.is_other_item ? [_c('relation-input', {
      attrs: {
        "type": item.inputType,
        "option-id": item.id,
        "question-id": _vm.question.id,
        "question-type": _vm.question.questionType,
        "max-length": item.maxLength,
        "min-length": item.minLength,
        "validate": item.validate
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    })] : _vm._e()], 2)]);
  }), 0)]);
};
var Sortvue_type_template_id_a7f70fb6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/choice/Sort.vue?vue&type=template&id=a7f70fb6

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/choice/Sort.vue?vue&type=script&lang=js



/* harmony default export */ var Sortvue_type_script_lang_js = ({
  name: 'Sort',
  changeExpr: 'changeExpr',
  changeDelay: true,
  components: {
    RelationInput: RelationInput,
    Draggable: vuedraggable_umd_default.a
  },
  data() {
    return {
      items: []
    };
  },
  created() {
    // this.issue.value = this.issue.value.filter(i => i.select)
    this.items = this.issue.items.slice().map(item => {
      return {
        select: false,
        ...item
      };
    });
  },
  computed: {
    changeExpr() {
      let items = this.issue.value.filter(item => item.select);
      return items.map(item => item.id + '|' + item.value).join('-');
    },
    disabled() {
      return this.issue.value.slice().filter(i => i.select).length >= this.issue.max_choice;
    },
    maxChoice() {
      let val = parseInt(this.issue.max_choice) || -1;
      return val > 0 ? val : this.items.length;
    }
  },
  methods: {
    getLastSelectIndex() {
      for (let i = this.items.length - 1; i >= 0; i--) {
        let item = this.items[i];
        if (item.select) return i;
      }
      return -1;
    },
    onUpdateValue(item, index) {
      if (!item.isSelect) {
        let lastSelectIndex = this.getLastSelectIndex();
        item.isSelect = true;
        if (lastSelectIndex > -1) {
          let res = this.items.splice(index, 1);
          this.items.splice(lastSelectIndex + 1, 0, ...res);
        } else {
          this.items.unshift(...this.items.splice(index, 1));
        }
      } else {
        item.isSelect = false;
        this.items.push(...this.items.splice(index, 1));
      }
    },
    onLeftSortEnd() {},
    onSortEnd() {
      let value = this.issue.value;
      value.forEach(v => v.select = true);
    },
    onChangeState(item) {
      if (this.view) return;
      let selects = this.issue.value.slice();
      if (!item.select) {
        let len = selects.filter(i => i.select).length;
        if (len >= this.issue.max_choice) return;
      }
      let index = selects.findIndex(i => i.id === item.id);
      selects.splice(index, 1);
      item.select = !item.select;
      let insertIndex = -1;
      for (let i = 0; i < selects.length; i++) {
        let val = selects[i];
        if (!val.select) {
          insertIndex = i;
          break;
        }
      }
      if (insertIndex !== -1) {
        selects.splice(insertIndex, 0, item);
      } else {
        selects.push(item);
      }
      console.log(selects);
      this.issue.value = selects;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/choice/Sort.vue?vue&type=script&lang=js
 /* harmony default export */ var choice_Sortvue_type_script_lang_js = (Sortvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/choice/Sort.vue





/* normalize component */

var Sort_component = normalizeComponent(
  choice_Sortvue_type_script_lang_js,
  Sortvue_type_template_id_a7f70fb6_render,
  Sortvue_type_template_id_a7f70fb6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sort = (Sort_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/HandWriting.vue?vue&type=template&id=4dc3c053
var HandWritingvue_type_template_id_4dc3c053_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "hand-writing"
  }, [!_vm.view ? [_c('div', {
    staticClass: "relative"
  }, [_c('canvas', {
    ref: "container",
    staticClass: "rounded-small"
  }), _vm.issue.url ? [_c('div', {
    staticClass: "absolute inset-0 z-10"
  }, [_c('img', {
    staticClass: "max-w-full",
    attrs: {
      "src": _vm.previewUrl,
      "alt": ""
    }
  })])] : _vm._e()], 2), !_vm.view ? _c('div', {
    staticClass: "mt-2"
  }, [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("清空")])], 1) : _vm._e()] : [_vm.issue.url ? [_c('div', [_c('img', {
    staticClass: "max-w-full",
    attrs: {
      "src": _vm.previewUrl,
      "alt": ""
    }
  })])] : _vm._e()]], 2);
};
var HandWritingvue_type_template_id_4dc3c053_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/HandWriting.vue?vue&type=template&id=4dc3c053

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+signature_pad@3.0.0-beta.4/node_modules/signature_pad/dist/signature_pad.js
/*!
 * Signature Pad v3.0.0-beta.4 | https://github.com/szimek/signature_pad
 * (c) 2020 Szymon Nowak | Released under the MIT license
 */

class Point {
    constructor(x, y, time) {
        this.x = x;
        this.y = y;
        this.time = time || Date.now();
    }
    distanceTo(start) {
        return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
    equals(other) {
        return this.x === other.x && this.y === other.y && this.time === other.time;
    }
    velocityFrom(start) {
        return this.time !== start.time
            ? this.distanceTo(start) / (this.time - start.time)
            : 0;
    }
}

class Bezier {
    constructor(startPoint, control2, control1, endPoint, startWidth, endWidth) {
        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }
    static fromPoints(points, widths) {
        const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
        const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
        return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
    }
    static calculateControlPoints(s1, s2, s3) {
        const dx1 = s1.x - s2.x;
        const dy1 = s1.y - s2.y;
        const dx2 = s2.x - s3.x;
        const dy2 = s2.y - s3.y;
        const m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
        const m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
        const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        const dxm = m1.x - m2.x;
        const dym = m1.y - m2.y;
        const k = l2 / (l1 + l2);
        const cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
        const tx = s2.x - cm.x;
        const ty = s2.y - cm.y;
        return {
            c1: new Point(m1.x + tx, m1.y + ty),
            c2: new Point(m2.x + tx, m2.y + ty),
        };
    }
    length() {
        const steps = 10;
        let length = 0;
        let px;
        let py;
        for (let i = 0; i <= steps; i += 1) {
            const t = i / steps;
            const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
            const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
            if (i > 0) {
                const xdiff = cx - px;
                const ydiff = cy - py;
                length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }
            px = cx;
            py = cy;
        }
        return length;
    }
    point(t, start, c1, c2, end) {
        return (start * (1.0 - t) * (1.0 - t) * (1.0 - t))
            + (3.0 * c1 * (1.0 - t) * (1.0 - t) * t)
            + (3.0 * c2 * (1.0 - t) * t * t)
            + (end * t * t * t);
    }
}

function throttle(fn, wait = 250) {
    let previous = 0;
    let timeout = null;
    let result;
    let storedContext;
    let storedArgs;
    const later = () => {
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper(...args) {
        const now = Date.now();
        const remaining = wait - (now - previous);
        storedContext = this;
        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        }
        else if (!timeout) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
}

class SignaturePad {
    constructor(canvas, options = {}) {
        this.canvas = canvas;
        this.options = options;
        this._handleMouseDown = (event) => {
            if (event.which === 1) {
                this._mouseButtonDown = true;
                this._strokeBegin(event);
            }
        };
        this._handleMouseMove = (event) => {
            if (this._mouseButtonDown) {
                this._strokeMoveUpdate(event);
            }
        };
        this._handleMouseUp = (event) => {
            if (event.which === 1 && this._mouseButtonDown) {
                this._mouseButtonDown = false;
                this._strokeEnd(event);
            }
        };
        this._handleTouchStart = (event) => {
            event.preventDefault();
            if (event.targetTouches.length === 1) {
                const touch = event.changedTouches[0];
                this._strokeBegin(touch);
            }
        };
        this._handleTouchMove = (event) => {
            event.preventDefault();
            const touch = event.targetTouches[0];
            this._strokeMoveUpdate(touch);
        };
        this._handleTouchEnd = (event) => {
            const wasCanvasTouched = event.target === this.canvas;
            if (wasCanvasTouched) {
                event.preventDefault();
                const touch = event.changedTouches[0];
                this._strokeEnd(touch);
            }
        };
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = ('throttle' in options ? options.throttle : 16);
        this.minDistance = ('minDistance' in options
            ? options.minDistance
            : 5);
        this.dotSize =
            options.dotSize ||
                function dotSize() {
                    return (this.minWidth + this.maxWidth) / 2;
                };
        this.penColor = options.penColor || 'black';
        this.backgroundColor = options.backgroundColor || 'rgba(0,0,0,0)';
        this.onBegin = options.onBegin;
        this.onEnd = options.onEnd;
        this._strokeMoveUpdate = this.throttle
            ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle)
            : SignaturePad.prototype._strokeUpdate;
        this._ctx = canvas.getContext('2d');
        this.clear();
        this.on();
    }
    clear() {
        const { _ctx: ctx, canvas } = this;
        ctx.fillStyle = this.backgroundColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this._data = [];
        this._reset();
        this._isEmpty = true;
    }
    fromDataURL(dataUrl, options = {}, callback) {
        const image = new Image();
        const ratio = options.ratio || window.devicePixelRatio || 1;
        const width = options.width || this.canvas.width / ratio;
        const height = options.height || this.canvas.height / ratio;
        this._reset();
        image.onload = () => {
            this._ctx.drawImage(image, 0, 0, width, height);
            if (callback) {
                callback();
            }
        };
        image.onerror = (error) => {
            if (callback) {
                callback(error);
            }
        };
        image.src = dataUrl;
        this._isEmpty = false;
    }
    toDataURL(type = 'image/png', encoderOptions) {
        switch (type) {
            case 'image/svg+xml':
                return this._toSVG();
            default:
                return this.canvas.toDataURL(type, encoderOptions);
        }
    }
    on() {
        this.canvas.style.touchAction = 'none';
        this.canvas.style.msTouchAction = 'none';
        if (window.PointerEvent) {
            this._handlePointerEvents();
        }
        else {
            this._handleMouseEvents();
            if ('ontouchstart' in window) {
                this._handleTouchEvents();
            }
        }
    }
    off() {
        this.canvas.style.touchAction = 'auto';
        this.canvas.style.msTouchAction = 'auto';
        this.canvas.removeEventListener('pointerdown', this._handleMouseDown);
        this.canvas.removeEventListener('pointermove', this._handleMouseMove);
        document.removeEventListener('pointerup', this._handleMouseUp);
        this.canvas.removeEventListener('mousedown', this._handleMouseDown);
        this.canvas.removeEventListener('mousemove', this._handleMouseMove);
        document.removeEventListener('mouseup', this._handleMouseUp);
        this.canvas.removeEventListener('touchstart', this._handleTouchStart);
        this.canvas.removeEventListener('touchmove', this._handleTouchMove);
        this.canvas.removeEventListener('touchend', this._handleTouchEnd);
    }
    isEmpty() {
        return this._isEmpty;
    }
    fromData(pointGroups) {
        this.clear();
        this._fromData(pointGroups, ({ color, curve }) => this._drawCurve({ color, curve }), ({ color, point }) => this._drawDot({ color, point }));
        this._data = pointGroups;
    }
    toData() {
        return this._data;
    }
    _strokeBegin(event) {
        const newPointGroup = {
            color: this.penColor,
            points: [],
        };
        if (typeof this.onBegin === 'function') {
            this.onBegin(event);
        }
        this._data.push(newPointGroup);
        this._reset();
        this._strokeUpdate(event);
    }
    _strokeUpdate(event) {
        if (this._data.length === 0) {
            this._strokeBegin(event);
            return;
        }
        const x = event.clientX;
        const y = event.clientY;
        const point = this._createPoint(x, y);
        const lastPointGroup = this._data[this._data.length - 1];
        const lastPoints = lastPointGroup.points;
        const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
        const isLastPointTooClose = lastPoint
            ? point.distanceTo(lastPoint) <= this.minDistance
            : false;
        const color = lastPointGroup.color;
        if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
            const curve = this._addPoint(point);
            if (!lastPoint) {
                this._drawDot({ color, point });
            }
            else if (curve) {
                this._drawCurve({ color, curve });
            }
            lastPoints.push({
                time: point.time,
                x: point.x,
                y: point.y,
            });
        }
    }
    _strokeEnd(event) {
        this._strokeUpdate(event);
        if (typeof this.onEnd === 'function') {
            this.onEnd(event);
        }
    }
    _handlePointerEvents() {
        this._mouseButtonDown = false;
        this.canvas.addEventListener('pointerdown', this._handleMouseDown);
        this.canvas.addEventListener('pointermove', this._handleMouseMove);
        document.addEventListener('pointerup', this._handleMouseUp);
    }
    _handleMouseEvents() {
        this._mouseButtonDown = false;
        this.canvas.addEventListener('mousedown', this._handleMouseDown);
        this.canvas.addEventListener('mousemove', this._handleMouseMove);
        document.addEventListener('mouseup', this._handleMouseUp);
    }
    _handleTouchEvents() {
        this.canvas.addEventListener('touchstart', this._handleTouchStart);
        this.canvas.addEventListener('touchmove', this._handleTouchMove);
        this.canvas.addEventListener('touchend', this._handleTouchEnd);
    }
    _reset() {
        this._lastPoints = [];
        this._lastVelocity = 0;
        this._lastWidth = (this.minWidth + this.maxWidth) / 2;
        this._ctx.fillStyle = this.penColor;
    }
    _createPoint(x, y) {
        const rect = this.canvas.getBoundingClientRect();
        return new Point(x - rect.left, y - rect.top, new Date().getTime());
    }
    _addPoint(point) {
        const { _lastPoints } = this;
        _lastPoints.push(point);
        if (_lastPoints.length > 2) {
            if (_lastPoints.length === 3) {
                _lastPoints.unshift(_lastPoints[0]);
            }
            const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2]);
            const curve = Bezier.fromPoints(_lastPoints, widths);
            _lastPoints.shift();
            return curve;
        }
        return null;
    }
    _calculateCurveWidths(startPoint, endPoint) {
        const velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) +
            (1 - this.velocityFilterWeight) * this._lastVelocity;
        const newWidth = this._strokeWidth(velocity);
        const widths = {
            end: newWidth,
            start: this._lastWidth,
        };
        this._lastVelocity = velocity;
        this._lastWidth = newWidth;
        return widths;
    }
    _strokeWidth(velocity) {
        return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
    }
    _drawCurveSegment(x, y, width) {
        const ctx = this._ctx;
        ctx.moveTo(x, y);
        ctx.arc(x, y, width, 0, 2 * Math.PI, false);
        this._isEmpty = false;
    }
    _drawCurve({ color, curve }) {
        const ctx = this._ctx;
        const widthDelta = curve.endWidth - curve.startWidth;
        const drawSteps = Math.floor(curve.length()) * 2;
        ctx.beginPath();
        ctx.fillStyle = color;
        for (let i = 0; i < drawSteps; i += 1) {
            const t = i / drawSteps;
            const tt = t * t;
            const ttt = tt * t;
            const u = 1 - t;
            const uu = u * u;
            const uuu = uu * u;
            let x = uuu * curve.startPoint.x;
            x += 3 * uu * t * curve.control1.x;
            x += 3 * u * tt * curve.control2.x;
            x += ttt * curve.endPoint.x;
            let y = uuu * curve.startPoint.y;
            y += 3 * uu * t * curve.control1.y;
            y += 3 * u * tt * curve.control2.y;
            y += ttt * curve.endPoint.y;
            const width = Math.min(curve.startWidth + ttt * widthDelta, this.maxWidth);
            this._drawCurveSegment(x, y, width);
        }
        ctx.closePath();
        ctx.fill();
    }
    _drawDot({ color, point, }) {
        const ctx = this._ctx;
        const width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
        ctx.beginPath();
        this._drawCurveSegment(point.x, point.y, width);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    _fromData(pointGroups, drawCurve, drawDot) {
        for (const group of pointGroups) {
            const { color, points } = group;
            if (points.length > 1) {
                for (let j = 0; j < points.length; j += 1) {
                    const basicPoint = points[j];
                    const point = new Point(basicPoint.x, basicPoint.y, basicPoint.time);
                    this.penColor = color;
                    if (j === 0) {
                        this._reset();
                    }
                    const curve = this._addPoint(point);
                    if (curve) {
                        drawCurve({ color, curve });
                    }
                }
            }
            else {
                this._reset();
                drawDot({
                    color,
                    point: points[0],
                });
            }
        }
    }
    _toSVG() {
        const pointGroups = this._data;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const minX = 0;
        const minY = 0;
        const maxX = this.canvas.width / ratio;
        const maxY = this.canvas.height / ratio;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', this.canvas.width.toString());
        svg.setAttribute('height', this.canvas.height.toString());
        this._fromData(pointGroups, ({ color, curve }) => {
            const path = document.createElement('path');
            if (!isNaN(curve.control1.x) &&
                !isNaN(curve.control1.y) &&
                !isNaN(curve.control2.x) &&
                !isNaN(curve.control2.y)) {
                const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} ` +
                    `C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ` +
                    `${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ` +
                    `${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
                path.setAttribute('d', attr);
                path.setAttribute('stroke-width', (curve.endWidth * 2.25).toFixed(3));
                path.setAttribute('stroke', color);
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke-linecap', 'round');
                svg.appendChild(path);
            }
        }, ({ color, point }) => {
            const circle = document.createElement('circle');
            const dotSize = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
            circle.setAttribute('r', dotSize.toString());
            circle.setAttribute('cx', point.x.toString());
            circle.setAttribute('cy', point.y.toString());
            circle.setAttribute('fill', color);
            svg.appendChild(circle);
        });
        const prefix = 'data:image/svg+xml;base64,';
        const header = '<svg' +
            ' xmlns="http://www.w3.org/2000/svg"' +
            ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
            ` viewBox="${minX} ${minY} ${maxX} ${maxY}"` +
            ` width="${maxX}"` +
            ` height="${maxY}"` +
            '>';
        let body = svg.innerHTML;
        if (body === undefined) {
            const dummy = document.createElement('dummy');
            const nodes = svg.childNodes;
            dummy.innerHTML = '';
            for (let i = 0; i < nodes.length; i += 1) {
                dummy.appendChild(nodes[i].cloneNode(true));
            }
            body = dummy.innerHTML;
        }
        const footer = '</svg>';
        const data = header + body + footer;
        return prefix + btoa(data);
    }
}

/* harmony default export */ var signature_pad = (SignaturePad);
//# sourceMappingURL=signature_pad.js.map

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/HandWriting.vue?vue&type=script&lang=js


/* harmony default export */ var HandWritingvue_type_script_lang_js = ({
  name: 'HandWriting',
  changeExpr: 'changeExpr',
  data() {
    return {
      changeExpr: false
    };
  },
  computed: {
    previewUrl() {
      if (this.issue.url) {
        return Object(dygc_esm_bundler["i" /* convertUrl */])(this.issue.url);
      } else {
        return '';
      }
    }
  },
  methods: {
    init() {
      if (this.view) return;
      let el = this.$refs.container;
      let signature = new signature_pad(el, {
        onEnd: () => {
          this.changeExpr = true;
        }
      });
      // signature.addEventListener('endStroke', () => {
      //   this.changeExpr = true
      // })
      this.issue.setSignature(signature);
      this.$nextTick(() => {
        this.drawGrid('#ccc', 10, 10);
      });
    },
    drawGrid(color, stepx, stepy) {
      let canvas = this.$refs.container;
      let context = canvas.getContext('2d');
      context.save();
      context.fillStyle = 'white';
      let cw = context.canvas.width;
      let ch = context.canvas.height;
      context.fillRect(0, 0, cw, ch);
      context.lineWidth = 0.5;
      context.strokeStyle = color;
      const fn = (x, y, lx, ly) => {
        context.beginPath();
        context.moveTo(x, y);
        context.lineTo(lx, ly);
        context.closePath();
        context.stroke();
      };
      for (let i = stepx; i < cw; i += stepx) {
        fn(i, 0, i, ch);
      }
      for (let j = stepy; j < ch; j += stepy) {
        fn(0, j, cw, j);
      }
      context.restore();
    },
    clear() {
      this.issue.url = '';
      this.issue.signature.clear();
      this.$nextTick(() => {
        this.drawGrid('#ccc', 10, 10);
      });
    }
  },
  mounted() {
    this.init();
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/HandWriting.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_HandWritingvue_type_script_lang_js = (HandWritingvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/HandWriting.vue





/* normalize component */

var HandWriting_component = normalizeComponent(
  specific_format_HandWritingvue_type_script_lang_js,
  HandWritingvue_type_template_id_4dc3c053_render,
  HandWritingvue_type_template_id_4dc3c053_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HandWriting = (HandWriting_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/SelectCascader.vue?vue&type=template&id=beca6a18
var SelectCascadervue_type_template_id_beca6a18_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "inline-block relative"
  }, [_c('div', _vm._l(_vm.leaves, function (item, index) {
    return _c('div', {
      key: item,
      staticClass: "inline-block cascader-item mr-5 last:mr-0"
    }, [_c('cascader-item', {
      staticClass: "w-full",
      attrs: {
        "groups": _vm.groups,
        "leave-num": item,
        "option": _vm.optionItems[index],
        "placeholder": _vm.optionItems[index].placeholder,
        "options": _vm.optionItems
      },
      model: {
        value: _vm.optionItems[index].value,
        callback: function ($$v) {
          _vm.$set(_vm.optionItems[index], "value", $$v);
        },
        expression: "optionItems[index].value"
      }
    })], 1);
  }), 0), _vm.levelsNum < _vm.requiredNum ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.issue.items, function (item) {
    return _c('el-input', {
      key: item.id,
      attrs: {
        "placeholder": "详细地址"
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    });
  }), 1) : _vm._e(), _vm.view ? _c('div', {
    staticClass: "absolute inset-0 z-50"
  }) : _vm._e()]), _vm.showVoteProgress ? _c('div', {
    staticClass: "vote-answer vote-answering-wrapper"
  }, [_vm.voteItems.length ? [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._v(" 投票排名 ")])] : _vm._e(), _c('choice-vote-content', {
    attrs: {
      "items": _vm.voteItems
    }
  }), _vm.voteItems.length > 5 ? [_c('el-button', {
    staticClass: "w-full",
    on: {
      "click": _vm.onShowMoreRank
    }
  }, [_vm._v("查看更多排名")])] : _vm._e()], 2) : _vm._e()]);
};
var SelectCascadervue_type_template_id_beca6a18_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/cascader/SelectCascader.vue?vue&type=template&id=beca6a18

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/CascaderItem.vue?vue&type=template&id=484c78de
var CascaderItemvue_type_template_id_484c78de_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.selectOptions.length ? _c('el-select', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: _vm.selectValue,
      callback: function ($$v) {
        _vm.selectValue = $$v;
      },
      expression: "selectValue"
    }
  }, _vm._l(_vm.selectOptions, function (option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "value": option.value,
        "label": option.label
      }
    });
  }), 1) : _vm._e();
};
var CascaderItemvue_type_template_id_484c78de_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/cascader/CascaderItem.vue?vue&type=template&id=484c78de

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/CascaderItem.vue?vue&type=script&lang=js

/* harmony default export */ var CascaderItemvue_type_script_lang_js = ({
  name: 'CascaderItem',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    leaveNum: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  created() {
    this.initWatchers();
  },
  methods: {
    initWatchers() {
      let un = this.$watch('option.value', val => {
        this.valueChange && this.valueChange(val);
        un();
        this._parentChange();
      });
    },
    _parentChange() {
      if (this.option.parent) {
        this.$watch('option.parent.value', () => {
          this.$emit('input', '');
          this.parentChange && this.parentChange();
        });
      }
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    selectOptions() {
      let result = [];
      let i = 0;
      let results = this.groups;
      if (this.leaveNum !== 1) {
        if (!this.options[this.leaveNum - 2].value) return result;
      }
      while (i < this.leaveNum - 1) {
        let id = this.options[i].value;
        if (!id) {
          break;
        }
        let find = results.find(item => item.id === id);
        if (!find) break;
        results = find.nextLevelOptions || [];
        i++;
      }
      results.forEach(item => {
        let resultItem = {
          label: item.content,
          value: item.id
        };
        result.push(resultItem);
      });
      return result;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/cascader/CascaderItem.vue?vue&type=script&lang=js
 /* harmony default export */ var cascader_CascaderItemvue_type_script_lang_js = (CascaderItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/cascader/CascaderItem.vue





/* normalize component */

var CascaderItem_component = normalizeComponent(
  cascader_CascaderItemvue_type_script_lang_js,
  CascaderItemvue_type_template_id_484c78de_render,
  CascaderItemvue_type_template_id_484c78de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CascaderItem = (CascaderItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/cascader/SelectCascader.vue?vue&type=script&lang=js



/* harmony default export */ var SelectCascadervue_type_script_lang_js = ({
  name: 'SelectCascader',
  mixins: [vote],
  changeExpr: 'changeExpr',
  changeDelay: true,
  components: {
    CascaderItem: CascaderItem
  },
  data() {
    return {
      levelsNum: 0,
      groups: [],
      address: '',
      fillContext: '',
      optionItems: []
    };
  },
  created() {
    this.initIssue();
    this.initWatchers();
  },
  methods: {
    initIssue() {
      let issue = this.issue;
      this.levelsNum = issue.levelsNum;
      this.groups = issue.groups;
      let optionItems = [];
      let levels = issue.levels.slice();
      while (levels.length < this.requiredNum) {
        levels.push(' ');
      }
      let level;
      while (level = levels.shift()) {
        optionItems.push({
          value: '',
          placeholder: `请选择${level.trim()}`
        });
      }
      let head = null;
      optionItems.forEach(item => {
        item.parent = head;
        head = item;
      });
      this.optionItems = optionItems;
    },
    initWatchers() {
      this.$watch('optionItems', () => {
        this.question.issue.value = this.optionItems.map(item => item.value).filter(_ => _);
      }, {
        deep: true
      });
    }
  },
  watch: {},
  computed: {
    changeExpr() {
      const arr = this.optionItems.slice().concat(this.issue.items.slice());
      return arr.map(i => i.value).join('-');
    },
    requiredNum() {
      return this.question.issue.requiredNum;
    },
    leaves() {
      let requiredNum = this.requiredNum;
      let leaves = this.levelsNum;
      return Math.min(requiredNum, leaves);
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.issue.value.length) {
        let value = this.issue.value.slice();
        this.optionItems.forEach(item => {
          item.value = value.shift();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./src/questions/cascader/SelectCascader.vue?vue&type=script&lang=js
 /* harmony default export */ var cascader_SelectCascadervue_type_script_lang_js = (SelectCascadervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/cascader/SelectCascader.vue





/* normalize component */

var SelectCascader_component = normalizeComponent(
  cascader_SelectCascadervue_type_script_lang_js,
  SelectCascadervue_type_template_id_beca6a18_render,
  SelectCascadervue_type_template_id_beca6a18_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SelectCascader = (SelectCascader_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/CascadeRegion.vue?vue&type=template&id=7bfd8d0a
var CascadeRegionvue_type_template_id_7bfd8d0a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cascade-region"
  }, [_vm.cascadeOptions.length ? [_c('el-cascader', {
    ref: "cascaderRef",
    attrs: {
      "disabled": _vm.view,
      "props": _vm.props
    },
    on: {
      "change": _vm.onChangeValue
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })] : _vm._e()], 2);
};
var CascadeRegionvue_type_template_id_7bfd8d0a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/CascadeRegion.vue?vue&type=template&id=7bfd8d0a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/CascadeRegion.vue?vue&type=script&lang=js

/* harmony default export */ var CascadeRegionvue_type_script_lang_js = ({
  changeExpr: 'issue.answerValue',
  name: 'CascadeRegion',
  data() {
    const vm = this;
    return {
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const {
            level
          } = node;
          if (level === 0) {
            resolve(vm.cascadeOptions);
          } else {
            if (node.data.next === 0) {
              resolve([]);
            } else {
              vm.issue.getCascade(node.data.regionCode).then(resolve);
            }
          }
        },
        label: 'regionName',
        value: 'regionCode'
      },
      cascadeOptions: [],
      value: []
    };
  },
  created() {
    this.issue.getCascade().then(res => {
      this.cascadeOptions = res;
    });
  },
  methods: {
    onChangeValue() {
      let nodes = this.$refs.cascaderRef.getCheckedNodes();
      let results = [];
      for (let i = 0, len = nodes.length; i < len; i++) {
        let node = nodes[i];
        node.path.forEach((code, index) => {
          results.push({
            optionId: code,
            value: node.pathLabels[index],
            rowId: '',
            colId: ''
          });
        });
      }
      this.issue.answerValue = results;
    }
  },
  mounted() {
    if (this.issue.answerValue.length) {
      this.value = this.issue.answerValue.map(i => i.optionId);
      const uw = this.$watch('cascadeOptions', () => {
        uw && uw();
        this.$nextTick(() => {
          this.$refs.cascaderRef.inputValue = this.issue.answerValue.map(i => i.value).join('/');
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/CascadeRegion.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_CascadeRegionvue_type_script_lang_js = (CascadeRegionvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/CascadeRegion.vue





/* normalize component */

var CascadeRegion_component = normalizeComponent(
  specific_format_CascadeRegionvue_type_script_lang_js,
  CascadeRegionvue_type_template_id_7bfd8d0a_render,
  CascadeRegionvue_type_template_id_7bfd8d0a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CascadeRegion = (CascadeRegion_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/Downloadable.vue?vue&type=template&id=72cf8108
var Downloadablevue_type_template_id_72cf8108_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "downloadable"
  }, _vm._l(_vm.question.content.file, function (f) {
    return _c('ul', [_c('li', {
      staticClass: "flex flex-nowrap justify-between items-center w-3/4"
    }, [_c('div', {
      staticClass: "flex flex-nowrap items-center"
    }, [_c('i', {
      staticClass: "el-icon-paperclip self-start mt-1"
    }), _c('div', {
      staticClass: "px-4 font-normal break-words text-justify"
    }, [_vm._v(_vm._s(f.name))])]), _c('el-button', {
      staticClass: "flex-shrink-0 self-start",
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function ($event) {
          return _vm.downloadFile(f);
        }
      }
    }, [_vm._v("下载 ")])], 1)]);
  }), 0);
};
var Downloadablevue_type_template_id_72cf8108_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/Downloadable.vue?vue&type=template&id=72cf8108

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/Downloadable.vue?vue&type=script&lang=js
/* harmony default export */ var Downloadablevue_type_script_lang_js = ({
  name: 'Downloadable',
  methods: {
    downloadFile(file) {
      var a = document.createElement('a');
      const fileNameArr = file.name.split('.');
      fileNameArr.pop();
      a.href = window.location.origin + '/fill/api/v1/downloadWithName?fileName=' + file.url + '&downLoadName=' + fileNameArr.join('.');
      a.click();
    }
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/Downloadable.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_Downloadablevue_type_script_lang_js = (Downloadablevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/Downloadable.vue





/* normalize component */

var Downloadable_component = normalizeComponent(
  specific_format_Downloadablevue_type_script_lang_js,
  Downloadablevue_type_template_id_72cf8108_render,
  Downloadablevue_type_template_id_72cf8108_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Downloadable = (Downloadable_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/MaxDiff.vue?vue&type=template&id=8527e586&scoped=true
var MaxDiffvue_type_template_id_8527e586_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "max-diff"
  }, [_c('div', [_vm.isPKDiff ? [_c('el-radio-group', {
    staticClass: "w-full",
    attrs: {
      "value": _vm.currentResult.bestId
    },
    on: {
      "input": _vm.onSelectBest
    }
  }, [_c('div', {
    staticClass: "max-diff-pk clearfix"
  }, [_c('div', {
    staticClass: "max-diff-pk-left"
  }, [_c('single-choice-item', {
    class: {
      checked: _vm.currentResult.bestId === _vm.currentRenderTask[0].id
    },
    attrs: {
      "item": _vm.currentRenderTask[0]
    }
  })], 1), _c('div', {
    staticClass: "max-diff-pc-icon"
  }, [_c('span', [_vm._v("PK")])]), _c('div', {
    staticClass: "max-diff-pk-right"
  }, [_c('single-choice-item', {
    class: {
      checked: _vm.currentResult.bestId === _vm.currentRenderTask[1].id
    },
    attrs: {
      "item": _vm.currentRenderTask[1]
    }
  })], 1)])])] : [_c('transition', {
    attrs: {
      "tag": "div",
      "name": "max-diff"
    }
  }, [_c('table', {
    key: _vm.currentNum,
    staticClass: "max-diff-table",
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "33.33%"
    },
    attrs: {
      "span": "3"
    }
  })]), _c('thead', [_c('tr', [_vm.issue.align === 0 ? _c('th') : _vm._e(), _c('th', [_vm._v(_vm._s(_vm.issue.labelBest))]), _vm.issue.align === 1 ? _c('th') : _vm._e(), _c('th', [_vm._v(_vm._s(_vm.issue.labelWorst))])])]), _c('tbody', _vm._l(_vm.currentRenderTask, function (item) {
    return _c('tr', {
      key: item.id
    }, [_vm.issue.align === 0 ? _c('td', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]) : _vm._e(), _c('td', {
      staticClass: "cursor-pointer",
      on: {
        "click": function ($event) {
          return _vm.onChangeBest(item.id, item);
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": item.id,
        "value": _vm.currentResult.bestId
      },
      on: {
        "input": function ($event) {
          return _vm.onChangeBest($event, item);
        }
      }
    }, [_c('span')])], 1), _vm.issue.align === 1 ? _c('td', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content.richText)
      }
    })]) : _vm._e(), _c('td', {
      staticClass: "cursor-pointer",
      on: {
        "click": function ($event) {
          return _vm.onChangeWorst(item.id, item);
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": item.id,
        "value": _vm.currentResult.worstId
      },
      on: {
        "input": function ($event) {
          return _vm.onChangeWorst($event, item);
        }
      }
    }, [_c('span')])], 1)]);
  }), 0)])])], _c('div', {
    staticClass: "max-diff-progress text-center"
  }, [!_vm.view ? _c('div', {
    staticClass: "max-diff-reset-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onResetSelect
    }
  }, [_vm._v("重新选择")])], 1) : _vm._e(), _c('div', [_vm.view ? [_c('el-button', {
    staticClass: "_edit_btn",
    attrs: {
      "size": "mini",
      "icon": "el-icon-arrow-left",
      "disabled": _vm.disabledLeftBtn
    },
    on: {
      "click": _vm.onDecrease
    }
  })] : _vm._e(), _c('div', {
    staticClass: "max-diff-progress-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentNum))]), _c('span', [_vm._v("/")]), _c('span', [_vm._v(_vm._s(_vm.issue.taskNum))])]), _vm.view ? [_c('el-button', {
    staticClass: "_edit_btn",
    attrs: {
      "size": "mini",
      "icon": "el-icon-arrow-right",
      "disabled": _vm.disabledRightBtn
    },
    on: {
      "click": _vm.onIncrease
    }
  })] : _vm._e()], 2)])], 2)]);
};
var MaxDiffvue_type_template_id_8527e586_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/MaxDiff.vue?vue&type=template&id=8527e586&scoped=true

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/MaxDiff.vue?vue&type=script&lang=js

/* harmony default export */ var MaxDiffvue_type_script_lang_js = ({
  name: 'MaxDiff',
  components: {
    SingleChoiceItem: SingleChoiceItem
  },
  changeExpr: 'changeExpr',
  data() {
    return {
      currentNum: 1
    };
  },
  computed: {
    disabledLeftBtn() {
      return this.currentNum <= 1;
    },
    disabledRightBtn() {
      return this.currentNum >= this.issue.taskNum;
    },
    changeExpr() {
      return this.issue.results.map(item => item.bestId + '-' + item.worstId).join(',');
    },
    currentRenderTask() {
      return this.issue.tasks[this.currentNum - 1];
    },
    currentResult() {
      return this.issue.results[this.currentNum - 1];
    },
    isPKDiff() {
      return false; //  this.issue.numPerTask === 2
    }
  },
  methods: {
    onDecrease() {
      this.currentNum--;
    },
    onIncrease() {
      this.currentNum++;
    },
    onChangeBest(val, item) {
      if (this.view) return;
      if (this.currentResult.worstId === val) {
        this.currentResult.worstId = '';
      }
      this.currentResult.bestId = val;
      this.checkAndNext();
    },
    onChangeWorst(val, item) {
      if (this.view) return;
      if (this.currentResult.bestId === val) {
        this.currentResult.bestId = '';
      }
      this.currentResult.worstId = val;
      this.checkAndNext();
    },
    checkAndNext() {
      if (this.changeAndNextTimer) {
        clearTimeout(this.changeAndNextTimer);
      }
      if (this.currentNum === this.issue.tasks.length) return;
      if (this.issue.numPerTask === 1) {
        this.changeAndNextTimer = setTimeout(() => {
          this.currentNum++;
          this.changeAndNextTimer = null;
        }, 500);
        return;
      }
      if (this.currentResult.bestId && this.currentResult.worstId) {
        this.changeAndNextTimer = setTimeout(() => {
          this.currentNum++;
          this.changeAndNextTimer = null;
        }, 500);
      }
    },
    onResetSelect() {
      this.issue.results.forEach(item => {
        item.bestId = '';
        item.worstId = '';
      });
      this.currentNum = 1;
    },
    onSelectBest(id) {
      if (this.view) return;
      this.currentResult.bestId = id;
      let a = this.currentRenderTask.find(t => t.id !== id);
      this.currentResult.worstId = a.id;
      this.checkAndNext();
    }
  },
  mounted() {
    this.$nextTick(() => {
      let idx = this.issue.getCurrentIndex();
      if (idx !== -1) {
        this.currentNum = idx + 1;
      }
    });
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/MaxDiff.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_MaxDiffvue_type_script_lang_js = (MaxDiffvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/questions/specific-format/MaxDiff.vue?vue&type=style&index=0&id=8527e586&prod&scoped=true&lang=scss
var MaxDiffvue_type_style_index_0_id_8527e586_prod_scoped_true_lang_scss = __webpack_require__("be09");

// CONCATENATED MODULE: ./src/questions/specific-format/MaxDiff.vue






/* normalize component */

var MaxDiff_component = normalizeComponent(
  specific_format_MaxDiffvue_type_script_lang_js,
  MaxDiffvue_type_template_id_8527e586_scoped_true_render,
  MaxDiffvue_type_template_id_8527e586_scoped_true_staticRenderFns,
  false,
  null,
  "8527e586",
  null
  
)

/* harmony default export */ var MaxDiff = (MaxDiff_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/MapQ.vue?vue&type=template&id=3577636a
var MapQvue_type_template_id_3577636a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "map-q relative"
  }, [_vm.mapPattern ? [_c('map-pattern', {
    attrs: {
      "issue": _vm.issue
    }
  })] : _vm.textPattern ? [_c('text-map', {
    attrs: {
      "issue": _vm.issue
    }
  })] : _vm._e(), _vm.view ? _c('div', {
    staticClass: "absolute inset-0 z-10"
  }) : _vm._e()], 2);
};
var MapQvue_type_template_id_3577636a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/specific-format/MapQ.vue?vue&type=template&id=3577636a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/map/MapPattern.vue?vue&type=template&id=af69dd50
var MapPatternvue_type_template_id_af69dd50_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "map-pattern"
  }, [_vm.showMap ? [_c('div', {
    staticClass: "border border-solid border-border-gray p-3 rounded-t-small border-b-0"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-small"
  }, [_vm._v("正在获取位置信息。。。")]) : _c('div', {
    staticClass: "relative"
  }, [_c('p', {
    staticClass: "text-medium"
  }, [_vm._v(" " + _vm._s(_vm.address.add_name) + " "), _vm._m(0)]), _vm.address.R && _vm.address.Q ? _c('p', {
    staticClass: "text-theme-black-350"
  }, [_c('span', {
    staticClass: "text-medium mr-5"
  }, [_vm._v("经度：" + _vm._s(_vm.address.R))]), _c('span', {
    staticClass: "text-medium"
  }, [_vm._v("纬度：" + _vm._s(_vm.address.Q))])]) : _vm._e()])])] : _vm._e(), _c('div', {
    ref: "mapNode",
    staticClass: "cursor-pointer map-wrapper flex relative"
  }, [_c('span', {
    staticClass: "m-auto",
    on: {
      "click": _vm.onClickGetPos
    }
  }, [_vm._v("点击获取地理位置")])]), _vm.showMap ? _c('div', {
    staticClass: "border border-solid border-border-gray p-3 rounded-b-small border-t-0 flex"
  }, [_c('div', {
    staticClass: "reset-btn rounded-medium border border-solid border-border-gray mr-3 box-border flex justify-center items-center cursor-pointer",
    staticStyle: {
      "width": "40px",
      "height": "34px"
    },
    on: {
      "click": _vm.getGeolocation
    }
  }, [_vm._m(1)]), _c('div', {
    staticClass: "flex-1"
  }, [!_vm.issue.disallowUpdateLocation ? _c('text-map', {
    attrs: {
      "issue": _vm.issue
    },
    on: {
      "change": _vm.onChange
    }
  }) : _vm._e()], 1)]) : _vm._e()], 2);
};
var MapPatternvue_type_template_id_af69dd50_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "text-red pos-icon"
  }, [_c('i', {
    staticClass: "el-icon-location-outline"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "pos-icon"
  }, [_c('i', {
    staticClass: "el-icon-location-outline"
  })]);
}];

// CONCATENATED MODULE: ./src/questions/components/map/MapPattern.vue?vue&type=template&id=af69dd50

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/map/TextMap.vue?vue&type=template&id=550f3abe
var TextMapvue_type_template_id_550f3abe_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative"
  }, [_c('el-input', {
    ref: "reference",
    attrs: {
      "placeholder": "请输入地点、街道等位置信息"
    },
    on: {
      "focus": function ($event) {
        _vm.visible = true;
      },
      "blur": _vm.onBlur
    },
    model: {
      value: _vm.issue.inputValue,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "inputValue", $$v);
      },
      expression: "issue.inputValue"
    }
  }), _c('el-select-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "popper",
    attrs: {
      "append-to-body": ""
    }
  }, [_c('ul', _vm._l(_vm.poiList, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "py-2 px-3 cursor-pointer hover:bg-theme-gray"
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.onSelect(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])]);
  }), 0)])], 1);
};
var TextMapvue_type_template_id_550f3abe_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/map/TextMap.vue?vue&type=template&id=550f3abe

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/map/TextMap.vue?vue&type=script&lang=js

/* harmony default export */ var TextMapvue_type_script_lang_js = ({
  name: 'TextMap',
  props: {
    issue: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ElSelectDropdown: select_dropdown
  },
  data() {
    return {
      value: '',
      poiList: [],
      visible: false
    };
  },
  methods: {
    onChangeValue() {
      let item = this.poiList.find(i => i.id === this.value);
      if (item) {
        this.issue.changeValue(item);
        this.$emit('change', item);
      }
    },
    onRemoteMethod(val) {
      this.issue.getPoiList(val).then(list => {
        this.poiList = list;
      });
    },
    onBlur() {
      setTimeout(() => {
        console.log('blur');
        // this.visible=false
      }, 20);
    },
    onSelect(item) {
      this.issue.inputValue = item.name;
      this.visible = false;
      this.$emit('change', item);
      this.issue.changeValue(item);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.value = this.issue.inputValue;
    });
  },
  watch: {
    'issue.inputValue'(val) {
      this.onRemoteMethod(val);
    }
  }
});
// CONCATENATED MODULE: ./src/questions/components/map/TextMap.vue?vue&type=script&lang=js
 /* harmony default export */ var map_TextMapvue_type_script_lang_js = (TextMapvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/map/TextMap.vue





/* normalize component */

var TextMap_component = normalizeComponent(
  map_TextMapvue_type_script_lang_js,
  TextMapvue_type_template_id_550f3abe_render,
  TextMapvue_type_template_id_550f3abe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextMap = (TextMap_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/map/MapPattern.vue?vue&type=script&lang=js


/* harmony default export */ var MapPatternvue_type_script_lang_js = ({
  name: 'MapPattern',
  components: {
    TextMap: TextMap
  },
  props: {
    issue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      address: {},
      showMap: false
    };
  },
  methods: {
    onChange(val) {
      this.setZoomAndCenter(val);
    },
    setZoomAndCenter(item) {
      if (!item) return;
      let [lng, lat] = item.location.split(',');
      let center = [parseFloat(lng), parseFloat(lat)];
      this.mapCase.setZoomAndCenter(20, center);
      this.address = {
        Q: lat,
        R: lng,
        add_name: item.name
      };
      this.buildMap(center, this.mapCase);
    },
    onClickGetPos() {
      this.showMap = true;
      this.loading = true;
      let scriptEl = document.createElement('script');
      scriptEl.src = `https://webapi.amap.com/maps?v=1.4.15&key=${dygc_esm_bundler["b" /* GD_KEY */]}`;
      document.body.appendChild(scriptEl);
      scriptEl.onload = () => {
        this.loadMap();
      };
    },
    getGeolocation() {
      let map = this.mapCase;
      let self = this;
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        //是否使用高精度定位，默认:true
        timeout: 10000,
        //超过10秒后停止定位，默认：5s
        showMarker: false,
        showCircle: false,
        showButton: false,
        //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20),
        //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true,
        //定位成功后是否自动调整地图视野到定位点
        convert: false
      });
      map.addControl(geolocation);
      let [val, lng_lat] = this.issue.value.split('|');
      if (lng_lat) {
        let [lng, lat] = lng_lat.split(',');
        this.buildMap([parseFloat(lng), parseFloat(lat)], map);
      } else {
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            Object(dygc_esm_bundler["u" /* transFormPoint */])(result.position.R, result.position.Q).then(res => {
              let [lng, lat] = res.locations.split(',');
              const Q = lat,
                R = lng;
              const lngs = lng.split('.');
              const lats = lat.split('.');
              if (lngs[1]) {
                lngs[1] = lngs[1].slice(0, 6);
              }
              if (lats[1]) {
                lats[1] = lats[1].slice(0, 6);
              }
              self.getPosComplete({
                position: {
                  lng: lngs.join('.'),
                  lat: lats.join('.'),
                  Q,
                  R
                }
              });
            });
          } else {
            self.getPosError(result);
          }
        });
      }
    },
    loadMap() {
      let el = this.$refs.mapNode;
      let map = this.mapCase = new AMap.Map(el, {
        resizeEnable: true
      });
      let self = this;
      if (!this.issue.disallowUpdateLocation) {
        map.on('click', function (e) {
          self.getPosComplete({
            position: e.lnglat
          });
        });
      }
      AMap.plugin('AMap.ToolBar', () => {
        const toolBar = new AMap.ToolBar({
          position: {
            top: '110px',
            right: '40px'
          }
        });
        map.addControl(toolBar);
      });
      AMap.plugin('AMap.Geolocation', this.getGeolocation);
    },
    buildMap(center, map) {
      // let el = this.$refs.mapNode
      // let map = new AMap.Map(el, {
      //   resizeEnable: true,
      //   zoom: 30,
      //   center
      // })
      let marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: center
      });
      // let circle = new AMap.Circle({
      //   center: new AMap.LngLat(center[0], center[1]), // 圆心位置
      //   radius: 100, //半径
      //   strokeColor: '#b3e0f2', //线颜色
      //   strokeOpacity: 1, //线透明度
      //   strokeWeight: 3, //线粗细度
      //   fillColor: 'rgb(189, 231, 245)', //填充颜色
      //   fillOpacity: 0.35 //填充透明度
      // })
      map.clearMap();
      map.add(marker);
      // map.add(circle)
      map.setFitView();
    },
    getPosComplete(data) {
      this.loading = false;
      let {
        Q,
        R,
        lat,
        lng
      } = data.position;
      let center = [parseFloat(R), parseFloat(Q)];
      this.buildMap(center, this.mapCase);
      let item = {
        Q: lat,
        R: lng
      };
      Object(dygc_esm_bundler["l" /* getGeocode */])(`${R},${Q}`).then(data => {
        item.add_name = data.regeocode.formatted_address;
        this.address = item;
        this.issue.value = `${item.add_name}|${item.R},${item.Q}`;
      });
    },
    getPosError(result) {
      this.loading = false;
      this.address = {
        add_name: '获取失败',
        Q: '',
        R: ''
      };
      // this.value= "获取失败"
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.issue.inputValue) {
        this.onClickGetPos();
      }
    });
  }
});
// CONCATENATED MODULE: ./src/questions/components/map/MapPattern.vue?vue&type=script&lang=js
 /* harmony default export */ var map_MapPatternvue_type_script_lang_js = (MapPatternvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/map/MapPattern.vue





/* normalize component */

var MapPattern_component = normalizeComponent(
  map_MapPatternvue_type_script_lang_js,
  MapPatternvue_type_template_id_af69dd50_render,
  MapPatternvue_type_template_id_af69dd50_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MapPattern = (MapPattern_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/specific-format/MapQ.vue?vue&type=script&lang=js


/* harmony default export */ var MapQvue_type_script_lang_js = ({
  name: 'MapQ',
  changeExpr: 'issue.value',
  components: {
    TextMap: TextMap,
    MapPattern: MapPattern
  },
  computed: {
    pattern() {
      return this.question.issue.displayType;
    },
    textPattern() {
      return this.pattern === 0;
    },
    mapPattern() {
      return this.pattern === 1;
    }
  }
});
// CONCATENATED MODULE: ./src/questions/specific-format/MapQ.vue?vue&type=script&lang=js
 /* harmony default export */ var specific_format_MapQvue_type_script_lang_js = (MapQvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/specific-format/MapQ.vue





/* normalize component */

var MapQ_component = normalizeComponent(
  specific_format_MapQvue_type_script_lang_js,
  MapQvue_type_template_id_3577636a_render,
  MapQvue_type_template_id_3577636a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MapQ = (MapQ_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/CustomSingleScale.vue?vue&type=template&id=0888d226
var CustomSingleScalevue_type_template_id_0888d226_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "custom-scale"
  }, [_c('div', {
    staticClass: "inline-block"
  }, [_c('ul', {
    staticClass: "flex justify-between"
  }, _vm._l(_vm.issue.labels, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "inline-block mr-2 last:mr-0 scale-wrap",
      on: {
        "click": function ($event) {
          _vm.issue.value = item.id;
        }
      }
    }, [_c('div', {
      staticClass: "scale-item whitespace-nowrap",
      class: {
        selected: _vm.issue.value === item.id
      }
    }, [_vm.issue.show_option_value ? _c('span', [_vm._v(_vm._s(item.num))]) : _vm._e()]), _vm.issue.show_option_desc ? _c('div', {
      staticClass: "break-words custom-label-text"
    }, [_c('span', [_vm._v(_vm._s(item.text))])]) : _vm._e()]);
  }), 0)]), _vm.issue.show_unknown ? _c('div', {
    key: "unknown",
    staticClass: "unknown-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "unknown"
    },
    model: {
      value: _vm.issue.value,
      callback: function ($$v) {
        _vm.$set(_vm.issue, "value", $$v);
      },
      expression: "issue.value"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.issue.unknown_text))])])], 1) : _vm._e()]);
};
var CustomSingleScalevue_type_template_id_0888d226_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/scale/CustomSingleScale.vue?vue&type=template&id=0888d226

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/CustomSingleScale.vue?vue&type=script&lang=js
/* harmony default export */ var CustomSingleScalevue_type_script_lang_js = ({
  name: 'CustomSingleScale',
  props: {
    showOperate: {
      type: Boolean,
      default: true
    }
  },
  created() {},
  methods: {}
});
// CONCATENATED MODULE: ./src/questions/scale/CustomSingleScale.vue?vue&type=script&lang=js
 /* harmony default export */ var scale_CustomSingleScalevue_type_script_lang_js = (CustomSingleScalevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/scale/CustomSingleScale.vue





/* normalize component */

var CustomSingleScale_component = normalizeComponent(
  scale_CustomSingleScalevue_type_script_lang_js,
  CustomSingleScalevue_type_template_id_0888d226_render,
  CustomSingleScalevue_type_template_id_0888d226_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomSingleScale = (CustomSingleScale_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/Total.vue?vue&type=template&id=84feda12
var Totalvue_type_template_id_84feda12_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._l(_vm.issue.items, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "mb-3 last:mb-0"
    }, [_c('total-item', {
      attrs: {
        "disabled": _vm.view,
        "issue": _vm.issue,
        "item": _vm.itemModel(item)
      }
    })], 1);
  }), _vm.issue.showSum ? _c('div', {
    staticClass: "mt-5"
  }, [_vm._v("加总值：" + _vm._s(_vm.sum))]) : _vm._e()], 2);
};
var Totalvue_type_template_id_84feda12_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/scale/Total.vue?vue&type=template&id=84feda12

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"61f198f1-vue-loader-template"}!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/TotalItem.vue?vue&type=template&id=3d7a128a
var TotalItemvue_type_template_id_3d7a128a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.issue.showUnknown ? _c('div', {
    staticClass: "relative unknown-wrap",
    style: {
      paddingRight: _vm.wrapPaddingRight
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.richText)
    }
  }), _c('div', {
    staticClass: "unknown-box relative"
  }, [_c('el-radio', {
    attrs: {
      "label": true
    },
    model: {
      value: _vm.item.selectUnknown,
      callback: function ($$v) {
        _vm.$set(_vm.item, "selectUnknown", $$v);
      },
      expression: "item.selectUnknown"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.issue.unknownText) + " ")])]), _vm.disabled ? _c('div', [_c('div', {
    staticClass: "absolute inset-0 z-10"
  })]) : _vm._e()], 1)]) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.richText)
    }
  }), _c('div', {
    staticClass: "relative"
  }, [_c('el-slider', {
    ref: "elSlider",
    class: {
      disabled: _vm.item.selectUnknown
    },
    attrs: {
      "max": _vm.item.max,
      "min": _vm.item.min,
      "marks": _vm.marks,
      "show-input": ""
    },
    on: {
      "change": function ($event) {
        _vm.item.selectUnknown = false;
      }
    },
    model: {
      value: _vm.item.value,
      callback: function ($$v) {
        _vm.$set(_vm.item, "value", $$v);
      },
      expression: "item.value"
    }
  }), _vm.disabled ? _c('div', [_c('div', {
    staticClass: "absolute inset-0 z-10"
  })]) : _vm._e()], 1)]);
};
var TotalItemvue_type_template_id_3d7a128a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/questions/components/TotalItem.vue?vue&type=template&id=3d7a128a

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/components/TotalItem.vue?vue&type=script&lang=js
/* harmony default export */ var TotalItemvue_type_script_lang_js = ({
  name: 'TotalItem',
  props: {
    item: Object,
    issue: Object,
    disabled: Boolean
  },
  computed: {
    wrapPaddingRight() {
      return Math.max(this.issue.unknownText.length * 20, 40) + 'px';
    },
    marks() {
      const min = this.item.min;
      const max = this.item.max;
      let res = {
        [min]: min.toString(),
        [max]: max.toString()
      };
      if (!this.issue.showGraticule) return res;
      const graticule = this.issue.graticule;
      let step = (max - min) / graticule;
      let val = min + step;
      while (val < max) {
        const finalValue = Math.round(val);
        res[finalValue] = finalValue.toString();
        val += step;
      }
      return res;
    }
  },
  mounted() {
    if (this.issue.showUnknown) {
      this.uw = this.$watch('item.selectUnknown', val => {
        const sliderEl = this.$refs.elSlider.$refs.slider;
        if (val) {
          sliderEl.classList.add('disabled');
        } else {
          sliderEl.classList.remove('disabled');
        }
      }, {
        immediate: true
      });
    }
  },
  beforeDestroy() {
    this.uw && this.uw();
  }
});
// CONCATENATED MODULE: ./src/questions/components/TotalItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TotalItemvue_type_script_lang_js = (TotalItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/components/TotalItem.vue





/* normalize component */

var TotalItem_component = normalizeComponent(
  components_TotalItemvue_type_script_lang_js,
  TotalItemvue_type_template_id_3d7a128a_render,
  TotalItemvue_type_template_id_3d7a128a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TotalItem = (TotalItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/questions/scale/Total.vue?vue&type=script&lang=js

/* harmony default export */ var Totalvue_type_script_lang_js = ({
  name: 'Total',
  components: {
    TotalItem: TotalItem
  },
  changeExpr: "sum",
  computed: {
    sum() {
      return this.issue.getSum();
    }
  },
  methods: {
    itemModel(item) {
      return {
        ...item,
        value: +item.value
      };
    }
  }
});
// CONCATENATED MODULE: ./src/questions/scale/Total.vue?vue&type=script&lang=js
 /* harmony default export */ var scale_Totalvue_type_script_lang_js = (Totalvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/questions/scale/Total.vue





/* normalize component */

var Total_component = normalizeComponent(
  scale_Totalvue_type_script_lang_js,
  Totalvue_type_template_id_84feda12_render,
  Totalvue_type_template_id_84feda12_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Total = (Total_component.exports);
// CONCATENATED MODULE: ./src/questions/index.js



































const components = {
  SingleChoice: SingleChoice,
  MultipleChoice: MultipleChoice,
  Cascader: Cascader,
  MatrixSingleChoice: MatrixSingleChoice,
  MatrixMultipleChoice: MatrixMultipleChoice,
  SingleSelectChoice: SingleSelectChoice,
  MultipleSelectChoice: MultipleSelectChoice,
  MatrixSelectChoice: MatrixSelectChoice,
  Blanks: Blanks,
  TextFill: TextFill,
  Scale: Scale,
  CustomSingleScale: CustomSingleScale,
  MatrixScroll: MatrixScroll,
  MatrixCompose: MatrixCompose,
  MatrixGravity: MatrixGravity,
  MatrixAuto: MatrixAuto,
  MultipleBlanks: MultipleBlanks,
  SingleImageChoice: SingleImageChoice,
  MultipleImageChoice: MultipleImageChoice,
  MatrixFill: MatrixFill,
  UploadFile: UploadFile,
  DateQ: DateQ,
  Classification: Classification,
  ImageChoice: ImageChoice,
  NPSScale: NPSScale,
  MatrixScale: MatrixScale,
  Sort: Sort,
  HandWriting: HandWriting,
  CityAddress: SelectCascader,
  CascadeRegion: CascadeRegion,
  Downloadable: Downloadable,
  MapQ: MapQ,
  Total: Total,
  MaxDiff: MaxDiff
};
Object(dygc_esm_bundler["s" /* registerMixin */])(components, dygc_esm_bundler["d" /* answerMixin */]);

// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/components/QuestionItem.vue?vue&type=script&lang=js





/* harmony default export */ var QuestionItemvue_type_script_lang_js = ({
  name: 'QuestionItem',
  components: {
    AdapterUploadFiles: AdapterUploadFiles,
    ...components
  },
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    enableQuestionIndex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpenNote: false,
      isOverFlowNote: true
    };
  },
  computed: {
    title() {
      const content = this.question.content;
      return content.richText || content.text;
    },
    content() {
      return this.question.content;
    },
    componentName() {
      if (this.question.issue.getComponentType) {
        return this.question.issue.getComponentType();
      } else {
        return dygc_esm_bundler["g" /* componentMap */].get(this.question.questionType);
      }
    },
    showNote() {
      if (!this.question.setting.enableNote) return false;
      return !!this.question.note;
    },
    getNoteClass() {
      if (!this.question.setting.enableFold) return '';
      if (!this.isOverFlowNote) return '';
      return this.isOpenNote ? '' : 'fixed-height-note';
    }
  },
  methods: {
    initTitle() {
      let child = this.$refs.title.childNodes[0];
      let el = child;
      if (child.nodeType !== 1) {
        el = this.$refs.title;
      }
      const nodes = [];
      const enableQuestionIndex = this.enableQuestionIndex;
      if (enableQuestionIndex && this.question.num) {
        let span = document.createElement('span');
        span.innerText = `${this.question.num}.`;
        span.className = 'mr-1';
        nodes.push(span);
      }
      if (this.question.required) {
        let span = document.createElement('span');
        span.innerText = '*';
        span.className = 'text-red mr-1';
        nodes.push(span);
      }
      for (const node of nodes) {
        el.insertBefore(node, el.childNodes[0]);
      }
      if (this.question.issue.defaultTip) {
        const span = document.createElement('span');
        span.innerText = `【${this.question.issue.defaultTip}】`;
        el.appendChild(span);
      }
      if (this.hasAnswerScore) {
        const span = document.createElement('span');
        span.innerHTML = `<span>${this.totalScore} 分</span>`;
        span.className = 'text-theme-black-450 px-2 leading-22 rounded-small ml-2';
        el.appendChild(span);
      }
      // const typeText = typeMapping.get(this.question.questionType)
      // if (this.$bus.enableQuestionType && typeText) {
      //   const span = document.createElement('span')
      //   span.innerHTML = `<span>【${typeText}】</span>`
      //   span.className = 'bg-theme-100 text-theme-700 leading-22 rounded-small ml-2'
      //   el.appendChild(span)
      // }
      previewImage(this.$refs.title);
      previewImage(this.$refs.qContent);
      let note = this.$refs.note;
      if (note) {
        this.isOverFlowNote = note.clientHeight < note.scrollHeight;
      } else {
        this.isOverFlowNote = false;
      }
    }
  },
  mounted() {
    this.initTitle();
  }
});
// CONCATENATED MODULE: ./src/components/QuestionItem.vue?vue&type=script&lang=js
 /* harmony default export */ var components_QuestionItemvue_type_script_lang_js = (QuestionItemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/QuestionItem.vue





/* normalize component */

var QuestionItem_component = normalizeComponent(
  components_QuestionItemvue_type_script_lang_js,
  QuestionItemvue_type_template_id_418222d6_render,
  QuestionItemvue_type_template_id_418222d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QuestionItem = (QuestionItem_component.exports);
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--13-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+thread-loader@2.1.3_webpack@4.28.4/node_modules/thread-loader/dist/cjs.js!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+babel-loader@8.3.0_axq7qbih4wjtw6eoi75my2aisi/node_modules/babel-loader/lib!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+cache-loader@4.1.0_webpack@4.28.4/node_modules/cache-loader/dist/cjs.js??ref--1-0!/root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib??vue-loader-options!./src/components/PreviewQuestion.vue?vue&type=script&lang=js

/* harmony default export */ var PreviewQuestionvue_type_script_lang_js = ({
  name: 'PreviewQuestion',
  extends: QuestionItem,
  props: {},
  computed: {
    hasAnswerScore() {
      if (!this.question.setting.enableAnswerScore) return false;
      return !!(this.answerScore.optionScoreItems || []).length;
    },
    answerScore() {
      return this.question.answerScore || {};
    },
    isCorrectAnswer() {
      if (!this.question.setting.enableAnswerScore) return false;
      const issue = this.question.issue;
      if (issue.isCorrectAnswer) {
        return issue.isCorrectAnswer(this.answerScore);
      } else {
        return true;
      }
    },
    correctAnswerList() {
      const issue = this.question.issue;
      if (issue.getCorrectAnswerList) {
        return this.question.getCorrectAnswerList(this.answerScore);
      } else {
        return [];
      }
    },
    totalScore() {
      const issue = this.question.issue;
      if (issue.getTotalScore) {
        return issue.getTotalScore(this.answerScore);
      } else {
        return '';
      }
    },
    score() {
      if (!this.question.setting.enableAnswerScore) return '';
      const issue = this.question.issue;
      if (issue.getScore) {
        return issue.getScore(this.answerScore);
      } else {
        return '';
      }
    }
  },
  methods: {},
  mounted() {},
  provide() {
    return {
      view: true
    };
  }
});
// CONCATENATED MODULE: ./src/components/PreviewQuestion.vue?vue&type=script&lang=js
 /* harmony default export */ var components_PreviewQuestionvue_type_script_lang_js = (PreviewQuestionvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/components/PreviewQuestion.vue





/* normalize component */

var PreviewQuestion_component = normalizeComponent(
  components_PreviewQuestionvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PreviewQuestion = (PreviewQuestion_component.exports);
// EXTERNAL MODULE: ./src/assets/scss/tailwind.scss
var tailwind = __webpack_require__("401d");

// EXTERNAL MODULE: ./src/assets/scss/lib.scss
var lib = __webpack_require__("ced4");

// EXTERNAL MODULE: ./src/assets/scss/question/index.scss
var question = __webpack_require__("d1cd");

// CONCATENATED MODULE: ./src/lib.js





/* harmony default export */ var src_lib = ({
  PreviewQuestion: PreviewQuestion,
  QuestionItem: QuestionItem
});
// CONCATENATED MODULE: /root/workspace/dygc_jgAw/node_modules/.pnpm/registry.npmmirror.com+@vue+cli-service@4.5.19_vgqb3v6m2ynwvuzumqmye2vzna/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_lib);



/***/ }),

/***/ "eebc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var shared = __webpack_require__("e7d4");
var hasOwn = __webpack_require__("80a8");
var uid = __webpack_require__("a961");
var NATIVE_SYMBOL = __webpack_require__("024b");
var USE_SYMBOL_AS_UID = __webpack_require__("8420");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "eed0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),

/***/ "ef26":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("0d52");
var isObject = __webpack_require__("e2a4");
var setPrototypeOf = __webpack_require__("03e6");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "ef57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("6bd2");
var call = __webpack_require__("2f9c");
var propertyIsEnumerableModule = __webpack_require__("f243");
var createPropertyDescriptor = __webpack_require__("8b31");
var toIndexedObject = __webpack_require__("2703");
var toPropertyKey = __webpack_require__("56bb");
var hasOwn = __webpack_require__("80a8");
var IE8_DOM_DEFINE = __webpack_require__("1eca");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "f243":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "f385":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "f3b3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isMac = exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.rafThrottle = rafThrottle;
exports.objToArray = objToArray;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _types = __webpack_require__("8511");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var kebabCase = exports.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};

var capitalize = exports.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var looseEqual = exports.looseEqual = function looseEqual(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

var isEqual = exports.isEqual = function isEqual(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
      {
        return !val.size;
      }
    // Plain Object
    case '[object Object]':
      {
        return !Object.keys(val).length;
      }
  }

  return false;
};

function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

var isMac = exports.isMac = function isMac() {
  return !_vue2.default.prototype.$isServer && /macintosh|mac os x/i.test(navigator.userAgent);
};

/***/ }),

/***/ "f499":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("79a2");
var defineGlobalProperty = __webpack_require__("4113");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "f514":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f627":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__("abb2");
var clearErrorStack = __webpack_require__("5d7c");
var ERROR_STACK_INSTALLABLE = __webpack_require__("0d07");

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ "f66f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("c64c");
var hasOwn = __webpack_require__("80a8");
var createNonEnumerableProperty = __webpack_require__("abb2");
var isPrototypeOf = __webpack_require__("29f7");
var setPrototypeOf = __webpack_require__("03e6");
var copyConstructorProperties = __webpack_require__("0604");
var proxyAccessor = __webpack_require__("2fb7");
var inheritIfRequired = __webpack_require__("ef26");
var normalizeStringArgument = __webpack_require__("b839");
var installErrorCause = __webpack_require__("0ef3");
var installErrorStack = __webpack_require__("f627");
var DESCRIPTORS = __webpack_require__("6bd2");
var IS_PURE = __webpack_require__("eed0");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "f8ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "f938":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("0d52");
var tryToString = __webpack_require__("b150");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "f9ec":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "fa71":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("665b");
var buildURL = __webpack_require__("2d7b");
var InterceptorManager = __webpack_require__("e63d");
var dispatchRequest = __webpack_require__("195a");
var mergeConfig = __webpack_require__("c3c5");
var validator = __webpack_require__("db93");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "fd1c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("799f");
var $findLastIndex = __webpack_require__("22ec").findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlastindex
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "fd95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("c64c");
var isCallable = __webpack_require__("0d52");
var isPrototypeOf = __webpack_require__("29f7");
var USE_SYMBOL_AS_UID = __webpack_require__("8420");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "fe2d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("3117")))

/***/ }),

/***/ "fe7c":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 78);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__("b166");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__("26b9");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__("da05");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__("5a8b");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8409");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = __webpack_require__("5dea");

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __webpack_require__("3a91");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__("233f");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8bbf");

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "el-message-box__wrapper",
        attrs: {
          tabindex: "-1",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": _vm.title || "dialog"
        },
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.handleWrapperClick($event)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "el-message-box",
            class: [_vm.customClass, _vm.center && "el-message-box--center"]
          },
          [
            _vm.title !== null
              ? _c("div", { staticClass: "el-message-box__header" }, [
                  _c("div", { staticClass: "el-message-box__title" }, [
                    _vm.icon && _vm.center
                      ? _c("div", {
                          class: ["el-message-box__status", _vm.icon]
                        })
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(_vm.title))])
                  ]),
                  _vm.showClose
                    ? _c(
                        "button",
                        {
                          staticClass: "el-message-box__headerbtn",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function($event) {
                              _vm.handleAction(
                                _vm.distinguishCancelAndClose
                                  ? "close"
                                  : "cancel"
                              )
                            },
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.handleAction(
                                _vm.distinguishCancelAndClose
                                  ? "close"
                                  : "cancel"
                              )
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-message-box__close el-icon-close"
                          })
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _c("div", { staticClass: "el-message-box__content" }, [
              _c("div", { staticClass: "el-message-box__container" }, [
                _vm.icon && !_vm.center && _vm.message !== ""
                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
                  : _vm._e(),
                _vm.message !== ""
                  ? _c(
                      "div",
                      { staticClass: "el-message-box__message" },
                      [
                        _vm._t("default", [
                          !_vm.dangerouslyUseHTMLString
                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
                            : _c("p", {
                                domProps: { innerHTML: _vm._s(_vm.message) }
                              })
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInput,
                      expression: "showInput"
                    }
                  ],
                  staticClass: "el-message-box__input"
                },
                [
                  _c("el-input", {
                    ref: "input",
                    attrs: {
                      type: _vm.inputType,
                      placeholder: _vm.inputPlaceholder
                    },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleInputEnter($event)
                      }
                    },
                    model: {
                      value: _vm.inputValue,
                      callback: function($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "el-message-box__errormsg",
                      style: {
                        visibility: !!_vm.editorErrorMessage
                          ? "visible"
                          : "hidden"
                      }
                    },
                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "el-message-box__btns" },
              [
                _vm.showCancelButton
                  ? _c(
                      "el-button",
                      {
                        class: [_vm.cancelButtonClasses],
                        attrs: {
                          loading: _vm.cancelButtonLoading,
                          round: _vm.roundButton,
                          size: "small"
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.handleAction("cancel")
                          }
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.handleAction("cancel")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cancelButtonText ||
                                _vm.t("el.messagebox.cancel")
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showConfirmButton,
                        expression: "showConfirmButton"
                      }
                    ],
                    ref: "confirm",
                    class: [_vm.confirmButtonClasses],
                    attrs: {
                      loading: _vm.confirmButtonLoading,
                      round: _vm.roundButton,
                      size: "small"
                    },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.handleAction("confirm")
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.handleAction("confirm")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.confirmButtonText ||
                            _vm.t("el.messagebox.confirm")
                        ) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&

// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_ = __webpack_require__(13);
var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_ = __webpack_require__(6);
var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

// EXTERNAL MODULE: external "element-ui/lib/input"
var input_ = __webpack_require__(10);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "element-ui/lib/button"
var button_ = __webpack_require__(14);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(2);

// EXTERNAL MODULE: external "element-ui/lib/locale"
var lib_locale_ = __webpack_require__(20);

// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
var aria_dialog_ = __webpack_require__(47);
var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var messageBox = void 0;
var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  mixins: [popup_default.a, locale_default.a],

  props: {
    modal: {
      default: true
    },
    lockScroll: {
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: true
    },
    closeOnPressEscape: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      default: false,
      type: Boolean
    },
    roundButton: {
      default: false,
      type: Boolean
    }
  },

  components: {
    ElInput: input_default.a,
    ElButton: button_default.a
  },

  computed: {
    icon: function icon() {
      var type = this.type,
          iconClass = this.iconClass;

      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
    },
    confirmButtonClasses: function confirmButtonClasses() {
      return 'el-button--primary ' + this.confirmButtonClass;
    },
    cancelButtonClasses: function cancelButtonClasses() {
      return '' + this.cancelButtonClass;
    }
  },

  methods: {
    getSafeClose: function getSafeClose() {
      var _this = this;

      var currentId = this.uid;
      return function () {
        _this.$nextTick(function () {
          if (currentId === _this.uid) _this.doClose();
        });
      };
    },
    doClose: function doClose() {
      var _this2 = this;

      if (!this.visible) return;
      this.visible = false;
      this._closing = true;

      this.onClose && this.onClose();
      messageBox.closeDialog(); // 解绑
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }
      this.opened = false;
      this.doAfterClose();
      setTimeout(function () {
        if (_this2.action) _this2.callback(_this2.action, _this2);
      });
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
      }
    },
    handleInputEnter: function handleInputEnter() {
      if (this.inputType !== 'textarea') {
        return this.handleAction('confirm');
      }
    },
    handleAction: function handleAction(action) {
      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }
      this.action = action;
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose();
      }
    },
    validate: function validate() {
      if (this.$type === 'prompt') {
        var inputPattern = this.inputPattern;
        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
          return false;
        }
        var inputValidator = this.inputValidator;
        if (typeof inputValidator === 'function') {
          var validateResult = inputValidator(this.inputValue);
          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
            return false;
          }
          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
            return false;
          }
        }
      }
      this.editorErrorMessage = '';
      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
      return true;
    },
    getFirstFocus: function getFirstFocus() {
      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
      return btn || title;
    },
    getInputElement: function getInputElement() {
      var inputRefs = this.$refs.input.$refs;
      return inputRefs.input || inputRefs.textarea;
    },
    handleClose: function handleClose() {
      this.handleAction('close');
    }
  },

  watch: {
    inputValue: {
      immediate: true,
      handler: function handler(val) {
        var _this3 = this;

        this.$nextTick(function (_) {
          if (_this3.$type === 'prompt' && val !== null) {
            _this3.validate();
          }
        });
      }
    },

    visible: function visible(val) {
      var _this4 = this;

      if (val) {
        this.uid++;
        if (this.$type === 'alert' || this.$type === 'confirm') {
          this.$nextTick(function () {
            _this4.$refs.confirm.$el.focus();
          });
        }
        this.focusAfterClosed = document.activeElement;
        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
      }

      // prompt
      if (this.$type !== 'prompt') return;
      if (val) {
        setTimeout(function () {
          if (_this4.$refs.input && _this4.$refs.input.$el) {
            _this4.getInputElement().focus();
          }
        }, 500);
      } else {
        this.editorErrorMessage = '';
        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
      }
    }
  },

  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      if (_this5.closeOnHashChange) {
        window.addEventListener('hashchange', _this5.close);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close);
    }
    setTimeout(function () {
      messageBox.closeDialog();
    });
  },
  data: function data() {
    return {
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      iconClass: '',
      customClass: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputType: 'text',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      dangerouslyUseHTMLString: false,
      focusAfterClosed: null,
      isOnComposition: false,
      distinguishCancelAndClose: false
    };
  }
});
// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/message-box/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/message-box/src/main.vue"
/* harmony default export */ var main = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_ = __webpack_require__(23);

// CONCATENATED MODULE: ./packages/message-box/src/main.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var defaults = {
  title: null,
  message: '',
  type: '',
  iconClass: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  closeOnHashChange: true,
  inputValue: null,
  inputPlaceholder: '',
  inputType: 'text',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: '',
  cancelButtonText: '',
  confirmButtonClass: '',
  cancelButtonClass: '',
  customClass: '',
  beforeClose: null,
  dangerouslyUseHTMLString: false,
  center: false,
  roundButton: false,
  distinguishCancelAndClose: false
};






var MessageBoxConstructor = external_vue_default.a.extend(main);

var currentMsg = void 0,
    instance = void 0;
var msgQueue = [];

var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var callback = currentMsg.callback;
    if (typeof callback === 'function') {
      if (instance.showInput) {
        callback(instance.inputValue, action);
      } else {
        callback(action);
      }
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        if (instance.showInput) {
          currentMsg.resolve({ value: instance.inputValue, action: action });
        } else {
          currentMsg.resolve(action);
        }
      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
        currentMsg.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var main_showNextMsg = function showNextMsg() {
  if (!instance) {
    initInstance();
  }
  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();

      var options = currentMsg.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
        showNextMsg();
      };
      if (Object(vdom_["isVNode"])(instance.message)) {
        instance.$slots.default = [instance.message];
        instance.message = null;
      } else {
        delete instance.$slots.default;
      }
      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
        if (instance[prop] === undefined) {
          instance[prop] = true;
        }
      });
      document.body.appendChild(instance.$el);

      external_vue_default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var main_MessageBox = function MessageBox(options, callback) {
  if (external_vue_default.a.prototype.$isServer) return;
  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: merge_default()({}, defaults, MessageBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });

      main_showNextMsg();
    });
  } else {
    msgQueue.push({
      options: merge_default()({}, defaults, MessageBox.defaults, options),
      callback: callback
    });

    main_showNextMsg();
  }
};

main_MessageBox.setDefaults = function (defaults) {
  main_MessageBox.defaults = defaults;
};

main_MessageBox.alert = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false
  }, options));
};

main_MessageBox.confirm = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    $type: 'confirm',
    showCancelButton: true
  }, options));
};

main_MessageBox.prompt = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt'
  }, options));
};

main_MessageBox.close = function () {
  instance.doClose();
  instance.visible = false;
  msgQueue = [];
  currentMsg = null;
};

/* harmony default export */ var src_main = (main_MessageBox);

// CONCATENATED MODULE: ./packages/message-box/index.js

/* harmony default export */ var message_box = __webpack_exports__["default"] = (src_main);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__("a6f3");

/***/ })

/******/ });

/***/ })

/******/ });
//# sourceMappingURL=lib.common.js.map